import React from "react";
import "./TubeSVG.css";

// const mapContactImg = require("../../../../assets/media/background/map-contact.png");

/*
TODO: used "replace" added <a href="#"></a> outside <text>, for some reason, without the <a>, after zoom in, mousemove causes text inside <text> to shrink back to its original size.

TODO: Temporary workaround, don't know why it's doing this, revisit later.

*/

export default function TubeSVG(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 2542.6 1794.3"
      style={{
        width: "100%",
        height: "auto",
        // filter: "invert(90%)"
      }}
      // TODO: add isMobile version!!!
      // style={{
      //     width: !showFilter ? (isMobile ? "auto" : "100vw") : "calc(100vw - 400px)",
      //     height: !showFilter ? (isMobile ? "calc(100vh - 207.13px)" : "auto") : "auto"
      // }}
      id="tubemapSVG"
      // xmlSpace="preserve"
      {...props}
    >
      {/* <style>
                {
                    ".st2{fill:#f1f2f2}.st4{fill:#fff}.st15{fill:none;stroke:#fff;stroke-width:4.1668}.st25{font-family:'ArialMT'}.st26{font-size:12px}.st27{fill:#fff;stroke:#fff;stroke-width:4.1668}.st28,.st29{fill:#fff;stroke:#d1d3d4;stroke-width:1.6277}.st29{stroke-width:1.7512}.st30{font-family:'MuktaVaani-Medium'}.st31{font-size:64.0421px}.st32{fill:#e6e7e8}.st33{fill:#b1b3b6}.st34{font-size:16.1694px}.st35{font-size:19.1092px}.st36{fill:none}.st37{fill:#c7eafb}.st38{fill:none;stroke:#00aeef;stroke-width:.6527}.st40{fill:#00b3f0}.st41{font-size:10.1389px}.st42{fill:#1c3f94}.st43{fill:none;stroke:#d385a9;stroke-width:5.6998;stroke-linejoin:round;stroke-miterlimit:3.994}.st44{fill:#d385a9}.st45{stroke-miterlimit:3.994;stroke-dasharray:8.8176,4.4088,0,8.8176,4.4088,0}.st45,.st46,.st51{fill:none;stroke:#fff;stroke-width:2.0207;stroke-linejoin:round}.st51{stroke:#d385a9;stroke-width:5.6988;stroke-miterlimit:3.994}.st52,.st58{stroke-width:2.0204}.st52{fill:none;stroke:#fff;stroke-linejoin:round}.st58{stroke-miterlimit:3.994;stroke-dasharray:14.1732,8.5039}.st58,.st65,.st66{fill:none;stroke:#fff;stroke-linejoin:round}.st65{stroke-width:2.0207;stroke-miterlimit:3.994;stroke-dasharray:14.1732,8.5039}.st66{stroke-width:2.02}.st72{fill:#ee3124}.st75,.st76{fill:none;stroke:#7ac143;stroke-width:5.7091;stroke-linejoin:round;stroke-miterlimit:3.9938}.st76{stroke:#fff;stroke-width:1.9592}.st77{fill:#7ac143}.st79,.st80{fill:none;stroke:#f58025;stroke-width:5.7012;stroke-linejoin:round;stroke-miterlimit:3.9938}.st80{stroke:#fff;stroke-width:1.9558}.st81{fill:#f58025}.st82,.st83,.st84,.st85,.st89,.st90,.st91{fill:none;stroke:#634ea0;stroke-width:5.8789;stroke-linejoin:round;stroke-miterlimit:3.9938}.st83,.st84,.st85,.st89,.st90,.st91{stroke:#fff;stroke-width:2.0167}.st84,.st85,.st89,.st90,.st91{stroke:#634ea0;stroke-width:5.817;stroke-miterlimit:3.994}.st85,.st89,.st90,.st91{stroke:#fff;stroke-width:1.996}.st89,.st90,.st91{stroke:#634ea0;stroke-width:5.818}.st90,.st91{stroke-width:5.7012;stroke-miterlimit:3.9938}.st91{stroke:#00b1b0}.st93{fill:#b06010}.st95{fill:none;stroke:#f1f2f2;stroke-width:7.4007;stroke-linejoin:round;stroke-miterlimit:3.9938}.st96{fill:#949ca1}.st100,.st102,.st99{fill:none;stroke:#009ddc;stroke-width:5.7012;stroke-linejoin:round;stroke-miterlimit:3.9938}.st100,.st102{stroke:#000}.st102{stroke:#1c3f94}.st103,.st104{fill:none;stroke:#f1f2f2;stroke-width:2.3277}.st104{stroke:#ee3124;stroke-width:5.7012;stroke-linejoin:round;stroke-miterlimit:3.9938}.st105{fill:#f386a1}.st107{fill:#ffd200}.st109{fill:#00853f}.st110{fill:none;stroke:#00853f;stroke-width:5.7012;stroke-linejoin:round;stroke-miterlimit:3.9938}.st113{fill:#97005e}.st114{fill:none;stroke:#97005e;stroke-width:5.7012;stroke-linejoin:round;stroke-miterlimit:3.9938}.st115{fill:#750d1d}.st116{fill:#dcddde}.st121{font-size:11.7595px}.st122{font-size:11.7685px}.st123{font-size:11.7594px}.st124{font-size:11.7599px}.st125{font-size:11.7626px}.st126{font-size:11.7621px}.st127{font-size:11.7563px}.st128{font-size:11.769px}.st129{font-size:11.7488px}.st131{font-size:11.7678px}.st132{font-size:11.7566px}.st133{font-size:11.7571px}.st134{font-size:11.7662px}.st135{font-size:11.7651px}.st136{font-size:11.7572px}.st137{font-size:12.2225px}.st140{fill:none;stroke:#26b1e6;stroke-width:1.85;stroke-linejoin:round}.st141{font-size:21.4018px}.st142,.st143{stroke-miterlimit:3.8636}.st142{fill:none;stroke:#79004c;stroke-width:2.4979;stroke-linejoin:round}.st143{fill:#fff;stroke:#d1d3d4;stroke-width:1.1501}.st144{font-size:13.38px}.st145{font-size:10.96px}.st147{font-size:13.9416px}.st148{font-size:13.9399px}.st151,.st152{fill:none;stroke:#00b3f0;stroke-width:.2835;stroke-linejoin:round}.st152{stroke-width:1.198}.st154{font-size:19.1748px}.st155{fill-rule:evenodd;clip-rule:evenodd;fill:#577197}.st156{font-size:9px}.st158{fill:#577197}.st161{font-family:'STHeitiTC-Light'}"
                }
            </style> */}
      <g id="Fare_Zones">
        <defs>
          <path
            id="SVGID_1_"
            d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
          />
        </defs>
        <clipPath id="SVGID_00000137840082370482228090000014091637231020262811_">
          <use xlinkHref="#SVGID_1_" overflow="visible" />
        </clipPath>
        <g clipPath="url(#SVGID_00000137840082370482228090000014091637231020262811_)">
          <defs>
            <path
              id="SVGID_00000087383716292038344120000011707254773439713954_"
              d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
            />
          </defs>
          <clipPath id="SVGID_00000183959767520055761340000008533824381605019041_">
            <use
              xlinkHref="#SVGID_00000087383716292038344120000011707254773439713954_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000183959767520055761340000008533824381605019041_)">
            <path
              className="st2"
              d="M1309.2 113.9h209.9c4.4 0 10.6-2.6 13.8-5.7l70.5-70.5c3.1-3.1 8.9-7.3 12.9-9.3l58.5-29.3c4-2 10.8-3.8 15.3-3.9l904.4-35.5c4.4-.2 8.1 3.3 8 7.8l-5 1863.8c0 4.4-3.6 8.1-8.1 8.1l-2653.2-6.9c-4.4 0-8.1-3.7-8.1-8.1l-5.3-1440.5c0-4.4 2.5-10.6 5.7-13.8L332.7-34.2c3.1-3.1 9.3-5.8 13.8-5.8l94.7-1.1c4.4 0 10.6 2.5 13.8 5.6l143.6 143.6c3.1 3.1 9.3 5.7 13.8 5.7l696.8.1z"
            />
          </g>
          <defs>
            <path
              id="SVGID_00000176739579866849470500000014561568396833552265_"
              d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
            />
          </defs>
          <clipPath id="SVGID_00000016049920612862850780000012276120375369873302_">
            <use
              xlinkHref="#SVGID_00000176739579866849470500000014561568396833552265_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000016049920612862850780000012276120375369873302_)">
            <path
              className="st4"
              d="M-70.4 464.2c0-4.4 2.6-10.6 5.7-13.8l461-458c3.1-3.1 8.2-3.1 11.4.1l24.1 24.8c3.1 3.2 8.2 8.4 11.3 11.5l150.8 150.8c3.1 3.1 9.3 5.7 13.8 5.7h173.4c4.4 0 10.6-2.6 13.8-5.7l56.1-56.1c3.1-3.1 9.3-5.7 13.8-5.7H1527.6c4.4 0 10.6-2.6 13.8-5.7l52.4-52.4c3.1-3.1 9.3-5.7 13.8-5.8l115.3-.7c4.4 0 10.6 2.5 13.8 5.7l31.1 31.1c3.1 3.1 9.3 5.7 13.8 5.7h93.8c4.4 0 10.6-2.6 13.8-5.7l120.9-120.9c3.1-3.1 9.3-5.7 13.8-5.7l574.9-1.3c4.4 0 8.1 3.6 8.1 8v1690.3c0 4.4-3.6 8.1-8.1 8.1H-59.1c-4.4 0-8.1-3.6-8.1-8.1l-3.2-1196.2z"
            />
          </g>
          <defs>
            <path
              id="SVGID_00000163036387140814587840000014834269364706679997_"
              d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
            />
          </defs>
          <clipPath id="SVGID_00000116198218128573214300000003689436581733231543_">
            <use
              xlinkHref="#SVGID_00000163036387140814587840000014834269364706679997_"
              overflow="visible"
            />
          </clipPath>
          <path
            clipPath="url(#SVGID_00000116198218128573214300000003689436581733231543_)"
            fill="#e1e8f6"
            d="M-144.8 520.1L193.5 520.1 245.6 571.2 245.6 747.5 -127 1083.7z"
          />
          <g>
            <defs>
              <path
                id="SVGID_00000111895252632514998810000014580178343757100196_"
                d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
              />
            </defs>
            <clipPath id="SVGID_00000088838719889799262590000010664609558193061290_">
              <use
                xlinkHref="#SVGID_00000111895252632514998810000014580178343757100196_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_00000088838719889799262590000010664609558193061290_)">
              <path
                className="st2"
                d="M-95.4 525.8c-.1-1.3 2.4-5 5.6-8.1l287.6-287.2c3.1-3.1 9.3-5.7 13.8-5.7h602.1c4.4 0 10.6-2.6 13.8-5.7l89.2-89.1c3.1-3.1 9.3-5.7 13.8-5.7h322.6c4.4 0 8.4-.3 8.8-.7s4.3-.7 8.8-.7h263.1c4.4 0 10.6-2.6 13.8-5.7l48.1-48.1c3.1-3.1 9.3-5.7 13.8-5.7l76-.1c4.4 0 9.5 1.5 11.3 3.2 1.8 1.8 5.8 5.8 8.9 9l49.2 49.5c3.1 3.1 9.3 5.7 13.8 5.7l135.2.3c4.4 0 10.6-2.6 13.8-5.7l96.7-96.5c3.1-3.1 8.3-8.2 11.5-11.4l26.9-26.5c3.2-3.1 8.3-3.1 11.4 0l242 242.2c3.1 3.1 9.3 5.7 13.8 5.7l273.4-.1c4.4 0 8.1 3.6 8.1 8.1v1414.3c0 4.4-3.6 8.1-8.1 8.1H789.8c-4.4 0-10.6-2.6-13.8-5.7l-304.1-304.1c-3.1-3.1-9.3-5.7-13.8-5.7l-521.7-.1c-4.4 0-8.1-3.6-8.1-8.1L-73 785.8c0-4.4 3.6-8.1 8.1-8.1l256.4-.1c4.4 0 10.6-2.6 13.7-5.8l25.4-26.1c3.1-3.2 5.6-9.4 5.6-13.8l-.4-150.5c0-4.4-2.6-10.6-5.7-13.8l-33.5-33.7c-3.1-3.1-9.3-5.7-13.8-5.7l-270.1.1c-4.4 0-8.1-1.1-8.1-2.5z"
              />
            </g>
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000126313018951619251640000012167279147256617122_"
                d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
              />
            </defs>
            <clipPath id="SVGID_00000152965176791457979360000016514109203725406353_">
              <use
                xlinkHref="#SVGID_00000126313018951619251640000012167279147256617122_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_00000152965176791457979360000016514109203725406353_)">
              <path
                className="st4"
                d="M192.8 416.3c0-4.4 2.6-10.6 5.7-13.8l74.1-74.1c3.1-3.1 9.3-5.7 13.8-5.7h128.2c4.4 0 10.6-2.6 13.8-5.7l22-22c3.1-3.1 9.3-5.7 13.8-5.7H525c4.4 0 10.6-2.6 13.8-5.7l28.5-28.5c3.1-3.1 9.3-5.7 13.8-5.7h300.5c4.4 0 10.7-2.5 13.8-5.6l97.6-95.1c3.2-3.1 9.4-5.6 13.8-5.6h234.7c4.4 0 10.6-2.6 13.8-5.7l4.8-4.8c3.1-3.1 9.3-5.7 13.8-5.7l266.8-.2c4.4 0 10.6-2.6 13.8-5.7l32.5-32.6c3.1-3.1 9.3-5.7 13.8-5.7h49.1c4.4 0 10.6 2.6 13.8 5.7l70.6 70.8c3.1 3.1 9.3 5.7 13.8 5.7h386.1c4.4 0 10.6 2.6 13.8 5.7l67.4 67.4c3.1 3.1 5.7 9.3 5.7 13.8v23.9c0 4.4 2.6 10.6 5.7 13.8l51.8 51.8c3.1 3.1 5.7 9.3 5.7 13.8v125.3c0 4.4 3.1 10 6.8 12.4l120 75.3c4.4 2.7 9.4 4.2 14.5 4.2h66.6c4.4 0 9.6 3.3 11.4 7.3l106.3 230.7c1.9 4 3.4 11 3.4 15.4l-.9 835.6c0 4.4-3.6 8.1-8.1 8.1H753.8c-4.4 0-10.6-2.6-13.8-5.7l-572.8-570.8c-3.1-3.1-5.7-9.3-5.7-13.8V863.3c0-4.4 2.6-10.6 5.7-13.8l78.2-78.2c3.1-3.1 5.7-9.3 5.7-13.8V571.8c0-4.4-2.6-10.6-5.7-13.8l-46.9-46.9c-3.1-3.1-5.7-9.3-5.7-13.8v-81z"
              />
            </g>
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000008148379504875114970000006080767013858136473_"
                d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
              />
            </defs>
            <clipPath id="SVGID_00000050651858793383267050000012609001224981328789_">
              <use
                xlinkHref="#SVGID_00000008148379504875114970000006080767013858136473_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_00000050651858793383267050000012609001224981328789_)">
              <path
                className="st2"
                d="M1053.6 163.6c3.1-3.1 9.3-5.7 13.8-5.7h391c4.4 0 10.6 2.6 13.8 5.7l21.2 21.2c3.1 3.1 9.3 5.7 13.8 5.7h579.7c4.4 0 10.6 2.6 13.8 5.7l85.6 85.6c3.1 3.1 5.7 9.3 5.7 13.8v29.8c0 4.4 2.6 10.6 5.7 13.8l52.8 52.8c3.1 3.1 5.7 9.3 5.7 13.8V479c0 4.4-2.6 10.6-5.7 13.8l-57.1 57.1c-3.1 3.1-2.9 8.1.4 11l42.6 36.5c6.9 6.3 15.9 9.8 25.2 9.8h229.8c4.4 0 9 3.5 10.2 7.8l101.1 369.2c1.2 4.3 2.1 11.4 2 15.8l-5.8 387.3c-.1 4.4-3.8 8.1-8.2 8.1l-527.3-.3c-4.4 0-10.6 2.6-13.8 5.7l-84.6 84.7c-3.1 3.1-9.3 5.7-13.8 5.7h-433.9c-4.4 0-10.6 2.6-13.8 5.7l-73.3 73.3c-3.1 3.1-9.3 5.7-13.8 5.7H897.1c-4.4 0-10.6-2.6-13.8-5.7l-210.4-210.4c-3.1-3.1-9.3-5.7-13.8-5.7h-91c-4.4 0-10.6-2.6-13.8-5.7L336.6 1130c-3.1-3.1-9.3-5.7-13.8-5.7h-26.4c-4.4 0-10.6-2.6-13.8-5.7l-10-10c-3.1-3.1-5.7-9.3-5.7-13.8v-528c0-4.4 2.6-10.6 5.7-13.8l81.6-81.6c3.1-3.1 9.3-5.7 13.8-5.7h135.2c4.4 0 10.6-2.6 13.8-5.7l143.8-143.8c3.1-3.1 9.3-5.7 13.8-5.7h223.9c4.4 0 10.6-2.6 13.8-5.7l141.3-141.2z"
              />
            </g>
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000039098712373277631590000018173447849671712694_"
                d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
              />
            </defs>
            <clipPath id="SVGID_00000006666480191965037740000009863241975069767836_">
              <use
                xlinkHref="#SVGID_00000039098712373277631590000018173447849671712694_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_00000006666480191965037740000009863241975069767836_)">
              <path
                className="st4"
                d="M2011.6 1404.5c-3.2 3.1-9.5 5.6-13.9 5.6h-318.9c-4.4 0-10.6 2.6-13.8 5.7l-42.3 42.3c-3.1 3.1-9.3 5.7-13.8 5.7h-139.2c-4.4 0-10.6 2.6-13.8 5.7l-69.2 69.2c-3.1 3.1-9.3 5.7-13.8 5.7l-548.8-.2c-4.4 0-10.6-2.6-13.8-5.7L626 1354.7c-3.1-3.1-5.7-9.3-5.7-13.8v-116.1c0-4.4-2.6-10.6-5.7-13.8l-55-54.9c-3.1-3.1-9.3-5.7-13.8-5.7h-27.7c-4.4 0-10.6-2.6-13.8-5.7l-47.8-47.8c-3.1-3.1-5.7-9.3-5.7-13.8v-11c0-4.4-2.6-10.6-5.7-13.8l-20.5-20.5c-3.1-3.1-9.3-5.7-13.8-5.7h-36.5c-4.4 0-10.6-2.6-13.8-5.7l-14.9-15c-3.1-3.1-5.7-9.3-5.7-13.8V723.4c0-4.4 2.5-10.7 5.7-13.8l215.6-219.1c3.1-3.2 9.3-5.8 13.7-5.8h105.3c4.4 0 10.6-2.6 13.8-5.7l36.4-36.4c3.1-3.1 9.3-5.7 13.8-5.7h26.9c4.4 0 10.6-2.6 13.8-5.7l74.6-74.7c3.1-3.1 9.3-5.7 13.8-5.7h154.5c4.4 0 10.6-2.6 13.8-5.7l19.4-19.4c3.1-3.1 9.3-5.7 13.8-5.7h210.8c4.4 0 10.6-2.6 13.8-5.7l2.8-2.8c3.1-3.1 9.3-5.7 13.8-5.7h111.4c4.4 0 10.6-2.6 13.8-5.7l36.5-36.5c3.1-3.1 9.3-5.7 13.8-5.7l263.9-.1c4.4 0 10.6 2.6 13.8 5.7l59.9 59.9c3.1 3.1 9.3 5.7 13.8 5.7h42.8c4.4 0 10.6 2.6 13.8 5.7l93.9 93.9c3.1 3.1 9.3 5.7 13.8 5.7h80.1c4.4 0 10.6 2.6 13.8 5.7l17.8 17.8c3.1 3.1 5.7 9.3 5.7 13.8l-.3 183.8c0 4.4 2.6 10.6 5.7 13.8l218.9 218.9c3.1 3.1 5.6 9.3 5.5 13.8l-6.3 245.1c-.1 4.4-3.8 8.1-8.3 8.1l-232.7 1.4c-4.4 0-8.1 3.7-8.1 8.1v148.6c0 4.4-2.6 10.6-5.8 13.6l-81.6 77.6z"
              />
            </g>
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000144336876129196144890000014142743279743184307_"
                d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
              />
            </defs>
            <clipPath id="SVGID_00000016763696561799545560000011710570568792875169_">
              <use
                xlinkHref="#SVGID_00000144336876129196144890000014142743279743184307_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_00000016763696561799545560000011710570568792875169_)">
              <path
                className="st2"
                d="M1864.8 1320.9c0 4.4-2.6 10.6-5.7 13.8l-23.8 23.9c-3.1 3.1-9.3 5.7-13.8 5.7h-32.3c-4.4 0-10.6-2.6-13.8-5.7l-44.5-44.5c-3.1-3.1-9.3-5.7-13.8-5.7h-169.6c-4.4 0-10.6 2.6-13.8 5.7l-111.3 111.3c-3.1 3.1-9.3 5.7-13.8 5.7h-405.1c-4.4 0-10.6-2.6-13.8-5.7l-174.6-174.6c-3.1-3.1-9.3-5.7-13.8-5.7h-45.8c-4.4 0-10.6-2.6-13.8-5.7l-196.2-196.1c-3.1-3.1-5.7-9.3-5.7-13.8v-28.4c0-4.4 2.6-10.6 5.7-13.8l31.3-31.3c3.1-3.1 5.7-9.3 5.7-13.8V583.1c0-4.4 2.6-10.6 5.7-13.8l22.4-22.4c3.1-3.1 9.3-5.7 13.8-5.7H674c4.4 0 10.6-2.6 13.8-5.7l84.8-85.2c3.1-3.1 9.3-5.7 13.8-5.7h196c4.4 0 10.6-2.6 13.8-5.7l11.3-11.3c3.1-3.1 9.3-5.7 13.8-5.7h103.8c4.4 0 10.6-2.6 13.8-5.7l24.4-24.4c3.1-3.1 9.3-5.7 13.8-5.7h289.1c4.4 0 9.9-1.9 12.2-4.2l6.8-6.8c1.5-1.5 6.2-2.6 10.7-2.6h75.8c4.4 0 10.7 2.5 13.8 5.6l2.3 2.3c3.2 3.1 8.3 8.2 11.5 11.3l49.5 49.5c3.1 3.1 9.3 5.7 13.8 5.7h65.3c4.4 0 10.6 2.6 13.8 5.7L1846.1 557c3.1 3.1 9.3 5.7 13.8 5.7h49.1c4.4 0 10.3 2.2 13.1 5s5 8.6 5 13.1l-.1 451.7c0 4.4 3.4 8.1 7.7 8.1 4.2 0 7.7 3.6 7.7 8.1v75.7c0 4.4-2.6 10.6-5.7 13.8l-66.4 66.7c-3.1 3.2-5.7 9.3-5.7 13.8l.2 102.2z"
              />
            </g>
          </g>
          <g>
            <defs>
              <path
                id="SVGID_00000156551811388536545680000014722818688992617347_"
                d="M2493 1603.4L30.5 1625.1 30.5 37.9 2493 16.2z"
              />
            </defs>
            <clipPath id="SVGID_00000044161464457202182320000005033448233501525934_">
              <use
                xlinkHref="#SVGID_00000156551811388536545680000014722818688992617347_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_00000044161464457202182320000005033448233501525934_)">
              <path
                className="st4"
                d="M1346.5 576.5c4.4 0 10.6 2.6 13.8 5.7l44.5 44.5c3.1 3.1 9.3 5.7 13.8 5.7h135.5c4.4 0 11.2 1.9 14.9 4.3l24.1 15c3.8 2.3 10.5 4.3 14.9 4.3h82c4.4 0 8.1 3.6 8.1 8.1v75.3c0 4.4-2.6 10.6-5.7 13.8l-16.3 16.3c-3.1 3.1-5.7 9.3-5.7 13.8v181.2c0 4.4-3.6 8.1-8.1 8.1h-56.9c-4.4 0-10.6 2.6-13.8 5.7l-139.2 139.2c-3.1 3.1-5.7 9.3-5.7 13.8l.1 53.1c0 4.4-2.6 10.6-5.7 13.8l-58.1 58.1c-3.1 3.1-9.3 5.7-13.8 5.7h-100c-4.4 0-10.5 2.7-13.5 5.9l-14 15.3c-3 3.3-8 3.4-11.2.2l-13.7-13.7c-3.1-3.1-8.1-3-11.1.3l-.1.1c-3 3.3-9 6-13.5 6H1098c-4.4 0-10.6 2.6-13.6 5.8L1071 1296c-3.1 3.2-9.2 5.8-13.6 5.8H948.9c-4.4 0-8.1-3.6-8.1-8.1v-148.3c0-4.4-2.6-10.6-5.7-13.8l-101.5-101.4c-3.1-3.1-5.7-9.3-5.7-13.8v-85.1c0-4.4 2.6-10.6 5.7-13.8l5.8-5.8c3.1-3.1 5.7-9.3 5.7-13.8v-59c0-4.4-2.6-10.6-5.7-13.8l-2.3-2.3c-3.1-3.1-5.7-9.3-5.7-13.8v-50.1c0-4.4-2.6-10.6-5.7-13.8l-77.9-77.8c-3.1-3.1-5.7-9.3-5.7-13.8v-6.8c0-4.4 3.6-8.1 8.1-8.1h245.4c4.4 0 10.6 2.6 13.8 5.7l18.7 18.7c3.1 3.1 9.3 5.7 13.8 5.7h72.1c4.4 0 10.6-2.6 13.8-5.7l22.8-22.8c3.1-3.1 9.3-5.7 13.8-5.7h48.4c4.4 0 10.6-2.6 13.8-5.7l46.9-46.9c3.1-3.1 9.3-5.7 13.8-5.7l59.2.3z"
              />
            </g>
          </g>
        </g>
        <defs>
          <path
            id="SVGID_00000015344007029565250040000015591301192104439736_"
            d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
          />
        </defs>
        <clipPath id="SVGID_00000002362008813788596910000005811088232410251674_">
          <use
            xlinkHref="#SVGID_00000015344007029565250040000015591301192104439736_"
            overflow="visible"
          />
        </clipPath>
        <g clipPath="url(#SVGID_00000002362008813788596910000005811088232410251674_)">
          <path
            className="st2"
            d="M2602.9 216.6c0 4.4-3.6 8.1-8.1 8.1l-261 .1c-4.4 0-10.6-2.6-13.8-5.7L2071.5-29.7c-3.1-3.1-2.1-5.7 2.4-5.7h11.1c4.4 0 10.6 2.6 13.8 5.7l230.8 230.4c3.1 3.1 9.3 5.7 13.8 5.7h251.5c4.4 0 8.1 3.6 8.1 8.1l-.1 2.1z"
          />
        </g>
        <defs>
          <path
            id="SVGID_00000065067731683967672910000014102354595602043010_"
            d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
          />
        </defs>
        <clipPath id="SVGID_00000005253584737273477030000005733689131320390585_">
          <use
            xlinkHref="#SVGID_00000065067731683967672910000014102354595602043010_"
            overflow="visible"
          />
        </clipPath>
        <g clipPath="url(#SVGID_00000005253584737273477030000005733689131320390585_)">
          <path
            className="st2"
            d="M2599.1 161.5c0 4.4-3.6 8.1-8.1 8.1l-183.8.1c-4.4 0-10.6-2.6-13.8-5.7L2195.8-33.8c-3.1-3.1-2.1-5.7 2.4-5.7l392.8-1.1c4.4 0 8.1 3.6 8.1 8v194.1z"
          />
        </g>
        <defs>
          <path
            id="SVGID_00000018948410152282599570000008123647602967401877_"
            d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
          />
        </defs>
        <clipPath id="SVGID_00000018939336311482907870000014833279132400550807_">
          <use
            xlinkHref="#SVGID_00000018948410152282599570000008123647602967401877_"
            overflow="visible"
          />
        </clipPath>
        <g clipPath="url(#SVGID_00000018939336311482907870000014833279132400550807_)">
          <path
            className="st2"
            d="M770.3 1561.9c-4.6 0-5.7 2.7-2.4 5.9l264.3 264.3c3.2 3.2 9.6 5.9 14.2 5.9h154.1c4.6 0 5.7-2.7 2.4-5.9l-264.5-264.5c-3.2-3.2-9.6-5.9-14.2-5.9l-153.9.2z"
          />
          <path
            className="st15"
            d="M770.3 1561.9c-4.6 0-5.7 2.7-2.4 5.9l264.3 264.3c3.2 3.2 9.6 5.9 14.2 5.9h154.1c4.6 0 5.7-2.7 2.4-5.9l-264.5-264.5c-3.2-3.2-9.6-5.9-14.2-5.9l-153.9.2z"
          />
        </g>
        <g>
          <defs>
            <path
              id="SVGID_00000064348078088353241240000014377511057385125299_"
              d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
            />
          </defs>
          <clipPath id="SVGID_00000147186205552322029110000009618551115080853378_">
            <use
              xlinkHref="#SVGID_00000064348078088353241240000014377511057385125299_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000147186205552322029110000009618551115080853378_)">
            <path
              className="st2"
              d="M829.5 1487.9v-16.7l.5-118.8c0-4.6 3.8-8.3 8.4-8.3h10.7c4.6 0 11 2.7 14.2 5.9l63.1 63.1c3.2 3.2 5.9 9.6 5.9 14.2V1542c0 4.6 2.7 11 5.9 14.2l15.2 15.2c3.2 3.2 9.6 5.9 14.2 5.9h507.7c4.6 0 11-2.7 14.2-5.9l34.1-34.1c3.2-3.2 9.6-5.9 14.2-5.9h397.8c4.6 0 11-2.7 14.2-5.9l120.6-120.6c3.2-3.2 9.6-5.9 14.2-5.9H2620c4.6 0 8.3 3.8 8.3 8.3V1831c0 4.6-3.8 8.3-8.3 8.3l-1465.7-6.3c-4.6 0-11-2.7-14.2-5.9l-247.4-247.4-11.8-11.8-45.6-45.5c-3.2-3.2-5.9-9.6-5.9-14.2l.1-20.3z"
            />
            <path
              className="st15"
              d="M829.5 1487.9v-16.7l.5-118.8c0-4.6 3.8-8.3 8.4-8.3h10.7c4.6 0 11 2.7 14.2 5.9l63.1 63.1c3.2 3.2 5.9 9.6 5.9 14.2V1542c0 4.6 2.7 11 5.9 14.2l15.2 15.2c3.2 3.2 9.6 5.9 14.2 5.9h507.7c4.6 0 11-2.7 14.2-5.9l34.1-34.1c3.2-3.2 9.6-5.9 14.2-5.9h397.8c4.6 0 11-2.7 14.2-5.9l120.6-120.6c3.2-3.2 9.6-5.9 14.2-5.9H2620c4.6 0 8.3 3.8 8.3 8.3V1831c0 4.6-3.8 8.3-8.3 8.3l-1465.7-6.3c-4.6 0-11-2.7-14.2-5.9l-247.4-247.4-11.8-11.8-45.6-45.5c-3.2-3.2-5.9-9.6-5.9-14.2l.1-20.3z"
            />
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGID_00000031189031657774787660000015545456628857173648_"
              d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
            />
          </defs>
          <clipPath id="SVGID_00000075133875456347625400000015562045817934818469_">
            <use
              xlinkHref="#SVGID_00000031189031657774787660000015545456628857173648_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000075133875456347625400000015562045817934818469_)">
            <path
              className="st4"
              d="M1164.8 1652.4h-16.7l-173.7.2c-4.6 0-5.7 2.7-2.4 5.9l116.9 116.9c3.2 3.2 8.8 5.9 12.4 5.9h10.5c1.8 0 2.7-.8 1.7-1.7-.9-.9.9-4.4 4.2-7.6l113.5-113.5c3.2-3.2 2.1-5.9-2.4-5.9l-64-.2z"
            />
            <path
              className="st15"
              d="M1164.8 1652.4h-16.7l-173.7.2c-4.6 0-5.7 2.7-2.4 5.9l116.9 116.9c3.2 3.2 8.8 5.9 12.4 5.9h10.5c1.8 0 2.7-.8 1.7-1.7-.9-.9.9-4.4 4.2-7.6l113.5-113.5c3.2-3.2 2.1-5.9-2.4-5.9l-64-.2z"
            />
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGID_00000081613605227425890550000015539780118697898376_"
              d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
            />
          </defs>
          <clipPath id="SVGID_00000168827051667380818940000003408260817957037720_">
            <use
              xlinkHref="#SVGID_00000081613605227425890550000015539780118697898376_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000168827051667380818940000003408260817957037720_)">
            <path
              className="st4"
              d="M1375.8 1652.5c-3.8 0-9.5 2.7-12.7 5.9l-116.9 116.9c-3.2 3.2-2.1 5.9 2.4 5.9h96.7c4.6 0 11-2.7 14.2-5.9l116.4-116.9c3.2-3.2 2.1-5.9-2.4-5.9h-97.7z"
            />
            <path
              className="st15"
              d="M1375.8 1652.5c-3.8 0-9.5 2.7-12.7 5.9l-116.9 116.9c-3.2 3.2-2.1 5.9 2.4 5.9h96.7c4.6 0 11-2.7 14.2-5.9l116.4-116.9c3.2-3.2 2.1-5.9-2.4-5.9h-97.7z"
            />
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGID_00000118365017678664165260000013788822358011180989_"
              d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
            />
          </defs>
          <clipPath id="SVGID_00000051375280689098301610000018192856256760174518_">
            <use
              xlinkHref="#SVGID_00000118365017678664165260000013788822358011180989_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000051375280689098301610000018192856256760174518_)">
            <path
              className="st4"
              d="M2323.2 1311.4c0 4.6-2.7 10.9-6 14.1l-71.1 68.5c-3.3 3.2-4.9 5.6-3.6 5.3 1.3-.2 5.1 2.2 8.3 5.4l10.9 10.9 11.8 11.8 62 62c3.2 3.2 9.6 5.9 14.2 5.9l146.5-.1c4.6 0 8.5-3.8 8.7-8.3l4.9-105.2c.2-4.6.4-12.1.3-16.7l-5.1-690.5c0-4.6-3.8-8.3-8.4-8.4l-131.3-.4c-4.6 0-8.3 3.7-8.3 8.3l1.8 344c0 4.6-1.2 11.9-2.8 16.2l-30 83.8c-1.6 4.3-2.8 11.6-2.8 16.2v177.2z"
            />
            <path
              className="st15"
              d="M2323.2 1311.4c0 4.6-2.7 10.9-6 14.1l-71.1 68.5c-3.3 3.2-4.9 5.6-3.6 5.3 1.3-.2 5.1 2.2 8.3 5.4l10.9 10.9 11.8 11.8 62 62c3.2 3.2 9.6 5.9 14.2 5.9l146.5-.1c4.6 0 8.5-3.8 8.7-8.3l4.9-105.2c.2-4.6.4-12.1.3-16.7l-5.1-690.5c0-4.6-3.8-8.3-8.4-8.4l-131.3-.4c-4.6 0-8.3 3.7-8.3 8.3l1.8 344c0 4.6-1.2 11.9-2.8 16.2l-30 83.8c-1.6 4.3-2.8 11.6-2.8 16.2v177.2z"
            />
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGID_00000110436241974352198800000014322827821639225020_"
              d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
            />
          </defs>
          <clipPath id="SVGID_00000035502154961076021850000012795520099265327285_">
            <use
              xlinkHref="#SVGID_00000110436241974352198800000014322827821639225020_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000035502154961076021850000012795520099265327285_)">
            <path
              className="st2"
              d="M2365.4 665.8c-4.6-.1-8.4 3.6-8.5 8.2l-7.8 462.4c-.1 4.6-3.2 10.4-7 13l-7.5 5.1c-3.8 2.6-6.9 8.4-6.9 13v145.2c0 4.6 2.6 11 5.9 14.2l59.1 59.1c3.2 3.2 3.1 8.4-.4 11.4l-32.8 28.7c-3.4 3-6.3 9.2-6.2 13.8l.1 12c0 4.6 2.7 11 5.9 14.2l18.3 18.3c3.2 3.2 9.6 5.9 14.2 5.9l100.6.4c4.6 0 5.7-2.6 2.4-5.9l-77.5-77.5c-3.2-3.2-5.9-9.6-5.9-14.2v-31.5V1230c0-4.6 2.6-11 5.9-14.2l117.4-117.7c3.2-3.2 5.9-9.7 6-14.2l3.4-406.4c0-4.6-3.7-8.4-8.3-8.5l-170.4-3.2z"
            />
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGID_00000093147135350933895990000014857112009399130761_"
              d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
            />
          </defs>
          <clipPath id="SVGID_00000135684894148478471160000015117566854234949787_">
            <use
              xlinkHref="#SVGID_00000093147135350933895990000014857112009399130761_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000135684894148478471160000015117566854234949787_)">
            <path
              className="st2"
              d="M2501.7 1148.8c-2.4-3.9-6.9-4.5-10.2-1.3L2423 1216c-3.2 3.2-5.9 9.6-5.9 14.2V1390.4c0 4.6 2.6 11 5.9 14.2l25.1 25.1 11.8 11.8 44.9 44.9c3.2 3.2 5.2 2.2 4.3-2.3l-5.2-27.4c-.9-4.5-1.7-11.9-2-16.5l-.8-16c-.2-4.6-.4-12.1-.4-16.7V1359v-131c0-4.6.7-12 1.5-16.5l4.3-24.1c.8-4.5 1.4-11.9 1.4-16.5l-.1-3.5c-.1-4.6-2-11.6-4.4-15.5l-1.7-3.1z"
            />
            <path
              className="st15"
              d="M2501.7 1148.8c-2.4-3.9-6.9-4.5-10.2-1.3L2423 1216c-3.2 3.2-5.9 9.6-5.9 14.2V1390.4c0 4.6 2.6 11 5.9 14.2l25.1 25.1 11.8 11.8 44.9 44.9c3.2 3.2 5.2 2.2 4.3-2.3l-5.2-27.4c-.9-4.5-1.7-11.9-2-16.5l-.8-16c-.2-4.6-.4-12.1-.4-16.7V1359v-131c0-4.6.7-12 1.5-16.5l4.3-24.1c.8-4.5 1.4-11.9 1.4-16.5l-.1-3.5c-.1-4.6-2-11.6-4.4-15.5l-1.7-3.1z"
            />
          </g>
        </g>
        <g>
          <defs>
            <path
              id="SVGID_00000109722360085517845980000004786075496884614287_"
              d="M2493.1 1761.3L33.8 1761.3 33.8 37.9 2493.4 37.9z"
            />
          </defs>
          <clipPath id="SVGID_00000144312141861575207390000003912556541454832294_">
            <use
              xlinkHref="#SVGID_00000109722360085517845980000004786075496884614287_"
              overflow="visible"
            />
          </clipPath>
          <g clipPath="url(#SVGID_00000144312141861575207390000003912556541454832294_)">
            <path
              className="st4"
              d="M1840.5 1660.4c-3 3.5-2.8 8.9.4 12.2l102.8 102.8c3.2 3.2 2.1 5.9-2.4 5.9h-96.7c-4.6 0-11-2.7-14.2-5.9L1714 1658.5c-3.2-3.2-2.1-5.9 2.4-5.9h31c4.6 0 11.1-2.6 14.4-5.7l33.2-31.1c3.3-3.1 9.8-5.7 14.4-5.7h40c4.6 0 11 2.7 14.2 5.9l2.4 2.4c3.2 3.2 3.4 8.7.4 12.2l-25.9 29.8z"
            />
            <path
              className="st15"
              d="M1840.5 1660.4c-3 3.5-2.8 8.9.4 12.2l102.8 102.8c3.2 3.2 2.1 5.9-2.4 5.9h-96.7c-4.6 0-11-2.7-14.2-5.9L1714 1658.5c-3.2-3.2-2.1-5.9 2.4-5.9h31c4.6 0 11.1-2.6 14.4-5.7l33.2-31.1c3.3-3.1 9.8-5.7 14.4-5.7h40c4.6 0 11 2.7 14.2 5.9l2.4 2.4c3.2 3.2 3.4 8.7.4 12.2l-25.9 29.8z"
            />
          </g>
        </g>
        <g>
          <path
            d="M1938.4 1021.9c-4.4 0-8.1-3.7-8.1-8.1V910.3c0-4.4-2.6-10.7-5.7-13.8l-32.6-32.6c-3.1-3.1-5.7-9.3-5.7-13.8v-32.2c0-4.4 2.6-10.7 5.7-13.8l32.6-32.6c3.1-3.1 5.7-9.3 5.7-13.8v-177c0-4.4-2.5-10.6-5.5-13.6s-9.2-5.5-13.6-5.5h-18.3c-4.4 0-10.7-2.6-13.8-5.7l-3.4-3.3c-3.2-3.1-5.7-9.3-5.7-13.8l.1-15.4c0-4.4 2.6-10.7 5.7-13.8l3.3-3.3c3.1-3.1 9.3-5.7 13.8-5.7h65.1c4.4 0 10.7 2.6 13.8 5.7l44 44c3.1 3.1 9.3 5.7 13.8 5.7h47.4c4.4 0 10.6 2.6 13.8 5.7l2.6 2.6c3.1 3.1 5.7 9.3 5.7 13.8v76c0 4.4-2.6 10.7-5.7 13.8l-37.8 37.8c-3.1 3.1-3.1 8.3 0 11.4l24.6 24.6c3.1 3.1 5.7 9.3 5.7 13.8V873c0 4.4-3.6 8.1-8.1 8.1l-39.8.1c-4.4 0-10.7 2.6-13.8 5.7l-16.4 16.4c-3.1 3.2-5.7 9.4-5.7 13.8v51.8c0 4.4-2.6 10.7-5.7 13.8l-33.5 33.5c-3.1 3.1-9.3 5.7-13.8 5.7h-10.7z"
            fill="#e2e3e4"
          />
          <path
            d="M1938.4 1021.9c-4.4 0-8.1-3.7-8.1-8.1V910.3c0-4.4-2.6-10.7-5.7-13.8l-32.6-32.6c-3.1-3.1-5.7-9.3-5.7-13.8v-32.2c0-4.4 2.6-10.7 5.7-13.8l32.6-32.6c3.1-3.1 5.7-9.3 5.7-13.8v-177c0-4.4-2.5-10.6-5.5-13.6s-9.2-5.5-13.6-5.5h-18.3c-4.4 0-10.7-2.6-13.8-5.7l-3.4-3.3c-3.2-3.1-5.7-9.3-5.7-13.8l.1-15.4c0-4.4 2.6-10.7 5.7-13.8l3.3-3.3c3.1-3.1 9.3-5.7 13.8-5.7h65.1c4.4 0 10.7 2.6 13.8 5.7l44 44c3.1 3.1 9.3 5.7 13.8 5.7h47.4c4.4 0 10.6 2.6 13.8 5.7l2.6 2.6c3.1 3.1 5.7 9.3 5.7 13.8v76c0 4.4-2.6 10.7-5.7 13.8l-37.8 37.8c-3.1 3.1-3.1 8.3 0 11.4l24.6 24.6c3.1 3.1 5.7 9.3 5.7 13.8V873c0 4.4-3.6 8.1-8.1 8.1l-39.8.1c-4.4 0-10.7 2.6-13.8 5.7l-16.4 16.4c-3.1 3.2-5.7 9.4-5.7 13.8v51.8c0 4.4-2.6 10.7-5.7 13.8l-33.5 33.5c-3.1 3.1-9.3 5.7-13.8 5.7h-10.7z"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
          />
        </g>
        <g>
          <text transform="translate(1183.388 1664.35)" className="st25 st26" />
          <text transform="translate(1353.852 1664.35)" className="st25 st26" />
          <text transform="translate(1321.929 1689.49)" className="st25 st26" />
          <text transform="translate(1334.873 1714.62)" className="st25 st26" />
          <text transform="translate(1364.097 1739.76)" className="st25 st26" />
        </g>
        <path
          className="st27"
          d="M1194.1 1652.5H1375.6999999999998V1676H1194.1z"
        />
        <path
          className="st27"
          d="M1454.4 1652.5H1721.1000000000001V1661.9H1454.4z"
        />
      </g>
      <g id="Zones_numbers_and_boxes">
        <path
          className="st28"
          d="M1248.6 1419.5H1336.8999999999999V1442.4H1248.6z"
        />
        <path
          className="st28"
          d="M1626.4 643.2H1680.6000000000001V666.1H1626.4z"
        />
        <path className="st28" d="M1786.2 494.4H1840.4V517.3H1786.2z" />
        <path className="st28" d="M2019.3 569.6H2094.2V592.5H2019.3z" />
        <path className="st28" d="M2019.3 732.6H2067.3V765.4H2019.3z" />
        <path
          className="st28"
          d="M2019.3 794.8H2082.7V817.6999999999999H2019.3z"
        />
        <path
          className="st28"
          d="M2125.4 654.6H2189.2000000000003V677.5H2125.4z"
        />
        <path className="st28" d="M1867 1245.5H1960.7V1266.4H1867z" />
        <path className="st28" d="M1867 1269.8H1972.1V1290.7H1867z" />
        <path
          className="st28"
          d="M1867 1294.4H1961.7V1315.3000000000002H1867z"
        />
        <path
          className="st28"
          d="M1867 1318.9H1954.1V1339.8000000000002H1867z"
        />
        <path
          className="st28"
          d="M980.2 1413.5H1073.1000000000001V1434.4H980.2z"
        />
        <path className="st28" d="M735.6 1235.5H811.6V1256.4H735.6z" />
        <path
          className="st28"
          d="M233.9 1156.9H313.6V1177.8000000000002H233.9z"
        />
        <path className="st28" d="M517 1137.7H598.9V1158.6000000000001H517z" />
        <path
          className="st28"
          d="M1526.4 1453.5H1627.8000000000002V1474.4H1526.4z"
        />
        <path
          className="st28"
          d="M967.2 1538.2H1078.2V1559.1000000000001H967.2z"
        />
        <path className="st28" d="M1867 1197H1994.2V1226.8H1867z" />
        <path className="st28" d="M1937.5 900.5H1970.4V936.5H1937.5z" />
        <path
          className="st28"
          d="M1932.2 657H1987.6000000000001V688.7H1932.2z"
        />
        <path className="st28" d="M1882.5 523.3H1964.1V555H1882.5z" />
        <path
          className="st28"
          d="M2019.3 614.7H2094.8V646.4000000000001H2019.3z"
        />
        <path
          className="st28"
          d="M2019.3 660.6H2065.1V692.3000000000001H2019.3z"
        />
        <path className="st28" d="M2019.3 844.8H2076.2V876.5H2019.3z" />
        <path className="st28" d="M1934.5 732.5H1987.7V762.9H1934.5z" />
        <path
          className="st28"
          d="M1912 1017.1L1948.6 1017.1 1982.3 989.5 1982.3 1048.1 1912 1048.1z"
        />
        <path
          className="st28"
          d="M552.4 529.8H667.9V551.1999999999999H552.4z"
        />
        <path className="st28" d="M388 210.2H451.6V231.6H388z" />
        <path
          className="st28"
          d="M870.3 427.2H972.4V448.59999999999997H870.3z"
        />
        <path className="st28" d="M1138.7 399.3H1210.8V420.7H1138.7z" />
        <path className="st28" d="M1054.1 313.5H1155.3V334.9H1054.1z" />
        <path className="st28" d="M955.5 339.5H1015.3V360.9H955.5z" />
        <path
          className="st28"
          d="M1341.9 366.2H1397.7V387.59999999999997H1341.9z"
        />
        <path className="st28" d="M1534.8 357.5H1579.2V387.4H1534.8z" />
        <path
          className="st28"
          d="M1490.7 249.9H1579.1000000000001V271.3H1490.7z"
        />
        <path className="st28" d="M2004.6 423.6H2080.9V445H2004.6z" />
        <path
          className="st28"
          d="M2118.9 454.9H2194.7000000000003V475.29999999999995H2118.9z"
        />
        <path className="st28" d="M566.1 865.5H606V895.1H566.1z" />
        <path className="st28" d="M518 1019.6H576.5V1050.3H518z" />
        <path className="st28" d="M818.8 1019.5H859V1052.1H818.8z" />
        <path className="st28" d="M854.1 829.9H911.6V858.1H854.1z" />
        <path
          className="st29"
          d="M1024 1281.7H1092.7V1301.6000000000001H1024z"
        />
        <path className="st29" d="M1132.7 1246.1H1205.7V1266H1132.7z" />
        <text transform="translate(1699.164 862.694)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(1896.002 851.893)" className="st25 st26" />
        <text transform="translate(1896.002 851.893)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(1927.062 851.893)" className="st25 st26" />
        <text transform="translate(1926.422 851.893)" className="st4 st30 st31">
          {"/"}
        </text>
        <text transform="translate(1949.245 851.893)" className="st25 st26" />
        <text transform="translate(1948.962 851.893)" className="st4 st30 st31">
          {"3"}
        </text>
        <text transform="translate(1979.534 851.893)" className="st25 st26" />
        <text transform="translate(2290.225 700.646)" className="st4 st30 st31">
          {"4"}
        </text>
        <text
          transform="translate(2158.482 851.893)"
          className="st32 st30 st31"
        >
          {"3"}
        </text>
        <text transform="translate(1855.17 657.905)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(1121.925 575.435)" className="st4 st30 st31">
          {"2"}
        </text>
        <text
          transform="translate(1344.437 1390.673)"
          className="st4 st30 st31"
        >
          {"2"}
        </text>
        <text transform="translate(259.284 91.349)" className="st4 st30 st31">
          {"8"}
        </text>
        <text transform="translate(618.977 171.286)" className="st4 st30 st31">
          {"8"}
        </text>
        <text transform="translate(876.22 219.02)" className="st4 st30 st31">
          {"6"}
        </text>
        <text transform="translate(83.5 470.437)" className="st4 st30 st31">
          {"6"}
        </text>
        <text transform="translate(1858.276 91.349)" className="st4 st30 st31">
          {"8"}
        </text>
        <text transform="translate(1567.998 1103.25)" className="st4 st30 st31">
          {"2"}
        </text>
        <text
          transform="translate(2177.773 1332.347)"
          className="st4 st30 st31"
        >
          {"4"}
        </text>
        <text
          transform="translate(2346.077 1319.166)"
          className="st4 st30 st31"
        >
          {"6"}
        </text>
        <text
          transform="translate(2440.822 1334.511)"
          className="st4 st30 st31"
        >
          {"8"}
        </text>
        <text transform="translate(1936.076 367.806)" className="st4 st30 st31">
          {"4"}
        </text>
        <text transform="translate(2162.981 175.647)" className="st4 st30 st31">
          {"6"}
        </text>
        <text transform="translate(2124.646 219.5)" className="st32 st30 st31">
          {"5"}
        </text>
        <text transform="translate(2245.88 99.014)" className="st32 st30 st31">
          {"9"}
        </text>
        <text
          transform="translate(1517.331 867.573)"
          className="st32 st30 st31"
        >
          {"1"}
        </text>
        <text transform="translate(2000.98 1320.69)" className="st32 st30 st31">
          {"3"}
        </text>
        <text
          transform="translate(2304.228 1450.699)"
          className="st32 st30 st31"
        >
          {"5"}
        </text>
        <text transform="translate(665.216 1141.596)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(664.45 1278.808)" className="st32 st30 st31">
          {"3"}
        </text>
        <text transform="translate(795.99 1499.91)" className="st32 st30 st31">
          {"3"}
        </text>
        <text
          transform="translate(1938.611 455.194)"
          className="st32 st30 st31"
        >
          {"3"}
        </text>
        <text transform="translate(345.835 798.097)" className="st32 st30 st31">
          {"3"}
        </text>
        <text transform="translate(925.752 798.097)" className="st32 st30 st31">
          {"1"}
        </text>
        <text
          transform="translate(1159.022 1176.023)"
          className="st32 st30 st31"
        >
          {"1"}
        </text>
        <text transform="translate(1350.11 1503.6)" className="st32 st30 st31">
          {"3"}
        </text>
        <text
          transform="translate(1526.694 1388.225)"
          className="st32 st30 st31"
        >
          {"3"}
        </text>
        <text
          transform="translate(1496.063 1543.547)"
          className="st32 st30 st31"
        >
          {"5"}
        </text>
        <text
          transform="translate(1096.598 1751.851)"
          className="st32 st30 st31"
        >
          {"5"}
        </text>
        <text
          transform="translate(1337.137 1751.851)"
          className="st32 st30 st31"
        >
          {"5"}
        </text>
        <text
          transform="translate(1829.316 1751.851)"
          className="st32 st30 st31"
        >
          {"5"}
        </text>
        <text transform="translate(1220.66 374.854)" className="st32 st30 st31">
          {"3"}
        </text>
        <text transform="translate(969.699 217.348)" className="st32 st30 st31">
          {"5"}
        </text>
        <text
          transform="translate(1593.018 184.785)"
          className="st32 st30 st31"
        >
          {"5"}
        </text>
        <text transform="translate(1933.024 92.517)" className="st32 st30 st31">
          {"7"}
        </text>
        <text transform="translate(157.385 92.515)" className="st32 st30 st31">
          {"9"}
        </text>
        <text transform="translate(385.952 92.515)" className="st32 st30 st31">
          {"7"}
        </text>
        <text transform="translate(162.521 628.818)" className="st25 st26" />
        <text transform="translate(162.521 628.818)" className="st33 st30 st34">
          {"Outside"}
        </text>
        <text transform="translate(220.083 628.818)" className="st25 st26" />
        <text transform="translate(175.521 644.248)" className="st33 st30 st34">
          {"fare"}
        </text>
        <text transform="translate(206.356 644.248)" className="st25 st26" />
        <text transform="translate(169.841 659.688)" className="st33 st30 st34">
          {"zones"}
        </text>
        <text transform="translate(208.938 659.688)" className="st25 st26" />
        <text transform="translate(805.409 218.453)" className="st32 st30 st31">
          {"7"}
        </text>
        <text transform="translate(211.73 1022.356)" className="st32 st30 st31">
          {"5"}
        </text>
        <text
          transform="translate(386.608 1278.808)"
          className="st32 st30 st31"
        >
          {"5"}
        </text>
        <text
          transform="translate(1855.527 1464.155)"
          className="st4 st30 st31"
        >
          {"4"}
        </text>
        <text transform="translate(967.391 1751.36)" className="st4 st30 st31">
          {"4"}
        </text>
        <text transform="translate(1196.615 1751.36)" className="st4 st30 st31">
          {"4"}
        </text>
        <text transform="translate(1591.532 1751.36)" className="st4 st30 st31">
          {"6"}
        </text>
        <text
          transform="translate(1427.547 1530.995)"
          className="st4 st30 st31"
        >
          {"4"}
        </text>
        <text transform="translate(1139.632 256.687)" className="st4 st30 st31">
          {"4"}
        </text>
        <text transform="translate(284.192 913.693)" className="st4 st30 st31">
          {"4"}
        </text>
        <text transform="translate(591.97 798.097)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(534.367 1278.808)" className="st4 st30 st31">
          {"4"}
        </text>
        <text transform="translate(252.864 1278.808)" className="st4 st30 st31">
          {"6"}
        </text>
        <text transform="translate(75.632 1018.995)" className="st4 st30 st31">
          {"6"}
        </text>
        <path className="st28" d="M2126.5 481.2H2208.9V512.1H2126.5z" />
        <text transform="translate(1156.889 60.081)" className="st25 st26" />
        <text transform="translate(1156.889 60.081)" className="st32 st30 st35">
          {"Outside fare"}
        </text>
        <text transform="translate(1257.038 60.081)" className="st25 st26" />
        <text transform="translate(1182.659 78.231)" className="st32 st30 st35">
          {"zones"}
        </text>
        <text transform="translate(1228.864 78.231)" className="st25 st26" />
        <text transform="translate(2369.794 80.304)" className="st25 st26" />
        <text transform="translate(2369.794 80.304)" className="st4 st30 st35">
          {"Outside fare"}
        </text>
        <text transform="translate(2469.943 80.304)" className="st25 st26" />
        <text transform="translate(2395.564 98.454)" className="st4 st30 st35">
          {"zones"}
        </text>
        <text transform="translate(2441.769 98.454)" className="st25 st26" />
        <text transform="translate(1699.164 862.694)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(1855.17 657.905)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(1121.925 575.435)" className="st4 st30 st31">
          {"2"}
        </text>
        <text
          transform="translate(1344.437 1390.673)"
          className="st4 st30 st31"
        >
          {"2"}
        </text>
        <text transform="translate(1567.998 1103.25)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(665.216 1141.596)" className="st4 st30 st31">
          {"2"}
        </text>
        <text transform="translate(591.97 798.097)" className="st4 st30 st31">
          {"2"}
        </text>
        <path className="st36" d="M3421 8.5H6298.2V1794.3H3421z" />
      </g>
      <g id="River">
        <path
          className="st37"
          d="M35.9 1340.7h411.6c7.5 0 13.5-6.1 13.5-13.5v-187.3c0-14.4 11.7-26.2 26.1-26.2l119.9-.1c7.2 0 13.8 2.9 18.5 7.7 4.7 4.7 88.4 88.3 90.9 90.8 2.4 2.4 5.8 3.9 9.6 3.9h337.4c5.5 0 9.9-4.4 9.9-9.9v-133.6c0-14.4 11.7-26.2 26.1-26.2l222.7.1c2.7-.1 5.2-1.2 7.1-3.1l70-68.2 2.5-2.5c4.9-5.1 11.8-8.1 19.1-8h304.7c15.2 0 27.4 12.3 27.4 27.5v174.7c0 4.4 3.6 8 8 8h121.9c4.6 0 8.4-3.8 8.4-8.4V1000c0-15.9 12.9-28.9 28.8-28.9h130.3c17.5 0 31.8 14.2 31.8 31.7v138.6c0 3.9 3.2 7.1 7.1 7.1h96.6v22.8h-91.4c-18.4 0-33.3-14.9-33.3-33.3V999.7c0-5.1-4.1-9.2-9.2-9.2H1919c-4.6 0-8.4 3.8-8.4 8.4v166.4c0 15.9-12.9 28.9-28.8 28.9H1761c-15.2 0-27.5-12.3-27.5-27.4V991.2c0-5.8-4.7-10.4-10.4-10.4l-302.4.1c-2.7.1-5.2 1.2-7.1 3l-72.5 70.7c-4.9 5.1-11.8 8.1-19.1 8h-222.1c-5.8 0-10.4 4.7-10.4 10.4v129.8c0 14.4-11.7 26.2-26.1 26.2H725.6c-7.2 0-13.8-2.9-18.5-7.7s-88.5-88.4-90.9-90.9c-2.5-2.5-5.8-4-9.6-4l-119.2.1c-7.5 0-13.5 6.1-13.5 13.5v187.3c0 14.4-11.7 26.2-26.1 26.2H35.9v-12.8"
        />
        <path
          className="st38"
          d="M2185.9 1171.3h-91.2c-18.4 0-33.3-14.9-33.3-33.3V999.7c0-5.1-4.1-9.2-9.2-9.2h-132.8c-4.6 0-8.4 3.8-8.4 8.4v166.4c0 15.9-12.9 28.9-28.8 28.9h-120.8c-15.2 0-27.5-12.3-27.5-27.4V991.2c0-5.8-4.7-10.4-10.4-10.4l-302.4.1c-2.7.1-5.2 1.2-7.1 3l-72.5 70.7c-4.9 5.1-11.8 8.1-19.1 8h-222.1c-5.8 0-10.4 4.7-10.4 10.4v129.8c0 14.4-11.7 26.2-26.1 26.2H726c-7.2 0-13.8-2.9-18.5-7.7s-88.5-88.4-90.9-90.9c-2.5-2.5-5.8-4-9.6-4l-119.2.1c-7.5 0-13.5 6.1-13.5 13.5v187.3c0 14.4-11.7 26.2-26.1 26.2H35.9"
        />
        <path
          className="st37"
          d="M2495.3 651.5h-121c-17.9 0-32.4 14.5-32.4 32.3v457.3c0 4-3.2 7.3-7.2 7.5H2175v22.8h157.2c18.8.2 34-15 34-33.8V684.9c0-5.2 4.2-9.4 9.4-9.4h119.9l-.2-24z"
        />
        <path
          d="M2174.9 1171.3h157c18.8.2 34-15 34-33.8V684.8c0-5.2 4.2-9.4 9.4-9.4h120.1l-.1-24.1h-121.2c-17.9 0-32.4 14.5-32.4 32.3V1141c0 4-3.2 7.3-7.2 7.5H2175"
          fill="none"
          stroke="#00aeef"
          strokeWidth={0.6525}
        />
        <path
          className="st38"
          d="M35.9 1340.7h411.8c7.5 0 13.5-6.1 13.5-13.5v-187.3c0-14.4 11.7-26.2 26.1-26.2l119.9-.1c7.2 0 13.8 2.9 18.5 7.7 4.7 4.7 88.4 88.3 90.9 90.8 2.4 2.4 5.8 3.9 9.6 3.9h337.4c5.5 0 9.9-4.4 9.9-9.9v-133.6c0-14.4 11.7-26.2 26.1-26.2l222.7.1c2.7-.1 5.2-1.2 7.1-3.1l70-68.2 2.5-2.5c4.9-5.1 11.8-8.1 19.1-8h304.7c15.2 0 27.4 12.3 27.4 27.5v174.7c0 4.4 3.6 8 8 8H1883c4.6 0 8.4-3.8 8.4-8.4V1000c0-15.9 12.9-28.9 28.8-28.9h130.3c17.5 0 31.8 14.2 31.8 31.7v138.6c0 3.9 3.2 7.1 7.1 7.1h96.4"
        />
        <text
          transform="matrix(.9995 0 0 1 1598.367 976.08)"
          className="st25 st26"
        />
        <text
          transform="matrix(.9995 0 0 1 1598.367 976.08)"
          className="st40 st30 st41"
        >
          {"Ri"}
        </text>
        <text
          transform="matrix(.9995 0 0 1 1606.515 976.08)"
          className="st25 st26"
        />
        <text
          transform="matrix(.9995 0 0 1 1606.514 976.08)"
          className="st40 st30 st41"
        >
          {"v"}
        </text>
        <text
          transform="matrix(.9995 0 0 1 1611.347 976.08)"
          className="st25 st26"
        />
        <text
          transform="matrix(.9995 0 0 1 1611.26 976.08)"
          className="st40 st30 st41"
        >
          {"er Thames"}
        </text>
        <text
          transform="matrix(.9995 0 0 1 1656.052 976.08)"
          className="st25 st26"
        />
        <path
          className="st42"
          d="M856 1207.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M856 1223.9c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.2-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M851 1218l-1.8-2.4h1.8l1.1-1.4s0-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.2-1.9.1-2.3.3zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.5h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1H854v1.1zM1089.8 1187.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1089.8 1203.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7s-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1084.8 1198l-1.8-2.4h1.8l1.1-1.4s.1-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.2-1.9.1-2.3.3zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm-.1-3.5h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1zM995.2 1220.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M995.2 1236.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.4 7.7 7.7-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M990.2 1230.4l-1.8-2.4h1.8l1.1-1.4s0-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.2-1.9.1-2.3.3zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm-.1-3.5h1.7v-1.1h-.6s-.1 0-.3.1l-.3.3-.5.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1zM1133.4 1037.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1133.4 1054.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1128.4 1048.2l-1.8-2.4h1.8l1.1-1.4s.1-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.1-1.9.2-2.3.3zm.7 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.5h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1zM1515.6 972.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1515.6 988.4c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1510.6 982.5l-1.8-2.4h1.8l1.1-1.4s.1 0 .2-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.5-.7-.1-1.9.2-2.3.4zm.7 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.5h1.7v-1h-.7s-.1 0-.3.1l-.3.3-.4.6zm4.4 0h1.8v-1h-1.8v1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1h1.9l-.4-.7zm-6 .8h1.8v-1h-1.8v1zM1578.4 955.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1578.4 971.7c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1573.4 965.8l-1.8-2.4h1.8l1.1-1.4s.1 0 .2-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.5-.8-.1-1.9.2-2.3.4zm.7 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.6h1.7v-1h-.7s-.1 0-.3.1l-.3.3-.4.6zm4.4 0h1.8v-1h-1.8v1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1h1.9l-.4-.7zm-6 .8h1.8v-1h-1.8v1zM1178.4 1053.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1178.4 1070c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1173.3 1064.1l-1.8-2.4h1.8l1.1-1.4s.1-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.2-1.8.1-2.3.3zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.6h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1zM1267.9 1037.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1267.9 1054.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1262.8 1048.2l-1.8-2.4h1.8l1.1-1.4s.1-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.1-1.9.2-2.3.3zm.8 1.2c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.6h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1zM1851.3 1185.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1851.3 1201.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1846.2 1196l-1.8-2.4h1.8l1.1-1.4s.1-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.2-1.9.1-2.3.3zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.5h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1zM1945.5 982.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1945.5 998.4c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1940.4 992.5l-1.8-2.4h1.8l1.1-1.4s.1 0 .2-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.5-.7-.1-1.9.2-2.3.4zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.6h1.7v-1h-.7s-.1 0-.3.1l-.3.3-.4.6zm4.4 0h1.8v-1h-1.8v1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1h1.9l-.4-.7zm-6 .8h1.8v-1h-1.8v1zM1361.2 1004c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1361.2 1020.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1356.2 1014.3l-1.8-2.4h1.8l1.1-1.4s.1 0 .2-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.5-.7-.1-1.9.3-2.3.4zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm-.1-3.5h1.7v-1h-.7s-.1 0-.3.1l-.3.3-.4.6zm4.4 0h1.8v-1h-1.8v1zm3.9-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1h1.9l-.4-.7zm-6.1.8h1.8v-1h-1.8v1zM791.8 1204.9l-1.8-2.4h1.8l1.1-1.4s0-.1.2-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.3-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.2-1.9.1-2.3.3zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.3.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.2-.1-1.7-.2-1.8-.4-2.6-.1-3.5.1l.3.7zm0-3.5h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1H797v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1z"
        />
        <g>
          <path
            className="st42"
            d="M2160.6 1162.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2160.6 1179.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <path
            className="st42"
            d="M2155.5 1173.2l-1.8-2.4h1.8l1.1-1.4.1-.1c.1-.1.3-.1.3-.1h1.4v-.5h.6l.4-.8h.5l-.2.5.3.4h1.7v.5h2.7s.2 0 .4.1c.2.2.2.3.2.3l.4 1.2h1l.9 2.4s-1.1-.7-2.8-.6c-1.4.1-1.9.6-3.5.6-.9 0-2.2-.4-3.2-.4-.7-.1-1.9.2-2.3.3zm.8 1.1c.6-.2 1.4-.4 2.8-.1.7.1 1.4.3 2 .3.8 0 1.3-.2 2-.3.6-.2 1.3-.3 1.8-.3.9 0 1.6.2 2 .3l-.3-.8c-.7-.2-2-.4-3.5 0-.6.2-1.2.3-1.9.3-.6 0-1.1-.1-1.7-.2-1.9-.4-2.6-.1-3.5.1l.3.7zm0-3.5h1.7v-1.1h-.7s-.1 0-.3.1l-.3.3-.4.7zm4.4 0h1.8v-1.1h-1.8v1.1zm3.8-.8s0-.1-.1-.2-.2-.1-.2-.1h-1.2v1.1h1.9l-.4-.8zm-6 .8h1.8v-1.1h-1.8v1.1z"
          />
        </g>
      </g>
      <g id="Thameslink">
        <path
          id="XMLID_209_"
          className="st43"
          d="M1346.9 743.5l5.2 5.2c3.1 3.1 5.7 9.2 5.7 13.6v34.5"
        />
        <path
          className="st44"
          d="M1008.2 392.5H1014.9000000000001V396.3H1008.2z"
        />
        <path
          id="XMLID_91_"
          transform="rotate(-45.001 2376.47 1389.127)"
          className="st44"
          d="M2373.1 1387.2H2379.7999999999997V1391H2373.1z"
        />
        <path
          id="XMLID_110_"
          className="st44"
          d="M2384.9 1364.4H2388.7000000000003V1371.1000000000001H2384.9z"
        />
        <path
          id="XMLID_69_"
          className="st44"
          d="M2219 1364.4H2222.8V1371.1000000000001H2219z"
        />
        <path
          id="XMLID_65_"
          className="st44"
          d="M1924.6 1364.4H1928.3999999999999V1371.1000000000001H1924.6z"
        />
        <path
          id="XMLID_71_"
          className="st44"
          d="M2167.4 1371.3H2171.2000000000003V1378H2167.4z"
        />
        <path
          id="XMLID_72_"
          className="st44"
          d="M1993.2 1371.3H1997V1378H1993.2z"
        />
        <path
          id="XMLID_73_"
          className="st44"
          d="M1924.6 1371.3H1928.3999999999999V1378H1924.6z"
        />
        <path
          id="XMLID_92_"
          transform="rotate(-45.001 1769.861 1320.104)"
          className="st44"
          d="M1766.5 1318.2H1773.2V1322H1766.5z"
        />
        <path className="st44" d="M1460.2 191.7H1466.9V195.5H1460.2z" />
        <path
          className="st44"
          d="M1460.2 236.9H1466.9V240.70000000000002H1460.2z"
        />
        <path
          id="XMLID_89_"
          className="st44"
          d="M1569.6 1679.9H1573.3999999999999V1686.6000000000001H1569.6z"
        />
        <path
          id="XMLID_148_"
          className="st44"
          d="M1248 1321.1H1254.7V1324.8999999999999H1248z"
        />
        <path
          id="XMLID_156_"
          className="st44"
          d="M785.4 1541.2H792.1V1545H785.4z"
        />
        <path
          id="XMLID_153_"
          className="st44"
          d="M1163.9 1510.5H1167.7V1517.2H1163.9z"
        />
        <path
          id="XMLID_166_"
          className="st44"
          d="M1035.5 1695.8H1039.3V1702.5H1035.5z"
        />
        <path
          id="XMLID_155_"
          transform="rotate(-45.001 985.523 1481.278)"
          className="st44"
          d="M982.2 1479.4H988.9000000000001V1483.2H982.2z"
        />
        <path
          id="XMLID_158_"
          transform="rotate(-45.001 809.86 1590.803)"
          className="st44"
          d="M806.5 1588.9H813.2V1592.7H806.5z"
        />
        <path
          id="XMLID_160_"
          transform="rotate(-45.001 836.832 1617.773)"
          className="st44"
          d="M833.5 1615.9H840.2V1619.7H833.5z"
        />
        <path
          id="XMLID_164_"
          transform="rotate(-45.001 880.1 1661.043)"
          className="st44"
          d="M876.8 1659.1H883.5V1662.8999999999999H876.8z"
        />
        <path
          id="XMLID_163_"
          transform="rotate(-45.001 906.237 1687.176)"
          className="st44"
          d="M902.9 1685.3H909.6V1689.1H902.9z"
        />
        <path
          id="XMLID_146_"
          className="st44"
          d="M1695.6 1679.9H1699.3999999999999V1686.6000000000001H1695.6z"
        />
        <path
          id="XMLID_154_"
          className="st44"
          d="M1569.6 1679.9H1573.3999999999999V1686.6000000000001H1569.6z"
        />
        <path
          id="XMLID_140_"
          transform="rotate(-45.001 1778.386 1675.243)"
          className="st44"
          d="M1776.5 1671.9H1780.3V1678.6000000000001H1776.5z"
        />
        <path className="st43" d="M1357.8 775.5L1357.8 893.5" />
        <path
          id="XMLID_200_"
          className="st43"
          d="M1435.1 1038.4v-10.2c0-4.4-2.5-10.5-5.7-13.6l-66-66c-3.1-3.1-5.7-9.2-5.7-13.6v-63.5"
        />
        <path className="st46" d="M1357.8 775.5L1357.8 782.6" />
        <path
          fill="none"
          stroke="#fff"
          strokeWidth={2.0207}
          strokeLinejoin="round"
          strokeDasharray="14.8266,8.8959"
          d="M1357.8 791.5L1357.8 881.9"
        />
        <path className="st46" d="M1357.8 886.4L1357.8 893.5" />
        <g id="XMLID_00000119100400540663415050000008350702927621030547_">
          <path className="st46" d="M1435.1 1038.4L1435.1 1031.3" />
          <path
            d="M1434.3 1023.2c-1-3.3-2.8-6.6-4.8-8.6l-66-66c-3.1-3.1-5.7-9.2-5.7-13.6v-52.3"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0207}
            strokeLinejoin="round"
            strokeDasharray="13.6605,8.1963"
          />
          <path className="st46" d="M1357.8 878.4v-7.1" />
        </g>
        <path id="XMLID_175_" className="st43" d="M1425.4 1010.5l-47.3-47.3" />
        <path className="st43" d="M1431.7 462.8L1438.1 456.5" />
        <path
          id="XMLID_121_"
          className="st43"
          d="M1438 456.5l-57.2 57.3c-3.1 3.1-5.7 9.2-5.7 13.6l.1 10.1"
        />
        <path
          id="XMLID_120_"
          className="st43"
          d="M1326.1 643.4l43.4-43.4c3.1-3.1 5.7-9.2 5.7-13.6v-31"
        />
        <path
          className="st43"
          d="M1543.9 409.2v.4c0-4.4-2.5-10.5-5.7-13.6l-28.7-28.7M1467.2 72.3v244.9c0 4.4 2.5 10.5 5.7 13.6l44.5 44.3M1622.7 1138.4h-61.3c-4.4 0-10.5-2.5-13.6-5.7M785.3 1541.6V1510M889.5 1675.2l-98.5-98.5c-3.1-3.1-5.7-9.2-5.7-13.6v-21.4"
        />
        <path
          id="XMLID_70_"
          className="st43"
          d="M1247.7 1642.8v24.6c0 4.4-2.4 11.5-5.7 14.5-1.9 1.8-5.2 5.3-8.7 8.8"
        />
        <path
          className="st43"
          d="M960.7 1702.2h-36.2c-4.4 0-10.5-2.5-13.6-5.7l-33.5-33.5"
        />
        <path
          className="st43"
          d="M1233.6 1690.4l-7 6.8c-3.1 3.1-9.2 5-13.6 5H956.3"
        />
        <path
          id="XMLID_00000145746328809957130290000018370991788164990358_"
          className="st43"
          d="M1247.7 1660.8l.3-343.7c0-5.3 2.2-10.3 6.1-13.9l19.8-18.2v-68.2c0-8.2 3.3-16 9.2-21.7l146.3-142.2c3.1-3.1 5.7-9.2 5.7-13.6v-11"
        />
        <g id="XMLID_00000161589328738359175210000002306609261230726832_">
          <path className="st46" d="M1247.7 1660.8L1247.7 1653.7" />
          <path
            d="M1247.7 1645.2l.3-328.1c0-5.3 2.2-10.3 6.1-13.9l11.5-10.6"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0207}
            strokeLinejoin="round"
            strokeDasharray="14.2036,8.5222"
          />
          <path
            className="st46"
            d="M1268.7 1289.7L1273.9 1284.9 1273.9 1277.8"
          />
          <path
            d="M1273.9 1269.2v-52.5c0-8.2 3.3-16 9.2-21.7l146.3-142.2c3-3 5.5-8.9 5.6-13.2"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0207}
            strokeLinejoin="round"
            strokeDasharray="14.4095,8.6457"
          />
          <path className="st46" d="M1435.1 1035.2L1435.1 1028.1" />
        </g>
        <path
          id="XMLID_194_"
          className="st2"
          d="M1581.5 1275.4H1591.8V1296.8000000000002H1581.5z"
        />
        <path
          className="st43"
          d="M1429.2 1285.3H1282c-4.4 0-10.5-2.5-13.6-5.7"
        />
        <g id="XMLID_133_">
          <path
            className="st51"
            d="M1247.9 1440.3v37.8c0 4.4-2.5 10.5-5.7 13.6l-19.2 19.2m-233.8-30.8l31.6 31.6c3.1 3.1 9.2 5.7 13.6 5.7h12.8m-57.7-37c-21.6-21.6-131.5-131.6-132.1-132.3-3.1-3.1-9.2-5.7-13.6-5.7h-1.2m193.1 174.9h172.9c4.4 0 10.3-2 13.6-5.7.6-.7-2.9 2.9 12-12"
          />
          <path className="st52" d="M1247.9 1440.3L1247.9 1447.3" />
          <path
            d="M1247.9 1454.7v23.4c0 4.4-2.5 10.5-5.7 13.6-.6.6 1.6-1.7-11.6 11.6"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="12.202,7.3212"
          />
          <path className="st52" d="M1228 1505.9l-5 5M989.2 1480.1l5 5" />
          <path
            d="M1000.7 1491.6l20.1 20.1c3.1 3.1 9.2 5.7 13.6 5.7h1.1"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="15.3525,9.2115"
          />
          <path className="st52" d="M1040.1 1517.3L1047.2 1517.3" />
          <g>
            <path className="st52" d="M989.5 1480.4l-5-5" />
            <path
              d="M978.5 1469.4c-35-35-120.5-120.7-121.1-121.3-1-1.1-2.4-2-4-2.9"
              fill="none"
              stroke="#fff"
              strokeWidth={2.0204}
              strokeLinejoin="round"
              strokeDasharray="14.106,8.4636"
            />
            <path className="st52" d="M849.5 1343.6c-2-.7-4-1.1-5.8-1.1h-1.2" />
          </g>
          <g>
            <path className="st52" d="M1035.7 1517.3L1042.8 1517.3" />
            <path
              d="M1051.4 1517.3h157.3c4.4 0 10.3-2 13.6-5.7l4-4"
              fill="none"
              stroke="#fff"
              strokeWidth={2.0204}
              strokeLinejoin="round"
              strokeDasharray="14.2513,8.5508"
            />
            <path className="st52" d="M1229.3 1504.7l5-5" />
          </g>
        </g>
        <path
          className="st43"
          d="M1614.2 1138.4l57.7-.1c4.4 0 10.5 2.5 13.6 5.7l81.4 81.4M1429.2 1285.3l293.2-.1c4.4 0 10.5 2.5 13.6 5.7l66.8 66.8M2482.3 1237.9l-694.7.1c-4.4 0-10.5-2.5-13.6-5.7l-27.3-27.3M2479.7 1371.2l-655.2.1c-4.4 0-10.5-2.5-13.6-5.7l-27.3-27.3"
        />
        <path
          id="XMLID_119_"
          className="st43"
          d="M1375.1 555.2V530c0-4.4-2.5-10.5-5.7-13.6l-33.4-32.2"
        />
        <path
          className="st43"
          d="M1218.5 429l-30.5.3c-4.4 0-10.5 2.5-13.6 5.6l-9.7 10.6"
        />
        <path
          className="st43"
          d="M1078.6 456.1h68c4.4 0 10.5-2.5 13.6-5.6l14.1-15.5M1336.2 484.2l-50-50.2c-3.1-3.1-9.2-5.6-13.6-5.6l-77 .9"
        />
        <path
          className="st43"
          d="M1015 72.2v364.2c0 5.4 2.2 10.3 5.7 13.8l.2.1c3.8 3.8 8.8 5.7 13.8 5.7h44.8M1693.9 1489.6L1592 1387.8c-3.1-3.1-5.7-9.2-5.7-13.6v-100.5"
        />
        <path
          className="st43"
          d="M1534.4 1119.4l46.3 46.2c3.1 3.1 5.7 9.2 5.7 13.6v196.9M1743 1507.3h-23.2c-4.4 0-10.5-2.5-13.6-5.7l-35.8-35.8M1809.5 1608.4v23.2c0 4.4-2.5 10.5-5.7 13.6L1768 1681"
        />
        <path
          className="st43"
          d="M1784.6 1664.5l-16.4 16.4c-3.1 3.1-9.2 5.7-13.6 5.7h-50.7M1423.3 1751.2v-9.7c0-4.4 2.5-10.5 5.7-13.6l35.8-35.8"
        />
        <path
          className="st43"
          d="M1448.1 1708.6l16.4-16.4c3.1-3.1 9.2-5.7 13.6-5.7H1719M1802 1519.2l1.8 1.8c3.1 3.1 5.7 9.2 5.7 13.6v96.3"
        />
        <path
          className="st43"
          d="M1741.8 1507.4h40.3c4.4 0 10.5 2.5 13.6 5.7l8.1 8.1"
        />
        <g id="XMLID_130_">
          <path className="st52" d="M1240 1684L1235 1689" />
          <path
            d="M1228.9 1695l-1.8 1.8c-3.1 3.1-9.2 5.4-13.6 5.4h-289c-4.4 0-10.5-2.5-13.6-5.7-.5-.4-6.8-6.8-16.2-16.2l-13-12.9-90.8-90.8c-3.1-3.1-5.7-9.2-5.7-13.6v-39.4"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="14.3196,8.5918"
          />
          <path className="st52" d="M785.3 1519.3L785.2 1512.2" />
        </g>
        <path
          id="XMLID_206_"
          className="st58"
          d="M1438.1 456.5l-1.3 1.3.3-.3-56.2 56.2c-3.1 3.1-5.7 9.2-5.7 13.6v1.6"
        />
        <path
          className="st43"
          d="M1529.8 438l-4.2 4.2c-3.1 3.1-9.2 5.6-13.6 5.6h-20.8m36.6-7.8l10.5-10.5c3.1-3.1 5.6-9.2 5.6-13.6v-6.2"
        />
        <path
          className="st58"
          d="M1529.8 438l-4.2 4.2c-3.1 3.1-9.2 5.6-13.6 5.6h-20.8m36.6-7.8l10.5-10.5c3.1-3.1 5.6-9.2 5.6-13.6v-6.2"
        />
        <g id="XMLID_33_">
          <path
            d="M1499.8 447.9h-45.2c-4.4 0-10.5 2.5-13.6 5.6l-3.9 4"
            fill="none"
            stroke="#d385a9"
            strokeWidth={5.7005}
            strokeLinejoin="round"
            strokeMiterlimit={3.994}
          />
          <path className="st52" d="M1499.8 447.9L1492.7 447.9" />
          <path
            d="M1484.6 447.9h-30c-2.8 0-6.2 1-9.1 2.5"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="13.619,8.1714"
          />
          <path className="st52" d="M1442 452.5c-.4.3-.8.6-1.1 1l-3.9 4" />
        </g>
        <path
          id="XMLID_183_"
          className="st43"
          d="M1327.1 642.5l-5.2 5.2c-3.1 3.1-5.7 9.2-5.7 13.6l-.1 37.5"
        />
        <path
          id="XMLID_185_"
          d="M1325.6 643.8l-1.7 1.7-1.9 2.1c-3.1 3.1-5.7 9.2-5.7 13.6l-.1 35.2"
          fill="none"
          stroke="#fff"
          strokeWidth={2.0204}
          strokeLinejoin="round"
          strokeMiterlimit={3.994}
          strokeDasharray="8.8176,4.4088,0,8.8176,4.4088,0"
        />
        <path
          id="XMLID_184_"
          className="st43"
          d="M1349.5 746.1l-27.5-27.5c-3.1-3.1-5.7-9.2-5.7-13.6l-.1-37.5"
        />
        <path
          id="XMLID_32_"
          className="st58"
          d="M1348.4 745.1l-24.5-24.5-1.9-2.1c-3.1-3.1-5.7-9.2-5.7-13.6l-.1-35.2"
        />
        <g id="XMLID_122_">
          <path className="st52" d="M1342.6 739.3L1347.6 744.3" />
          <path
            d="M1352.3 748.9c2.9 3 5.2 8.6 5.4 12.9"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="10.9188,6.5513"
          />
          <path className="st52" d="M1357.8 765L1357.8 772.1" />
        </g>
        <path
          id="XMLID_31_"
          className="st58"
          d="M1467.2 69.5v247.8c0 4.4 2.5 10.5 5.7 13.6l5.6 5.6L1501 359l37.3 37.1c3.1 3.1 5.7 9.2 5.7 13.6v3h-.1"
        />
        <g id="XMLID_168_">
          <path className="st52" d="M1425.4 1010.5l-5-5" />
          <path
            d="M1415.5 1000.6c-6.1-6-14.4-14.4-23.7-23.7"
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="11.5492,6.9295"
          />
          <path className="st52" d="M1389.4 974.4l-5-5" />
        </g>
        <path
          id="XMLID_29_"
          d="M2480.4 1237.9l-692.8.1c-4.4 0-10.5-2.5-13.6-5.7l-27.3-27.3-17.5-17.4-7.4-7.4-36.3-36.3c-3.1-3.1-9.2-5.7-13.6-5.7h-8l-41.2.1h-61.3c-4.4 0-10.5-2.5-13.6-5.7l-6.9-6.9"
          fill="none"
          stroke="#fff"
          strokeWidth={2.0211}
          strokeLinejoin="round"
          strokeMiterlimit={3.994}
          strokeDasharray="14.1732,8.5039"
        />
        <path
          className="st65"
          d="M1575.8 1285.2l-146.6.1H1282c-4.4 0-10.5-2.5-13.6-5.7"
        />
        <path className="st43" d="M1547.8 1132.8L1429.5 1014.6" />
        <path
          className="st58"
          d="M1580.9 1165.9L1511.6 1096.6 1488.7 1073.8 1429.5 1014.6"
        />
        <path
          className="st58"
          d="M2479.7 1371.2l-655.2.1c-4.4 0-10.5-2.5-13.6-5.7l-27.3-27.3-27.1-27.1-20.6-20.6c-3.1-3.1-9.2-5.7-13.6-5.7h-89.5"
        />
        <g id="XMLID_118_">
          <path className="st66" d="M1324.4 644.9L1329.5 639.9" />
          <path
            d="M1335.6 633.8l33.9-33.8c3.1-3.1 5.7-9.2 5.7-13.6V530c0-4.4-2.5-10.5-5.7-13.6l-25.3-24.5-35.2-35.1-22.8-22.9c-3.1-3.1-9.2-5.6-13.6-5.6l-74 .9"
            fill="none"
            stroke="#fff"
            strokeWidth={2.02}
            strokeLinejoin="round"
            strokeDasharray="14.3693,8.6216"
          />
          <path
            className="st66"
            d="M1194.3 429.2l-7.1.1h.7c-2.1 0-4.5.6-6.9 1.5"
          />
          <path
            d="M1174 435.2l-1.9 2-10 11-2 2.2c-3.1 3.1-9.2 5.6-13.6 5.6h-111.9c-5 0-10-1.9-13.8-5.7l-.2-.1c-3.5-3.5-5.7-8.4-5.7-13.8v-353"
            fill="none"
            stroke="#fff"
            strokeWidth={2.02}
            strokeLinejoin="round"
            strokeDasharray="13.945,8.367"
          />
          <path className="st66" d="M1015 79.3L1015 72.2" />
        </g>
        <path
          className="st65"
          d="M1585.6 1173.6c.4 1.6.8 3.1.8 4.5v196.1c0 4.4 2.5 10.5 5.7 13.6l69 68.8 9.3 9.2 35.8 35.8c3.1 3.1 9.2 5.7 13.6 5.7h23.2l17.8.1h21.2c4.4 0 10.5 2.5 13.6 5.7l2 2 4.3 4.2 1.8 1.8c3.1 3.1 5.7 9.2 5.7 13.6v96.9c0 4.4-2.5 10.5-5.7 13.6l-12.8 12.8-22.8 22.9c-3.1 3.1-9.2 5.7-13.6 5.7h-276.4c-4.4 0-10.5 2.5-13.6 5.7l-4.1 4.1-16.4 16.4-15.1 15.1c-3.1 3.1-5.7 9.2-5.7 13.6v8"
        />
        <path
          className="st51"
          d="M827 1350l1.8-1.8c3.1-3.1 9.2-5.7 13.6-5.7h.5m-14.1 5.7L791 1386c-3.1 3.1-5.7 9.2-5.7 13.6v40.3"
        />
        <path
          className="st58"
          d="M827 1350l1.8-1.8c3.1-3.1 9.2-5.7 13.6-5.7h.5m-14.1 5.7L791 1386c-3.1 3.1-5.7 9.2-5.7 13.6v40.3"
        />
        <path
          className="st44"
          d="M2473.8 1246.7L2480.9 1246.7 2487.1 1238 2480.9 1229.5 2473.8 1229.5 2479.7 1238z"
        />
        <path
          className="st44"
          d="M2473.8 1379.9L2480.9 1379.9 2487.1 1371.3 2480.9 1362.8 2473.8 1362.8 2479.7 1371.3z"
        />
        <path
          className="st44"
          d="M1414.7 1741.8L1414.7 1748.9 1423.3 1755.2 1431.9 1748.9 1431.9 1741.8 1423.3 1747.8z"
        />
        <path
          className="st44"
          d="M1476 81.1L1476 74 1467.3 67.7 1458.8 74 1458.8 81.1 1467.3 75.1z"
        />
        <path
          className="st44"
          d="M1023.7 81L1023.7 73.8 1015 67.6 1006.5 73.8 1006.5 81 1015 75z"
        />
        <g id="XMLID_77_">
          <path className="st52" d="M1634.9 1285.2L1627.8 1285.2" />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="13.2086,7.9252"
            d="M1619.9 1285.2L1602.7 1285.2"
          />
          <path className="st52" d="M1598.8 1285.2L1591.7 1285.2" />
        </g>
        <path
          id="XMLID_193_"
          className="st2"
          d="M1589.3 1282.2H1590.3V1288.1000000000001H1589.3z"
        />
        <path
          id="XMLID_191_"
          className="st2"
          d="M1582.5 1282.3H1583.5V1288.2H1582.5z"
        />
        <path className="st44" d="M1016.2 132.1H1021.7V135.9H1016.2z" />
        <path className="st44" d="M1016.3 246.2H1021.8V250H1016.3z" />
        <path className="st44" d="M1008.2 348.4H1013.2V352.2H1008.2z" />
        <g>
          <path
            fill="none"
            stroke="#d385a9"
            strokeWidth={5.6988}
            strokeLinejoin="round"
            strokeMiterlimit={3.9938}
            d="M785.3 1515.4L785.3 1399.8"
          />
          <path className="st52" d="M785.3 1515.4L785.3 1508.3" />
          <path
            fill="none"
            stroke="#fff"
            strokeWidth={2.0204}
            strokeLinejoin="round"
            strokeDasharray="12.6857,10.1486"
            d="M785.3 1498.2L785.3 1411.9"
          />
          <path className="st52" d="M785.3 1406.9L785.3 1399.8" />
        </g>
        <path
          className="st72"
          d="M2389.9 1454.6L2385.6 1452.7 2391.8 1452.7 2391.8 1451.4 2385.4 1451.4 2388.6 1449.8 2391.8 1449.8 2391.8 1448.6 2388.6 1448.6 2384.7 1446.8 2381.7 1446.8 2385.9 1448.6 2379.5 1448.6 2379.5 1449.8 2385.9 1449.8 2382.6 1451.4 2379.5 1451.4 2379.5 1452.7 2382.8 1452.7 2387 1454.6z"
        />
        <path
          id="XMLID_310_"
          d="M2419.4 1427.3L2369 1377c-3.8-3.8-8.8-5.7-13.8-5.7"
          fill="none"
          stroke="#d385a9"
          strokeWidth={5.7078}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
        <path
          id="XMLID_308_"
          d="M2419.4 1427.3L2369 1377c-3.8-3.8-8.8-5.7-13.8-5.7"
          fill="none"
          stroke="#fff"
          strokeWidth={2.02}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
          strokeDasharray="14.1732,8.5039"
        />
      </g>
      <g id="Tramlink">
        <path
          className="st75"
          d="M2220.4 1422.2h-113.7c-5.4 0-10.3 2.2-13.8 5.7l-163.5 163.5c-3.8 3.8-8.8 5.7-13.8 5.7"
        />
        <path
          className="st75"
          d="M2111.5 1473.8H2055c-5.4 0-10.3 2.2-13.8 5.7M1639.2 1597.1H947.6c-5.8 0-13-2.5-17-6.5l-80.5-83.9c-3.1-3.1-5.7-9.3-5.7-13.7v-130"
        />
        <path
          className="st75"
          d="M1563.8 1597.1c4.4 0 10.6-2.6 13.8-5.7l39.3-39.3"
        />
        <path
          className="st75"
          d="M1811.9 1597.1c-14.4 0-26-11.6-26-26s-11.7-26-26-26h-125.3c-14.4 0-26 11.7-26 26 0 14.4 11.6 26 26 26h281"
        />
        <path
          className="st76"
          d="M1639.2 1597.1H947.6c-5.8 0-13-2.5-17-6.5l-80.5-83.9c-3.1-3.1-5.7-9.3-5.7-13.7v-130"
        />
        <path
          className="st76"
          d="M1563.8 1597.1c4.4 0 10.6-2.6 13.8-5.7l39.3-39.3"
        />
        <path
          className="st76"
          d="M1811.9 1597.1c-14.4 0-26-11.6-26-26s-11.7-26-26-26h-125.3c-14.4 0-26 11.7-26 26 0 14.4 11.6 26 26 26h281M2111.5 1473.8H2055c-5.4 0-10.3 2.2-13.8 5.7"
        />
        <path
          className="st75"
          d="M2319 1513.2l-85.3-85.3c-3.8-3.8-8.8-5.7-13.8-5.7"
        />
        <path
          className="st76"
          d="M2319 1513.2l-85.3-85.3c-3.8-3.8-8.8-5.7-13.8-5.7"
        />
        <path
          className="st72"
          d="M1785.8 1524.9L1781.4 1523 1787.6 1523 1787.6 1521.7 1781.2 1521.7 1784.5 1520.1 1787.6 1520.1 1787.6 1518.9 1784.5 1518.9 1780.5 1517.1 1777.6 1517.1 1781.7 1518.9 1775.3 1518.9 1775.3 1520.1 1781.7 1520.1 1778.4 1521.7 1775.3 1521.7 1775.3 1523 1778.6 1523 1782.8 1524.9z"
        />
        <path
          className="st72"
          d="M2200.2 1477.3L2195.8 1475.3 2202 1475.3 2202 1474.1 2195.6 1474.1 2198.9 1472.5 2202 1472.5 2202 1471.2 2198.9 1471.2 2194.9 1469.4 2192 1469.4 2196.1 1471.2 2189.8 1471.2 2189.8 1472.5 2196.1 1472.5 2192.8 1474.1 2189.8 1474.1 2189.8 1475.3 2193 1475.3 2197.2 1477.3z"
        />
        <path
          className="st72"
          d="M2225.6 1440.3L2221.3 1438.4 2227.4 1438.4 2227.4 1437.1 2221.1 1437.1 2224.3 1435.5 2227.4 1435.5 2227.4 1434.3 2224.3 1434.3 2220.4 1432.5 2217.4 1432.5 2221.6 1434.3 2215.2 1434.3 2215.2 1435.5 2221.6 1435.5 2218.2 1437.1 2215.2 1437.1 2215.2 1438.4 2218.5 1438.4 2222.7 1440.3z"
        />
        <path
          className="st72"
          d="M2309.9 1551.1L2305.5 1549.1 2311.6 1549.1 2311.6 1547.8 2305.3 1547.8 2308.5 1546.3 2311.6 1546.3 2311.6 1545 2308.5 1545 2304.6 1543.2 2301.6 1543.2 2305.8 1545 2299.4 1545 2299.4 1546.3 2305.8 1546.3 2302.5 1547.8 2299.4 1547.8 2299.4 1549.1 2302.7 1549.1 2306.9 1551.1z"
        />
        <path
          className="st2"
          d="M1702.2 1604.8L1696.5 1597.1 1702.2 1589.4 1710.4 1589.4 1705.1 1597.1 1710.5 1604.8z"
        />
        <path
          className="st77"
          d="M1706.9 1591.4L1703 1591.4 1698.8 1597.1 1703 1602.8 1706.9 1602.8 1702.9 1597.1z"
        />
        <path
          className="st2"
          d="M1793.8 1573.2L1786.4 1579.3 1778.4 1574.2 1777.9 1565.9 1785.9 1570.8 1793.2 1564.9z"
        />
        <path
          className="st77"
          d="M1780.1 1569.3L1780.3 1573.2 1786.3 1577.1 1791.7 1572.6 1791.5 1568.6 1786 1573z"
        />
        <path
          className="st2"
          d="M1596.4 1604.8L1590.7 1597.1 1596.4 1589.4 1604.7 1589.4 1599.3 1597.1 1604.7 1604.8z"
        />
        <path
          className="st77"
          d="M1601.1 1591.4L1597.2 1591.4 1593 1597.1 1597.2 1602.8 1601.1 1602.8 1597.1 1597.1z"
        />
        <path
          className="st2"
          d="M1604 1584.7L1609.1 1576.6 1618.4 1579 1621.4 1586.7 1612.3 1584.6 1607.1 1592.4z"
        />
        <path
          className="st77"
          d="M1618.3 1584.1L1616.8 1580.5 1609.9 1578.7 1606.2 1584.7 1607.6 1588.3 1611.4 1582.5z"
        />
        <path
          className="st2"
          d="M1578.8 1579.3L1588.2 1580.7 1589.7 1590.2 1586.3 1593.5 1583.3 1593.5 1582.1 1586.8 1572.9 1585.2z"
        />
        <path
          className="st77"
          d="M1584.9 1592.1L1587.7 1589.4 1586.6 1582.3 1579.6 1581.3 1576.8 1584 1583.7 1585.2z"
        />
        <path
          className="st2"
          d="M1676.8 1537.4L1682.4 1545.1 1676.8 1552.8 1668.5 1552.8 1673.9 1545.1 1668.5 1537.4z"
        />
        <path
          className="st77"
          d="M1672.1 1550.9L1676 1550.9 1680.2 1545.1 1676 1539.4 1672.1 1539.4 1676.1 1545.1z"
        />
        <path className="st75" d="M1940.8 1735.3L1940.8 1735.3" />
        <path className="st75" d="M1940.8 1735.3L1940.8 1735.3" />
        <path
          className="st75"
          d="M1915.6 1597.1c5.4 0 10.3 2.2 13.8 5.7s139.7 139.5 139.7 139.5"
        />
        <path
          d="M1915.6 1597.1c5.4 0 10.3 2.2 13.8 5.7s139.7 139.5 139.7 139.5"
          fill="none"
          stroke="#fff"
          strokeWidth={1.9584}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
        <path
          className="st76"
          d="M2220.4 1422.2h-113.7c-5.4 0-10.3 2.2-13.8 5.7l-163.5 163.5c-3.8 3.8-8.8 5.7-13.8 5.7"
        />
      </g>
      <g id="Overground">
        <path
          className="st79"
          d="M913.7 1286.9v-51.2c0-4.4-2.5-12.6-5.7-15.7l-105.3-105.3c-3.1-3.1-5.7-9.2-5.7-13.6V932.7c0-4.4-2.5-10.5-5.5-13.4L591.3 718.9c-4-4-5.6-10.6-5.6-16.4l.1-64.8c0-4.4 2.6-10.5 5.7-13.6"
        />
        <path
          className="st80"
          d="M913.7 1286.9v-51.2c0-4.4-2.5-12.6-5.7-15.7l-105.3-105.3c-3.1-3.1-5.7-9.2-5.7-13.6V932.7c0-4.4-2.5-10.5-5.5-13.4L591.3 718.9c-4-4-5.6-10.6-5.6-16.4l.1-64.8c0-4.4 2.6-10.5 5.7-13.6"
        />
        <path className="st81" d="M813.2 522.5H817V529.2H813.2z" />
        <path
          className="st81"
          d="M863.1 529.2H866.9V535.9000000000001H863.1z"
        />
        <path
          className="st81"
          d="M1645.9 544.1H1649.7V550.8000000000001H1645.9z"
        />
        <path
          transform="rotate(-45.009 1264.542 504.505)"
          className="st81"
          d="M1261.2 502.6H1267.9V506.40000000000003H1261.2z"
        />
        <path
          className="st79"
          d="M1990.4 579.8h-282.7c-4.4 0-10.5-2.5-13.6-5.7l-16.8-16.9c-4.3-4.3-10.4-7-17-7h-346.7c-4.4 0-10.5-2.5-13.6-5.7l-40-40c-3.1-3.1-9.2-5.6-13.6-5.6H922.8c-4.4 0-10.5 2.5-13.6 5.6L890.8 523c-3.1 3.1-9.2 5.7-13.6 5.7H694.9c-4.4 0-10.5 2.5-13.6 5.7L556.6 658.9c-3.1 3.1-5.7 9.2-5.7 13.6v294.3c0 4.4-2.5 10.5-5.7 13.6l-46.3 46.3c-4.6 4.6-9.1 12.7-9.1 19.7v143.7"
        />
        <path
          className="st80"
          d="M1990.4 579.8h-282.7c-4.4 0-10.5-2.5-13.6-5.7l-16.8-16.9c-4.3-4.3-10.4-7-17-7h-346.7c-4.4 0-10.5-2.5-13.6-5.7l-40-40c-3.1-3.1-9.2-5.6-13.6-5.6H922.8c-4.4 0-10.5 2.5-13.6 5.6L890.8 523c-3.1 3.1-9.2 5.7-13.6 5.7H694.9c-4.4 0-10.5 2.5-13.6 5.7L556.6 658.9c-3.1 3.1-5.7 9.2-5.7 13.6v294.3c0 4.4-2.5 10.5-5.7 13.6l-46.3 46.3c-4.6 4.6-9.1 12.7-9.1 19.7v143.7"
        />
        <path className="st81" d="M810.7 599H814.5V605.7H810.7z" />
        <path
          className="st81"
          d="M1029.4 1306.9H1033.2V1313.6000000000001H1029.4z"
        />
        <path
          className="st79"
          d="M1286.3 1373.9h-133.1c-5 0-10-1.9-13.8-5.7l-55.6-55.6c-3.8-3.8-8.8-5.7-13.8-5.7H936.3"
        />
        <path
          className="st80"
          d="M1286.3 1373.9h-133.1c-5 0-10-1.9-13.8-5.7l-55.6-55.6c-3.8-3.8-8.8-5.7-13.8-5.7H936.3"
        />
        <path
          className="st79"
          d="M1684.2 1153.3c0 5-1.9 10-5.7 13.8l-37.5 37.5c-3.8 3.8-8.8 5.7-13.8 5.7H1583c-5 0-10 1.9-13.8 5.7l-93.4 93.4"
        />
        <path
          className="st80"
          d="M1684.2 1153.3c0 5-1.9 10-5.7 13.8l-37.5 37.5c-3.8 3.8-8.8 5.7-13.8 5.7H1583c-5 0-10 1.9-13.8 5.7l-93.4 93.4"
        />
        <path
          className="st79"
          d="M1485.1 1300l-9.1 9.1c-3.8 3.8-8.8 5.7-13.8 5.7H1365c-5 0-10 1.9-13.8 5.7l-47.6 47.6c-3.5 3.5-8.4 5.7-13.8 5.7h-51.5"
        />
        <path
          className="st80"
          d="M1485.1 1300l-9.1 9.1c-3.8 3.8-8.8 5.7-13.8 5.7H1365c-5 0-10 1.9-13.8 5.7l-47.6 47.6c-3.5 3.5-8.4 5.7-13.8 5.7h-51.5"
        />
        <path
          transform="rotate(-45.009 1788.176 497.42)"
          className="st81"
          d="M1786.3 494H1790.1V500.7H1786.3z"
        />
        <path
          transform="rotate(-45.009 1811.426 474.171)"
          className="st81"
          d="M1809.5 470.8H1813.3V477.5H1809.5z"
        />
        <path
          transform="rotate(-45.009 1730.018 511.523)"
          className="st81"
          d="M1726.7 509.6H1733.4V513.4H1726.7z"
        />
        <path
          transform="rotate(-45.009 1694.455 475.963)"
          className="st81"
          d="M1691.1 474.1H1697.8V477.90000000000003H1691.1z"
        />
        <path
          transform="rotate(-45.009 1689.452 167.802)"
          className="st81"
          d="M1687.6 164.4H1691.3999999999999V171.1H1687.6z"
        />
        <path
          transform="rotate(-45.009 1722.006 135.259)"
          className="st81"
          d="M1720.1 131.9H1723.8999999999999V138.6H1720.1z"
        />
        <path
          transform="rotate(-45.009 1753.232 104.021)"
          className="st81"
          d="M1751.3 100.6H1755.1V107.3H1751.3z"
        />
        <path
          className="st79"
          d="M1662.4 198.2c0-4.4 2.5-10.5 5.7-13.6l111.9-112"
        />
        <path
          className="st80"
          d="M1662.4 198.2c0-4.4 2.5-10.5 5.7-13.6l111.9-112"
        />
        <path
          className="st81"
          d="M1944.3 466.4H1948.1V473.09999999999997H1944.3z"
        />
        <path className="st81" d="M1892.7 459.6H1896.5V466.3H1892.7z" />
        <path
          transform="rotate(-45.009 1467.709 363.004)"
          className="st81"
          d="M1465.8 359.6H1469.6V366.3H1465.8z"
        />
        <path
          transform="rotate(-45.001 2128.598 509.908)"
          className="st81"
          d="M2125.1 507.9H2132.1V511.79999999999995H2125.1z"
        />
        <path className="st81" d="M679.3 129.5H686V133.3H679.3z" />
        <path
          className="st81"
          d="M679.4 232.9H686.1V236.70000000000002H679.4z"
        />
        <path
          className="st81"
          d="M679.4 265.1H686.1V268.90000000000003H679.4z"
        />
        <path
          transform="rotate(-45.001 1725.547 656.853)"
          className="st81"
          d="M1723.7 653.5H1727.5V660.2H1723.7z"
        />
        <path
          transform="rotate(-45.001 1742.463 638.123)"
          className="st81"
          d="M1740.6 634.7H1744.3999999999999V641.4000000000001H1740.6z"
        />
        <path
          className="st81"
          d="M1747.4 618.2H1754.1000000000001V622H1747.4z"
        />
        <path className="st81" d="M679.3 562.1H686V565.9H679.3z" />
        <path
          className="st79"
          d="M679.3 75.3v518.1c0 3.3 1.6 7.2 3.9 9.4 2.3 2.3 6.2 2.9 9.4 2.8h472.7c4.4 0 10.5 2.5 13.6 5.7 3.1 3.1 43.6 43.7 43.6 43.7"
        />
        <path
          className="st80"
          d="M679.3 75.3v518.1c0 3.3 1.6 7.2 3.9 9.4 2.3 2.3 6.2 2.9 9.4 2.8h472.7c4.4 0 10.5 2.5 13.6 5.7 3.1 3.1 43.6 43.7 43.6 43.7"
        />
        <path className="st81" d="M1677.5 994.5H1684.2V998.2H1677.5z" />
        <path
          className="st81"
          d="M1684.2 947.2H1690.9V950.9000000000001H1684.2z"
        />
        <path
          className="st81"
          d="M1677.4 1123.4H1684.1000000000001V1127.1000000000001H1677.4z"
        />
        <path className="st81" d="M1684.2 1421H1690.9V1424.7H1684.2z" />
        <path className="st81" d="M1841.6 306.8H1848.3V310.6H1841.6z" />
        <path
          className="st81"
          d="M1662.4 291.5H1669.1000000000001V295.3H1662.4z"
        />
        <path
          className="st81"
          d="M1662.4 266H1669.1000000000001V269.8H1662.4z"
        />
        <path
          className="st81"
          d="M1662.4 236.9H1669.1000000000001V240.70000000000002H1662.4z"
        />
        <path
          className="st81"
          d="M1662.4 431.1H1669.1000000000001V434.90000000000003H1662.4z"
        />
        <path
          className="st79"
          d="M1747.3 541.5c0-4.4-2.5-10.5-5.7-13.6l-73.7-73.7c-3.1-3.1-5.7-9.2-5.7-13.6V101"
        />
        <path
          className="st80"
          d="M1747.3 541.5c0-4.4-2.5-10.5-5.7-13.6l-73.7-73.7c-3.1-3.1-5.7-9.2-5.7-13.6V101"
        />
        <path
          className="st79"
          d="M1547.1 761.9l70-72.8c7.8-7.8 15.8-11.6 26.2-11.6h47c4.4 0 10.5-2.5 13.6-5.7l37.7-37.8c3.1-3.1 5.7-9.2 5.7-13.6v-79c0-4.4 2.5-10.5 5.7-13.6l82.9-82.9c3.1-3.1 5.7-9.2 5.7-13.6V177"
        />
        <path
          className="st80"
          d="M1547.1 761.9l70-72.8c7.8-7.8 15.8-11.6 26.2-11.6h47c4.4 0 10.5-2.5 13.6-5.7l37.7-37.8c3.1-3.1 5.7-9.2 5.7-13.6v-79c0-4.4 2.5-10.5 5.7-13.6l82.9-82.9c3.1-3.1 5.7-9.2 5.7-13.6V177"
        />
        <path
          className="st79"
          d="M1684.2 1153.3c0 5 1.9 10 5.7 13.8l16.1 16.1c3.8 3.8 5.7 8.8 5.7 13.8v31.6"
        />
        <path
          className="st80"
          d="M1684.2 1153.3c0 5 1.9 10 5.7 13.8l16.1 16.1c3.8 3.8 5.7 8.8 5.7 13.8v31.6"
        />
        <path
          className="st79"
          d="M1684.2 1390.2c0 5-1.9 10-5.7 13.8l-52.6 52.6"
        />
        <path
          className="st80"
          d="M1684.2 1390.2c0 5-1.9 10-5.7 13.8l-52.6 52.6"
        />
        <g>
          <path
            className="st79"
            d="M1684.2 1529.3V618.7c0-4.4-2.6-10.5-5.7-13.6l-30.6-30.3c-4.3-4.3-10.4-7-17-7h-69.6"
          />
          <path
            className="st80"
            d="M1684.2 1529.3V618.7c0-4.4-2.6-10.5-5.7-13.6l-30.6-30.3c-4.3-4.3-10.4-7-17-7h-69.6"
          />
        </g>
        <g>
          <path
            className="st79"
            d="M2267.1 305.8l76.5 76.5c3.1 3.1 9.2 5.6 13.6 5.6h10.2"
          />
          <path
            className="st80"
            d="M2267.1 305.8l76.5 76.5c3.1 3.1 9.2 5.6 13.6 5.6h10.2"
          />
        </g>
        <g>
          <path
            className="st79"
            d="M2163.8 613.4l4.1 4.1c3.1 3.1 9.2 5.7 13.6 5.7H2197.7c4.4 0 10.5 2.5 13.6 5.7L2320.4 738"
          />
          <path
            className="st80"
            d="M2163.8 613.4l4.1 4.1c3.1 3.1 9.2 5.7 13.6 5.7H2197.7c4.4 0 10.5 2.5 13.6 5.7L2320.4 738"
          />
        </g>
        <g>
          <path
            className="st79"
            d="M2164.3 613.8l-20-20c-3.1-3.1-5.6-9.2-5.6-13.6V532.8c0-4.4-2.5-10.5-5.6-13.6l-47.1-47.1c-3.1-3.1-9.2-5.6-13.6-5.6H1871c-4.4 0-10.5-2.5-13.6-5.6L1743.6 347c-3.1-3.1-9.2-5.6-13.6-5.6h-227.8c-4.4 0-10.5 2.5-13.7 5.6l-58.5 58.5c-3.1 3.1-9.2 5.6-13.6 5.6h-94c-4.4 0-10.5 2.5-13.6 5.6-2.5 2.5-49.8 49.9-49.8 49.9-3.1 3.1-9.2 5.6-13.6 5.6h-15.7"
          />
          <path
            className="st80"
            d="M2164.3 613.8l-20-20c-3.1-3.1-5.6-9.2-5.6-13.6V532.8c0-4.4-2.5-10.5-5.6-13.6l-47.1-47.1c-3.1-3.1-9.2-5.6-13.6-5.6H1871c-4.4 0-10.5-2.5-13.6-5.6L1743.6 347c-3.1-3.1-9.2-5.6-13.6-5.6h-227.8c-4.4 0-10.5 2.5-13.7 5.6l-58.5 58.5c-3.1 3.1-9.2 5.6-13.6 5.6h-94c-4.4 0-10.5 2.5-13.6 5.6-2.5 2.5-49.8 49.9-49.8 49.9-3.1 3.1-9.2 5.6-13.6 5.6h-15.7"
          />
        </g>
        <path
          className="st80"
          d="M1662.4 198.2c0-4.4 2.5-10.5 5.7-13.6M1684.2 1153.3c0 5-1.9 10-5.7 13.8M1684.2 1153.3c0 5 1.9 10 5.7 13.8M1684.2 1390.2c0 5-1.9 10-5.7 13.8M1747.3 541.5c0-4.4-2.5-10.5-5.7-13.6M585.8 637.8c0-4.4 2.6-10.5 5.7-13.6"
        />
      </g>
      <g id="Crossrail">
        <path
          className="st42"
          d="M136.6 693.7H143.29999999999998V697.5H136.6z"
        />
        <path
          className="st42"
          d="M136.6 749.9H143.29999999999998V753.6999999999999H136.6z"
        />
        <path
          className="st42"
          d="M136.6 664.5H143.29999999999998V668.3H136.6z"
        />
        <path
          className="st42"
          d="M136.6 664.5H143.29999999999998V668.3H136.6z"
        />
        <path
          className="st42"
          d="M136.6 635.3H143.29999999999998V639.0999999999999H136.6z"
        />
        <path
          className="st42"
          d="M136.6 635.3H143.29999999999998V639.0999999999999H136.6z"
        />
        <path className="st42" d="M136.6 606.2H143.29999999999998V610H136.6z" />
        <path className="st42" d="M136.6 606.2H143.29999999999998V610H136.6z" />
        <path className="st42" d="M136.6 577H143.29999999999998V580.8H136.6z" />
        <path className="st42" d="M136.6 577H143.29999999999998V580.8H136.6z" />
        <path
          className="st42"
          d="M136.6 547.8H143.29999999999998V551.5999999999999H136.6z"
        />
        <path
          className="st42"
          d="M136.6 547.8H143.29999999999998V551.5999999999999H136.6z"
        />
        <path
          className="st42"
          d="M129.9 799.9H136.6V803.6999999999999H129.9z"
        />
        <path
          className="st42"
          d="M129.9 749.9H136.6V753.6999999999999H129.9z"
        />
        <path className="st42" d="M136.6 800H143.29999999999998V803.8H136.6z" />
        <path className="st42" d="M129.9 800H136.6V803.8H129.9z" />
        <path className="st42" d="M136.6 723H143.29999999999998V726.8H136.6z" />
        <path className="st42" d="M129.9 723H136.6V726.8H129.9z" />
        <path className="st42" d="M315.6 841.7H322.3V845.5H315.6z" />
        <path
          className="st42"
          d="M308.9 841.7H315.59999999999997V845.5H308.9z"
        />
        <path
          className="st42"
          d="M129.9 722.8H136.6V726.5999999999999H129.9z"
        />
        <path
          className="st42"
          d="M129.9 635.3H136.6V639.0999999999999H129.9z"
        />
        <path className="st42" d="M136.6 606.2H143.29999999999998V610H136.6z" />
        <path className="st42" d="M136.6 577H143.29999999999998V580.8H136.6z" />
        <path
          className="st42"
          d="M136.6 547.8H143.29999999999998V551.5999999999999H136.6z"
        />
        <path
          className="st82"
          d="M136.6 552.8v271.3c0 5.4 2.2 10.3 5.7 13.8l.1.2c3.8 3.8 8.8 5.7 13.8 5.7H224"
        />
        <path
          className="st83"
          d="M136.6 552.8v271.3c0 5.4 2.2 10.3 5.7 13.8l.1.2c3.8 3.8 8.8 5.7 13.8 5.7H224"
        />
        <path
          transform="rotate(-45.001 2142.226 434.36)"
          className="st42"
          d="M2140.3 431H2144.1000000000004V437.7H2140.3z"
        />
        <path
          transform="rotate(-45.001 2188.006 388.581)"
          className="st42"
          d="M2186.1 385.2H2189.9V391.9H2186.1z"
        />
        <path
          transform="rotate(-45.001 2301.797 274.792)"
          className="st42"
          d="M2299.9 271.4H2303.7000000000003V278.09999999999997H2299.9z"
        />
        <path
          transform="rotate(-45.001 2323.847 252.742)"
          className="st42"
          d="M2322 249.4H2325.8V256.1H2322z"
        />
        <path
          transform="rotate(-45.001 2323.831 252.778)"
          className="st42"
          d="M2321.9 249.4H2325.7000000000003V256.1H2321.9z"
        />
        <path
          className="st84"
          d="M874.9 725.3h49.5c3.4 0 8.1 2 10.5 4.3l60.2 60.3c2.4 2.4 7.1 4.3 10.5 4.3h277.1c3.4 0 8.1-2 10.5-4.3l52.3-52.3 3.4-3.4"
        />
        <path
          className="st85"
          d="M876.5 725.3h47.9c3.4 0 8.1 2 10.5 4.3l60.2 60.3c2.4 2.4 7.1 4.3 10.5 4.3h277c3.4 0 8.1-2 10.5-4.3l50.4-50.4 5.3-5.2"
        />
        <path
          className="st42"
          d="M313.7 836.8H317.59999999999997V843.8H313.7z"
        />
        <path className="st42" d="M291.2 841.7H297.9V845.5H291.2z" />
        <path className="st42" d="M284.5 841.7H291.2V845.5H284.5z" />
        <path className="st42" d="M289.3 836.8H293.2V843.8H289.3z" />
        <path className="st42" d="M290.1 843.8H294V850.8H290.1z" />
        <path className="st42" d="M230.8 841.7H237.5V845.5H230.8z" />
        <path className="st42" d="M224 841.7H230.7V845.5H224z" />
        <path
          className="st42"
          d="M228.8 836.8H232.70000000000002V843.8H228.8z"
        />
        <path className="st42" d="M229.7 843.8H233.6V850.8H229.7z" />
        <path
          className="st82"
          d="M829.2 728.1h-240c-4.4 0-10.5 2.5-13.6 5.7-3.1 3.1-104.2 104.4-104.2 104.4-3.1 3.1-9.2 5.7-13.6 5.7H289.3"
        />
        <path
          className="st83"
          d="M829.2 728.1h-240c-4.4 0-10.5 2.5-13.6 5.7-3.1 3.1-104.2 104.4-104.2 104.4-3.1 3.1-9.2 5.7-13.6 5.7H289.3"
        />
        <path
          fill="none"
          stroke="#f1f2f2"
          strokeWidth={8.8544}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
          d="M186 1203.6L202.1 1187.6"
        />
        <path
          className="st82"
          d="M194.9 1276.9V863.4c0-5.4 2.2-10.3 5.7-13.8l.1-.2c3.8-3.8 8.8-5.7 13.8-5.7h74.6"
        />
        <path
          className="st83"
          d="M194.9 1276.9V863.4c0-5.4 2.2-10.3 5.7-13.8l.1-.2c3.8-3.8 8.8-5.7 13.8-5.7h74.6"
        />
        <path
          className="st83"
          d="M136.6 802.8v21.3c0 5.4 2.2 10.3 5.7 13.8l.1.2c3.8 3.8 8.8 5.7 13.8 5.7H224"
        />
        <path className="st42" d="M408 841.7H414.7V845.5H408z" />
        <path className="st42" d="M401.2 841.7H407.9V845.5H401.2z" />
        <path className="st42" d="M406 836.8H409.9V843.8H406z" />
        <path className="st42" d="M364.6 841.7H371.3V845.5H364.6z" />
        <path
          className="st42"
          d="M357.9 841.7H364.59999999999997V845.5H357.9z"
        />
        <path className="st42" d="M362.6 836.8H366.5V843.8H362.6z" />
        <path className="st42" d="M408 860H414.7V863.8H408z" />
        <path className="st42" d="M401.2 860H407.9V863.8H401.2z" />
        <path className="st42" d="M406 855.1H409.9V862.1H406z" />
        <path
          d="M124.4 1275.4v-21.9c0-4.5 2.6-10.7 5.8-13.9l59-59c3.2-3.2 5.8-9.4 5.8-13.9v-24.3"
          fill="none"
          stroke="#634ea0"
          strokeWidth={5.999}
          strokeLinejoin="round"
          strokeMiterlimit={3.994}
        />
        <path
          d="M124.4 1275.4v-21.9c0-4.5 2.6-10.7 5.8-13.9l59-59c3.2-3.2 5.8-9.4 5.8-13.9v-24.3"
          fill="none"
          stroke="#fff"
          strokeWidth={2.058}
          strokeLinejoin="round"
          strokeMiterlimit={3.994}
        />
        <path className="st83" d="M194.9 1276.9L194.9 863.4" />
        <path
          className="st84"
          d="M1346.7 738.2h172.9c3.4 0 8.1 2 10.5 4.3l2.6 2.6 9.2 8.6 3 3"
        />
        <path
          className="st85"
          d="M1345.7 738.2h173.9c3.4 0 8.1 2 10.5 4.3l2.8 2.8 8.9 8.4 2.9 2.9"
        />
        <g>
          <path
            className="st89"
            d="M1570.1 744c23.2-23.2 53.1-53.8 57.2-56.4 3.8-2.4 9.4-4.5 13.9-4.5 7.4 0 14.6.1 14.6.1h2s215.4-.1 222.8-.1c4.5 0 10.8-2.6 13.9-5.8 4.5-4.5 392.5-392.5 535.4-535.3"
          />
          <path
            className="st85"
            d="M1570.8 743.3c22.6-22.6 46.7-47 53.3-53.1 3.9-3.6 11.6-6.9 15.8-6.9h18.7s214.6-.2 222-.2c4.5 0 10.8-2.6 13.9-5.8L2429.8 142"
          />
          <path
            className="st90"
            d="M1544.2 761.2H1662l14.2.1c3.4 0 8.1 2 10.5 4.3l122.6 117.6c2.4 2.4 4.3 7.1 4.3 10.5v47.8c0 3.4 1.9 8.1 4.3 10.5l5.5 5.5c2.4 2.4 7.1 4.3 10.5 4.3H2189.9c17.3 0 22.1 18.8 22.1 22.1v252.8"
          />
          <path
            className="st80"
            d="M1544.2 761.2H1662l14.2.1c3.4 0 8.1 2 10.5 4.3l122.6 117.6c2.4 2.4 4.3 7.1 4.3 10.5v47.8c0 3.4 1.9 8.1 4.3 10.5l5.5 5.5c2.4 2.4 7.1 4.3 10.5 4.3H2189.9c17.3 0 22.1 18.8 22.1 22.1v252.8"
          />
        </g>
      </g>
      <g id="D_L_R">
        <path
          className="st91"
          d="M1650.7 900.5c-4.4 0-10.5 2.5-13.6 5.7l-29.1 29.1"
        />
        <path
          className="st80"
          d="M1650.7 900.5c-4.4 0-10.5 2.5-13.6 5.7l-29.1 29.1"
        />
        <path
          className="st91"
          d="M2035.3 900.5c-4.4 0-10.5-2.5-13.6-5.7l-.3-.3c-3.1-3.1-5.7-9.2-5.7-13.6V569.3c0-4.4-2.5-10.5-5.7-13.6-4.4-4.4-30.2-30.4-30.2-30.4-3.1-3.1-9.2-5.7-13.6-5.7h-40.9"
        />
        <path
          className="st80"
          d="M2035.3 900.5c-4.4 0-10.5-2.5-13.6-5.7l-.3-.3c-3.1-3.1-5.7-9.2-5.7-13.6V569.3c0-4.4-2.5-10.5-5.7-13.6-4.4-4.4-30.2-30.4-30.2-30.4-3.1-3.1-9.2-5.7-13.6-5.7h-40.9"
        />
        <path className="st89" d="M1991.1 580.8l42.7-42.7" />
        <path
          className="st91"
          d="M2034.1 900.5c4.4 0 10.5 2.5 13.6 5.7l129.6 129.6c3.1 3.1 5.6 9.2 5.6 13.6v134.8"
        />
        <path
          className="st80"
          d="M2034.1 900.5c4.4 0 10.5 2.5 13.6 5.7l129.6 129.6c3.1 3.1 5.6 9.2 5.6 13.6v134.8"
        />
        <path className="st90" d="M1917.4 961.9L2132.2 961.9" />
        <path className="st80" d="M1917.4 961.9L2132.2 961.9" />
        <path
          className="st91"
          d="M1836.9 900.5c4 0 9.8 2.5 12.9 5.7l11.4 11.4c3.1 3.1 5.7 9.2 5.7 13.6"
        />
        <path
          className="st80"
          d="M1836.9 900.5c4 0 9.8 2.5 12.9 5.7l11.4 11.4c3.1 3.1 5.7 9.2 5.7 13.6"
        />
        <path
          className="st91"
          d="M1496.5 872.2h108.8c4.4 0 10.5 2.5 13.7 5.7l17 17c3.1 3.1 9.2 5.7 13.6 5.7h517c4.4 0 10.5 2.5 13.6 5.7l56.5 53.4V1127"
        />
        <path
          className="st80"
          d="M1496.5 872.2h108.8c4.4 0 10.5 2.5 13.7 5.7l17 17c3.1 3.1 9.2 5.7 13.6 5.7h517c4.4 0 10.5 2.5 13.6 5.7l56.5 53.4V1127"
        />
        <path
          className="st91"
          d="M2010 582.2l-137.5 137.6c-3.1 3.1-5.7 7.8-5.7 12.2v597.1"
        />
        <path
          className="st80"
          d="M2010 582.2l-137.5 137.6c-3.1 3.1-5.7 7.8-5.7 12.2v597.1"
        />
        <g>
          <path className="st90" d="M1851.4 961.9L1917.4 961.9" />
          <path className="st80" d="M1851.4 961.9L1917.4 961.9" />
        </g>
        <g>
          <path className="st90" d="M1813.6 893.8L1813.6 941.6" />
          <path className="st80" d="M1813.6 893.8L1813.6 941.6" />
        </g>
        <path
          className="st80"
          d="M1836.9 900.5c4 0 9.8 2.5 12.9 5.7l11.4 11.4c3.1 3.1 5.7 9.2 5.7 13.6M2035.3 900.5c-4.4 0-10.5-2.5-13.6-5.7M2034.1 900.5c4.4 0 10.5 2.5 13.6 5.7M1650.7 900.5c-4.4 0-10.5 2.5-13.6 5.7"
        />
        <path className="st85" d="M1995.1 576.8l36.3-36.3" />
      </g>
      <path
        d="M1235.3 1078.5h101.2c4.4 0 10.5-2.5 13.6-5.7l101.6-101.6c3.1-3.1 5.7-9.2 5.7-13.6v-93.2"
        fill="none"
        stroke="#86cebc"
        strokeWidth={5.7012}
        strokeLinejoin="round"
        strokeMiterlimit={3.9938}
        id="W__x26__City"
      />
      <g id="Bakerloo">
        <path
          transform="rotate(-45.001 1083.747 752.827)"
          className="st93"
          d="M1080.4 750.9H1087.1000000000001V754.6999999999999H1080.4z"
        />
        <path className="st93" d="M873.5 658.9H877.3V665.6H873.5z" />
        <path
          className="st93"
          d="M664.7 424.4H671.4000000000001V428.2H664.7z"
        />
        <path
          className="st93"
          d="M664.7 448.1H671.4000000000001V451.90000000000003H664.7z"
        />
        <path
          className="st93"
          d="M664.7 494.1H671.4000000000001V497.90000000000003H664.7z"
        />
        <path
          className="st93"
          d="M664.7 516.9H671.4000000000001V520.6999999999999H664.7z"
        />
        <path
          transform="rotate(-44.992 676.516 640.08)"
          className="st93"
          d="M673.2 638.2H679.9000000000001V642H673.2z"
        />
        <path
          className="st93"
          d="M727.4 665.6H731.1999999999999V672.3000000000001H727.4z"
        />
        <path
          transform="rotate(-45.001 697.067 660.624)"
          className="st93"
          d="M693.7 658.7H700.4000000000001V662.5H693.7z"
        />
        <path className="st93" d="M1234.3 1159.7H1241V1163.5H1234.3z" />
        <path
          d="M1257.4 1268.8l-17.5-17.5c-3.1-3.1-5.7-9.2-5.7-13.6V972.3c0-4.4-2.5-10.5-5.7-13.6l-108-108c-3.1-3.1-5.7-9.2-5.7-13.6v-40.3c0-5.4-2.1-10.7-5.7-13.6l-111.6-112c-3.1-3.1-9.2-5.7-13.6-5.7-4.3 0-268.9.1-268.9.1-4.4 0-10.5-2.5-13.6-5.7L677 635.5c-3.5-3.5-5.4-8.3-5.4-13.3v-9.3-322.1"
          fill="none"
          stroke="#b06010"
          strokeWidth={5.7012}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
        <path className="st95" d="M659.9 382.9L692.2 382.9" />
        <path className="st81" d="M672.5 424.4H677.6V428.2H672.5z" />
        <path
          className="st81"
          d="M672.5 448.1H677.6V451.90000000000003H672.5z"
        />
        <path
          className="st81"
          d="M672.5 494.1H677.6V497.90000000000003H672.5z"
        />
        <path
          className="st81"
          d="M672.5 516.9H677.6V520.6999999999999H672.5z"
        />
      </g>
      <g id="Jubilee">
        <path className="st96" d="M798.5 289.7H805.2V293.5H798.5z" />
        <path className="st96" d="M798.5 318.4H805.2V322.2H798.5z" />
        <path
          transform="rotate(-45.009 827.904 400.542)"
          className="st96"
          d="M824.5 398.7H831.2V402.5H824.5z"
        />
        <path
          transform="rotate(-45.001 850.117 422.733)"
          className="st96"
          d="M846.8 420.8H853.5V424.6H846.8z"
        />
        <path
          transform="rotate(-44.992 871.329 444.003)"
          className="st96"
          d="M868 442.1H874.7V445.90000000000003H868z"
        />
        <path
          className="st96"
          d="M1033.7 650.3H1040.4V654.0999999999999H1033.7z"
        />
        <path
          d="M798.6 268.1v99.8c0 4.4 2.5 10.5 5.7 13.6L1024.8 602c5.6 5.5 9 13.2 9 21.7v232c0 4.4 2.5 10.5 5.7 13.6l154.3 153.5c3.1 3.1 5.7 9.3 5.7 13.6v62.3c0 10.6 8.6 25.4 19.1 25.4H1320c4.4 0 10.5-2.5 13.6-5.7l96.8-96.8c3.1-3.1 9.2-5.7 13.6-5.7h500c4.4 0 10.5-2.5 13.6-5.7l30.8-30.8c3.1-3.1 5.7-7.1 5.7-12.8V613.1c0-5.7 2.5-9.7 5.7-12.8l15.8-15.8"
          fill="none"
          stroke="#949ca1"
          strokeWidth={5.7012}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
      </g>
      <g id="Victoria">
        <path
          fill="#009ddc"
          d="M1057.4 1116.1H1064.1000000000001V1119.8999999999999H1057.4z"
        />
        <path
          className="st99"
          d="M1531.1 604.9V471.7c0-4.4 2.5-10.5 5.7-13.6l68.8-68.8c3.1-3.1 7.9-5.6 11.6-5.6H1861M1221.2 1405.9l-151.5-151.5c-3.1-3.1-5.7-9.2-5.7-13.6l.5-369.8c0-4.4 2.5-10.5 5.7-13.6L1281 646.5c3.1-3.1 9.2-5.7 13.6-5.7h200.6"
        />
        <path
          className="st99"
          d="M1465.1 640.9h53.5c6.9 0 12.4-5.6 12.4-12.4v-35.3"
        />
      </g>
      <g id="Northern">
        <path d="M1211.1 768.5H1216.8999999999999V771.7H1211.1z" />
        <path d="M1402 666.3H1405.8V673H1402z" />
        <path
          className="st100"
          d="M1258.8 550.8c0-4.4-2.5-10.5-5.7-13.6L955 239.1"
        />
        <path
          transform="rotate(-45.009 1311.47 238.704)"
          d="M1304.7 236.8H1318.1000000000001V240.60000000000002H1304.7z"
        />
        <path d="M1331.6 170.5H1338.3V174.3H1331.6z" />
        <path d="M1338.3 314.4H1345V318.2H1338.3z" />
        <path d="M1338.3 344.7H1345V348.5H1338.3z" />
        <path d="M1338.3 449.3H1345V453.1H1338.3z" />
        <path
          className="st100"
          d="M1338.3 273.5c0-4.4-2.5-10.5-5.7-13.6l-21.1-21.1"
        />
        <path
          transform="rotate(-45.001 982.214 270.978)"
          d="M978.9 269.1H985.6V272.90000000000003H978.9z"
        />
        <path
          transform="rotate(-45.009 1008.525 297.33)"
          d="M1005.2 295.4H1011.9000000000001V299.2H1005.2z"
        />
        <path
          transform="rotate(-45.009 1077.712 358.886)"
          d="M1074.4 357H1081.1000000000001V360.8H1074.4z"
        />
        <path
          transform="rotate(-45.009 1139.084 418.102)"
          d="M1135.7 416.2H1142.4V420H1135.7z"
        />
        <path
          transform="rotate(-45.001 1220.818 509.613)"
          d="M1217.5 507.7H1224.2V511.5H1217.5z"
        />
        <path
          transform="rotate(-45.001 1246.55 535.355)"
          d="M1243.2 533.5H1249.9V537.3H1243.2z"
        />
        <path
          className="st100"
          d="M1270.8 647.1v-44.5c0-4.4-2.5-10.5-5.7-13.6l-.7-.7c-3.1-3.1-5.7-9.2-5.7-13.6v-23.8c0-4.4 2.5-10.5 5.7-13.6l68.2-68.2c3.1-3.1 5.7-9.2 5.7-13.6V147.9"
        />
        <path
          className="st100"
          d="M1246.8 656.9v-54.3c0-4.4 2.5-10.5 5.7-13.6l.7-.7c3.1-3.1 5.7-9.2 5.7-13.6v-23.8M1212.5 1263l-5.3 5.4c-3.1 3.1-5.7 9.2-5.7 13.7v16c0 4.4-2.5 10.5-5.7 13.6l-16.8 16.8M1236.7 1290.5l-9.8 9.8c-3.1 3.1-9.2 5.7-13.6 5.7h-3.8c-4.4 0-10.5 2.5-13.6 5.7l-16.8 16.8"
        />
        <path d="M1240.1 602.1H1246.8V605.9H1240.1z" />
        <path
          transform="rotate(-44.992 1187.306 1315.187)"
          d="M1185.4 1311.8H1189.2V1318.5H1185.4z"
        />
        <path
          transform="rotate(-45.017 1395.684 1139.306)"
          d="M1393.8 1135.9H1397.6V1142.6000000000001H1393.8z"
        />
        <path
          className="st100"
          d="M1233.3 1293.9l243.2-243.2c3.1-3.1 5.7-9.2 5.7-13.6V685.8c0-5.4-2.2-10.3-5.7-13.8s-8.4-5.7-13.8-5.7H1290c-10.6 0-19.2-8.6-19.2-19.2"
        />
        <path className="st100" d="M885 1622.4L1159.8 1347.7 1163 1344.5" />
        <path
          className="st100"
          d="M1137.4 1269.8h60.5c5.4 0 10.3-2.2 13.8-5.7s5.7-8.4 5.7-13.8v-42.9"
        />
        <path className="st100" d="M1100.1 1248.7L984.2 1248.7" />
        <path
          className="st100"
          d="M1217.4 1210.8V701.9c0-4.4 2.5-10.5 5.7-13.6l18.1-18.2c3.1-3.1 5.7-9.1 5.7-13.3M1087.2 1248.7h13.6c4.4 0 10.5 2.5 13.6 5.7l9.7 9.7c3.1 3.1 9.1 5.7 13.3 5.7"
        />
        <path
          transform="rotate(-45.025 1092.882 1409.78)"
          d="M1091 1406.4H1094.8V1413.1000000000001H1091z"
        />
        <path
          transform="rotate(-45.001 1072.274 1430.454)"
          d="M1070.4 1427.1H1074.2V1433.8H1070.4z"
        />
        <path
          transform="rotate(-45.017 1037.152 1474.948)"
          d="M1035.3 1471.6H1039.1V1478.3H1035.3z"
        />
        <path
          transform="rotate(-45.025 1020.917 1491.266)"
          d="M1019 1487.9H1022.8V1494.6000000000001H1019z"
        />
        <path
          transform="rotate(-45.053 988.634 1523.668)"
          d="M986.8 1520.4H990.5999999999999V1527.1000000000001H986.8z"
        />
        <path
          fill="none"
          stroke="#000"
          strokeWidth={5.7005}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
          d="M1196.4 1311.1L1161.3 1346.2"
        />
      </g>
      <g id="Piccadilly">
        <path
          transform="rotate(-45.009 1248.258 848.112)"
          className="st42"
          d="M1246.4 844.7H1250.2V851.4000000000001H1246.4z"
        />
        <path className="st42" d="M1287.3 743.2H1294V747H1287.3z" />
        <path
          transform="rotate(-45.001 1032.273 905.768)"
          className="st42"
          d="M1030.4 902.4H1034.2V909.1H1030.4z"
        />
        <path
          transform="rotate(-45.001 981.427 956.594)"
          className="st42"
          d="M979.6 953.2H983.4V959.9000000000001H979.6z"
        />
        <path className="st42" d="M890.7 991.8H894.5V998.5H890.7z" />
        <path className="st42" d="M1576.1 135.7H1589.6V139.5H1576.1z" />
        <path
          className="st42"
          d="M1576.1 197.3H1582.8V201.10000000000002H1576.1z"
        />
        <path className="st42" d="M1576.1 228.1H1582.8V231.9H1576.1z" />
        <path className="st42" d="M1576.1 258.9H1582.8V262.7H1576.1z" />
        <path className="st42" d="M1576.1 289.7H1582.8V293.5H1576.1z" />
        <path className="st42" d="M1576.1 289.7H1582.8V293.5H1576.1z" />
        <path className="st42" d="M1576.1 320.4H1582.8V324.2H1576.1z" />
        <path className="st42" d="M1578.6 372.9H1585.3V376.7H1578.6z" />
        <path
          transform="rotate(-44.992 1484.871 497.436)"
          className="st42"
          d="M1483 494.1H1486.8V500.8H1483z"
        />
        <path
          transform="rotate(-44.992 1512.626 469.684)"
          className="st42"
          d="M1510.7 466.3H1514.5V473H1510.7z"
        />
        <path
          transform="rotate(-44.984 385.732 1008.702)"
          className="st42"
          d="M383.9 1005.3H387.7V1012H383.9z"
        />
        <path
          transform="rotate(-44.984 353.271 1041.115)"
          className="st42"
          d="M351.4 1037.7H355.2V1044.4H351.4z"
        />
        <path className="st42" d="M404 991.9H407.8V998.6H404z" />
        <path
          transform="rotate(-44.984 331.698 1062.692)"
          className="st42"
          d="M329.8 1059.3H333.6V1066H329.8z"
        />
        <path
          transform="rotate(-44.984 289.006 1105.382)"
          className="st42"
          d="M287.1 1102H290.90000000000003V1108.7H287.1z"
        />
        <path
          transform="rotate(-44.984 235.447 1158.916)"
          className="st42"
          d="M233.6 1155.5H237.4V1162.2H233.6z"
        />
        <path
          className="st102"
          d="M385.4 1004.2c3.1-3.1 9.2-5.7 13.6-5.7h537.1c4.4 0 10.5-2.5 13.6-5.7l93.2-93.2c3.1-3.1 9.2-5.7 13.6-5.7h132.8c4.4 0 10.5-2.5 13.6-5.7l85.2-85.2c3.1-3.1 5.7-9.2 5.7-13.6v-88.6c0-4.4 2.5-10.5 5.7-13.6L1577 409.7c3.1-3.1 5.7-9.2 5.7-13.6V137.6"
        />
        <path className="st42" d="M442 436.4H448.7V440.2H442z" />
        <path className="st42" d="M442 598.4H448.7V602.1999999999999H442z" />
        <path className="st42" d="M442 813.9H448.7V817.6999999999999H442z" />
        <path
          className="st42"
          d="M543.3 998.6H547.0999999999999V1005.3000000000001H543.3z"
        />
        <path className="st42" d="M750 991.8H753.8V998.5H750z" />
        <path
          className="st102"
          d="M475.5 998.6c-6.8 0-13.4-2.5-18.6-7.7l-4.4-4.4c-2.5-2.5-3.7-5.2-3.8-8.9v-553c0-4.4-2.5-10.5-5.7-13.6 0 0-93-92.9-95.6-95.5-2.3-2.3-6.6-4.6-10.2-4.6H148.4M145.4 1279.6v-26.3c0-6 2.4-11.3 6.3-15.2l233.7-233.7"
        />
        <path
          className="st102"
          d="M230.2 1159.5c-4.2 4.2-6.3 9.7-6.3 15.2v98.4c0 11.9-9.6 21.5-21.5 21.5h-14.9c-11.9 0-21.5-9.6-21.5-21.5v-40.6c0-6 2.4-11.3 6.3-15.2l44.2-44.2"
        />
        <path className="st103" d="M217.1 1250.4L223.9 1257.2 230.6 1250.4" />
        <path className="st103" d="M172.8 1260.2L166.1 1253.4 159.3 1260.1" />
      </g>
      <g id="Central">
        <path className="st72" d="M911.2 861.8H915V868.5H911.2z" />
        <path className="st72" d="M805.6 861.8H809.4V868.5H805.6z" />
        <path
          transform="rotate(-45.001 980.484 829.516)"
          className="st72"
          d="M978.6 826.1H982.4V832.8000000000001H978.6z"
        />
        <path
          transform="rotate(-45.001 961.151 858.18)"
          className="st72"
          d="M959.3 854.8H963.0999999999999V861.5H959.3z"
        />
        <path className="st72" d="M1302.9 807.3H1306.7V813.9H1302.9z" />
        <path className="st72" d="M1396 857.6H1399.8V864.3000000000001H1396z" />
        <path className="st72" d="M1738.3 702.9H1742.1V709.6H1738.3z" />
        <path
          className="st104"
          d="M2000.9 407.9c0-6.9 5.6-12.4 12.4-12.4h95.2c6.9 0 12.4-5.6 12.4-12.4V258.7c0-6.9-5.6-12.4-12.4-12.4h-95.2c-6.9 0-12.4 5.6-12.4 12.4"
        />
        <path
          className="st72"
          d="M2000.9 99.6H2007.6000000000001V103.39999999999999H2000.9z"
        />
        <path
          className="st72"
          d="M2000.9 151.7H2007.6000000000001V155.5H2000.9z"
        />
        <path
          className="st72"
          d="M2000.9 432H2007.6000000000001V435.8H2000.9z"
        />
        <path
          className="st72"
          d="M2000.9 508.1H2007.6000000000001V511.90000000000003H2000.9z"
        />
        <path className="st72" d="M2001 312H2007.7V315.8H2001z" />
        <path className="st72" d="M2001 341.8H2007.7V345.6H2001z" />
        <path className="st72" d="M2121 305.9H2127.7V309.7H2121z" />
        <path className="st72" d="M2121 333.8H2127.7V337.6H2121z" />
        <path className="st72" d="M2121 367.2H2127.7V371H2121z" />
        <path
          className="st72"
          d="M2072.8 246.3H2076.6000000000004V253H2072.8z"
        />
        <path
          className="st72"
          d="M2102.9 395.5H2106.7000000000003V402.2H2102.9z"
        />
        <path className="st72" d="M2033.5 395.5H2037.3V402.2H2033.5z" />
        <path className="st72" d="M2068.2 388.8H2072V395.5H2068.2z" />
        <path
          className="st72"
          d="M2102.9 239.6H2106.7000000000003V246.29999999999998H2102.9z"
        />
        <path
          className="st104"
          d="M276 369.3v212.4c0 4.4 2.5 10.5 5.6 13.6l260.8 260.8c3.1 3.1 9.2 5.7 13.6 5.7"
        />
        <path
          className="st72"
          d="M269.4 393.1H276.09999999999997V396.90000000000003H269.4z"
        />
        <path className="st72" d="M269.3 519.8H276V523.5999999999999H269.3z" />
        <path
          transform="rotate(-45.001 363.276 681.787)"
          className="st72"
          d="M359.9 679.9H366.59999999999997V683.6999999999999H359.9z"
        />
        <path className="st72" d="M492.2 861.9H496V868.6H492.2z" />
        <path className="st72" d="M584.1 861.9H587.9V868.6H584.1z" />
        <path
          className="st72"
          d="M625.8 855.2H629.5999999999999V861.8000000000001H625.8z"
        />
        <path
          className="st104"
          d="M2000.9 73v478.8c0 5.1-2.1 13.2-5.7 16.7L1859.8 704c-3.1 3.1-9.2 5.7-13.6 5.7h-211.1c-4.4 0-10.5 2.5-13.6 5.7l-140.9 141c-3.1 3.1-9.2 5.7-13.6 5.7h-77c-4.4 0-10.5-2.5-13.7-5.7l-37-37c-3.1-3.1-9.2-5.7-13.6-5.7h-316.4c-4.4 0-10.5 2.5-13.6 5.7l-37 37c-3.1 3.1-9.2 5.7-13.7 5.7H409.1"
        />
      </g>
      <g id="H__x26__C">
        <path className="st105" d="M696.8 917.5H703.5V921.3H696.8z" />
        <path className="st105" d="M696.8 944.1H703.5V947.9H696.8z" />
        <path className="st105" d="M703.2 816H710.2V819.9H703.2z" />
        <path className="st105" d="M703.2 793.4H710.2V797.3H703.2z" />
        <path className="st105" d="M703.2 771.7H710.2V775.6H703.2z" />
        <path
          transform="rotate(-45.009 719.483 741.014)"
          className="st105"
          d="M717.5 737.5H721.4V744.5H717.5z"
        />
        <path
          transform="rotate(-45.009 744.24 716.325)"
          className="st105"
          d="M742.3 712.8H746.1999999999999V719.8H742.3z"
        />
        <path
          d="M703.2 963.5V760.3c0-2 .6-4.8 1.6-7.2 1-2.4 2.5-4.9 4-6.3l60.6-60.6c4.8-4.8 11.1-7.4 17.8-7.4h538.9c6.7 0 13.1 2.6 17.8 7.4l93.1 93c2.6 2.6 6.1 4 9.8 4h146.5c6.7 0 13.1 2.6 17.8 7.4l18.4 18.3c3.2 3.2 6.4 5.6 11.8 5.6 5.8 0 8.2-2.1 11.6-5.6l78.5-78.5c4.2-4.2 11.8-7.3 17.7-7.3h292.1c2.9 0 7.6-1.9 9.6-4l98.6-98.6"
          fill="none"
          stroke="#f386a1"
          strokeWidth={5.7016}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
      </g>
      <g id="Circle">
        <path className="st107" d="M890.7 1003.4H894.5V1010.1H890.7z" />
        <path
          transform="rotate(-45.02 1402.826 939.552)"
          className="st107"
          d="M1401 936.2H1404.8V942.9000000000001H1401z"
        />
        <path className="st107" d="M702.5 917.5H709.2V921.3H702.5z" />
        <path className="st107" d="M702.5 944.1H709.2V947.9H702.5z" />
        <path
          transform="rotate(-44.992 723.668 745.251)"
          className="st107"
          d="M721.7 741.8H725.6V748.8H721.7z"
        />
        <path className="st107" d="M709.2 816H716.2V819.9H709.2z" />
        <path
          d="M708.9 962.8V760.3h0c0-1.1.4-3.1 1.2-5h0c.8-1.9 1.9-3.7 2.7-4.4l60.7-60.7c3.8-3.8 8.8-5.7 13.8-5.7h-.4 539.3c5.4 0 10.3 2.2 13.8 5.7l93.1 93c3.5 3.5 8.4 5.7 13.8 5.7h146.5c5.4 0 10.3 2.2 13.8 5.7s5.7 8.4 5.7 13.8v74.1c0 5.4-2.2 10.3-5.7 13.8s-8.4 5.7-13.8 5.7H1453c-5.1 0-10 2-13.6 5.6l-98.5 98.5c-2.6 2.6-6.1 4-9.8 4h-461c-5.4 0-10.3-2.2-13.8-5.7-3.8-3.8-5.7-8.8-5.7-13.8V719.5c0-5.4 2.2-10.3 5.7-13.8l.2-.2c3.8-3.8 8.8-5.7 13.8-5.7h47"
          fill="none"
          stroke="#ffd200"
          strokeWidth={5.7012}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
        <path className="st107" d="M709.2 793.4H716.2V797.3H709.2z" />
        <path className="st105" d="M703.2 816H710.2V819.9H703.2z" />
        <path className="st105" d="M703.2 793.4H710.2V797.3H703.2z" />
        <path className="st107" d="M709.2 771.7H716.2V775.6H709.2z" />
        <path className="st105" d="M703.2 771.7H710.2V775.6H703.2z" />
        <path
          transform="rotate(-45.009 719.483 741.014)"
          className="st105"
          d="M717.5 737.5H721.4V744.5H717.5z"
        />
        <path className="st107" d="M850.6 921.2H857.3000000000001V925H850.6z" />
        <path
          className="st107"
          d="M850.6 775.1H857.3000000000001V778.9H850.6z"
        />
      </g>
      <g id="District">
        <path
          className="st109"
          d="M994.9 1015.9H998.6999999999999V1022.6H994.9z"
        />
        <path className="st109" d="M1097.3 1016H1101.1V1022.7H1097.3z" />
        <path
          className="st110"
          d="M825.4 1015.9c5.4 0 10.7-2.6 13.8-5.7s5.7-8.4 5.7-13.8v-277c0-6.7 2.6-13.1 7.4-17.8l.2-.2c4.8-4.8 11.1-7.4 17.8-7.4H917"
        />
        <path
          className="st110"
          d="M834.7 1016c-5.4 0-10.3-2.2-13.8-5.7s-5.7-8.4-5.7-13.8v-53.3"
        />
        <path
          d="M834.7 1016c-5.4 0-10.3-2.2-13.8-5.7s-5.7-8.4-5.7-13.8v-53.3"
          fill="none"
          stroke="#fff"
          strokeWidth={3.7644}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
        <path
          d="M834.7 1016c-5.4 0-10.3-2.2-13.8-5.7s-5.7-8.4-5.7-13.8v-53.3"
          fill="none"
          stroke="#00853f"
          strokeWidth={5.4498}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
          strokeDasharray="3.7995,3.7995"
        />
        <path className="st109" d="M808.4 1169.9H815.1V1173.7H808.4z" />
        <path className="st109" d="M808.4 1191H815.1V1194.8H808.4z" />
        <path
          className="st109"
          d="M808.4 1244.1H815.1V1247.8999999999999H808.4z"
        />
        <path className="st109" d="M808.4 1299.9H815.1V1303.7H808.4z" />
        <path
          className="st110"
          d="M834.7 1015.9c-5.4 0-10.3 2.2-13.8 5.7s-5.7 8.4-5.7 13.8v293.3"
        />
        <path
          transform="rotate(-44.992 1734.744 740)"
          className="st109"
          d="M1732.9 736.6H1736.7V743.3000000000001H1732.9z"
        />
        <path
          transform="rotate(-45.041 2346.808 435.861)"
          className="st109"
          d="M2344.9 432.5H2348.7000000000003V439.2H2344.9z"
        />
        <path
          transform="rotate(-44.955 2321.95 460.702)"
          className="st109"
          d="M2320.2 457.4H2324V464.09999999999997H2320.2z"
        />
        <path
          transform="rotate(-44.984 2266.873 514.642)"
          className="st109"
          d="M2265 511.3H2268.8V518H2265z"
        />
        <path
          transform="rotate(-44.972 2220.312 561.768)"
          className="st109"
          d="M2218.6 558.4H2222.4V565.1H2218.6z"
        />
        <path
          transform="rotate(-45.001 2099.864 682.929)"
          className="st109"
          d="M2098 679.5H2101.8V686.2H2098z"
        />
        <path
          className="st110"
          d="M2372.5 405.5l-317.8 317.8c-3.1 3.1-9.2 5.7-13.6 5.7H1749c-4.4 0-10.5 2.5-13.6 5.7l-111.2 111.1c-3.8 3.8-5.7 8.8-5.7 13.8v23.1c0 6.7-2.6 13.1-7.4 17.8s-11.1 7.4-17.8 7.4H1453c-3.6 0-7 1.4-9.6 4l-98.5 98.5c-3.5 3.5-8.4 5.7-13.8 5.7H662.8"
        />
        <path
          transform="rotate(-45.001 2067.673 715.048)"
          className="st109"
          d="M2065.8 711.7H2069.6000000000004V718.4000000000001H2065.8z"
        />
        <path
          className="st110"
          d="M509.3 1189.8v-154.7c0-5.3 2.1-10.1 5.6-13.6 3.5-3.5 8.3-5.6 13.6-5.6"
        />
        <path className="st109" d="M603.8 1016H607.4V1022.4H603.8z" />
        <path
          className="st109"
          d="M543.3 1016H547.0999999999999V1022.7H543.3z"
        />
        <path className="st109" d="M479 1016H482.8V1022.7H479z" />
        <path
          className="st110"
          d="M816.9 1016H479.4c-5.4 0-10.3-2.2-13.8-5.7l-18.9-18.9c-3.5-3.5-5.7-8.4-5.7-13.8v-78c0-5.4-2.2-10.3-5.7-13.8s-8.4-5.7-13.8-5.7h-12.4"
        />
        <path className="st109" d="M750 1009.2H753.8V1015.9000000000001H750z" />
        <path
          className="st109"
          d="M667.4 1016H671.1999999999999V1022.7H667.4z"
        />
        <path className="st109" d="M782.7 1016H786.5V1022.7H782.7z" />
        <path
          className="st109"
          d="M890.7 1009.1H894.5V1015.8000000000001H890.7z"
        />
        <path className="st109" d="M1311.5 1015.9H1315.3V1022.6H1311.5z" />
        <path
          transform="rotate(-45.001 1406.712 943.732)"
          className="st109"
          d="M1404.8 940.4H1408.6V947.1H1404.8z"
        />
        <path
          className="st107"
          d="M1097.3 1010.2H1101.1V1016.9000000000001H1097.3z"
        />
        <path
          className="st107"
          d="M1311.5 1010.2H1315.3V1016.9000000000001H1311.5z"
        />
      </g>
      <g id="Metropolitan">
        <path
          className="st113"
          d="M1104.1 690.2H1107.8999999999999V696.9000000000001H1104.1z"
        />
        <path
          className="st113"
          d="M1600.4 844.1H1607.1000000000001V847.9H1600.4z"
        />
        <path
          className="st114"
          d="M181.9 130.6c-4.4 0-10.5-2.5-13.6-5.7l-28.8-28.8"
        />
        <path
          className="st113"
          d="M306.8 296.4H310.6V303.09999999999997H306.8z"
        />
        <path
          transform="rotate(-45.001 360.726 313.122)"
          className="st113"
          d="M357.4 311.2H364.09999999999997V315H357.4z"
        />
        <path
          transform="rotate(-45.001 390.182 342.518)"
          className="st113"
          d="M386.8 340.6H393.5V344.40000000000003H386.8z"
        />
        <path
          transform="rotate(-44.992 390.892 228.386)"
          className="st113"
          d="M387.5 226.5H394.2V230.3H387.5z"
        />
        <path className="st113" d="M373.5 175H380.2V178.8H373.5z" />
        <path
          className="st113"
          d="M366.8 138.3H380.3V142.10000000000002H366.8z"
        />
        <path
          transform="rotate(-45.001 347.257 194.478)"
          className="st113"
          d="M343.9 192.6H350.59999999999997V196.4H343.9z"
        />
        <path
          transform="rotate(-45.001 417.966 255.43)"
          className="st113"
          d="M414.6 253.5H421.3V257.3H414.6z"
        />
        <path
          transform="rotate(-45.001 445.093 282.612)"
          className="st113"
          d="M441.7 280.7H448.4V284.5H441.7z"
        />
        <path
          transform="rotate(-45.001 498.15 335.64)"
          className="st113"
          d="M494.8 333.8H501.5V337.6H494.8z"
        />
        <path
          className="st113"
          d="M722.8 376.2H726.5999999999999V382.9H722.8z"
        />
        <path
          className="st114"
          d="M148.9 303.1h188.4c5.4 0 12 3.1 15.8 6.9l67.2 67.2c3.1 3.1 9.2 5.6 13.6 5.6h159"
        />
        <path
          className="st113"
          d="M497.9 382.9H501.7V389.59999999999997H497.9z"
        />
        <path
          className="st114"
          d="M1607.1 844.9v-36.4c0-3.7-1.4-7.2-4-9.8-2.6-2.6-6.1-4-9.8-4h-146.5c-6.7 0-13.1-2.6-17.8-7.4l-93.1-93c-2.6-2.6-6.1-4-9.8-4h-250.7c-8.1 0-15.6-4.5-21.1-9.9l-291.7-292c-2.7-2.7-9.2-5.5-13.5-5.5H548.6c-4.4 0-10.5-2.5-13.7-5.6l-240.8-241c-3.1-3.1-9.2-5.6-13.6-5.6H97"
        />
        <path
          className="st114"
          d="M379.1 221.4c-3.1-3.1-5.6-9.2-5.6-13.6v-67.1"
        />
        <path className="st95" d="M276.1 320L276.1 287.8" />
        <path
          className="st107"
          d="M1104.1 684.5H1107.8999999999999V691.2H1104.1z"
        />
        <path
          className="st105"
          d="M1104.1 678.8H1107.8999999999999V685.5H1104.1z"
        />
      </g>
      <g id="Air_Line">
        <path
          className="st72"
          d="M2059.4 981.5c.1-.3.3-1 .4-1.3 0 0 .5-2.2-1.6-7.2l2.4-2-.6-.6-6.9 6 .4.4 2.9-2.4c3.1 2.4 2.1 5.7 2.1 5.7s-.7 1.7-1.7 1.4 0 .4 0 .4l3.6.5c-.1-.1-1.2-.6-1-.9"
        />
        <path className="st72" d="M2052.8 976.2L2059.3 969.8 2059.3 969.8z" />
        <path
          className="st115"
          d="M2059.4 969.8L2052.9 976.2 2053 976.3 2059.9 970.3z"
        />
        <path
          className="st72"
          d="M2062.2 982.8c-.1-.1-.2-.2-.2-.3l-5.7-1.2h-.5c-.4 0-.7 0-1 .1h-.3l-2.4.4h-.1s-.1 0-.1.1c-.2.2-.4.5-.5.8-.4.6-.8 1.3-1 2-.4 1-.6 2-.6 2.9 0 1.2.2 2.4.8 3.6.3.6.7 1.3 1.2 1.9l.1.1c.1.1.2.3.4.4h.1l2.1.4h.2c.4.1.8.2 1.2.2h.2c.2 0 .4-.1.7-.1.3-.1.6-.1.9-.2.8-.2 1.6-.3 2.3-.5.6-.1 1.2-.3 1.9-.4h.1c.1 0 .2 0 .2-.1.1 0 .2-.1.2-.2.1-.2.2-.3.3-.5.2-.3.4-.7.5-1 .5-1.2.7-2.4.7-3.7 0-1-.3-1.9-.6-2.9-.5-.7-.8-1.3-1.1-1.8"
        />
        <path
          className="st4"
          d="M2055.1 982.5c-.1.4-.1.9-.1 1.3-.1.8-.1 1.5-.1 2.3v2.4c-.5 0-.9-.1-1.4-.1-.8-.1-1.6-.1-2.4-.2h-.4c0-.6 0-1.2.1-1.8.2-1.2.6-2.3 1.2-3.3 0 0 .1-.1.1-.2.1-.2.4-.3.5-.3l2.4-.3c-.1 0 .1 0 .1.2"
        />
        <path
          className="st115"
          d="M2057.5 993.7c.8-.2 1.6-.3 2.3-.5.6-.1 1.2-.3 1.9-.4h.1c.1 0 .2 0 .2-.1.1 0 .2-.1.2-.2.1-.2.2-.3.3-.5.2-.3.4-.7.5-1 .5-1.2.7-2.4.7-3.7 0-1-.3-1.9-.6-2.9-.2-.6-.6-1.2-.9-1.7-.1-.1-.1-.2-.2-.3-.1 0-.1-.1-.2-.1-.5-.1-3.6-.8-5.2-1-.2 0-.4-.1-.6-.1-.2 1.7-.7 6.8.1 12.8.2 0 .4 0 .5-.1.3 0 .6-.1.9-.2"
        />
        <path
          className="st116"
          d="M2062.9 988.2h-.6c-.5 0-1.1.1-1.6.1-.6 0-1.3.1-1.9.1l-1.7.1h-.6-.1c-.1-1.1-.1-2.1-.1-6.2l4.6.7h.1c.1 0 .5.1.7.4.1.1.1.2.2.4.1.1.1.2.1.3.1.1.1.2.1.3.6 1.3.9 2.5.8 3.8"
        />
        <path
          d="M2113.4 933.9h-15.2c-4.4 0-10.5 2.5-13.6 5.7l-60.6 60.6c-3.1 3.1-9.2 5.7-13.6 5.7h-10.8"
          fill="none"
          stroke="#fff"
          strokeWidth={6.0019}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
        <path
          d="M2113.4 933.9h-15.2c-4.4 0-10.5 2.5-13.6 5.7l-60.6 60.6c-3.1 3.1-9.2 5.7-13.6 5.7h-10.8"
          fill="none"
          stroke="#e31937"
          strokeWidth={5.7012}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
        <path
          d="M2113.4 933.9h-15.2c-4.4 0-10.5 2.5-13.6 5.7l-60.6 60.6c-3.1 3.1-9.2 5.7-13.6 5.7h-10.8"
          fill="none"
          stroke="#fff"
          strokeWidth={3.4195}
          strokeMiterlimit={1}
        />
        <path
          d="M2113.4 933.9h-15.2c-4.4 0-10.5 2.5-13.6 5.7l-60.6 60.6c-3.1 3.1-9.2 5.7-13.6 5.7h-10.8"
          fill="none"
          stroke="#e31937"
          strokeWidth={1.1398}
          strokeLinejoin="round"
          strokeMiterlimit={3.9938}
        />
      </g>
      <g id="Daggers">
        <path
          className="st72"
          d="M1848 649.5v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7 0-1.7.5-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.3-1 .9-1 .4 0 .6.1 1.3.5.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.5-.2-.8 0-.7.5-1.1 1.2-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.3.7-.5 1-.6 1.7.6 0 .6 0 1.8-.6.3-.2.6-.2.8-.2.6 0 .9.4.9 1s-.4 1-.9 1c-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1l-.6-.1zM1840.3 625.1v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7 0-1.7.5-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.3-1 .9-1 .4 0 .6.1 1.3.5.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.5-.2-.8 0-.7.5-1.1 1.2-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.3.7-.5 1-.6 1.7.6 0 .6 0 1.8-.6.3-.2.6-.2.8-.2.6 0 .9.4.9 1s-.4 1-.9 1c-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1l-.6-.1zM1822.6 930.3v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7 0-1.7.5-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.3-1 .9-1 .4 0 .6.1 1.3.5.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.5-.2-.8 0-.7.5-1.1 1.2-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.3.7-.5 1-.5 1.7.6 0 .6 0 1.8-.6.3-.2.6-.2.8-.2.6 0 .9.4.9 1s-.4 1-.9 1c-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1l-.7-.1zM2403.9 349.5v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7 0-1.6.5-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.4-1 .9-1 .4 0 .6.1 1.3.5.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.5-.2-.8 0-.7.5-1.1 1.1-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.4.6-.5 1-.5 1.7.6 0 .6 0 1.8-.6.3-.2.6-.2.8-.2.6 0 .9.4.9 1s-.4 1-.9 1c-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1l-.7-.1zM566.1 1048.4v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7.1-1.7.4-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.3-1 .9-1 .4 0 .6.1 1.3.4.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.6-.2-.8 0-.7.5-1.1 1.2-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.3.7-.5 1-.5 1.7.6 0 .6-.1 1.8-.6.3-.2.5-.2.8-.2.6 0 .9.4.9 1.1 0 .6-.4 1.1-1 1.1-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1h-.6z"
        />
      </g>
      <g id="Top_Pieces">
        <path
          className="st107"
          d="M994.9 1010.2H998.6999999999999V1016.9000000000001H994.9z"
        />
        <path className="st109" d="M844.9 921.2H851.6V925H844.9z" />
        <path className="st109" d="M844.9 775.1H851.6V778.9H844.9z" />
        <path className="st107" d="M1606.1 844.1H1612.8V847.9H1606.1z" />
        <path className="st93" d="M671.5 562.1H678.2V565.9H671.5z" />
        <path
          transform="rotate(-45.001 1730.682 735.912)"
          className="st105"
          d="M1728.8 732.5H1732.6V739.2H1728.8z"
        />
        <path
          transform="rotate(-45.009 2095.802 678.837)"
          className="st105"
          d="M2093.9 675.4H2097.7000000000003V682.1H2093.9z"
        />
        <path
          transform="rotate(-45.009 2063.642 710.997)"
          className="st105"
          d="M2061.8 707.6H2065.6000000000004V714.3000000000001H2061.8z"
        />
        <path className="st42" d="M306.8 304.1H310.6V310.8H306.8z" />
        <path
          transform="rotate(-45.001 355.302 318.528)"
          className="st42"
          d="M351.9 316.6H358.59999999999997V320.40000000000003H351.9z"
        />
        <path
          transform="rotate(-45.001 384.769 347.935)"
          className="st42"
          d="M381.4 346H388.09999999999997V349.8H381.4z"
        />
        <path className="st104" d="M276 264.6L276 371" />
      </g>
      <g id="Interchange_circles">
        <path
          transform="rotate(-52.831 2164.736 1209.4)"
          d="M2127.6 1205.2H2202.2V1213.8H2127.6z"
        />
        <path
          transform="rotate(-52.865 2164.576 1209.534)"
          className="st4"
          d="M2126.1 1208.1H2203.1V1210.8999999999999H2126.1z"
        />
        <path
          transform="rotate(-45.001 1882.656 976.617)"
          d="M1881 974.9H1884.4V978.3H1881z"
        />
        <path
          transform="rotate(-45.001 1879.009 980.246)"
          d="M1877.3 978.5H1880.7V981.9H1877.3z"
        />
        <path
          transform="rotate(-45.001 1875.366 983.908)"
          d="M1873.7 982.2H1877.1000000000001V985.6H1873.7z"
        />
        <path
          transform="rotate(-45.001 1890.246 969.024)"
          d="M1888.5 967.3H1891.9V970.6999999999999H1888.5z"
        />
        <path
          transform="rotate(-45.001 1886.596 972.68)"
          d="M1884.9 970.9H1888.3000000000002V974.3H1884.9z"
        />
        <path
          transform="rotate(-45.001 1882.956 976.316)"
          d="M1881.3 974.6H1884.7V978H1881.3z"
        />
        <path
          transform="rotate(-45.001 1881.234 950.686)"
          d="M1879.5 949H1882.9V952.4H1879.5z"
        />
        <path
          transform="rotate(-45.001 1877.584 947.05)"
          d="M1875.9 945.3H1879.3000000000002V948.6999999999999H1875.9z"
        />
        <path
          transform="rotate(-45.001 1873.942 943.408)"
          d="M1872.2 941.7H1875.6000000000001V945.1H1872.2z"
        />
        <path
          transform="rotate(-45.001 1888.815 958.281)"
          d="M1887.1 956.5H1890.5V959.9H1887.1z"
        />
        <path
          transform="rotate(-45.001 1885.172 954.639)"
          d="M1883.5 952.9H1886.9V956.3H1883.5z"
        />
        <path
          transform="rotate(-45.001 1881.533 950.985)"
          d="M1879.8 949.3H1883.2V952.6999999999999H1879.8z"
        />
        <path d="M1680.5 777.6H1708V786.2H1680.5z" />
        <path className="st4" d="M1680 780.5H1706.3V783.3H1680z" />
        <path d="M486.6 1143.7H509.1V1152.3H486.6z" />
        <path
          className="st4"
          d="M486.1 1146.6H509.40000000000003V1149.3999999999999H486.1z"
        />
        <path d="M486.6 1186.4H509.1V1195H486.6z" />
        <path
          className="st4"
          d="M486.1 1189.2H509.40000000000003V1192H486.1z"
        />
        <path
          transform="rotate(-45.001 202.7 1172.226)"
          d="M198.4 1161.3H207V1183.2H198.4z"
        />
        <path
          transform="rotate(-44.996 202.76 1172.233)"
          className="st4"
          d="M201.4 1163H204.20000000000002V1181.5H201.4z"
        />
        <path
          transform="rotate(-45.001 1041.473 822.285)"
          d="M1027.7 818H1055.2V826.6H1027.7z"
        />
        <path
          transform="rotate(-44.996 1040.808 823.044)"
          className="st4"
          d="M1027.7 821.7H1054V824.5H1027.7z"
        />
        <path d="M1232 471.7H1240.6V498.3H1232z" />
        <path className="st4" d="M1234.9 471.9H1237.7V498.2H1234.9z" />
        <path
          className="st4"
          d="M703.4 1004.6v5.1c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.2 7.1 7.2s7.2-3.2 7.2-7.2c0-2.9-1.8-5.4-4.3-6.5v-5.1c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.2-7.1s-7.1 3.2-7.1 7.1c0 2.9 1.7 5.4 4.3 6.5z"
        />
        <path d="M700.5 998.1c0-3.2 2.5-5.7 5.7-5.7s5.7 2.5 5.7 5.7c0 2.7-1.8 4.9-4.3 5.5v7.2c2.5.6 4.3 2.9 4.3 5.5 0 3.2-2.6 5.7-5.7 5.7-3.2 0-5.7-2.6-5.7-5.7 0-2.7 1.8-4.9 4.3-5.5v-7.2c-2.5-.6-4.3-2.9-4.3-5.5zm1.4 7.4v3.4c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.2-1.7-5.9-4.3-7.4v-3.4c2.6-1.5 4.2-4.3 4.2-7.4 0-4.7-3.8-8.5-8.5-8.5s-8.5 3.8-8.5 8.5c0 3.1 1.7 5.9 4.2 7.4z" />
        <path
          className="st4"
          d="M455.9 719c0 3.8-3.1 6.9-6.9 6.9-3.8 0-6.9-3.1-6.9-6.9s3.1-6.9 6.9-6.9c3.8 0 6.9 3.1 6.9 6.9z"
        />
        <path d="M457.3 719c0 4.6-3.7 8.3-8.3 8.3-4.6 0-8.3-3.7-8.3-8.3 0-4.6 3.7-8.3 8.3-8.3 4.6 0 8.3 3.7 8.3 8.3zm-8.3 5.5c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5 2.5 5.5 5.5 5.5z" />
        <path
          className="st4"
          d="M412.1 719c0 3.8-3.1 6.9-6.9 6.9-3.8 0-6.9-3.1-6.9-6.9s3.1-6.9 6.9-6.9c3.8 0 6.9 3.1 6.9 6.9z"
        />
        <path d="M413.4 719c0 4.6-3.7 8.3-8.3 8.3-4.6 0-8.3-3.7-8.3-8.3 0-4.6 3.7-8.3 8.3-8.3 4.6.1 8.3 3.8 8.3 8.3zm-8.2 5.5c3 0 5.5-2.5 5.5-5.5s-2.5-5.5-5.5-5.5-5.5 2.5-5.5 5.5c-.1 3.1 2.4 5.5 5.5 5.5z" />
        <path
          transform="rotate(-44.992 1849.868 389.605)"
          d="M1838 385.3H1861.7V393.90000000000003H1838z"
        />
        <path
          className="st4"
          d="M827.4 1004.6v5.1c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.2 7.1 7.2s7.2-3.2 7.2-7.2c0-2.9-1.8-5.4-4.3-6.5v-5.1c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.2-7.1s-7.1 3.2-7.1 7.1c0 2.9 1.8 5.4 4.3 6.5z"
        />
        <path d="M824.6 998.1c0-3.2 2.5-5.7 5.7-5.7s5.7 2.5 5.7 5.7c0 2.7-1.8 4.9-4.3 5.5v7.2c2.5.6 4.3 2.9 4.3 5.5 0 3.2-2.6 5.7-5.7 5.7-3.2 0-5.7-2.6-5.7-5.7 0-2.7 1.8-4.9 4.3-5.5v-7.2c-2.5-.6-4.3-2.9-4.3-5.5zm1.4 7.4v3.4c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.2-1.7-5.9-4.3-7.4v-3.4c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.1 1.7 5.9 4.3 7.4z" />
        <path d="M1161.3 992.1H1169.8999999999999V1014.6H1161.3z" />
        <path
          className="st4"
          d="M1164.2 991.8H1167V1015.0999999999999H1164.2z"
        />
        <path d="M1990 576.4H2013.8V585H1990z" />
        <path
          className="st4"
          d="M1989.5 579.3H2014.3V582.0999999999999H1989.5z"
        />
        <path
          transform="rotate(-45.001 1489.452 879.447)"
          d="M1478.6 875.1H1500.3V883.7H1478.6z"
        />
        <path
          className="st4"
          d="M1219.7 1002.4l8 8c-1 2.6-.5 5.6 1.6 7.7 2.8 2.8 7.3 2.8 10.1 0s2.8-7.3 0-10.1c-2.1-2.1-5.1-2.6-7.7-1.6l-8-8c1-2.6.5-5.6-1.6-7.7-2.8-2.8-7.3-2.8-10.1 0s-2.8 7.3 0 10.1c2.1 2 5.1 2.6 7.7 1.6z"
        />
        <path d="M1213 999.8c-2.2-2.2-2.2-5.8 0-8.1s5.8-2.2 8.1 0c1.9 1.9 2.2 4.8.9 6.9l9.4 9.4c2.2-1.3 5.1-1 6.9.9 2.2 2.2 2.2 5.8 0 8.1-2.2 2.2-5.8 2.2-8.1 0-1.9-1.9-2.2-4.8-.9-6.9l-9.4-9.4c-2.1 1.2-5 1-6.9-.9zm6.3 4.2l6.8 6.8c-.8 2.9 0 6 2.2 8.3 3.3 3.3 8.8 3.3 12.1 0 3.3-3.3 3.3-8.8 0-12.1-2.2-2.2-5.4-3-8.3-2.2l-6.8-6.8c.8-2.9 0-6-2.2-8.3-3.3-3.3-8.8-3.3-12.1 0s-3.3 8.8 0 12.1c2.3 2.2 5.4 3 8.3 2.2z" />
        <path
          className="st4"
          d="M1215.5 1270.2l16.2 16.2c-1 2.6-.4 5.7 1.7 7.8 2.7 2.6 7.2 2.6 9.9-.1 2.8-2.8 2.9-7.4.1-10.2-2.1-2.1-5.1-2.6-7.7-1.6l-16.2-16.2c1-2.6.4-5.7-1.7-7.8-2.7-2.6-7.2-2.6-9.9 0-2.9 2.8-2.9 7.4-.1 10.2 2.1 2.1 5.1 2.7 7.7 1.7z"
        />
        <path d="M1208.8 1267.6c-2.3-2.3-2.2-5.9.1-8.2 2.1-2 5.5-2.1 7.7-.2 2.1 1.9 2.5 4.9 1.2 7.2l17.7 17.7c2.3-1.4 5.3-1 7.2 1.2 1.9 2.2 1.8 5.6-.2 7.7-2.2 2.3-5.9 2.3-8.1.1-1.9-1.9-2.2-4.8-.9-6.9l-17.7-17.7c-2.2 1.2-5.1.9-7-.9zm6.3 4.2l15 15c-.9 3.3.2 6.9 3.3 9.2 3.1 2.2 7.4 2.1 10.3-.3 4.1-3.2 4.3-9.2.7-12.8-2.2-2.2-5.4-3-8.3-2.2l-15-15c.9-3.2-.2-6.9-3.2-9.1-3-2.2-7.3-2.1-10.3.2-4.1 3.2-4.3 9.2-.7 12.8 2.2 2.2 5.3 2.9 8.2 2.2z" />
        <path
          className="st42"
          d="M1608.2 925.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1605.3 936.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1608.4 928.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1609.1 930.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1165.6 986.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1162.7 997.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1165.8 989.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1166.5 991.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1064 885.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1061.1 896.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1064.2 888.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1064.8 890.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7zM1603.3 556.4v5.1c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.2 7.1 7.2 3.9 0 7.2-3.2 7.2-7.2 0-2.9-1.8-5.4-4.3-6.5v-5.1c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.2-7.1-3.9 0-7.1 3.2-7.1 7.1 0 2.9 1.8 5.4 4.3 6.5z"
        />
        <path d="M1600.4 549.8c0-3.2 2.6-5.7 5.7-5.7 3.2 0 5.7 2.5 5.7 5.7 0 2.7-1.8 4.9-4.3 5.5v7.2c2.5.6 4.3 2.9 4.3 5.5 0 3.2-2.6 5.7-5.7 5.7-3.2 0-5.7-2.6-5.7-5.7 0-2.7 1.8-4.9 4.3-5.5v-7.2c-2.4-.6-4.3-2.8-4.3-5.5zm1.5 7.5v3.4c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6 4.7 0 8.6-3.8 8.6-8.6 0-3.2-1.7-5.9-4.3-7.4v-3.4c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.1 1.7 5.9 4.3 7.4z" />
        <path
          transform="rotate(-45.004 919.33 1294.676)"
          className="st42"
          d="M915.1 1285.1H923.7V1304.3999999999999H915.1z"
        />
        <path
          className="st42"
          d="M1684.2 620.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1681.3 631.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1684.3 623.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1685 625.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1684.2 646.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1681.3 657.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1684.3 649.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1685 651.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1684.2 729.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1681.3 741c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1684.3 732.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1685 735.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1706.1 773.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1703.2 784.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1706.3 776.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1707 778.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          transform="rotate(-44.996 919.387 1294.721)"
          d="M915.2 1281.6H923.8000000000001V1307.8999999999999H915.2z"
        />
        <path
          transform="rotate(-45.009 920.099 1295.769)"
          className="st4"
          d="M918.7 1283.2H921.5V1308.4H918.7z"
        />
        <path
          className="st42"
          d="M1684.1 1007.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1681.2 1018.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1684.2 1010.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1684.9 1012.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path d="M826.1 992.8H834.7V1019.9H826.1z" />
        <path
          className="st4"
          d="M828.9 994.7H831.6999999999999V1020.7H828.9z"
        />
        <path
          className="st42"
          d="M830.3 989.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M827.4 1000.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM830.4 992.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M831.1 994.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M830.3 1007.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M827.4 1018.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM830.4 1010.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M831.1 1012.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path d="M1543.7 761.4H1552.3V788.9H1543.7z" />
        <path
          className="st4"
          d="M1547.9 796.4c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5 7.5 3.4 7.5 7.5c0 4.2-3.3 7.5-7.5 7.5z"
        />
        <path d="M1547.9 797.9c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm-5.9-8.9c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6c-3.4 0-6 2.7-6 6z" />
        <path
          transform="rotate(-45.001 1478.59 883.09)"
          d="M1474.3 852.2H1482.8999999999999V914H1474.3z"
        />
        <path
          className="st42"
          d="M2015.6 572.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2012.7 583.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2015.8 575c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2016.4 577.3l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1667.9 588c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1665 599c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1668.1 590.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1668.8 593.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1606.2 559.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1603.3 570.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1606.3 562.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1607 564.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7zM1464.5 861.8c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1465.9 861.8c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7-.1 3.2 2.5 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1489.4 886.7c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1490.8 886.7c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7-.1 3.2 2.5 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1507.7 905c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1509.1 905c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zm-8.5 5.8c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7-.1 3.1 2.5 5.7 5.7 5.7z" />
        <path
          transform="rotate(-45.009 1478.616 883.115)"
          className="st4"
          d="M1477.2 851.7H1480V914.5H1477.2z"
        />
        <path
          transform="rotate(-45.009 1489.44 879.48)"
          className="st4"
          d="M1478.1 878H1500.8999999999999V880.8H1478.1z"
        />
        <path
          className="st42"
          d="M1496.8 863.7c4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5z"
        />
        <path
          className="st4"
          d="M1493.9 874.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.2-1.5 3.2-3.2 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.8-1.5zM1497 866.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1497.6 868.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.4s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.9.7-.9.7z"
        />
        <path
          className="st42"
          d="M1357.7 809c4.7 0 8.5 3.8 8.5 8.5s-3.8 8.5-8.5 8.5-8.5-3.8-8.5-8.5 3.8-8.5 8.5-8.5z"
        />
        <path
          className="st4"
          d="M1354.8 820c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.2-1.5 3.2-3.2 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.8-1.5zM1357.8 811.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1358.5 814.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.4s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.9.7-.9.7z"
        />
        <path
          className="st42"
          d="M1459.7 518.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1456.8 529.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1459.9 521.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1460.6 523.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1709 375.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1706.1 386.1c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1709.2 378c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1709.9 380.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          transform="rotate(-45.001 1550.568 557.02)"
          d="M1546.3 548.1H1554.8999999999999V565.8000000000001H1546.3z"
        />
        <path
          transform="rotate(-44.996 1550.711 556.94)"
          className="st4"
          d="M1549.4 547.6H1552.2V566.4H1549.4z"
        />
        <path
          transform="rotate(-45.001 1758.64 569.237)"
          d="M1754.4 553.3H1763V585H1754.4z"
        />
        <path
          className="st42"
          d="M1866.9 741.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1864 752.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 744.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 746.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 789.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1864 800.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 792.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 795l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 819.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1864 830.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 822.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 824.3l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 848.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1864 859.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 851.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 853.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1295.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1306.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1866.9 1298.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.6 1300.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1270.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1281.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1866.9 1273.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.6 1275.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1201.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1212.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1866.9 1204.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.6 1206.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1150.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1161.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 1153.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 1155.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1120.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1132c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 1123.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 1126l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1091.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1102.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 1094c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 1096.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1061.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1072.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 1064.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 1066.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1031.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1042.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 1034.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 1036.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 983.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 994.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 986.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.6 989l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 929.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 940.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 932.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 934.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1892.2 954.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1889.4 965.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1892.4 957.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1893.1 959.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.8 1319.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1863.9 1330.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1866.9 1322.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.6 1325l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          transform="rotate(-44.992 2004.795 889.642)"
          d="M1988.8 885.3H2020.8999999999999V893.9H1988.8z"
        />
        <path
          transform="rotate(-45.009 2004.78 889.528)"
          className="st4"
          d="M1988.2 888.1H2021.3V890.9H1988.2z"
        />
        <path
          transform="rotate(-44.992 2208.646 954.575)"
          d="M2193.8 950.3H2223.5V958.9H2193.8z"
        />
        <path
          transform="rotate(-45.009 2208.621 954.432)"
          className="st4"
          d="M2193.3 953H2223.9V955.8H2193.3z"
        />
        <path
          transform="rotate(-44.992 2004.336 714.94)"
          d="M2000 698.9H2008.6V731H2000z"
        />
        <path
          transform="rotate(-45.009 2004.308 714.879)"
          className="st4"
          d="M2002.9 698.3H2005.7V731.4H2002.9z"
        />
        <path
          className="st42"
          d="M1994.1 891.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1991.2 903c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1994.2 894.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1994.9 897l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2016 869.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2013.1 880.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2016.1 872.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2016.8 874.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2198.5 955.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2195.6 966.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2198.6 958.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2199.3 960.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2219.6 934.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2216.6 945.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2219.7 937.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2220.4 939.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2113.1 892c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2110.2 903c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2113.2 894.9c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2113.9 897.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1866.9 892c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1864 903c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867 894.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.7-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1867.7 897.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1743.9 892c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1741 903c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1744.1 894.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.7-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1744.8 897.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1781.1 892c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1778.2 903c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1781.3 894.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.7-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1781.9 897.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1903.8 892c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1900.9 903c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1903.9 894.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.7-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1904.6 897.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1954.2 892c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1951.3 903c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1954.3 894.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.7-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1955 897.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2236.4 956.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2233.5 967.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2236.5 959.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2237.2 961.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2236.4 987.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2233.5 998.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2236.5 990.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2237.2 992.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2236.4 1018.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2233.5 1029.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2236.5 1021.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2237.2 1023.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2236.4 1049.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2233.5 1061c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2236.5 1052.8c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2237.2 1055l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2236.4 1081.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2233.5 1092.2c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2236.5 1084c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2237.2 1086.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2236.4 1112.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2233.5 1123.3c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2236.5 1115.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2237.2 1117.4l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2183.6 1112.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2180.7 1123.3c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2183.7 1115.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2184.4 1117.4l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2183.6 1040.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2180.7 1051.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2183.7 1043.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2184.4 1045.4l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2183.6 1076.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2180.7 1087.3c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2183.7 1079.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2184.4 1081.4l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2142 991.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2139.1 1003c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2142.2 994.8c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2142.9 997l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1924.1 511.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1921.2 522.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1924.2 514c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1924.9 516.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2015.6 796.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2012.7 808c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2015.8 799.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2016.5 802l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1961.8 997.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1958.9 1008.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1961.9 1000.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1962.6 1002.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1582.4 159.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1579.5 170.6c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1582.6 162.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1583.2 164.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1052.7 327.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1049.8 338.7c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1052.9 330.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1053.5 332.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M953.8 229.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M950.9 240.3c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM954 232.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M954.6 234.4l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1338.3 276.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1335.4 288c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1338.4 279.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1339.1 282l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1338.3 134.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1335.4 145.2c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1338.4 137c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1339.1 139.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1338.3 185.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1335.4 196.7c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1338.4 188.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1339.1 190.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          transform="rotate(-45.001 799.7 400.378)"
          d="M783.8 396.1H815.5999999999999V404.70000000000005H783.8z"
        />
        <path
          transform="rotate(-45.004 799.605 400.507)"
          className="st4"
          d="M784.3 399.1H815V401.90000000000003H784.3z"
        />
        <path
          className="st42"
          d="M232 122.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M229.1 133.1c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM232.1 125c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M232.8 127.2l-.1.9H230s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8H229s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M314.2 148.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M311.3 159.8c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM314.3 151.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M315 153.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M471.9 305.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M469 316.7c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM472.1 308.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M472.8 310.8l-.1.9H470s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H469s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M798.4 340.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M795.5 351.5c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM798.5 343.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M799.2 345.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M787.2 404.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M784.3 415.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM787.3 407.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M788 409.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M805.3 382.7c3.3-3.4 8.8-3.3 12.1 0 3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1z"
        />
        <path
          className="st4"
          d="M808.5 391.2c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM811.5 383.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M812.2 385.3l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M265.4 1115.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.5-3.8-8.5-8.6s3.8-8.6 8.5-8.6z"
        />
        <path
          className="st4"
          d="M262.5 1126.7c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM265.6 1118.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M266.3 1120.8l-.1.9h-2.7s-.6.1-.6.6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M509.3 1182.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.5-3.8-8.5-8.6s3.8-8.6 8.5-8.6z"
        />
        <path
          className="st4"
          d="M506.4 1193.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM509.5 1185c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M510.1 1187.2l-.1.9h-2.7s-.6.1-.6.6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M706.2 955.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M703.3 966.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM706.4 958.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M707 960.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M815.1 1142.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M812.2 1153.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM815.3 1145.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M816 1147.4l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M706.2 1007.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M703.3 1018.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM706.4 1010.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M707 1012.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M844.8 1428.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M841.9 1439.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM844.9 1431.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M845.6 1433.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M815.1 1265.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M812.2 1276.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM815.3 1268.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M816 1270.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M860.2 1511.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M857.3 1522.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM860.3 1514.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M861 1516.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M960 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M957.1 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM960.1 1591.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M960.8 1593.7l-.1.9H958s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8H957s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1015.7 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1012.8 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM1015.8 1591.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1016.5 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1075.6 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1072.7 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1075.7 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1076.4 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1141.2 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1138.3 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1141.3 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1142 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1289.8 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1286.9 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1289.9 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1290.6 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1359.4 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1356.5 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1359.5 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1360.2 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1420.4 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1417.5 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1420.5 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1421.2 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1481.6 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1478.7 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1481.8 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1482.4 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1542.3 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1539.4 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1542.5 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1543.2 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1594.9 1565.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1592 1576.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1595 1568.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1595.7 1570.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1645.1 1536.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1642.2 1547.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1645.2 1539.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1645.9 1541.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1663 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1660.1 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1663.2 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1663.9 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1741.7 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1738.8 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1741.8 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1742.5 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1751.4 1536.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1748.5 1547.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1751.5 1539.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1752.2 1541.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1947.4 1564.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1944.5 1575.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1947.6 1567.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1948.2 1570l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1973.8 1538.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1970.9 1549.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1974 1541.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1974.6 1543.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2000.2 1512c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1997.3 1523.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2000.4 1514.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2001.1 1517.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2026.6 1485.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2023.7 1496.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2026.8 1488.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2027.5 1490.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2128.8 1413.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2125.9 1424.7c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2128.9 1416.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2129.6 1418.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2111.5 1465.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2108.6 1476.3c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2111.7 1468.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2112.4 1470.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2189.6 1413.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2186.7 1424.7c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2189.8 1416.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2190.4 1418.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2253 1438.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2250.1 1449.9c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2253.2 1441.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2253.9 1443.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2285.7 1471.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2282.8 1482.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2285.8 1474.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.7-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2286.5 1476.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2317.5 1503.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2314.6 1514.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2317.7 1506.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2318.3 1508.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7zM1234.3 1071.8c-2.9 0-5.4 1.8-6.6 4.3h-4.1c-1.1-2.5-3.6-4.3-6.5-4.3s-5.4 1.8-6.6 4.3h-4.7c-1.1-2.5-3.6-4.3-6.5-4.3-3.9 0-7.1 3.2-7.1 7.1 0 3.9 3.2 7.2 7.1 7.2 2.9 0 5.4-1.8 6.5-4.3h4.7c1.1 2.5 3.6 4.3 6.6 4.3 2.9 0 5.4-1.8 6.5-4.3h4.1c1.1 2.5 3.6 4.3 6.5 4.3 3.9 0 7.1-3.2 7.1-7.2.1-3.9-3.1-7.1-7-7.1z"
        />
        <path d="M1240 1078.9c0 3.2-2.6 5.7-5.7 5.7-2.7 0-4.9-1.8-5.5-4.3h-6.1c-.6 2.5-2.9 4.3-5.5 4.3s-4.9-1.8-5.5-4.3h-6.7c-.6 2.5-2.9 4.3-5.5 4.3-3.2 0-5.7-2.6-5.7-5.7 0-3.2 2.6-5.7 5.7-5.7 2.7 0 4.9 1.8 5.5 4.3h6.7c.6-2.5 2.9-4.3 5.5-4.3s4.9 1.8 5.5 4.3h6.1c.6-2.5 2.9-4.3 5.5-4.3 3.1 0 5.7 2.6 5.7 5.7zm-5.7-8.6c-3.2 0-5.9 1.7-7.4 4.3h-2.3c-1.5-2.6-4.2-4.3-7.4-4.3s-5.9 1.7-7.4 4.3h-3c-1.5-2.6-4.2-4.3-7.4-4.3-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6 3.2 0 5.9-1.7 7.4-4.3h3c1.5 2.6 4.2 4.3 7.4 4.3s5.9-1.7 7.4-4.3h2.3c1.5 2.6 4.2 4.3 7.4 4.3 4.7 0 8.6-3.8 8.6-8.6-.1-4.7-3.9-8.6-8.6-8.6z" />
        <path
          className="st42"
          d="M1290 1115.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1287.1 1126.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1290.1 1118.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1290.8 1120.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1040.8 1239.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1037.9 1251c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1040.9 1242.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1041.6 1245.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M976.6 1240.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M973.7 1251.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM976.8 1243.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M977.5 1245.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7zM1234.3 1071.8c-2.9 0-5.4 1.8-6.6 4.3h-4.1c-1.1-2.5-3.6-4.3-6.5-4.3s-5.4 1.8-6.6 4.3h-4.7c-1.1-2.5-3.6-4.3-6.5-4.3-3.9 0-7.1 3.2-7.1 7.1 0 3.9 3.2 7.2 7.1 7.2 2.9 0 5.4-1.8 6.5-4.3h4.7c1.1 2.5 3.6 4.3 6.6 4.3 2.9 0 5.4-1.8 6.5-4.3h4.1c1.1 2.5 3.6 4.3 6.5 4.3 3.9 0 7.1-3.2 7.1-7.2.1-3.9-3.1-7.1-7-7.1z"
        />
        <path d="M1240 1078.9c0 3.2-2.6 5.7-5.7 5.7-2.7 0-4.9-1.8-5.5-4.3h-6.1c-.6 2.5-2.9 4.3-5.5 4.3-2.7 0-4.9-1.8-5.5-4.3h-6.7c-.6 2.5-2.9 4.3-5.5 4.3-3.2 0-5.7-2.6-5.7-5.7 0-3.2 2.6-5.7 5.7-5.7 2.7 0 4.9 1.8 5.5 4.3h6.7c.6-2.5 2.9-4.3 5.5-4.3s4.9 1.8 5.5 4.3h6.1c.6-2.5 2.9-4.3 5.5-4.3 3.1 0 5.7 2.5 5.7 5.7zm-5.7-8.6c-3.2 0-5.9 1.7-7.4 4.3h-2.3c-1.5-2.6-4.2-4.3-7.4-4.3s-5.9 1.7-7.4 4.3h-3c-1.5-2.6-4.2-4.3-7.4-4.3-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6 3.2 0 5.9-1.7 7.4-4.3h3c1.5 2.6 4.2 4.3 7.4 4.3s5.9-1.7 7.4-4.3h2.3c1.5 2.6 4.2 4.3 7.4 4.3 4.7 0 8.6-3.8 8.6-8.6-.1-4.7-3.9-8.6-8.6-8.6z" />
        <path
          className="st42"
          d="M1199.3 1070.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1196.4 1081.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1199.5 1073.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1200.2 1075.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1580 1007.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1577.1 1018.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1580.2 1010.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1580.9 1012.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1221 1397.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1218.1 1408.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1221.1 1400.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1221.8 1402.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1089.8 1265.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1086.9 1276.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1090 1268.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1090.6 1271l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M882.1 1616.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M879.2 1627.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM882.2 1619.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M882.9 1621.9l-.1.9H880s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8H879s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.5.2-.7.7-.7.7z"
        />
        <path
          className="st42"
          d="M1941.3 642.1c4.9 0 8.9 4 8.9 8.9s-4 8.9-8.9 8.9-8.9-4-8.9-8.9c.1-5 4-8.9 8.9-8.9z"
        />
        <path
          className="st4"
          d="M1938.3 653.5c.4 1.4 1.7 2.4 3.2 2.4 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.7-4.7 4.7-1.7 0-3.1-.9-4-2.2l.8-1.5zM1941.5 645c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1942.2 647.4l-.1.9h-2.8s-.6 0-.6.6.6.6.6.6h2.7l-.1.9h-3.6s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8c.6.3.9-.3.9-.3l1.6-3.2s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.5s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2015.6 622c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2012.7 633.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2015.7 624.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2016.4 627.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M2015.6 667.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2012.7 678.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2015.8 670.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M2016.5 672.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st42"
          d="M1708 892.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.5-8.6 8.5-4.7 0-8.6-3.8-8.6-8.5 0-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1705.1 903.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1708.1 895c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st4"
          d="M1708.8 897.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7zM808.7 1086.6h-5.1c-1.1-2.5-3.6-4.3-6.5-4.3-3.9 0-7.2 3.2-7.2 7.1 0 3.9 3.2 7.2 7.2 7.2 2.9 0 5.4-1.8 6.5-4.3h5.1c1.1 2.5 3.6 4.3 6.5 4.3 3.9 0 7.1-3.2 7.1-7.2 0-3.9-3.2-7.1-7.1-7.1-2.9 0-5.4 1.7-6.5 4.3z"
        />
        <path d="M815.2 1083.7c3.2 0 5.7 2.6 5.7 5.7 0 3.2-2.5 5.7-5.7 5.7-2.7 0-4.9-1.8-5.5-4.3h-7.2c-.6 2.5-2.9 4.3-5.5 4.3-3.2 0-5.7-2.6-5.7-5.7 0-3.2 2.6-5.7 5.7-5.7 2.7 0 4.9 1.8 5.5 4.3h7.2c.6-2.5 2.9-4.3 5.5-4.3zm-7.4 1.4h-3.4c-1.5-2.6-4.2-4.3-7.4-4.3-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6 3.2 0 5.9-1.7 7.4-4.3h3.4c1.5 2.6 4.2 4.3 7.4 4.3 4.7 0 8.6-3.8 8.6-8.6s-3.8-8.6-8.6-8.6c-3.2 0-5.9 1.8-7.4 4.3z" />
        <path
          className="st4"
          d="M925.8 1004.6v5.1c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.2 7.1 7.2s7.2-3.2 7.2-7.2c0-2.9-1.8-5.4-4.3-6.5v-5.1c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.2-7.1s-7.1 3.2-7.1 7.1c0 2.9 1.8 5.4 4.3 6.5z"
        />
        <path d="M922.9 998.1c0-3.2 2.5-5.7 5.7-5.7s5.7 2.5 5.7 5.7c0 2.7-1.8 4.9-4.3 5.5v7.2c2.5.6 4.3 2.9 4.3 5.5 0 3.2-2.6 5.7-5.7 5.7-3.2 0-5.7-2.6-5.7-5.7 0-2.7 1.8-4.9 4.3-5.5v-7.2c-2.4-.6-4.3-2.9-4.3-5.5zm1.5 7.4v3.4c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.2-1.7-5.9-4.3-7.4v-3.4c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.1 1.7 5.9 4.3 7.4z" />
        <path
          className="st4"
          d="M496.5 1091.7h6.4c1.1 2.5 3.6 4.3 6.5 4.3 3.9 0 7.1-3.2 7.1-7.1 0-3.9-3.2-7.2-7.1-7.2-2.9 0-5.4 1.8-6.5 4.3h-6.5c-1.1-2.5-3.6-4.3-6.5-4.3-3.9 0-7.1 3.2-7.1 7.2 0 3.9 3.2 7.1 7.1 7.1 2.9 0 5.5-1.8 6.6-4.3z"
        />
        <path d="M489.9 1094.6c-3.1 0-5.7-2.6-5.7-5.7 0-3.2 2.5-5.7 5.7-5.7 2.7 0 4.9 1.8 5.5 4.3h8.5c.6-2.5 2.9-4.3 5.5-4.3 3.2 0 5.7 2.6 5.7 5.7 0 3.2-2.6 5.7-5.7 5.7-2.7 0-4.9-1.8-5.5-4.3h-8.5c-.6 2.5-2.8 4.3-5.5 4.3zm7.4-1.4h4.7c1.5 2.6 4.2 4.3 7.4 4.3 4.7 0 8.6-3.8 8.6-8.6 0-4.7-3.8-8.6-8.6-8.6-3.2 0-5.9 1.7-7.4 4.3h-4.7c-1.5-2.6-4.2-4.3-7.4-4.3-4.7 0-8.6 3.8-8.6 8.6s3.8 8.6 8.6 8.6c3.2-.1 5.9-1.8 7.4-4.3z" />
        <path
          className="st4"
          d="M548 1008.5v-3.6c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.2-7.1-7.2s-7.2 3.2-7.2 7.2c0 2.9 1.8 5.4 4.3 6.5v3.6c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.1 7.2 7.1s7.1-3.2 7.1-7.1c-.1-2.8-1.8-5.4-4.3-6.5z"
        />
        <path d="M550.8 1015.1c0 3.2-2.5 5.7-5.7 5.7s-5.7-2.5-5.7-5.7c0-2.7 1.8-4.9 4.3-5.5v-5.7c-2.5-.6-4.3-2.9-4.3-5.5 0-3.2 2.6-5.7 5.7-5.7 3.2 0 5.7 2.6 5.7 5.7 0 2.7-1.8 4.9-4.3 5.5v5.6c2.5.7 4.3 2.9 4.3 5.6zm-1.4-7.4v-1.9c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.2 1.7 5.9 4.3 7.4v1.9c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.2-1.8-5.9-4.3-7.4z" />
        <path d="M793.7 937.8H816.2V946.4H793.7z" />
        <path className="st4" d="M793.2 940.7H816.5V943.5H793.2z" />
        <path
          className="st4"
          d="M1487.3 703.2c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0c2.8 2.7 2.8 7.3 0 10.1z"
        />
        <path d="M1488.3 704.2c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.3 8.8-3.3 12.1 0 3.3 3.3 3.3 8.7 0 12.1zm-10.1-2.1c2.2 2.2 5.8 2.2 8.1 0 2.2-2.2 2.2-5.8 0-8.1-2.2-2.2-5.8-2.2-8.1 0-2.2 2.3-2.2 5.9 0 8.1z" />
        <path
          className="st4"
          d="M1414.3 763.9c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0 2.8 7.4 0 10.1z"
        />
        <path d="M1415.3 764.9c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.3 8.8-3.3 12.1 0 3.4 3.4 3.4 8.8 0 12.1zm-10.1-2c2.2 2.2 5.8 2.2 8.1 0 2.2-2.2 2.2-5.8 0-8.1-2.2-2.2-5.8-2.2-8.1 0-2.2 2.3-2.2 5.9 0 8.1z" />
        <path
          className="st4"
          d="M1752.4 563c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0 2.8 7.3 0 10.1z"
        />
        <path d="M1753.4 564c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.3 8.8-3.3 12.1 0 3.4 3.3 3.4 8.7 0 12.1zm-10.1-2c2.2 2.2 5.8 2.2 8.1 0 2.2-2.2 2.2-5.8 0-8.1-2.2-2.2-5.8-2.2-8.1 0-2.2 2.2-2.2 5.8 0 8.1z" />
        <path
          className="st4"
          d="M854.7 861.8c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1 3.2-7.1 7.2-7.1c3.9 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M856.1 861.8c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.5-5.7-5.7-5.7-5.7 2.6-5.7 5.7c0 3.2 2.5 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1440.2 918.2c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9-.1 7.1 3.1 7.1 7.1z"
        />
        <path d="M1441.6 918.2c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6 8.6 3.8 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1122.1 813c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.8 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1123.5 813c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.7 0 8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1224.4 710.4c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1225.8 710.4c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6 8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.5 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1196.5 684.5c0 4.1-3.3 7.4-7.4 7.4-4.1 0-7.4-3.3-7.4-7.4 0-4.1 3.3-7.4 7.4-7.4 4.1 0 7.4 3.3 7.4 7.4z"
        />
        <path d="M1198 684.5c0 4.9-4 8.9-8.9 8.9s-8.9-4-8.9-8.9 4-8.9 8.9-8.9 8.9 4 8.9 8.9zm-8.9 5.9c3.3 0 5.9-2.7 5.9-5.9 0-3.3-2.7-5.9-5.9-5.9s-5.9 2.7-5.9 5.9c0 3.3 2.6 5.9 5.9 5.9z" />
        <path
          className="st4"
          d="M1171.1 894c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1172.5 894c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zm-8.5 5.8c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7-.1 3.1 2.5 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1224.3 874.5c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9-.1 7.1 3.1 7.1 7.1z"
        />
        <path d="M1225.7 874.5c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6 8.6 3.8 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1224.3 947.2c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1225.7 947.2c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zm-8.6 5.8c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1285.2 813.5c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.8 0 7.1 3.2 7.1 7.1z"
        />
        <path d="M1286.6 813.5c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.7.1 8.6 3.9 8.6 8.6zm-8.6 5.8c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M1040.2 704.6l14.7-14.7c2.6 1 5.6.5 7.7-1.6 2.8-2.8 2.8-7.3 0-10.1s-7.3-2.8-10.1 0c-2.1 2.1-2.6 5.1-1.6 7.7l-14.7 14.7c-2.6-1-5.6-.5-7.7 1.6-2.8 2.8-2.8 7.3 0 10.1s7.3 2.8 10.1 0c2.1-2.1 2.6-5.1 1.6-7.7z"
        />
        <path d="M1037.6 711.3c-2.2 2.2-5.8 2.2-8.1 0s-2.2-5.8 0-8.1c1.9-1.9 4.8-2.2 6.9-.9l16.2-16.2c-1.3-2.2-1-5.1.9-6.9 2.2-2.2 5.8-2.2 8.1 0s2.2 5.8 0 8.1c-1.9 1.9-4.8 2.2-6.9.9l-16.2 16.2c1.3 2.1 1 5-.9 6.9zm4.2-6.3l13.5-13.5c2.9.8 6 0 8.3-2.2 3.3-3.3 3.3-8.8 0-12.1-3.3-3.3-8.8-3.3-12.1 0-2.2 2.2-3 5.4-2.2 8.3l-13.5 13.5c-2.9-.8-6 0-8.3 2.2-3.3 3.3-3.3 8.8 0 12.1 3.3 3.3 8.8 3.3 12.1 0 2.3-2.2 3-5.4 2.2-8.3z" />
        <path
          className="st4"
          d="M919.3 690v-2c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.1-7.1s-7.2 3.2-7.2 7.1c0 2.9 1.8 5.4 4.3 6.5v2c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.1 7.2 7.1 3.9 0 7.1-3.2 7.1-7.1-.1-2.9-1.8-5.4-4.3-6.5z"
        />
        <path d="M922.1 696.6c0 3.2-2.5 5.7-5.7 5.7s-5.7-2.5-5.7-5.7c0-2.7 1.8-4.9 4.3-5.5v-4c-2.5-.6-4.3-2.9-4.3-5.5 0-3.2 2.6-5.7 5.7-5.7 3.2 0 5.7 2.6 5.7 5.7 0 2.7-1.8 4.9-4.3 5.5v4c2.5.6 4.3 2.8 4.3 5.5zm-1.4-7.5v-.2c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.2 1.7 5.9 4.3 7.4v.2c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.1-1.8-5.9-4.3-7.4z" />
        <path
          className="st42"
          d="M1165.6 1004.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1165.6 1020.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1162.7 1015.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1165.8 1007.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M1166.5 1009.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st4"
          d="M966.3 665.6c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1 3.2-7.1 7.2-7.1 7.1 3.1 7.1 7.1z"
        />
        <path d="M967.7 665.6c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6 8.6 3.8 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M686.4 168.4c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1 3.2-7.1 7.2-7.1c3.9-.1 7.1 3.2 7.1 7.1z"
        />
        <path d="M687.8 168.4c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6 8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7z" />
        <path
          className="st4"
          d="M682.4 584.8c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1 3.2-7.1 7.2-7.1 7.1 3.2 7.1 7.1z"
        />
        <path d="M683.8 584.8c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6 8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7-.1 3.2 2.5 5.7 5.7 5.7z" />
        <path
          className="st42"
          d="M675.6 532.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M675.6 548.4c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c-.1 4.2-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M672.7 543.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM675.7 535c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M676.4 537.3l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7zM747.3 520.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M747.3 536.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M744.4 531.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM747.4 523.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M748.1 525.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7zM675.6 464.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M675.6 480.4c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c-.1 4.2-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M672.7 475.2c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM675.7 467c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M676.4 469.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7zM675.2 287.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M675.2 303.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M672.4 298.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM675.4 290.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M676.1 292.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7zM679.2 193.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M679.2 209.3c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M676.3 204.1c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM679.4 196c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M680.1 198.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7zM679.3 67.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M679.3 83.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.4 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M676.4 78.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM679.5 70c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M680.1 72.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st4"
          d="M1270.8 646.1c-2.9 0-5.4 1.8-6.6 4.3h-10.8c-1.1-2.5-3.6-4.3-6.5-4.3s-5.4 1.8-6.6 4.3H1227c-1.1-2.5-3.6-4.3-6.5-4.3-3.9 0-7.1 3.2-7.1 7.1s3.2 7.2 7.1 7.2c2.9 0 5.4-1.8 6.5-4.3h13.3c1.1 2.5 3.6 4.3 6.6 4.3 2.9 0 5.4-1.8 6.5-4.3h10.8c1.1 2.5 3.6 4.3 6.5 4.3 3.9 0 7.1-3.2 7.1-7.1.1-4-3.1-7.2-7-7.2z"
        />
        <path d="M1276.5 653.2c0 3.2-2.6 5.7-5.7 5.7-2.7 0-4.9-1.8-5.5-4.3h-12.8c-.6 2.5-2.9 4.3-5.5 4.3-2.7 0-4.9-1.8-5.5-4.3H1226c-.6 2.5-2.9 4.3-5.5 4.3-3.2 0-5.7-2.6-5.7-5.7 0-3.2 2.6-5.7 5.7-5.7 2.7 0 4.9 1.8 5.5 4.3h15.3c.6-2.5 2.9-4.3 5.5-4.3 2.7 0 4.9 1.8 5.5 4.3h12.8c.6-2.5 2.9-4.3 5.5-4.3 3.3 0 5.9 2.6 5.9 5.7zm-5.7-8.5c-3.2 0-5.9 1.7-7.4 4.3h-9.1c-1.5-2.6-4.2-4.3-7.4-4.3s-5.9 1.7-7.4 4.3h-11.6c-1.5-2.6-4.2-4.3-7.4-4.3-4.7 0-8.6 3.8-8.6 8.6 0 4.7 3.8 8.6 8.6 8.6 3.2 0 5.9-1.7 7.4-4.3h11.6c1.5 2.6 4.2 4.3 7.4 4.3s5.9-1.7 7.4-4.3h9.1c1.5 2.6 4.2 4.3 7.4 4.3 4.7 0 8.6-3.8 8.6-8.6-.1-4.8-3.9-8.6-8.6-8.6z" />
        <path
          className="st42"
          d="M1220.5 644.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1220.5 660.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1217.6 655.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1220.6 647.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M1221.3 649.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7zM1578.4 896.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M1578.4 912.7c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M1575.5 907.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1578.5 899.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M1579.2 901.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
        />
        <path
          className="st4"
          d="M1666.2 810c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0c2.8 2.7 2.8 7.3 0 10.1z"
        />
        <path d="M1667.2 811c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.3 8.8-3.3 12.1 0 3.3 3.3 3.3 8.7 0 12.1zm-10.1-2.1c2.2 2.2 5.8 2.2 8.1 0 2.2-2.2 2.2-5.8 0-8.1-2.2-2.2-5.8-2.2-8.1 0-2.3 2.3-2.2 5.9 0 8.1z" />
        <path
          className="st4"
          d="M1691.2 1479.5c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.2 7.2-7.2 3.9 0 7.1 3.3 7.1 7.2z"
        />
        <path d="M1692.7 1479.5c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.5 5.7 5.7 5.7z" />
        <path
          className="st42"
          d="M767.8 887c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M767.8 903.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M765 898c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM768 889.9c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M768.7 892.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
        />
        <path
          className="st4"
          d="M2368.9 394.6v5.1c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.1 7.1 7.1s7.1-3.2 7.1-7.1c0-2.9-1.8-5.4-4.3-6.5v-5.1c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1 0 2.9 1.8 5.4 4.3 6.5z"
        />
        <path d="M2366 388c0-3.1 2.6-5.7 5.7-5.7s5.7 2.5 5.7 5.7c0 2.7-1.8 4.9-4.3 5.5v7.1c2.5.6 4.3 2.9 4.3 5.5 0 3.2-2.6 5.7-5.7 5.7s-5.7-2.6-5.7-5.7c0-2.7 1.8-4.9 4.3-5.5v-7.1c-2.4-.6-4.3-2.8-4.3-5.5zm1.5 7.4v3.4c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.2-1.7-5.9-4.3-7.4v-3.4c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.2 1.7 6 4.3 7.4z" />
        <path
          className="st4"
          d="M2148.7 607.2v9.4c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.2 7.1 7.2s7.1-3.2 7.1-7.2c0-2.9-1.8-5.4-4.3-6.5v-9.4c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.1-7.1s-7.1 3.2-7.1 7.1c0 2.8 1.8 5.4 4.3 6.5z"
        />
        <path d="M2145.8 600.6c0-3.2 2.6-5.7 5.7-5.7s5.7 2.5 5.7 5.7c0 2.7-1.8 4.9-4.3 5.5v11.4c2.5.6 4.3 2.9 4.3 5.5 0 3.2-2.6 5.7-5.7 5.7s-5.7-2.6-5.7-5.7c0-2.7 1.8-4.9 4.3-5.5v-11.4c-2.5-.6-4.3-2.8-4.3-5.5zm1.5 7.4v7.6c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.2-1.7-5.9-4.3-7.4V608c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.2 1.7 5.9 4.3 7.4z" />
        <path
          className="st42"
          d="M2316.1 346.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M2316.1 363.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
        />
        <path
          className="st42"
          d="M2313.2 357.9c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2316.2 349.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
        />
        <path
          className="st42"
          d="M2316.9 352l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
        />
        <g>
          <path
            className="st42"
            d="M2228.2 335.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2228.2 351.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2225.3 346.3c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2228.3 338.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2229 340.3l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2163.8 399.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2163.8 415.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2160.9 410.6c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2164 402.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2164.7 404.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2139.9 422.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2139.9 439c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2137 433.8c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2140.1 425.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2140.8 427.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2186.2 377.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2186.2 393.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2183.3 388.3c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2186.3 380.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2187 382.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2118.6 444.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2118.6 461.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2115.7 455.9c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2118.7 447.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2119.4 449.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2037.8 525.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2037.8 541.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2034.9 536.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2037.9 528.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2038.6 530.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2081.5 481.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2081.5 498.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2078.6 492.9c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2081.7 484.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2082.4 487l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2266.3 297.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2266.3 313.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2263.4 308.1c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2266.4 300c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2267.1 302.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2299.6 263.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2299.6 280c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2296.7 274.8c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2299.7 266.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2300.4 268.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2321.6 241.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2321.6 258c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2318.8 252.8c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2321.8 244.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2322.5 246.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M880.5 1183.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M880.5 1200.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M877.7 1195c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM880.7 1186.8c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M881.4 1189.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M931.5 1298.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6zM913.6 1280.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M913.6 1296.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M910.7 1291.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM913.7 1283.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M914.4 1285.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M931.5 1314.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.2-3.5 7.7-7.7 7.7z"
          />
          <path
            className="st42"
            d="M928.6 1309.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM931.6 1301.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M932.3 1303.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1630.9 1443c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1630.9 1459.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1628 1454.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1631 1445.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1631.7 1448.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1684.3 1440.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1684.3 1456.3c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681.4 1451.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1684.4 1443c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1685.1 1445.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1684.3 1368.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1684.3 1384.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681.4 1379.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1684.4 1371.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1685.1 1373.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1538.8 1237.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1538.8 1254.1c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1535.9 1248.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1539 1240.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1539.7 1242.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1684.3 1341.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1684.3 1357.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681.4 1352.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1684.4 1344.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1685.1 1346.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1684.3 1315c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1684.3 1331.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681.4 1326.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1684.4 1317.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1685.1 1320.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1684.3 1289.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1684.3 1306c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681.4 1300.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1684.4 1292.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1685.1 1294.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1684.2 1243.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1684.2 1259.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7-.1 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681.3 1254.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1684.3 1246.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1685 1248.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1711.8 1215.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1711.8 1232.1c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7-.1 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1708.9 1226.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1711.9 1218.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1712.6 1221l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M797 1080.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M797 1097.1c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M794.1 1091.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM797.2 1083.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M797.8 1086l-.1.9H795s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8H794s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M815.2 933.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6zM797 933.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M797 949.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M794.1 944.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM797.1 936.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M797.8 938.7l-.1.9H795s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H794s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M815.2 949.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <path
            className="st42"
            d="M812.3 944.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM815.3 936.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M816 938.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M1826.1 719.3v-3.2c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.2-7.1-7.2-3.9 0-7.2 3.2-7.2 7.2 0 2.9 1.8 5.4 4.3 6.5v3.2c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.1 7.2 7.1 3.9 0 7.1-3.2 7.1-7.1 0-2.9-1.8-5.4-4.3-6.5z"
          />
          <path d="M1828.9 725.8c0 3.2-2.6 5.7-5.7 5.7-3.2 0-5.7-2.5-5.7-5.7 0-2.7 1.8-4.9 4.3-5.5v-5.2c-2.5-.6-4.3-2.9-4.3-5.5 0-3.2 2.6-5.7 5.7-5.7 3.2 0 5.7 2.6 5.7 5.7 0 2.7-1.8 4.9-4.3 5.5v5.2c2.5.7 4.3 2.9 4.3 5.5zm-1.4-7.4V717c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6-4.7 0-8.6 3.8-8.6 8.6 0 3.2 1.7 5.9 4.3 7.4v1.4c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.1-1.7-5.9-4.3-7.4z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1836.3 571.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1836.3 588.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1833.4 582.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1836.5 574.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.5-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1837.2 577l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1904 571.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1904 588.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1901.1 582.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1904.2 574.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.5-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1904.8 577l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1987.5 572.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1987.5 588.4c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <path
            className="st42"
            d="M1984.6 583.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1987.7 575c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M1988.3 577.3l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2120.9 270.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2120.9 287c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2118 281.9c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2121 273.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2121.7 275.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2000.9 275.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2000.9 291.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1998 286.6c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2001.1 278.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2001.8 280.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2000.9 305.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2000.9 321.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1998 316.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2001.1 308.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2001.8 310.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2000.9 171.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2000.9 187.3c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1998 182.1c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2001.1 173.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2001.8 176.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2035.3 237.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2035.3 254c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2032.4 248.8c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2035.4 240.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2036.1 242.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2000.9 66.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2000.9 83.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1998.1 77.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2001.1 69.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2001.8 71.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2000.9 119c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2000.9 135.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1998.1 130c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2001.1 121.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.7-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2001.8 124.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M1533.7 544.3l4 4c-1 2.6-.5 5.6 1.6 7.7 2.8 2.8 7.3 2.8 10.1 0s2.8-7.3 0-10.1c-2.1-2.1-5.1-2.6-7.7-1.6l-4-4c1-2.6.5-5.6-1.6-7.7-2.8-2.8-7.3-2.8-10.1 0s-2.8 7.3 0 10.1c2.1 2 5.1 2.6 7.7 1.6z"
          />
          <path d="M1527.1 541.7c-2.2-2.2-2.2-5.8 0-8.1 2.2-2.2 5.8-2.2 8.1 0 1.9 1.9 2.2 4.8.9 6.9l5.5 5.5c2.2-1.3 5.1-1 6.9.9 2.2 2.2 2.2 5.8 0 8.1-2.2 2.2-5.8 2.2-8.1 0-1.9-1.9-2.2-4.8-.9-6.9l-5.5-5.5c-2.2 1.2-5.1.9-6.9-.9zm6.2 4.2l2.8 2.8c-.8 2.9 0 6 2.2 8.3 3.3 3.3 8.8 3.3 12.1 0s3.3-8.8 0-12.1c-2.2-2.2-5.4-3-8.3-2.2l-2.8-2.8c.8-2.9 0-6-2.2-8.3-3.3-3.3-8.8-3.3-12.1 0s-3.3 8.8 0 12.1c2.3 2.2 5.5 2.9 8.3 2.2z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1561.4 559.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1561.4 575.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1558.5 570.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1561.5 562.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1562.2 564.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1606.2 541.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1606.2 557.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1603.3 552.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1606.3 544.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1607 546.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1544.3 542.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1544.3 558.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1541.4 553.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1544.5 545.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1545.2 547.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1961.5 717.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1961.5 733.8c-4.2 0-7.7-3.5-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1958.6 728.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1961.6 720.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1962.3 722.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2151.5 592.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2151.5 608.3c-4.2 0-7.7-3.5-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2148.6 603.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2151.7 595c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.5-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2152.4 597.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2385.3 178.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2385.3 194.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2382.4 189.2c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2385.4 181c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2386.1 183.2l-.1.9h-2.7s-.6.1-.6.6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2429.9 133.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2429.9 149.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2427 144.6c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2430 136.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2430.7 138.6l-.1.9h-2.7s-.6.1-.6.6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1362.4 402.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1362.4 418.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1359.5 413.6c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1362.5 405.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1363.2 407.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1236.3 490.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1236.3 506.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <path
            className="st42"
            d="M1233.4 501.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1236.4 493.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M1237.1 495.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1236.3 463.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1236.3 479.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <path
            className="st42"
            d="M1233.4 474.8c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1236.4 466.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M1237.1 468.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1704.7 332.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1704.7 349c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1701.8 343.8c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1704.9 335.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1705.6 337.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1662.4 201.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1662.4 217.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1659.5 212.2c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1662.5 204c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1663.2 206.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1662.4 259.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1662.4 275.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1659.5 270.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1662.5 262.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1663.2 264.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1841.5 236c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1841.5 252.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1838.6 247.1c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1841.7 238.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1842.3 241.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1841.5 168.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1841.5 184.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1838.6 179.6c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1841.7 171.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1842.3 173.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1662.4 92.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1662.4 109.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1659.5 103.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1662.5 95.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1663.2 98l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1662.4 128.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1662.4 144.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7-.1 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1659.5 139.6c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1662.5 131.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1663.2 133.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1583 128.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1583 144.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1580.1 139.6c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1583.1 131.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1583.8 133.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1777.6 66.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1777.6 83.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1774.7 77.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1777.7 69.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1778.4 71.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1994.1 696.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1991.2 707.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1994.3 699c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.5-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1994.9 701.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2015.6 717.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2012.7 728.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2015.7 720.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2016.4 722.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2151.5 614.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2148.6 625.7c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2151.7 617.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2152.4 619.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2125.7 640.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2122.8 651.5c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2125.8 643.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2126.5 645.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M1761.4 373.9l-2.9 2.9c-2.6-1-5.6-.5-7.7 1.6-2.8 2.8-2.8 7.3 0 10.1s7.3 2.8 10.1 0c2.1-2.1 2.6-5.1 1.6-7.7l2.9-3c2.6 1 5.6.5 7.7-1.6 2.8-2.8 2.8-7.3 0-10.1s-7.3-2.8-10.1 0c-2.1 2.3-2.6 5.3-1.6 7.8z"
          />
          <path d="M1764 367.3c2.2-2.2 5.8-2.2 8.1 0s2.2 5.9 0 8.1c-1.9 1.9-4.8 2.2-6.9.9l-4.4 4.4c1.3 2.2 1 5.1-.9 6.9-2.2 2.2-5.8 2.2-8.1 0s-2.2-5.9 0-8.1c1.9-1.9 4.8-2.2 6.9-.9l4.4-4.4c-1.3-2.2-1-5 .9-6.9zm-4.2 6.2l-1.7 1.7c-2.9-.8-6 0-8.3 2.2-3.3 3.3-3.3 8.8 0 12.1s8.8 3.4 12.1 0c2.2-2.2 3-5.4 2.2-8.3l1.7-1.7c2.9.8 6 0 8.3-2.2 3.3-3.3 3.3-8.8 0-12.1s-8.8-3.3-12.1 0c-2.2 2.3-3 5.5-2.2 8.3z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1331.7 479.9c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0 2.8 7.3 0 10.1z"
          />
          <path d="M1332.8 480.9c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.4-3.3-8.8 0-12.1 3.3-3.4 8.8-3.4 12.1 0 3.3 3.3 3.3 8.8 0 12.1zm-10.1-2c2.2 2.2 5.8 2.2 8.1 0 2.2-2.2 2.2-5.9 0-8.1-2.2-2.2-5.8-2.2-8.1 0s-2.3 5.9 0 8.1z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1103.9 378.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1103.9 395c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1101 389.9c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1104 381.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1104.7 383.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1338.3 207.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1338.3 223.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7s-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1335.4 218.5c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1338.5 210.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1339.1 212.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1311.5 230.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1311.5 246.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1308.6 241.2c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1311.7 233c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1312.3 235.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1116.9 490.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1116.9 506.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1114 501.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1117 493.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1117.7 495.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1484.3 542.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1484.3 558.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1481.4 553.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1484.4 545.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1485.1 547.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M968.7 555.5l-14.8 14.8c-2.6-1-5.6-.5-7.7 1.6-2.8 2.8-2.8 7.3 0 10.1s7.3 2.8 10.1 0c2.1-2.1 2.6-5.1 1.6-7.7l14.8-14.8c2.6 1 5.6.5 7.7-1.6 2.8-2.8 2.8-7.3 0-10.1s-7.3-2.8-10.1 0c-2.1 2.1-2.6 5.1-1.6 7.7z"
          />
          <path d="M971.3 548.8c2.2-2.2 5.8-2.2 8.1 0 2.2 2.2 2.2 5.8 0 8.1-1.9 1.9-4.8 2.2-6.9.9L956.2 574c1.3 2.2 1 5.1-.9 6.9-2.2 2.2-5.8 2.2-8.1 0-2.2-2.2-2.2-5.8 0-8.1 1.9-1.9 4.8-2.2 6.9-.9l16.2-16.2c-1.1-2.1-.9-5 1-6.9zm-4.2 6.3l-13.6 13.6c-2.9-.8-6 0-8.3 2.2-3.3 3.3-3.3 8.8 0 12.1 3.3 3.3 8.8 3.3 12.1 0 2.2-2.2 3-5.4 2.2-8.3l13.6-13.6c2.9.8 6 0 8.3-2.2 3.3-3.3 3.3-8.8 0-12.1-3.3-3.3-8.8-3.3-12.1 0-2.2 2.3-3 5.5-2.2 8.3z" />
        </g>
        <g>
          <path
            className="st4"
            d="M576.1 382.9c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1 3.2-7.1 7.2-7.1c3.9-.1 7.1 3.2 7.1 7.1z"
          />
          <path d="M577.6 382.9c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6c4.7 0 8.6 3.8 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.5-5.7-5.7-5.7-5.7 2.6-5.7 5.7 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M417.1 372.3c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1 3.2-7.1 7.1-7.1c3.9 0 7.1 3.2 7.1 7.1z"
          />
          <path d="M418.5 372.3c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zM410 378c3.1 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7-.1 3.2 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st42"
            d="M144.1 93.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M144.1 109.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M141.2 104.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM144.3 96.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M145 98.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M894.1 462.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M894.1 478.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c-.1 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M891.2 473.7c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM894.2 465.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M894.9 467.8l-.1.9H892s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H891s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.5.1-.7.7-.7.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M798.5 254.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M798.5 270.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M795.6 265.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM798.7 257.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M799.4 259.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M200.5 298.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M200.5 314.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M197.6 309.5c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM200.6 301.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M201.3 303.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M241.3 298.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M241.3 314.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M238.4 309.5c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM241.5 301.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M242.1 303.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M148.4 298.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M148.4 314.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M145.5 309.5c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM148.5 301.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M149.2 303.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M95.8 122.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M95.8 138.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M92.9 133.2c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM95.9 125c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M96.6 127.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M310.3 1070.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.5-3.8-8.5-8.6s3.8-8.6 8.5-8.6z"
          />
          <path
            className="st4"
            d="M310.3 1087c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M307.4 1081.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM310.5 1073.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M311.1 1075.9l-.1.9h-2.7s-.6.1-.6.6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M329.2 1051.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.5-3.8-8.5-8.6s3.8-8.6 8.5-8.6z"
          />
          <path
            className="st4"
            d="M329.2 1068.1c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M326.3 1062.9c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM329.4 1054.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M330.1 1057l-.1.9h-2.7s-.6.1-.6.6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M451.9 937.5c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1 3.2-7.1 7.1-7.1c3.9-.1 7.1 3.1 7.1 7.1z"
          />
          <path d="M453.3 937.5c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6 8.6 3.8 8.6 8.6zm-8.5 5.7c3.1 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7-.1 3.1 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M283.3 264.1c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1 3.2-7.1 7.1-7.1c3.9 0 7.1 3.2 7.1 7.1z"
          />
          <path d="M284.7 264.1c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6c4.8.1 8.6 3.9 8.6 8.6zm-8.5 5.7c3.1 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M283.3 458.7c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1 3.2-7.1 7.1-7.1c3.9 0 7.1 3.2 7.1 7.1z"
          />
          <path d="M284.7 458.7c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6 8.6 3.9 8.6 8.6zm-8.5 5.7c3.1 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7-.1 3.2 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st42"
            d="M448.7 537.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M448.7 553.7c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M445.8 548.5c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM448.8 540.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M449.5 542.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M448.7 483.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M448.7 499.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M445.8 494.3c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4z"
            />
            <path
              className="st36"
              d="M448.8 486.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M449.5 488.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M569 374.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M569 390.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M566.1 385.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM569.1 377.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M569.8 379.5l-.1.9H567s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H566s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M306.7 612.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M306.7 628.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M303.8 623.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM306.9 615.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M307.5 617.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 687c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 703.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 698c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM136.7 689.9c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 692.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 743.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 759.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 754.3c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM136.7 746.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 748.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 793.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 809.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 804.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM136.7 796.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 798.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 716.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 732.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 727.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM136.7 719.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 721.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M315.6 835.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M315.6 851.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M312.7 846.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM315.8 838c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M316.5 840.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M291.2 835.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M291.2 851.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M288.3 846.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM291.3 838c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M292 840.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M230.8 835.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M230.8 851.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M227.9 846.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM230.9 838c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M231.6 840.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 657.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 674.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 668.9c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM136.7 660.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 663l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 628.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 644.9c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 639.7c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM136.7 631.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 633.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 599.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 615.7c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 610.5c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM136.7 602.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 604.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.5 0-.7.6-.7.6z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 570.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 586.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 581.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM136.7 573.2c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 575.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M136.6 541.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M136.6 557.4c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M133.7 552.2c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM136.7 544c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M137.4 546.3l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M509.5 1139.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M509.5 1155.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M506.6 1150.5c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM509.7 1142.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M510.4 1144.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M489.9 1182.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M489.9 1198.3c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M487 1193.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM490 1185c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M490.7 1187.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path d="M122.6 1275.3H145.1V1283.8999999999999H122.6z" />
          <path
            className="st4"
            d="M122.1 1278.1H145.4V1280.8999999999999H122.1z"
          />
          <path
            className="st42"
            d="M124.7 1271c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M121.8 1282c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM124.8 1273.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M125.5 1276.1l-.1.9h-2.7s-.6.1-.6.6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
          <g>
            <path
              className="st42"
              d="M145.4 1271c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
            />
            <path
              className="st4"
              d="M145.4 1287.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
            />
            <g>
              <path
                className="st42"
                d="M142.5 1282.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM145.5 1273.9c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
              />
              <path
                className="st42"
                d="M146.2 1276.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M489.9 1139.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M489.9 1155.7c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7s7.7 3.4 7.7 7.7c0 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M487 1150.5c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM490 1142.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M490.7 1144.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M458.8 989.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M458.8 1005.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M455.9 1000.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM458.9 992.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M459.6 994.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M706.2 876.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M706.2 893.1c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M703.3 887.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM706.4 879.8c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.8 0-1.3.5-1.3 1.3z"
            />
            <path
              className="st42"
              d="M707 882l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M1282.1 1283.9c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.1 7.2-7.1s7.1 3.1 7.1 7.1z"
          />
          <path d="M1283.6 1283.9c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6 4.7 0 8.6 3.8 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1265 1267.8c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.1 7.2-7.1s7.1 3.1 7.1 7.1z"
          />
          <path d="M1266.4 1267.8c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1168.5 1346.2c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.2 7.2-7.2 3.9.1 7.1 3.3 7.1 7.2z"
          />
          <path d="M1169.9 1346.2c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1129.6 1351.2c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.2 7.2-7.2 3.9.1 7.1 3.3 7.1 7.2z"
          />
          <path d="M1131 1351.2c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M822.5 1192.7c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1c0-3.9 3.2-7.2 7.2-7.2 3.8 0 7.1 3.2 7.1 7.2z"
          />
          <path d="M823.9 1192.7c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6c0-4.7 3.8-8.6 8.6-8.6 4.7 0 8.6 3.8 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1057.8 1456.8c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.2 7.2-7.2 3.9.1 7.1 3.2 7.1 7.2z"
          />
          <path d="M1059.2 1456.8c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st42"
            d="M550.9 910.7c4.9 0 8.9 4 8.9 8.9s-4 8.9-8.9 8.9-8.9-4-8.9-8.9c.1-4.9 4-8.9 8.9-8.9z"
          />
          <path
            className="st4"
            d="M550.9 927.5c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8c0 4.5-3.6 8-8 8z"
          />
          <g>
            <path
              className="st42"
              d="M547.9 922.2c.4 1.4 1.7 2.4 3.2 2.4 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.7-4.7 4.7-1.7 0-3.1-.9-4-2.2l.8-1.5zM551.1 913.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M551.8 916l-.1.9h-2.8s-.6 0-.6.6.6.6.6.6h2.7l-.1.9h-3.6s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8c.6.3.9-.3.9-.3l1.6-3.2s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.5s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M528 771.5c4.9 0 8.9 4 8.9 8.9s-4 8.9-8.9 8.9-8.9-4-8.9-8.9c.1-5 4-8.9 8.9-8.9z"
          />
          <path
            className="st4"
            d="M528 788.3c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"
          />
          <g>
            <path
              className="st42"
              d="M525 782.9c.4 1.4 1.7 2.4 3.2 2.4 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.7-4.7 4.7-1.7 0-3.1-.9-4-2.2l.8-1.5zM528.2 774.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3-1.3.5-1.3 1.3z"
            />
            <path
              className="st42"
              d="M528.9 776.8l-.1.9H526s-.6 0-.6.6.6.6.6.6h2.7l-.1.9H525s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8c.6.3.9-.3.9-.3l1.6-3.2s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.5s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M706.2 989.6c4.8 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.5-8.6 8.5s-8.6-3.8-8.6-8.5c0-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M706.2 1005.8c-4.3 0-7.7-3.4-7.7-7.7s3.5-7.7 7.7-7.7 7.7 3.4 7.7 7.7c.1 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M703.3 1000.6c.4 1.3 1.7 2.3 3.2 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3.1-.8-3.8-2.1l.6-1.4zM706.4 992.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M707 994.7l-.1.9h-2.8s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.5.1-.7.7-.7.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M550.9 943.9c4.9 0 8.9 4 8.9 8.9s-4 8.9-8.9 8.9-8.9-4-8.9-8.9c.1-4.9 4-8.9 8.9-8.9z"
          />
          <path
            className="st4"
            d="M550.9 960.7c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8c0 4.5-3.6 8-8 8z"
          />
          <g>
            <path
              className="st42"
              d="M547.9 955.4c.4 1.4 1.7 2.4 3.2 2.4 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.7-4.7 4.7-1.7 0-3.1-.9-4-2.2l.8-1.5zM551.1 946.9c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M551.8 949.2l-.1.9h-2.8s-.6 0-.6.6.6.6.6.6h2.7l-.1.9h-3.6s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8c.6.3.9-.3.9-.3l1.6-3.2s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.5s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1684.1 1512.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1684.1 1529.1c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681.2 1523.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1684.2 1515.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1684.9 1518l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <path
          id="lul-bakerloo_x5F_lul-circle_x5F_lul-district_x5F_lul-hammersmith_x5F_940GZZLUPAC_2_"
          d="M879 716.3c-2.2-2.2-5.4-3-8.3-2.2l-30.2-30.2c.8-2.9 0-6-2.2-8.3-2.2-2.2-5.4-3-8.3-2.2l-5.6-5.6c.8-2.9 0-6-2.2-8.3-3.3-3.3-8.8-3.3-12.1 0-3.3 3.3-3.3 8.8 0 12.1 2.2 2.2 5.4 3 8.3 2.2l5.6 5.6c-.8 2.9 0 6 2.2 8.3 2.2 2.2 5.4 3 8.3 2.2l30.2 30.2c-.8 2.9 0 6 2.2 8.3 3.4 3.3 15.5-8.8 12.1-12.1z"
        />
        <path
          id="lul-bakerloo_x5F_lul-circle_x5F_lul-district_x5F_940GZZLUPAC_x5F_lul-hammersmith-city_x5F_940GZZLUPAH_2_"
          className="st4"
          d="M868.1 719.4l-32.8-32.8c-2.2 1.3-5.1 1-6.9-.9-1.9-1.9-2.2-4.8-.9-6.9l-8.2-8.3c-2.2 1.3-5.1 1-6.9-.9-2.2-2.2-2.2-5.8 0-8.1 2.2-2.2 5.8-2.2 8.1 0 1.9 1.9 2.2 4.8.9 6.9l8.2 8.2c2.2-1.3 5.1-1 6.9.9 1.9 1.9 2.2 4.8.9 6.9l32.8 32.8c2.1-1.1-3.4 4.4-2.1 2.2z"
        />
        <g id="lul-circle_x5F_lul-hammersmith-city_x5F_940GZZLUPAH_4_">
          <path
            className="st42"
            d="M832.3 673.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M832.3 689.4c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M829.5 684.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM832.5 676c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M833.2 678.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g id="lul-circle_x5F_lul-hammersmith-city_x5F_940GZZLUPAH_00000006689068492916648090000001179806411748300971_">
          <path
            className="st42"
            d="M816.2 656.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M816.2 672.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M813.3 667.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM816.4 659.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M817.1 661.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M1863.8 383.6c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1 7.1 3.2 7.1 7.1z"
          />
          <path d="M1865.3 383.6c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6 4.7 0 8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7z" />
        </g>
        <path
          transform="rotate(-45.009 1848.244 391.12)"
          className="st4"
          d="M1837.7 389.7H1858.8V392.5H1837.7z"
        />
        <g>
          <path
            className="st42"
            d="M1817.8 413c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1817.8 429.2c-4.2 0-7.7-3.5-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1814.9 424c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1818 415.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.5-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1818.7 418.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1841.5 389.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1841.5 405.5c-4.2 0-7.7-3.5-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1838.6 400.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1841.6 392.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1842.3 394.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1774.1 365.3c3.3 3.4 3.3 8.8 0 12.1-3.3 3.3-8.8 3.4-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.4 8.8-3.4 12.1 0z"
          />
          <path
            className="st4"
            d="M1762.6 376.8c-3-3-3-7.9 0-10.9s7.9-3 10.9 0 3 7.9 0 10.9-7.9 3-10.9 0z"
          />
          <g>
            <path
              className="st42"
              d="M1765.2 373.8c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1768.2 365.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1768.9 367.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2371.7 397.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2368.8 408.7c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2371.9 400.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2372.6 402.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2297.9 471.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2295 482.6c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2298 474.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2298.7 476.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2244.7 529.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2241.8 540.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2244.8 532.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2245.5 534.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2189.1 581.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2186.2 592.7c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2189.2 584.5c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2189.9 586.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M1053.6 1010.3l8-8c2.6 1 5.6.5 7.7-1.6 2.8-2.8 2.8-7.3 0-10.1s-7.3-2.8-10.1 0c-2.1 2.1-2.6 5.1-1.6 7.7l-8 8c-2.6-1-5.6-.5-7.7 1.6-2.8 2.8-2.8 7.3 0 10.1s7.3 2.8 10.1 0c2.1-2.1 2.6-5.1 1.6-7.7z"
          />
          <path d="M1051 1017c-2.2 2.2-5.8 2.2-8.1 0s-2.2-5.8 0-8.1c1.9-1.9 4.8-2.2 6.9-.9l9.4-9.4c-1.3-2.2-1-5.1.9-6.9 2.2-2.2 5.8-2.2 8.1 0 2.2 2.2 2.2 5.8 0 8.1-1.9 1.9-4.8 2.2-6.9.9l-9.4 9.4c1.2 2.1.9 5-.9 6.9zm4.2-6.3l6.8-6.8c2.9.8 6 0 8.3-2.2 3.3-3.3 3.3-8.8 0-12.1-3.3-3.3-8.8-3.3-12.1 0-2.2 2.2-3 5.4-2.2 8.3l-6.8 6.8c-2.9-.8-6 0-8.3 2.2-3.3 3.3-3.3 8.8 0 12.1 3.3 3.3 8.8 3.3 12.1 0 2.2-2.3 2.9-5.4 2.2-8.3z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1064.2 987.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1061.3 998.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1064.3 990c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1065 992.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M194.9 1155.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M192 1167c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM195.1 1158.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M195.8 1161l-.1.9H193s-.6.1-.6.6.6.6.6.6h2.6l-.1.8H192s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M210 1171c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M207.1 1182.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM210.2 1173.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M210.9 1176.1l-.1.9H208s-.6.1-.6.6.6.6.6.6h2.6l-.1.8H207s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.7.7-.7.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 202.699 1285.425)"
            d="M198.4 1274.5H207V1296.4H198.4z"
          />
        </g>
        <path
          transform="rotate(-44.996 202.774 1285.431)"
          className="st4"
          d="M201.4 1276.2H204.20000000000002V1294.7H201.4z"
        />
        <g>
          <path
            className="st42"
            d="M194.9 1269.1c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M192 1280.2c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM195.1 1272c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M195.8 1274.2l-.1.9H193s-.6.1-.6.6.6.6.6.6h2.6l-.1.8H192s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M210 1284.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M207.1 1295.3c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM210.2 1287.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M210.9 1289.3l-.1.9H208s-.6.1-.6.6.6.6.6.6h2.6l-.1.8H207s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.7.7-.7.7z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M405.1 850.3V881c-2.5 1.1-4.3-6-4.3-3.1 0 3.9 3.2 7.1 7.1 7.1 3.9 0 7.1-3.2 7.1-7.1 0-2.9-1.8 4.2-4.3 3.1v-30.7c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.1-7.1-3.9 0-7.1 3.2-7.1 7.1.1 2.9 1.8 5.4 4.3 6.5z"
          />
          <path d="M402.3 843.8c0-3.2 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7 0 2.7-1.8 4.9-4.3 5.5V882c2.5.6 4.3-5.4 4.3-2.7 0 3.2-2.6 5.7-5.7 5.7s-5.7-2.6-5.7-5.7c0-2.7 1.8 3.3 4.3 2.7v-32.7c-2.5-.6-4.3-2.9-4.3-5.5zm1.4 6.8v31c-2.6 1.5-2.6-6.5-2.6-3.4 0 4.7 2.1 7.1 6.9 7.1 4.7 0 6.9-2.4 6.9-7.1 0-3.2 0 4.8-2.6 3.4v-31c2.6-1.5 3.7-3.7 3.7-6.8 0-4.7-3.3-8-8-8s-8 3.3-8 8c0 3.2 1.2 5.3 3.7 6.8z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1042.7 809.1c3.3-3.3 8.8-3.3 12.1 0s3.3 8.8 0 12.1c-3.3 3.3-8.8 3.3-12.1 0-3.4-3.3-3.4-8.8 0-12.1z"
          />
          <path
            className="st4"
            d="M1054.2 820.6c-3 3-7.9 3-10.9 0s-3-7.9 0-10.9 7.9-3 10.9 0 3 7.9 0 10.9z"
          />
          <g>
            <path
              className="st42"
              d="M1045.8 817.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1048.9 809.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1049.6 811.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1034.8 820.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1031.9 831.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1034.9 823.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1035.6 825.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M872.8 713.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M869.9 724.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM872.9 716.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M873.6 718.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1208.14 804.797)"
            d="M1194.4 800.5H1221.9V809.1H1194.4z"
          />
        </g>
        <path
          transform="rotate(-44.996 1207.475 805.539)"
          className="st4"
          d="M1194.4 804.2H1220.7V807H1194.4z"
        />
        <g>
          <path
            className="st42"
            d="M1194.4 807.5c3.3-3.3 8.8-3.3 12.1 0s3.3 8.8 0 12.1c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1z"
          />
          <path
            className="st4"
            d="M1205.9 819c-3 3-7.9 3-10.9 0s-3-7.9 0-10.9 7.9-3 10.9 0 3 7.9 0 10.9z"
          />
          <g>
            <path
              className="st42"
              d="M1197.6 816.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1200.6 807.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1201.3 810.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1217.6 786.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1214.7 797.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1217.7 789.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1218.4 791.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M680.4 339.5c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0z"
          />
          <path d="M681.4 338.5c3.3 3.3 3.3 8.8 0 12.1s-8.8 3.3-12.1 0c-3.3-3.3-3.3-8.8 0-12.1 3.4-3.4 8.8-3.4 12.1 0zm-2 10.1c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0-2.2 5.9 0 8.1c2.3 2.2 5.9 2.2 8.1 0z" />
        </g>
        <g>
          <path
            className="st4"
            d="M2064.7 466.4c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.1-3.2-7.1-7.1s3.2-7.1 7.1-7.1 7.1 3.2 7.1 7.1z"
          />
          <path d="M2066.1 466.4c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.5 5.7c3.1 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7-.1 3.2 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1897.9 726.3c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.2 7.2-7.2c3.9 0 7.1 3.2 7.1 7.2z"
          />
          <path d="M1899.3 726.3c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6 4.7 0 8.6 3.8 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1290.3 527c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1290.3 543.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1287.4 538.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1290.4 529.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1291.1 532.1l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <path
          transform="rotate(-44.996 1758.606 568.926)"
          className="st4"
          d="M1757.3 552.9H1760.1V585.1H1757.3z"
        />
        <g>
          <path
            className="st42"
            d="M1770 571.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1770 588.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7s-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1767.1 583c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1770.2 574.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1770.8 577l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M642 377.9c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0"
          />
          <path d="M643 376.9c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.3 8.7-3.3 12.1 0m-2 10.1c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.9 0 8.1 2.2 2.2 5.8 2.2 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 645.224 374.637)"
            d="M643.5 372.9H646.9V376.29999999999995H643.5z"
          />
          <path
            transform="rotate(-45.001 648.876 370.997)"
            d="M647.2 369.3H650.6V372.7H647.2z"
          />
          <path
            transform="rotate(-45.001 652.517 367.35)"
            d="M650.8 365.6H654.1999999999999V369H650.8z"
          />
          <path
            transform="rotate(-45.001 656.17 363.714)"
            d="M654.5 362H657.9V365.4H654.5z"
          />
          <path
            transform="rotate(-45.001 659.81 360.067)"
            d="M658.1 358.4H661.5V361.79999999999995H658.1z"
          />
          <path
            transform="rotate(-45.001 663.445 356.417)"
            d="M661.7 354.7H665.1V358.09999999999997H661.7z"
          />
          <g>
            <path
              transform="rotate(-45.001 667.097 352.777)"
              d="M665.4 351.1H668.8V354.5H665.4z"
            />
          </g>
        </g>
        <g>
          <path d="M415.1 717.3H418.5V720.6999999999999H415.1z" />
          <path d="M420.2 717.3H423.59999999999997V720.6999999999999H420.2z" />
          <path d="M425.4 717.3H428.79999999999995V720.6999999999999H425.4z" />
          <path d="M430.5 717.3H433.9V720.6999999999999H430.5z" />
          <g>
            <path d="M435.7 717.3H439.09999999999997V720.6999999999999H435.7z" />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M962.5 529.6c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0"
          />
          <path d="M963.5 528.6c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.3 8.7-3.3 12.1 0m-2 10.1c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.8 0 8.1 2.2 2.2 5.8 2.2 8.1 0z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1034.4 493.9c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0z"
          />
          <path d="M1035.4 492.9c3.3 3.3 3.3 8.8 0 12.1s-8.8 3.3-12.1 0c-3.3-3.3-3.3-8.8 0-12.1 3.3-3.4 8.8-3.4 12.1 0zm-2 10.1c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0-2.2 5.9 0 8.1c2.2 2.2 5.9 2.2 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 987.749 540.38)"
            d="M986 538.7H989.4V542.1H986z"
          />
          <path
            transform="rotate(-45.001 991.39 536.733)"
            d="M989.7 535H993.1V538.4H989.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 984.04 544.093)"
            d="M982.3 542.4H985.6999999999999V545.8H982.3z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 998.893 529.24)"
            d="M997.2 527.5H1000.6V530.9H997.2z"
          />
          <path
            transform="rotate(-45.001 1002.534 525.593)"
            d="M1000.8 523.9H1004.1999999999999V527.3H1000.8z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 995.145 532.99)"
            d="M993.4 531.3H996.8V534.6999999999999H993.4z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1006.282 521.843)"
            d="M1004.6 520.1H1008V523.5H1004.6z"
          />
          <path
            transform="rotate(-45.001 1009.934 518.203)"
            d="M1008.2 516.5H1011.6V519.9H1008.2z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1017.43 510.704)"
            d="M1015.7 509H1019.1V512.4H1015.7z"
          />
          <path
            transform="rotate(-45.001 1021.071 507.06)"
            d="M1019.4 505.3H1022.8V508.7H1019.4z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1013.682 514.453)"
            d="M1012 512.7H1015.4V516.1H1012z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M1062.9 610.6c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0 2.8 7.3 0 10.1z"
          />
          <path d="M1063.9 611.6c-3.3 3.3-8.8 3.3-12.1 0s-3.3-8.8 0-12.1c3.3-3.3 8.8-3.3 12.1 0 3.3 3.4 3.3 8.8 0 12.1zm-10.1-2c2.2 2.2 5.8 2.2 8.1 0s2.2-5.8 0-8.1-5.8-2.2-8.1 0c-2.2 2.3-2.2 5.9 0 8.1z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1038.8 624.6c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.4-2.8 10.1 0"
          />
          <path d="M1039.8 623.6c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0s-3.3-8.8 0-12.1c3.4-3.4 8.8-3.4 12.1 0m-2 10c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.8 0 8.1 2.3 2.3 5.9 2.3 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1045.728 617.643)"
            d="M1044 615.9H1047.4V619.3H1044z"
          />
          <path
            transform="rotate(-45.001 1049.369 613.996)"
            d="M1047.7 612.3H1051.1000000000001V615.6999999999999H1047.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1042.083 621.286)"
            d="M1040.4 619.6H1043.8000000000002V623H1040.4z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M1264.1 562c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1c2.7-2.8 7.3-2.8 10.1 0"
          />
          <path d="M1265.1 561c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0s-3.3-8.8 0-12.1c3.3-3.4 8.7-3.4 12.1 0m-2.1 10c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.8 0 8.1 2.3 2.3 5.9 2.3 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1267.292 558.69)"
            d="M1265.6 557H1269V560.4H1265.6z"
          />
          <path
            transform="rotate(-45.001 1270.951 555.044)"
            d="M1269.2 553.3H1272.6000000000001V556.6999999999999H1269.2z"
          />
          <path
            transform="rotate(-45.001 1274.585 551.408)"
            d="M1272.9 549.7H1276.3000000000002V553.1H1272.9z"
          />
          <path
            transform="rotate(-45.001 1278.233 547.754)"
            d="M1276.5 546H1279.9V549.4H1276.5z"
          />
          <g>
            <path
              transform="rotate(-45.001 1281.871 544.118)"
              d="M1280.2 542.4H1283.6000000000001V545.8H1280.2z"
            />
          </g>
        </g>
        <g>
          <path
            transform="rotate(-45.001 1197.619 675.935)"
            d="M1195.9 674.2H1199.3000000000002V677.6H1195.9z"
          />
          <path
            transform="rotate(-45.001 1201.264 672.307)"
            d="M1199.6 670.6H1203V674H1199.6z"
          />
          <path
            transform="rotate(-45.001 1204.912 668.652)"
            d="M1203.2 666.9H1206.6000000000001V670.3H1203.2z"
          />
          <path
            transform="rotate(-45.001 1208.539 665.01)"
            d="M1206.8 663.3H1210.2V666.6999999999999H1206.8z"
          />
          <g>
            <path
              transform="rotate(-45.001 1212.191 661.37)"
              d="M1210.5 659.6H1213.9V663H1210.5z"
            />
          </g>
        </g>
        <g>
          <path
            transform="rotate(-45.001 1468.531 535.118)"
            d="M1466.8 533.4H1470.2V536.8H1466.8z"
          />
          <path
            transform="rotate(-45.001 1472.172 538.771)"
            d="M1470.5 537H1473.9V540.4H1470.5z"
          />
          <path
            transform="rotate(-45.001 1475.817 542.413)"
            d="M1474.1 540.7H1477.5V544.1H1474.1z"
          />
        </g>
        <path className="st4" d="M1546.5 763.2H1549.3V789.5H1546.5z" />
        <g>
          <path
            transform="rotate(-49.351 1468.64 776.178)"
            d="M1454.8 771.9H1482.3V780.5H1454.8z"
          />
        </g>
        <path
          transform="rotate(-49.351 1469.346 775.26)"
          className="st4"
          d="M1456.1 773.8H1482.3999999999999V776.5999999999999H1456.1z"
        />
        <g>
          <path d="M1483.9 756.9H1550.9V765.5H1483.9z" />
        </g>
        <path
          className="st4"
          d="M1488.2 759.8H1552.3V762.5999999999999H1488.2z"
        />
        <g>
          <path
            className="st42"
            d="M1683.8 773.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1683.8 789.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1681 784.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1684 776.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1684.7 778.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1480.4 752.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1480.4 768.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1477.5 763.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1480.6 755.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1481.3 757.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            transform="rotate(-45.211 1557.527 752.511)"
            d="M1543.8 748.2H1571.3V756.8000000000001H1543.8z"
          />
          <path
            transform="rotate(-45.203 1558.383 751.877)"
            className="st4"
            d="M1545.2 750.5H1571.5V753.3H1545.2z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1569.9 732.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1569.9 748.5c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1567 743.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1570.1 735.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1570.8 737.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M687.7 866.8c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0 2.8 7.3 0 10.1"
          />
          <path d="M688.7 867.8c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.3-3.3 8.8-3.3 12.1 0 3.3 3.4 3.3 8.8 0 12.1m-10.1-2c2.2 2.2 5.8 2.2 8.1 0s2.2-5.8 0-8.1c-2.2-2.2-5.8-2.2-8.1 0-2.2 2.3-2.2 5.9 0 8.1z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 690.95 870.084)"
            d="M689.3 868.4H692.6999999999999V871.8H689.3z"
          />
          <path
            transform="rotate(-45.001 694.591 873.737)"
            d="M692.9 872H696.3V875.4H692.9z"
          />
          <g>
            <path
              transform="rotate(-45.001 698.228 877.376)"
              d="M696.5 875.7H699.9V879.1H696.5z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M767.8 869c-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1 3.9 0 7.1 3.2 7.1 7.1.1 3.9-3.1 7.1-7.1 7.1"
          />
          <path d="M767.8 870.4c-4.7 0-8.5-3.8-8.5-8.5s3.8-8.6 8.5-8.6 8.6 3.8 8.6 8.6c0 4.7-3.8 8.5-8.6 8.5m-5.7-8.6c0 3.2 2.5 5.7 5.7 5.7s5.7-2.5 5.7-5.7-2.6-5.7-5.7-5.7-5.7 2.6-5.7 5.7z" />
        </g>
        <g>
          <path d="M766.2 871.9H769.6V875.3H766.2z" />
          <path d="M766.2 877H769.6V880.4H766.2z" />
        </g>
        <g>
          <path d="M766.2 882.2H769.6V885.6H766.2z" />
        </g>
        <g>
          <path d="M704.4 979.5H707.8V982.9H704.4z" />
          <path d="M704.4 974.3H707.8V977.6999999999999H704.4z" />
        </g>
        <g>
          <path d="M704.4 984.6H707.8V988H704.4z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1667.5 378.6c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0"
          />
          <path d="M1668.5 377.6c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0s-3.3-8.8 0-12.1c3.3-3.3 8.7-3.3 12.1 0m-2 10.1c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.9 0 8.1 2.2 2.2 5.8 2.2 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1670.721 375.335)"
            d="M1669 373.6H1672.4V377H1669z"
          />
          <path
            transform="rotate(-45.001 1674.362 371.688)"
            d="M1672.7 370H1676.1000000000001V373.4H1672.7z"
          />
          <path
            transform="rotate(-45.001 1678.035 368.029)"
            d="M1676.3 366.3H1679.7V369.7H1676.3z"
          />
          <path
            transform="rotate(-45.001 1681.717 364.352)"
            d="M1680 362.6H1683.4V366H1680z"
          />
          <path
            transform="rotate(-45.001 1685.386 360.675)"
            d="M1683.7 358.9H1687.1000000000001V362.29999999999995H1683.7z"
          />
          <path
            transform="rotate(-45.001 1689.054 357.002)"
            d="M1687.3 355.3H1690.7V358.7H1687.3z"
          />
          <path
            transform="rotate(-45.001 1591.748 364.436)"
            d="M1590 362.7H1593.4V366.09999999999997H1590z"
          />
          <path
            transform="rotate(-45.001 1595.427 360.766)"
            d="M1593.7 359H1597.1000000000001V362.4H1593.7z"
          />
          <path
            transform="rotate(-45.001 1599.103 357.081)"
            d="M1597.4 355.4H1600.8000000000002V358.79999999999995H1597.4z"
          />
          <path
            transform="rotate(-45.001 1602.778 353.412)"
            d="M1601.1 351.7H1604.5V355.09999999999997H1601.1z"
          />
          <path
            transform="rotate(-45.001 1606.444 349.746)"
            d="M1604.7 348H1608.1000000000001V351.4H1604.7z"
          />
          <path
            transform="rotate(-45.001 1692.734 353.332)"
            d="M1691 351.6H1694.4V355H1691z"
          />
          <g>
            <path
              transform="rotate(-45.001 1696.403 349.655)"
              d="M1694.7 347.9H1698.1000000000001V351.29999999999995H1694.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1615.3 332.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1615.3 349c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1612.4 343.8c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1615.5 335.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1616.1 337.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M1587.8 367.4c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1c2.7-2.8 7.3-2.8 10.1 0"
          />
          <path d="M1588.8 366.4c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0s-3.3-8.8 0-12.1c3.3-3.4 8.7-3.4 12.1 0m-2 10c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.9 0 8.1 2.2 2.3 5.8 2.3 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1826.107 413.236)"
            d="M1824.4 411.5H1827.8000000000002V414.9H1824.4z"
          />
          <path
            transform="rotate(-45.001 1829.745 409.6)"
            d="M1828 407.9H1831.4V411.29999999999995H1828z"
          />
          <g>
            <path
              transform="rotate(-45.001 1833.393 405.946)"
              d="M1831.7 404.2H1835.1000000000001V407.59999999999997H1831.7z"
            />
          </g>
        </g>
        <g>
          <path
            transform="rotate(-45.001 2073.191 482.11)"
            d="M2071.5 480.4H2074.9V483.79999999999995H2071.5z"
          />
          <path
            transform="rotate(-45.001 2069.55 478.464)"
            d="M2067.8 476.7H2071.2000000000003V480.09999999999997H2067.8z"
          />
          <g>
            <path
              transform="rotate(-45.001 2065.903 474.822)"
              d="M2064.2 473.1H2067.6V476.5H2064.2z"
            />
          </g>
        </g>
        <g>
          <path
            transform="rotate(-45.001 1882.388 734.627)"
            d="M1880.7 732.9H1884.1000000000001V736.3H1880.7z"
          />
          <path
            transform="rotate(-45.001 1878.745 738.27)"
            d="M1877 736.5H1880.4V739.9H1877z"
          />
          <g>
            <path
              transform="rotate(-45.001 1875.098 741.918)"
              d="M1873.4 740.2H1876.8000000000002V743.6H1873.4z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1843 1007.7c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1840.1 1018.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1843.1 1010.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1843.8 1012.8l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1858.476 1000.798)"
            d="M1856.8 999.1H1860.2V1002.5H1856.8z"
          />
          <path
            transform="rotate(-45.001 1854.836 1004.435)"
            d="M1853.1 1002.7H1856.5V1006.1H1853.1z"
          />
          <g>
            <path
              transform="rotate(-45.001 1851.185 1008.09)"
              d="M1849.5 1006.4H1852.9V1009.8H1849.5z"
            />
          </g>
        </g>
        <g>
          <path d="M2111.4 910.6H2114.8V914H2111.4z" />
          <path d="M2111.4 915.8H2114.8V919.1999999999999H2111.4z" />
        </g>
        <g>
          <path
            className="st42"
            d="M2113.1 925.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2110.2 936.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2113.2 928.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2113.9 930.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path d="M2111.4 915.8H2114.8V919.1999999999999H2111.4z" />
          <path d="M2111.4 920.9H2114.8V924.3H2111.4z" />
        </g>
        <g>
          <path d="M1972.7 1004.1H1976.1000000000001V1007.5H1972.7z" />
          <path d="M1977.8 1004.1H1981.2V1007.5H1977.8z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1997.5 997.2c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1994.6 1008.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1997.7 1000.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1998.3 1002.4l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path d="M1982.9 1004.1H1986.3000000000002V1007.5H1982.9z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1689.1 919.5c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0"
          />
          <path d="M1690.1 918.5c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0s-3.3-8.8 0-12.1c3.3-3.3 8.8-3.3 12.1 0m-2 10.1c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.8 0 8.1 2.3 2.2 5.9 2.2 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1695.996 912.605)"
            d="M1694.3 910.9H1697.7V914.3H1694.3z"
          />
          <path
            transform="rotate(-45.001 1699.648 908.965)"
            d="M1697.9 907.2H1701.3000000000002V910.6H1697.9z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1692.354 916.248)"
            d="M1690.7 914.5H1694.1000000000001V917.9H1690.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1593.182 919.795)"
            d="M1591.5 918.1H1594.9V921.5H1591.5z"
          />
          <path
            transform="rotate(-45.001 1589.752 916.35)"
            d="M1588 914.6H1591.4V918H1588z"
          />
          <path
            transform="rotate(-45.001 1596.623 923.222)"
            d="M1594.9 921.5H1598.3000000000002V924.9H1594.9z"
          />
          <path
            transform="rotate(-45.001 1600.071 926.67)"
            d="M1598.4 924.9H1601.8000000000002V928.3H1598.4z"
          />
          <g>
            <path
              transform="rotate(-45.001 1586.307 912.925)"
              d="M1584.6 911.2H1588V914.6H1584.6z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M1343.4 392.1c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0 2.8 7.4 0 10.1"
          />
          <path d="M1344.4 393.1c-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1s8.8-3.3 12.1 0 3.4 8.8 0 12.1m-10.1-2c2.2 2.2 5.8 2.2 8.1 0s2.2-5.8 0-8.1c-2.2-2.2-5.8-2.2-8.1 0-2.2 2.3-2.2 5.9 0 8.1z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1346.693 395.413)"
            d="M1345 393.7H1348.4V397.09999999999997H1345z"
          />
          <path
            transform="rotate(-45.001 1350.341 399.059)"
            d="M1348.6 397.3H1352V400.7H1348.6z"
          />
          <g>
            <path
              transform="rotate(-45.001 1353.986 402.7)"
              d="M1352.3 401H1355.7V404.4H1352.3z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M1122.5 1378.3c3.9 0 7.1 3.2 7.1 7.1 0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.1-3.2-7.1-7.1-.1-3.9 3.2-7.1 7.1-7.1"
          />
          <path d="M1122.5 1376.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6m5.7 8.6c0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7s5.7-2.5 5.7-5.7z" />
        </g>
        <g>
          <path d="M1120.8 1366.7H1124.2V1370.1000000000001H1120.8z" />
          <path d="M1120.8 1361.5H1124.2V1364.9H1120.8z" />
        </g>
        <g>
          <path
            className="st4"
            d="M967.1 1547.3c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1c0-3.9 3.2-7.2 7.2-7.2 3.9.1 7.1 3.3 7.1 7.2z"
          />
          <path d="M968.5 1547.3c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6c0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7-.1 3.2 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path d="M958.2 1562.8H961.6V1566.2H958.2z" />
          <path d="M958.2 1557.6H961.6V1561H958.2z" />
        </g>
        <g>
          <path d="M958.2 1567.9H961.6V1571.3000000000002H958.2z" />
        </g>
        <g>
          <path d="M958.2 1573.1H961.6V1576.5H958.2z" />
        </g>
        <g>
          <path d="M958.2 1578.2H961.6V1581.6000000000001H958.2z" />
        </g>
        <g>
          <path d="M958.2 1583.4H961.6V1586.8000000000002H958.2z" />
        </g>
        <g>
          <path d="M1120.7 1371.8H1124.1000000000001V1375.2H1120.7z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 867.955 1204.28)"
            d="M866.3 1202.6H869.6999999999999V1206H866.3z"
          />
          <path
            transform="rotate(-45.001 864.312 1207.927)"
            d="M862.6 1206.2H866V1209.6000000000001H862.6z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 871.602 1200.636)"
            d="M869.9 1198.9H873.3V1202.3000000000002H869.9z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 987.49 1236.98)"
            d="M985.8 1235.3H989.1999999999999V1238.7H985.8z"
          />
          <path
            transform="rotate(-45.001 983.849 1240.617)"
            d="M982.2 1238.9H985.6V1242.3000000000002H982.2z"
          />
        </g>
        <g>
          <path d="M1088.1 1261.7H1091.5V1265.1000000000001H1088.1z" />
        </g>
        <g>
          <path d="M1088.1 1256.8H1091.5V1260.2H1088.1z" />
        </g>
        <g>
          <path d="M1088.1 1251.9H1091.5V1255.3000000000002H1088.1z" />
        </g>
        <g>
          <path d="M1088.1 1241.6H1091.5V1245H1088.1z" />
        </g>
        <g>
          <path d="M1088.1 1236.6H1091.5V1240H1088.1z" />
        </g>
        <path d="M1088.1 1226.5H1091.5V1229.9H1088.1z" />
        <path d="M1088.1 1231.6H1091.5V1235H1088.1z" />
        <g>
          <path d="M1088.1 1221.5H1091.5V1224.9H1088.1z" />
        </g>
        <g>
          <path d="M1088.1 1216.5H1091.5V1219.9H1088.1z" />
        </g>
        <path d="M1088.1 1211.5H1091.5V1214.9H1088.1z" />
        <g>
          <path d="M1088.1 1206.5H1091.5V1209.9H1088.1z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1149.674 1029.775)"
            d="M1148 1028.1H1151.4V1031.5H1148z"
          />
          <path
            transform="rotate(-45.001 1153.736 1025.715)"
            d="M1152 1024H1155.4V1027.4H1152z"
          />
          <path
            transform="rotate(-45.001 1157.67 1021.775)"
            d="M1156 1020.1H1159.4V1023.5H1156z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1145.613 1033.835)"
            d="M1143.9 1032.1H1147.3000000000002V1035.5H1143.9z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1141.552 1037.895)"
            d="M1139.9 1036.2H1143.3000000000002V1039.6000000000001H1139.9z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1590.114 952.946)"
            d="M1588.4 951.2H1591.8000000000002V954.6H1588.4z"
          />
          <path
            transform="rotate(-45.001 1593.566 949.509)"
            d="M1591.9 947.8H1595.3000000000002V951.1999999999999H1591.9z"
          />
          <path
            transform="rotate(-45.001 1586.622 956.446)"
            d="M1584.9 954.7H1588.3000000000002V958.1H1584.9z"
          />
          <path
            transform="rotate(-45.001 1596.867 946.203)"
            d="M1595.2 944.5H1598.6000000000001V947.9H1595.2z"
          />
          <path
            transform="rotate(-45.001 1600.296 942.779)"
            d="M1598.6 941.1H1602V944.5H1598.6z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1494.905 1004.041)"
            d="M1493.2 1002.3H1496.6000000000001V1005.6999999999999H1493.2z"
          />
          <path
            transform="rotate(-45.001 1498.344 1000.604)"
            d="M1496.6 998.9H1500V1002.3H1496.6z"
          />
          <path
            transform="rotate(-45.001 1491.402 1007.534)"
            d="M1489.7 1005.8H1493.1000000000001V1009.1999999999999H1489.7z"
          />
          <path
            transform="rotate(-45.001 1501.666 997.287)"
            d="M1500 995.6H1503.4V999H1500z"
          />
          <path
            transform="rotate(-45.001 1505.074 993.874)"
            d="M1503.4 992.1H1506.8000000000002V995.5H1503.4z"
          />
          <path
            transform="rotate(-45.001 1508.804 990.142)"
            d="M1507.1 988.4H1510.5V991.8H1507.1z"
          />
        </g>
        <g>
          <path d="M1576.7 929.8H1580.1000000000001V933.1999999999999H1576.7z" />
          <path d="M1576.7 924.7H1580.1000000000001V928.1H1576.7z" />
          <path d="M1576.7 919.7H1580.1000000000001V923.1H1576.7z" />
          <path d="M1576.7 914.6H1580.1000000000001V918H1576.7z" />
        </g>
        <g>
          <path d="M1576.7 935H1580.1000000000001V938.4H1576.7z" />
        </g>
        <g>
          <path d="M1576.7 940.1H1580.1000000000001V943.5H1576.7z" />
        </g>
        <g>
          <path d="M1576.7 945.4H1580.1000000000001V948.8H1576.7z" />
        </g>
        <g>
          <path d="M1576.7 950.6H1580.1000000000001V954H1576.7z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1186.85 1069.174)"
            d="M1185.2 1067.5H1188.6000000000001V1070.9H1185.2z"
          />
          <path
            transform="rotate(-45.001 1190.22 1072.544)"
            d="M1188.5 1070.8H1191.9V1074.2H1188.5z"
          />
        </g>
        <path
          transform="rotate(-45.001 1246.855 1025.534)"
          d="M1245.2 1023.8H1248.6000000000001V1027.2H1245.2z"
        />
        <g>
          <path
            transform="rotate(-45.001 1250.915 1029.595)"
            d="M1249.2 1027.9H1252.6000000000001V1031.3000000000002H1249.2z"
          />
        </g>
        <path
          transform="rotate(-45.001 1242.673 1021.356)"
          d="M1241 1019.6H1244.4V1023H1241z"
        />
        <g>
          <path
            transform="rotate(-45.001 1254.976 1033.655)"
            d="M1253.3 1031.9H1256.7V1035.3000000000002H1253.3z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1259.073 1037.757)"
            d="M1257.4 1036H1260.8000000000002V1039.4H1257.4z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1266.497 1275.838)"
            d="M1264.8 1274.1H1268.2V1277.5H1264.8z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1858.999 1202.004)"
            d="M1857.3 1200.3H1860.7V1203.7H1857.3z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1953.273 998.402)"
            d="M1951.6 996.7H1955V1000.1H1951.6z"
          />
        </g>
        <g>
          <path d="M1359.5 999.7H1362.9V1003.1H1359.5z" />
        </g>
        <g>
          <path
            className="st4"
            d="M965 1542.3c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0z"
          />
          <path d="M966 1541.3c3.3 3.3 3.3 8.8 0 12.1-3.3 3.3-8.8 3.3-12.1 0-3.3-3.3-3.3-8.8 0-12.1 3.4-3.3 8.8-3.3 12.1 0zm-2 10.1c2.2-2.2 2.2-5.8 0-8.1s-5.8-2.2-8.1 0c-2.2 2.2-2.2 5.8 0 8.1 2.3 2.2 5.9 2.2 8.1 0z" />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1692.47 1243.745)"
            d="M1690.8 1242H1694.2V1245.4H1690.8z"
          />
          <path
            transform="rotate(-45.001 1696.11 1240.102)"
            d="M1694.4 1238.4H1697.8000000000002V1241.8000000000002H1694.4z"
          />
          <path
            transform="rotate(-45.001 1699.751 1236.455)"
            d="M1698.1 1234.7H1701.5V1238.1000000000001H1698.1z"
          />
          <g>
            <path
              transform="rotate(-45.001 1703.396 1232.812)"
              d="M1701.7 1231.1H1705.1000000000001V1234.5H1701.7z"
            />
          </g>
        </g>
        <g>
          <path
            transform="rotate(-45.001 1692.363 1529.732)"
            d="M1690.7 1528H1694.1000000000001V1531.4H1690.7z"
          />
          <path
            transform="rotate(-45.001 1696.008 1533.374)"
            d="M1694.3 1531.6H1697.7V1535H1694.3z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1707.9 1536.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1705 1547.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1708 1539.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1708.7 1541.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1699.649 1537.012)"
            d="M1698 1535.3H1701.4V1538.7H1698z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1046.9 1004.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1046.9 1020.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1044 1015.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1047.1 1007.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1047.7 1009.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M2120.9 359.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2120.9 375.7c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7c0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M2118 370.5c.4 1.4 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2121 362.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M2121.7 364.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1865.7 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1862.8 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1865.9 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1866.5 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1898.5 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1895.6 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1898.7 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1899.3 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2067.7 1732.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2064.8 1743.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2067.8 1735.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2068.5 1737.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2046.8 1711.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2043.9 1722.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2047 1714.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2047.7 1716.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2026 1690.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2023.1 1701.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2026.2 1693.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.5-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2026.8 1696l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2005.2 1670c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2002.3 1681.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2005.3 1672.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2006 1675.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1984.3 1649.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1981.4 1660.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1984.5 1652.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1985.2 1654.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1963.5 1628.3c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1960.6 1639.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1963.6 1631.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1964.3 1633.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1942.7 1607.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1939.8 1618.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1942.8 1610.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1943.5 1612.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1865.7 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1862.8 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1865.9 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1866.5 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1898.5 1588.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1895.6 1599.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1898.7 1591.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1899.3 1593.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <path
          transform="rotate(-44.992 1229.588 1577.433)"
          d="M1205.1 1573.1H1254.1V1581.6999999999998H1205.1z"
        />
        <path
          transform="rotate(-45.001 1227.794 1579.203)"
          className="st4"
          d="M1203.3 1577.8H1252.2V1580.6H1203.3z"
        />
        <path
          transform="rotate(-44.992 1859.875 1248.97)"
          d="M1855.6 1235.1H1864.1999999999998V1262.6999999999998H1855.6z"
        />
        <path
          transform="rotate(-45.025 1858.082 1247.166)"
          className="st4"
          d="M1856.7 1233.4H1859.5V1260.9H1856.7z"
        />
        <g>
          <path d="M1361.4 986.6H1410.2V995.2H1361.4z" />
        </g>
        <g>
          <path d="M1342.1 619.7H1350.6999999999998V697.5H1342.1z" />
        </g>
        <g>
          <path d="M810.7 1333.2H819.3000000000001V1359.5H810.7z" />
          <path
            className="st4"
            d="M813.5 1332.4H816.3V1357.6000000000001H813.5z"
          />
        </g>
        <g>
          <path d="M814.6 1357.4H845.3000000000001V1366H814.6z" />
          <path className="st4" d="M813.9 1360.3H846.8V1363.1H813.9z" />
        </g>
        <path className="st4" d="M1360.9 989.5H1408.7V992.3H1360.9z" />
        <g>
          <path
            transform="rotate(-45.001 1471.641 1028.099)"
            d="M1452.5 1023.8H1490.9V1032.3999999999999H1452.5z"
          />
          <path
            transform="rotate(-45.009 1471.225 1028.522)"
            className="st4"
            d="M1453 1027.1H1489.5V1029.8999999999999H1453z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2183.6 1175.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2180.7 1186.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2183.7 1178.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2184.4 1180.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2212.1 1175.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M2209.2 1186.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2212.2 1178.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3z"
          />
          <path
            className="st4"
            d="M2212.9 1180.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M844.8 1353.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.5-3.8-8.5-8.6s3.8-8.6 8.5-8.6z"
          />
          <path
            className="st4"
            d="M841.9 1364.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM844.9 1356.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3z"
          />
          <path
            className="st4"
            d="M845.6 1358.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M815.2 1323.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.5-3.8-8.5-8.6-.1-4.7 3.7-8.6 8.5-8.6z"
          />
          <path
            className="st4"
            d="M812.3 1334.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM815.3 1326.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M816 1328.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1482.9 1007.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1480 1018.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1483 1010.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1483.7 1012.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1457.2 1034.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1454.3 1045.5c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1457.3 1037.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1458 1039.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M1783.2 1673.1c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1 3.9-.1 7.1 3.1 7.1 7.1z"
          />
          <path d="M1784.6 1673.1c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.8 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7s-5.7 2.6-5.7 5.7c-.1 3.1 2.5 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M2225.2 1371.3c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1c0-3.9 3.2-7.1 7.1-7.1 3.9 0 7.1 3.2 7.1 7.1z"
          />
          <path d="M2226.6 1371.3c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6c0-4.7 3.8-8.6 8.6-8.6 4.8.1 8.6 3.9 8.6 8.6zm-8.6 5.8c3.1 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7s-5.7 2.6-5.7 5.7 2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1933.6 1371.3c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.1-3.2-7.1-7.1 0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1z"
          />
          <path d="M1935 1371.3c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6 4.8.1 8.6 3.9 8.6 8.6zm-8.6 5.8c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M2339 1371.3c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1c0-3.9 3.2-7.1 7.1-7.1 3.9 0 7.1 3.2 7.1 7.1z"
          />
          <path d="M2340.4 1371.3c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6c0-4.7 3.8-8.6 8.6-8.6 4.8.1 8.6 3.9 8.6 8.6zm-8.6 5.8c3.1 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7s-5.7 2.6-5.7 5.7 2.6 5.7 5.7 5.7z" />
        </g>
        <path
          className="st42"
          d="M815.2 1353.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M815.2 1369.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
        />
        <g>
          <path
            className="st42"
            d="M812.3 1364.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM815.3 1356c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M816 1358.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <path
          className="st42"
          d="M815.2 1293.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
        />
        <path
          className="st4"
          d="M815.2 1309.5c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
        />
        <g>
          <path
            className="st42"
            d="M812.3 1304.3c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM815.3 1296.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M816 1298.4l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g id="XMLID_287_">
          <path id="XMLID_289_" d="M1386 1285.5H1394.6V1309.7H1386z" />
          <path
            id="XMLID_288_"
            className="st4"
            d="M1388.9 1287.3H1391.7V1310.3999999999999H1388.9z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1390.3 1305.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1390.3 1322.1c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1387.4 1316.9c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1390.4 1308.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1391.1 1311l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1247.7 1422.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1247.7 1439.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1244.8 1434c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1247.9 1425.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1248.6 1428.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1248.3 1518c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1248.3 1534.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1245.4 1529.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1248.5 1520.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1249.1 1523.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1390.3 1276.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1390.3 1293.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1387.4 1288c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1390.4 1279.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.7-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1391.1 1282.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1015 125.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1015 141.3c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1012.1 136.1c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM1015.2 127.9c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1015.8 130.2l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M993.1 490.4c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M993.1 506.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <path
            className="st42"
            d="M990.2 501.4c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.6-1.4zM993.2 493.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st42"
            d="M993.9 495.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H990s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.5.1-.7.7-.7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1035.6 447.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
            />
            <path
              className="st4"
              d="M1035.6 464.2c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
            />
          </g>
          <g>
            <path
              className="st42"
              d="M1032.7 459c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1035.7 450.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1036.4 453l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M1254.9 1454.8c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.1 7.2-7.1 3.9 0 7.1 3.2 7.1 7.1z"
          />
          <path d="M1256.3 1454.8c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6s8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1254.9 1475.2c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.1 7.2-7.1 3.9 0 7.1 3.2 7.1 7.1z"
          />
          <path d="M1256.3 1475.2c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6 4.8.1 8.6 3.9 8.6 8.6zm-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7z" />
        </g>
        <g>
          <path
            className="st42"
            d="M1697.5 1678c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1697.5 1694.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1694.6 1689.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1697.7 1680.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1698.3 1683.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1571.5 1678c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1571.5 1694.2c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1568.6 1689.1c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1571.7 1680.9c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1572.3 1683.1l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <path className="st4" d="M1344.9 615H1347.7V696.3H1344.9z" />
        <g>
          <path
            className="st42"
            d="M1346.4 657.9c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1343.5 669c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1346.5 660.8c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1347.2 663l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1346.4 632.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1343.5 643.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1346.5 635.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7.1-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1347.2 637.5l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1346.7 688c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4.1-9 9-9z"
          />
          <path
            className="st4"
            d="M1343.7 699.6c.4 1.4 1.7 2.5 3.3 2.5 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.8-4.8 4.8-1.7 0-3.2-.9-4-2.2l.8-1.7zM1346.9 691c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1347.6 693.4l-.1.9h-2.9s-.6.1-.6.7.6.6.6.6h2.7l-.1.9h-3.7s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8.9-.3.9-.3l1.6-3.3s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.6s0-.8-.8-.8c-.4.2-.6.8-.6.8z"
          />
        </g>
        <g id="XMLID_124_">
          <path
            id="XMLID_125_"
            transform="rotate(-45.001 1539.393 440.513)"
            d="M1535.1 428.3H1543.6999999999998V452.6H1535.1z"
          />
        </g>
        <g id="XMLID_113_">
          <path
            id="XMLID_123_"
            className="st4"
            d="M1538.5 439.6c-2.8 2.8-7.3 2.8-10.1 0s-2.8-7.3 0-10.1 7.3-2.8 10.1 0c2.8 2.7 2.8 7.3 0 10.1z"
          />
          <path
            id="XMLID_114_"
            d="M1539.5 440.6c-3.3 3.3-8.8 3.3-12.1 0s-3.3-8.8 0-12.1 8.8-3.3 12.1 0c3.3 3.3 3.3 8.7 0 12.1zm-10.1-2.1c2.2 2.2 5.8 2.2 8.1 0s2.2-5.9 0-8.1c-2.2-2.2-5.8-2.2-8.1 0-2.2 2.3-2.2 5.9 0 8.1z"
          />
        </g>
        <path
          id="XMLID_112_"
          transform="rotate(-44.996 1539.853 440.734)"
          className="st4"
          d="M1538.5 429.1H1541.3V452.5H1538.5z"
        />
        <g>
          <path
            transform="rotate(-45.001 969.68 522.2)"
            d="M968 520.5H971.4V523.9H968z"
          />
          <path
            transform="rotate(-45.001 973.327 518.56)"
            d="M971.6 516.8H975V520.1999999999999H971.6z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 966.041 525.843)"
            d="M964.3 524.1H967.6999999999999V527.5H964.3z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 976.966 514.913)"
            d="M975.3 513.2H978.6999999999999V516.6H975.3z"
          />
          <path
            transform="rotate(-45.001 980.61 511.27)"
            d="M978.9 509.6H982.3V513H978.9z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M1472.3 141.3c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0"
          />
          <path d="M1473.3 140.3c3.3 3.3 3.3 8.8 0 12.1s-8.8 3.3-12.1 0-3.3-8.8 0-12.1c3.3-3.4 8.7-3.4 12.1 0m-2 10.1c2.2-2.2 2.2-5.8 0-8.1-2.2-2.2-5.8-2.2-8.1 0-2.2 2.2-2.2 5.9 0 8.1 2.2 2.2 5.9 2.2 8.1 0z" />
        </g>
        <g>
          <path
            className="st4"
            d="M1472.3 233.7c2.8 2.8 2.8 7.3 0 10.1s-7.3 2.8-10.1 0-2.8-7.3 0-10.1 7.3-2.8 10.1 0"
          />
          <path d="M1473.3 232.7c3.3 3.3 3.3 8.8 0 12.1s-8.8 3.3-12.1 0-3.3-8.8 0-12.1c3.3-3.3 8.7-3.3 12.1 0m-2 10.1c2.2-2.2 2.2-5.8 0-8.1-2.2-2.2-5.8-2.2-8.1 0-2.2 2.2-2.2 5.9 0 8.1 2.2 2.2 5.9 2.2 8.1 0z" />
        </g>
        <g>
          <path d="M2198.5 1182.6H2201.7V1186H2198.5z" />
          <path d="M2193.1 1182.6H2196.2999999999997V1186H2193.1z" />
        </g>
        <g>
          <path
            transform="rotate(-52.84 2169.424 1177.082)"
            d="M2167.7 1175.7H2171.1V1178.6000000000001H2167.7z"
          />
          <path
            transform="rotate(-52.84 2172.702 1179.564)"
            d="M2171 1178.2H2174.4V1181.1000000000001H2171z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1818.08 1612.045)"
            d="M1816.4 1610.3H1819.8000000000002V1613.7H1816.4z"
          />
          <path
            transform="rotate(-45.001 1821.726 1608.405)"
            d="M1820 1606.7H1823.4V1610.1000000000001H1820z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 1825.358 1604.755)"
            d="M1823.7 1603H1827.1000000000001V1606.4H1823.7z"
          />
        </g>
        <path
          transform="rotate(-45.001 1355.988 727.393)"
          d="M1337.2 723.1H1374.9V731.7H1337.2z"
        />
        <path
          transform="rotate(-45.009 1356.077 727.578)"
          className="st4"
          d="M1337.3 726.1H1374.8999999999999V728.9H1337.3z"
        />
        <path
          id="XMLID_286_"
          className="st42"
          d="M1366.8 707.5c5 0 9 4 9 9s-4 9-9 9-9-4-9-9c-.1-5 4-9 9-9"
        />
        <path
          id="XMLID_285_"
          className="st4"
          d="M1366.8 724.6c-4.5 0-8.1-3.6-8.1-8.1s3.6-8.1 8.1-8.1 8.1 3.6 8.1 8.1c-.1 4.5-3.7 8.1-8.1 8.1"
        />
        <path
          id="XMLID_284_"
          className="st42"
          d="M1363.7 719.2c.4 1.4 1.7 2.5 3.3 2.5 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.8-4.8 4.8-1.7 0-3.2-.9-4-2.2l.8-1.7z"
        />
        <path
          id="XMLID_283_"
          className="st42"
          d="M1366.9 710.6c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7-.1-1.3.5-1.3 1.3"
        />
        <path
          id="XMLID_282_"
          className="st42"
          d="M1367.6 712.9l-.1.9h-2.9s-.6.1-.6.7.6.6.6.6h2.7l-.1.9h-3.7s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8.9-.3.9-.3l1.6-3.3s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.6s0-.7-.8-.8c-.4.2-.6.8-.6.8"
        />
        <path
          className="st42"
          d="M1346.2 613.8c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9"
        />
        <path
          className="st4"
          d="M1346.2 630.9c-4.5 0-8.1-3.6-8.1-8.1s3.6-8.1 8.1-8.1 8.1 3.6 8.1 8.1-3.6 8.1-8.1 8.1"
        />
        <path
          className="st42"
          d="M1343.2 625.4c.4 1.4 1.7 2.5 3.3 2.5 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.8-4.8 4.8-1.7 0-3.2-.9-4-2.2l.8-1.7zM1346.4 616.8c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M1347.1 619.2l-.1.9h-2.9s-.6.1-.6.7.6.6.6.6h2.7l-.1.9h-3.6s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8.9-.3.9-.3l1.6-3.3s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.6s0-.7-.8-.8c-.5.2-.7.8-.7.8"
        />
        <path
          transform="rotate(-45.001 1373.387 833.056)"
          d="M1371.7 831.3H1375.1000000000001V834.6999999999999H1371.7z"
        />
        <path
          transform="rotate(-45.001 1376.824 836.489)"
          d="M1375.1 834.8H1378.5V838.1999999999999H1375.1z"
        />
        <path
          transform="rotate(-45.001 1380.14 839.806)"
          d="M1378.4 838.1H1381.8000000000002V841.5H1378.4z"
        />
        <path
          transform="rotate(-45.001 1369.896 829.559)"
          d="M1368.2 827.8H1371.6000000000001V831.1999999999999H1368.2z"
        />
        <path
          transform="rotate(-45.001 1366.394 826.059)"
          d="M1364.7 824.3H1368.1000000000001V827.6999999999999H1364.7z"
        />
        <path
          transform="rotate(-45.001 1390.457 850.126)"
          d="M1388.8 848.4H1392.2V851.8H1388.8z"
        />
        <path
          transform="rotate(-45.001 1393.894 853.559)"
          d="M1392.2 851.8H1395.6000000000001V855.1999999999999H1392.2z"
        />
        <path
          transform="rotate(-45.001 1386.966 846.629)"
          d="M1385.3 844.9H1388.7V848.3H1385.3z"
        />
        <path
          transform="rotate(-45.001 1383.463 843.129)"
          d="M1381.8 841.4H1385.2V844.8H1381.8z"
        />
        <path
          className="st4"
          d="M1409.2 861.8c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1s3.2-7.1 7.2-7.1c3.9-.1 7.1 3.1 7.1 7.1"
        />
        <path d="M1410.7 861.8c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6c4.7 0 8.6 3.8 8.6 8.6m-8.6 5.7c3.2 0 5.7-2.5 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7" />
        <path
          transform="rotate(-45.001 1227.794 1579.203)"
          className="st4"
          d="M1203.3 1577.8H1252.2V1580.6H1203.3z"
        />
        <path
          className="st42"
          d="M1209.6 1588.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M1206.7 1599.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1209.7 1591.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st4"
          d="M1210.4 1593.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7M1507.9 1284.9c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.1 7.2-7.1 3.9 0 7.1 3.2 7.1 7.1"
        />
        <path d="M1509.3 1284.9c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6 4.7.1 8.6 3.9 8.6 8.6m-8.6 5.8c3.2 0 5.7-2.6 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7" />
        <path
          className="st4"
          d="M1774.8 1322.6c0 3.9-3.2 7.1-7.1 7.1-3.9 0-7.2-3.2-7.2-7.1 0-3.9 3.2-7.1 7.2-7.1 3.9-.1 7.1 3.1 7.1 7.1"
        />
        <path d="M1776.2 1322.6c0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6 4.7 0 8.6 3.8 8.6 8.6m-8.6 5.7c3.2 0 5.7-2.6 5.7-5.7s-2.6-5.7-5.7-5.7c-3.2 0-5.7 2.6-5.7 5.7s2.6 5.7 5.7 5.7" />
        <path
          className="st42"
          d="M1801.9 1228.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M1801.9 1244.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M1799 1239.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1802.1 1231.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M1802.8 1233.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7M1847.4 1228.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M1847.4 1244.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M1844.6 1239.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1847.6 1231.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M1848.3 1233.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7M1867 1247.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M1864.1 1258.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1867.1 1250.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st4"
          d="M1867.8 1252.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
        />
        <g>
          <path
            className="st42"
            d="M2143.1 1229.6c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
          />
          <path
            className="st4"
            d="M2143.1 1245.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
          />
          <path
            className="st42"
            d="M2140.2 1240.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2143.2 1232.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
          />
          <path
            className="st42"
            d="M2143.9 1234.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
          />
        </g>
        <path
          className="st42"
          d="M2395.7 1229.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M2395.7 1245.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M2392.8 1240.2c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2395.9 1232.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M2396.6 1234.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7M2452.4 1229.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M2452.4 1245.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M2449.5 1240.2c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2452.6 1232.1c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M2453.2 1234.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7M1854.6 1362.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M1854.6 1379c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M1851.7 1373.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1854.8 1365.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M1855.4 1367.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7M2118.7 1362.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M2118.7 1379c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M2115.8 1373.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2118.8 1365.7c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M2119.5 1367.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7M2445.8 1362.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M2445.8 1379c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7-.1 4.3-3.5 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M2442.9 1373.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2445.9 1365.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M2446.6 1367.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7M2419.4 1418.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M2419.4 1435c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M2416.5 1429.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2419.5 1421.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M2420.2 1423.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7M2294.1 1362.8c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M2294.1 1379c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M2291.2 1373.8c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM2294.2 1365.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M2294.9 1367.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
        />
        <path
          id="XMLID_262_"
          transform="rotate(-44.992 984.37 507.633)"
          d="M982.7 505.9H986.1V509.29999999999995H982.7z"
        />
        <path
          id="XMLID_261_"
          transform="rotate(-44.992 1001.264 490.74)"
          d="M999.6 489H1003V492.4H999.6z"
        />
        <path
          id="XMLID_260_"
          transform="rotate(-45.009 1004.982 487.034)"
          d="M1003.3 485.3H1006.6999999999999V488.7H1003.3z"
        />
        <path
          id="XMLID_259_"
          transform="rotate(-45.001 1008.633 483.382)"
          d="M1006.9 481.7H1010.3V485.09999999999997H1006.9z"
        />
        <path
          id="XMLID_258_"
          transform="rotate(-44.992 1012.367 479.635)"
          d="M1010.7 477.9H1014.1V481.29999999999995H1010.7z"
        />
        <path
          id="XMLID_257_"
          transform="rotate(-44.992 1016.014 475.99)"
          d="M1014.3 474.3H1017.6999999999999V477.7H1014.3z"
        />
        <path
          id="XMLID_256_"
          transform="rotate(-45.009 1019.732 472.285)"
          d="M1018 470.6H1021.4V474H1018z"
        />
        <path
          id="XMLID_255_"
          transform="rotate(-44.992 1023.618 468.401)"
          d="M1021.9 466.7H1025.3V470.09999999999997H1021.9z"
        />
        <path
          id="XMLID_254_"
          transform="rotate(-44.992 1027.254 464.75)"
          d="M1025.5 463H1028.9V466.4H1025.5z"
        />
        <path
          className="st42"
          d="M1833.7 1588.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M1830.8 1599.4c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1833.9 1591.3c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3"
        />
        <path
          className="st4"
          d="M1834.6 1593.5l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
        />
        <path
          className="st42"
          d="M1809.6 1611.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.9-8.6 8.6-8.6"
        />
        <path
          className="st4"
          d="M1809.6 1627.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.5 7.7-7.7 7.7"
        />
        <path
          className="st42"
          d="M1806.7 1622.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1809.7 1614.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3"
        />
        <path
          className="st42"
          d="M1810.4 1616.7l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
        />
        <g>
          <path
            className="st42"
            d="M1247.7 1550.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.7 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1247.7 1567c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1244.8 1561.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1247.9 1553.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1248.6 1555.9l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1226.6 1687.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1226.6 1703.8c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.2-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1223.7 1698.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1226.8 1690.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1227.4 1692.6l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1159 1693.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1159 1709.9c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7s-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1156.1 1704.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1159.1 1696.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1159.8 1698.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1095.3 1693.7c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1095.3 1709.9c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7s-3.4 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M1092.4 1704.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1095.5 1696.6c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.8 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M1096.2 1698.8l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.7.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M1545.1 437.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1542.2 448.5c.4 1.4 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.9-3.8-2.1l.7-1.4zM1545.2 440.4c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.5-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1545.9 442.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1361.1 981.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1358.2 992.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1361.2 984.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1361.9 986.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1405.8 981.8c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1402.9 992.8c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1405.9 984.7c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1406.6 986.9l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1343.8 731.3c5 0 9 4 9 9s-4 9-9 9-9-4-9-9 4-9 9-9z"
          />
          <path
            className="st4"
            d="M1340.7 742.9c.4 1.4 1.7 2.5 3.3 2.5 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.8-4.8 4.8-1.7 0-3.2-.9-4-2.2l.8-1.7zM1343.9 734.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3s-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1344.6 736.7l-.1.9h-2.9s-.6.1-.6.7.6.6.6.6h2.7l-.1.9h-3.7s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8.9-.3.9-.3l1.6-3.3s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.6s0-.8-.8-.8c-.4.1-.6.8-.6.8z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M1458.2 779.9c5 0 9 4 9 9s-4 9-9 9-9-4-9-9c0-4.9 4-9 9-9z"
          />
          <path
            className="st4"
            d="M1455.1 791.6c.4 1.4 1.7 2.5 3.3 2.5 1.9 0 3.4-1.5 3.4-3.4 0-1-.4-1.9-1.1-2.5l.2-1.5c1.3.8 2.2 2.3 2.2 4 0 2.6-2.1 4.8-4.8 4.8-1.7 0-3.2-.9-4-2.2l.8-1.7zM1458.3 783c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3s-1.3.5-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1459.1 785.3l-.1.9h-2.9s-.6.1-.6.7.6.6.6.6h2.7l-.1.9h-3.7s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2 4.1s-.2.5.3.8.9-.3.9-.3l1.6-3.3s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.3s.3 0 .6-.3.3-.6.3-.6l.5-3.6s0-.8-.8-.8c-.5.2-.6.8-.6.8z"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M408 835.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M408 851.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M405.1 846.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM408.1 838c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M408.8 840.2l-.1.9H406s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H405s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M364.6 835.1c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M364.6 851.3c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M361.7 846.1c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM364.7 838c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M365.4 840.2l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M408 853.3c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6 0-4.7 3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M408 869.6c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7 7.7 3.5 7.7 7.7-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M405.1 864.4c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM408.1 856.2c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M408.8 858.4l-.1.9H406s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H405s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M408 871.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M405.1 882.6c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM408.1 874.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M408.8 876.7l-.1.9H406s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8H405s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7z"
          />
        </g>
        <g>
          <path
            transform="rotate(-45.001 841.752 716.067)"
            d="M824 711.8H859.6V720.4H824z"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M861.1 703.7c0 3.9-3.2 7.1-7.1 7.1s-7.2-3.2-7.2-7.1 3.2-7.1 7.2-7.1c3.9-.1 7.1 3.2 7.1 7.1z"
          />
          <path d="M862.5 703.7c0 4.7-3.8 8.6-8.6 8.6s-8.6-3.8-8.6-8.6 3.8-8.6 8.6-8.6 8.6 3.9 8.6 8.6zm-8.5 5.7c3.2 0 5.7-2.6 5.7-5.7 0-3.2-2.6-5.7-5.7-5.7-3.2 0-5.7 2.6-5.7 5.7s2.5 5.7 5.7 5.7z" />
        </g>
        <path
          transform="rotate(-44.996 840.823 717.063)"
          className="st4"
          d="M823.8 715.7H857.9V718.5H823.8z"
        />
        <g id="lul-circle_x5F_lul-hammersmith-city_x5F_940GZZLUPAH_3_">
          <path
            className="st42"
            d="M828.8 719.5c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6s3.8-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M828.8 735.8c-4.2 0-7.7-3.4-7.7-7.7s3.4-7.7 7.7-7.7c4.2 0 7.7 3.5 7.7 7.7-.1 4.2-3.5 7.7-7.7 7.7z"
          />
          <g>
            <path
              className="st42"
              d="M825.8 730.6c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.6-1.4zM828.9 722.4c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7.1-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M829.6 724.6l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.5.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
            />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M749 1004.6v5.1c-2.5 1.1-4.3 3.6-4.3 6.5 0 3.9 3.2 7.2 7.1 7.2s7.2-3.2 7.2-7.2c0-2.9-1.8-5.4-4.3-6.5v-5.1c2.5-1.1 4.3-3.6 4.3-6.5 0-3.9-3.2-7.1-7.2-7.1s-7.1 3.2-7.1 7.1c.1 2.9 1.8 5.4 4.3 6.5z"
          />
          <path d="M746.2 998.1c0-3.2 2.5-5.7 5.7-5.7s5.7 2.5 5.7 5.7c0 2.7-1.8 4.9-4.3 5.5v7.2c2.5.6 4.3 2.9 4.3 5.5 0 3.2-2.6 5.7-5.7 5.7-3.2 0-5.7-2.6-5.7-5.7 0-2.7 1.8-4.9 4.3-5.5v-7.2c-2.5-.6-4.3-2.9-4.3-5.5zm1.4 7.4v3.4c-2.6 1.5-4.3 4.2-4.3 7.4 0 4.7 3.8 8.6 8.6 8.6s8.6-3.8 8.6-8.6c0-3.2-1.7-5.9-4.3-7.4v-3.4c2.6-1.5 4.3-4.2 4.3-7.4 0-4.7-3.8-8.6-8.6-8.6s-8.6 3.8-8.6 8.6c0 3.1 1.8 5.9 4.3 7.4z" />
        </g>
        <path
          id="lul-bakerloo_x5F_lul-circle_x5F_lul-district_x5F_940GZZLUPAC_x5F_lul-hammersmith-city_x5F_940GZZLUPAH_00000141451106227805165740000009680234996223009436_"
          transform="rotate(-45.001 852.65 701.996)"
          className="st4"
          d="M851.2 685.7H854V718.2H851.2z"
        />
        <g>
          <path
            className="st42"
            d="M1547.8 752.6c4.7 0 8.6 3.8 8.6 8.6s-3.8 8.6-8.6 8.6c-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6z"
          />
          <path
            className="st4"
            d="M1544.9 763.7c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM1548 755.5c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.8 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M1548.6 757.7l-.1.9h-2.7s-.6 0-.6.6c0 .5.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3c.3-.2.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.2-.8.7-.8.7z"
          />
        </g>
      </g>
      <g id="Station_Names">
        <text transform="translate(352.082 861.854)" className="st25 st26" />
        <text
          transform="translate(352.082 861.854)"
          className="st42 st30 st121"
        >
          {"West"}
        </text>
        <text transform="translate(377.011 861.854)" className="st25 st26" />
        <text
          transform="translate(349.522 873.244)"
          className="st42 st30 st121"
        >
          {"Ealing"}
        </text>
        <text transform="translate(380.049 873.244)" className="st25 st26" />
        <path
          className="st72"
          d="M369.2 883.7L365.1 881.9 370.8 881.9 370.8 880.7 364.9 880.7 367.9 879.2 370.8 879.2 370.8 878 367.9 878 364.3 876.4 361.5 876.4 365.4 878 359.4 878 359.4 879.2 365.4 879.2 362.3 880.7 359.4 880.7 359.4 881.9 362.5 881.9 366.4 883.7z"
        />
        <text
          transform="translate(1086.695 748.974)"
          className="st42 st30 st122"
        >
          {"Regent's Park"}
        </text>
        <text transform="translate(1170.55 773.623)" className="st25 st26" />
        <text
          transform="translate(1170.55 773.623)"
          className="st42 st30 st123"
        >
          {"Goodge"}
        </text>
        <text transform="translate(1209.426 773.623)" className="st25 st26" />
        <text
          transform="translate(1178.37 785.023)"
          className="st42 st30 st123"
        >
          {"Street"}
        </text>
        <text transform="translate(1209.191 785.023)" className="st25 st26" />
        <text
          transform="translate(860.201 780.836)"
          className="st42 st30 st123"
        >
          {"Bayswater"}
        </text>
        <text transform="translate(99.712 801.808)" className="st25 st26" />
        <text transform="translate(99.712 801.808)" className="st42 st30 st123">
          {"West"}
        </text>
        <text transform="translate(127.3 801.808)" className="st25 st26" />
        <text transform="translate(84.382 813.208)" className="st42 st30 st123">
          {"Drayton"}
        </text>
        <text transform="translate(124.928 813.208)" className="st25 st26" />
        <text transform="translate(103.922 755.68)" className="st42 st30 st123">
          {"Iver"}
        </text>
        <text transform="translate(82.99 728.595)" className="st42 st30 st123">
          {"Langley"}
        </text>
        <text transform="translate(74.806 670.26)" className="st42 st30 st123">
          {"Burnham"}
        </text>
        <text transform="translate(85.448 641.094)" className="st42 st30 st123">
          {"Taplow"}
        </text>
        <text transform="translate(1228.974 715.484)" className="st25 st26" />
        <text
          transform="translate(1228.974 715.484)"
          className="st42 st30 st123"
        >
          {"Warren"}
        </text>
        <text transform="translate(1265.71 715.484)" className="st25 st26" />
        <text
          transform="translate(1228.974 726.884)"
          className="st42 st30 st123"
        >
          {"Street"}
        </text>
        <text transform="translate(1259.795 726.884)" className="st25 st26" />
        <text
          transform="translate(1559.445 849.127)"
          className="st42 st30 st123"
        >
          {"Aldgate"}
        </text>
        <text
          transform="translate(1417.812 755.192)"
          className="st42 st30 st123"
        >
          {"Barbican"}
        </text>
        <text transform="translate(1247.025 743.793)" className="st25 st26" />
        <text
          transform="translate(1247.025 743.793)"
          className="st42 st30 st123"
        >
          {"Russell"}
        </text>
        <text transform="translate(1281.068 743.793)" className="st25 st26" />
        <text
          transform="translate(1246.165 755.193)"
          className="st42 st30 st123"
        >
          {"Square"}
        </text>
        <text transform="translate(1281.008 755.193)" className="st25 st26" />
        <text transform="translate(859.87 926.697)" className="st42 st30 st123">
          {"High Street Kensington"}
        </text>
        <text
          transform="translate(1494.079 702.397)"
          className="st42 st30 st123"
        >
          {"Old Street"}
        </text>
        <text
          transform="translate(1071.997 885.875)"
          className="st42 st30 st123"
        >
          {"Green Park"}
        </text>
        <text transform="translate(992.7 717.585)" className="st25 st26" />
        <text transform="translate(992.7 717.585)" className="st42 st30 st123">
          {"Baker"}
        </text>
        <text transform="translate(1020.887 717.585)" className="st25 st26" />
        <text transform="translate(989.95 728.985)" className="st42 st30 st123">
          {"Street"}
        </text>
        <text transform="translate(1020.77 728.985)" className="st25 st26" />
        <text transform="translate(856.818 842.005)" className="st25 st26" />
        <text
          transform="translate(856.818 842.005)"
          className="st42 st30 st123"
        >
          {"Notting"}
        </text>
        <text transform="translate(895.53 842.005)" className="st25 st26" />
        <text
          transform="translate(856.818 853.405)"
          className="st42 st30 st123"
        >
          {"Hill Gate"}
        </text>
        <text transform="translate(899.304 853.405)" className="st25 st26" />
        <text transform="translate(1365.896 924.145)" className="st25 st26" />
        <text
          transform="translate(1365.896 924.145)"
          className="st42 st30 st123"
        >
          {"Mansion"}
        </text>
        <text transform="translate(1411.099 924.145)" className="st25 st26" />
        <text
          transform="translate(1365.896 935.545)"
          className="st42 st30 st123"
        >
          {"House"}
        </text>
        <text transform="translate(1397.129 935.545)" className="st25 st26" />
        <text
          transform="translate(1294.963 1032.637)"
          className="st42 st30 st123"
        >
          {"Temple"}
        </text>
        <text transform="translate(1126.76 827.79)" className="st25 st26" />
        <text transform="translate(1126.76 827.79)" className="st42 st30 st123">
          {"Oxford"}
        </text>
        <text transform="translate(1160.967 827.79)" className="st25 st26" />
        <text transform="translate(1126.76 839.19)" className="st42 st30 st123">
          {"Circus"}
        </text>
        <text transform="translate(1157.063 839.19)" className="st25 st26" />
        <text transform="translate(1541.737 920.501)" className="st25 st26" />
        <text
          transform="translate(1541.737 920.501)"
          className="st42 st30 st123"
        >
          {"Tower"}
        </text>
        <text transform="translate(1572.206 920.501)" className="st25 st26" />
        <text
          transform="translate(1556.817 931.902)"
          className="st42 st30 st123"
        >
          {"Hill"}
        </text>
        <text transform="translate(1573.057 931.902)" className="st25 st26" />
        <text
          transform="translate(1090.105 996.792)"
          className="st42 st30 st123"
        >
          {"Westminster"}
        </text>
        <text transform="translate(1118.355 913.467)" className="st25 st26" />
        <text
          transform="translate(1118.355 913.467)"
          className="st42 st30 st123"
        >
          {"Piccadilly"}
        </text>
        <text transform="translate(1164.263 913.467)" className="st25 st26" />
        <text
          transform="translate(1134.075 924.867)"
          className="st42 st30 st123"
        >
          {"Circus"}
        </text>
        <text transform="translate(1164.378 924.867)" className="st25 st26" />
        <text transform="translate(1165.5 951.548)" className="st25 st26" />
        <text transform="translate(1165.5 951.548)" className="st42 st30 st123">
          {"Charing"}
        </text>
        <text transform="translate(1204.728 951.548)" className="st25 st26" />
        <text
          transform="translate(1177.47 962.948)"
          className="st42 st30 st123"
        >
          {"Cross"}
        </text>
        <text transform="translate(1204.433 962.948)" className="st25 st26" />
        <text
          transform="translate(1282.142 830.267)"
          className="st42 st30 st123"
        >
          {"Holborn"}
        </text>
        <text transform="translate(1616.335 950.237)" className="st25 st26" />
        <text
          transform="translate(1616.335 950.237)"
          className="st42 st30 st123"
        >
          {"Tower"}
        </text>
        <text transform="translate(1649.461 950.237)" className="st25 st26" />
        <text
          transform="translate(1616.335 961.637)"
          className="st42 st30 st123"
        >
          {"Gateway"}
        </text>
        <text transform="translate(1659.774 961.637)" className="st25 st26" />
        <text
          transform="translate(1499.129 893.477)"
          className="st42 st30 st123"
        >
          {"Monument"}
        </text>
        <text transform="translate(1410.8 806.716)" className="st42 st30 st123">
          {"Moorgate"}
        </text>
        <text
          transform="translate(1226.654 888.453)"
          className="st42 st30 st123"
        >
          {"Leicester Square"}
        </text>
        <text
          transform="translate(940.958 902.053)"
          className="st42 st30 st123"
        >
          {"Hyde Park Corner"}
        </text>
        <text
          transform="translate(906.167 952.798)"
          className="st42 st30 st123"
        >
          {"Knightsbridge"}
        </text>
        <text
          transform="translate(1389.47 682.847)"
          className="st42 st30 st123"
        >
          {"Angel"}
        </text>
        <text
          transform="translate(884.153 878.876)"
          className="st42 st30 st123"
        >
          {"Queensway"}
        </text>
        <text
          transform="translate(916.134 825.987)"
          className="st42 st30 st123"
        >
          {"Marble Arch"}
        </text>
        <text transform="translate(912.717 1035.357)" className="st25 st26" />
        <text
          transform="translate(912.717 1035.357)"
          className="st42 st30 st123"
        >
          {"South"}
        </text>
        <text transform="translate(942.421 1035.357)" className="st25 st26" />
        <text
          transform="translate(898.957 1046.757)"
          className="st42 st30 st123"
        >
          {"Kensington"}
        </text>
        <text transform="translate(956.237 1046.757)" className="st25 st26" />
        <text transform="translate(978.965 1032.793)" className="st25 st26" />
        <text
          transform="translate(978.965 1032.793)"
          className="st42 st30 st123"
        >
          {"Sloane"}
        </text>
        <text transform="translate(1012.455 1032.793)" className="st25 st26" />
        <text
          transform="translate(978.145 1044.194)"
          className="st42 st30 st123"
        >
          {"Square"}
        </text>
        <text transform="translate(1012.988 1044.194)" className="st25 st26" />
        <text
          transform="translate(1251.882 859.36)"
          className="st42 st30 st123"
        >
          {"Covent Garden"}
        </text>
        <text transform="translate(1543.377 809.574)" className="st25 st26" />
        <text
          transform="translate(1543.377 809.574)"
          className="st42 st30 st123"
        >
          {"Liverpool"}
        </text>
        <text transform="translate(1589.72 809.574)" className="st25 st26" />
        <text
          transform="translate(1543.377 820.974)"
          className="st42 st30 st123"
        >
          {"Street"}
        </text>
        <text transform="translate(1574.198 820.974)" className="st25 st26" />
        <text transform="translate(1069.137 706.46)" className="st25 st26" />
        <text
          transform="translate(1069.137 706.46)"
          className="st42 st30 st123"
        >
          {"Great Portland"}
        </text>
        <text transform="translate(1142.832 706.46)" className="st25 st26" />
        <text
          transform="translate(1090.307 717.86)"
          className="st42 st30 st123"
        >
          {"Street"}
        </text>
        <text transform="translate(1121.128 717.86)" className="st25 st26" />
        <text
          transform="translate(1445.196 849.77)"
          className="st42 st30 st123"
        >
          {"Bank"}
        </text>
        <text transform="translate(1301.19 793.739)" className="st25 st26" />
        <text
          transform="translate(1301.19 793.739)"
          className="st42 st30 st123"
        >
          {"Chancery"}
        </text>
        <text transform="translate(1350.555 793.739)" className="st25 st26" />
        <text
          transform="translate(1301.19 805.139)"
          className="st42 st30 st123"
        >
          {"Lane"}
        </text>
        <text transform="translate(1324.802 805.139)" className="st25 st26" />
        <text transform="translate(967.53 870.392)" className="st25 st26" />
        <text transform="translate(967.53 870.392)" className="st42 st30 st123">
          {"Lancaster"}
        </text>
        <text transform="translate(1015.92 870.392)" className="st25 st26" />
        <text transform="translate(967.53 881.792)" className="st42 st30 st123">
          {"Gate"}
        </text>
        <text transform="translate(991.12 881.792)" className="st25 st26" />
        <text transform="translate(788.55 878.288)" className="st25 st26" />
        <text transform="translate(788.55 878.288)" className="st42 st30 st123">
          {"Holland"}
        </text>
        <text transform="translate(826.815 878.288)" className="st25 st26" />
        <text transform="translate(796.54 889.688)" className="st42 st30 st123">
          {"Park"}
        </text>
        <text transform="translate(818.824 889.688)" className="st25 st26" />
        <path
          className="st72"
          d="M1157 951.5L1152.7 949.6 1158.8 949.6 1158.8 948.3 1152.5 948.3 1155.7 946.7 1158.8 946.7 1158.8 945.5 1155.7 945.5 1151.8 943.7 1148.8 943.7 1153 945.5 1146.6 945.5 1146.6 946.7 1153 946.7 1149.6 948.3 1146.6 948.3 1146.6 949.6 1149.9 949.6 1154.1 951.5z"
        />
        <path
          className="st72"
          d="M1517.8 940.3L1515.2 939.2 1518.9 939.2 1518.9 938.4 1515.1 938.4 1517 937.5 1518.9 937.5 1518.9 936.7 1517 936.7 1514.7 935.6 1512.9 935.6 1515.4 936.7 1511.6 936.7 1511.6 937.5 1515.4 937.5 1513.4 938.4 1511.6 938.4 1511.6 939.2 1513.6 939.2 1516.1 940.3z"
        />
        <text transform="translate(1395.862 894.22)" className="st25 st26" />
        <text
          transform="translate(1395.862 894.22)"
          className="st42 st30 st123"
        >
          {"Cannon"}
        </text>
        <text transform="translate(1436.444 894.22)" className="st25 st26" />
        <text
          transform="translate(1402.732 905.62)"
          className="st42 st30 st123"
        >
          {"Street"}
        </text>
        <text transform="translate(1433.553 905.62)" className="st25 st26" />
        <path
          className="st72"
          d="M1394.8 905.4L1390.4 903.5 1396.6 903.5 1396.6 902.2 1390.3 902.2 1393.5 900.6 1396.6 900.6 1396.6 899.3 1393.5 899.3 1389.6 897.5 1386.6 897.5 1390.7 899.3 1384.4 899.3 1384.4 900.6 1390.7 900.6 1387.4 902.2 1384.4 902.2 1384.4 903.5 1387.6 903.5 1391.8 905.4z"
        />
        <path
          className="st42"
          d="M1775.2 928.4l-2.1-2.8h2.1l1.2-1.6s.1 0 .2-.1.3-.1.3-.1h1.6v-.6h.7l.4-1h.5l-.2.5.3.4h1.9v.6h3.2s.3 0 .5.2.3.4.3.4l.5 1.3h1.1l1.1 2.8s-1.2-.8-3.2-.7c-1.6.1-2.3.7-4.1.7-1 0-2.5-.5-3.7-.5-.7 0-2.1.3-2.6.5zm.9 1.3c.7-.2 1.6-.5 3.2-.1.8.2 1.6.3 2.3.4 1 0 1.5-.2 2.3-.3.7-.2 1.5-.3 2.1-.3 1.1 0 1.8.2 2.3.4l-.3-.9c-.9-.3-2.3-.5-4.1 0-.7.2-1.5.4-2.2.3-.7 0-1.3-.1-2-.3-2.2-.5-3-.2-4.1.1l.5.7zm0-4.1h2v-1.2h-.8s-.2 0-.3.1c-.1.1-.3.4-.3.4l-.6.7zm5.1 0h2.1v-1.2h-2.1v1.2zm4.5-.9s-.1-.1-.1-.2c-.1-.1-.2-.1-.2-.1h-1.4v1.2h2.2l-.5-.9zm-7 .9h2.1v-1.2h-2.1v1.2zM1759.5 999.1l-2.1-2.8h2.1l1.2-1.6s.1 0 .2-.1.3-.1.3-.1h1.6v-.6h.7l.4-1h.5l-.2.5.3.4h1.9v.6h3.2s.3 0 .5.2.3.4.3.4l.5 1.3h1.1l1.1 2.8s-1.2-.8-3.2-.7c-1.6.1-2.3.7-4.1.7-1 0-2.5-.5-3.7-.5-.8-.1-2.2.3-2.6.5zm.9 1.3c.7-.2 1.6-.5 3.2-.1.8.2 1.6.3 2.3.4 1 0 1.5-.2 2.3-.3.7-.2 1.5-.3 2.1-.3 1.1 0 1.8.2 2.3.4l-.3-.9c-.9-.3-2.3-.5-4.1 0-.7.2-1.5.4-2.2.3-.7 0-1.3-.1-2-.3-2.2-.5-3-.2-4.1.1l.5.7zm-.1-4.1h2v-1.2h-.8s-.2 0-.3.1c-.1.1-.3.4-.3.4l-.6.7zm5.2 0h2.1v-1.2h-2.1v1.2zm4.4-.9s-.1-.1-.1-.2c-.1-.1-.2-.1-.2-.1h-1.4v1.2h2.2l-.5-.9zm-7 .9h2.1v-1.2h-2.1v1.2z"
        />
        <path
          className="st72"
          d="M1591.8 820.9L1587.4 818.9 1593.6 818.9 1593.6 817.6 1587.2 817.6 1590.4 816.1 1593.6 816.1 1593.6 814.8 1590.4 814.8 1586.5 813 1583.5 813 1587.7 814.8 1581.3 814.8 1581.3 816.1 1587.7 816.1 1584.4 817.6 1581.3 817.6 1581.3 818.9 1584.6 818.9 1588.8 820.9z"
        />
        <path
          className="st72"
          d="M1564.5 702.4L1560.2 700.4 1566.3 700.4 1566.3 699.1 1560 699.1 1563.2 697.6 1566.3 697.6 1566.3 696.3 1563.2 696.3 1559.3 694.5 1556.3 694.5 1560.5 696.3 1554.1 696.3 1554.1 697.6 1560.5 697.6 1557.1 699.1 1554.1 699.1 1554.1 700.4 1557.4 700.4 1561.6 702.4z"
        />
        <path
          className="st72"
          d="M1403.1 806.7L1398.7 804.8 1404.9 804.8 1404.9 803.5 1398.6 803.5 1401.8 801.9 1404.9 801.9 1404.9 800.7 1401.8 800.7 1397.8 798.9 1394.9 798.9 1399 800.7 1392.7 800.7 1392.7 801.9 1399 801.9 1395.7 803.5 1392.7 803.5 1392.7 804.8 1395.9 804.8 1400.1 806.7z"
        />
        <text transform="translate(865.71 976.376)" className="st25 st26" />
        <text transform="translate(865.71 976.376)" className="st42 st30 st123">
          {"Gloucester"}
        </text>
        <text transform="translate(919.296 976.376)" className="st25 st26" />
        <text transform="translate(880.12 987.777)" className="st42 st30 st123">
          {"Road"}
        </text>
        <text transform="translate(905.025 987.777)" className="st25 st26" />
        <text transform="translate(1074.33 1032.793)" className="st25 st26" />
        <text
          transform="translate(1074.33 1032.793)"
          className="st42 st30 st123"
        >
          {"St James's"}
        </text>
        <text transform="translate(1124.213 1032.793)" className="st25 st26" />
        <text
          transform="translate(1088.11 1044.194)"
          className="st42 st30 st123"
        >
          {"Park"}
        </text>
        <text transform="translate(1110.394 1044.194)" className="st25 st26" />
        <text transform="translate(1160.733 703.61)" className="st25 st26" />
        <text
          transform="translate(1160.733 703.61)"
          className="st42 st30 st123"
        >
          {"Euston"}
        </text>
        <text transform="translate(1195.094 703.61)" className="st25 st26" />
        <text
          transform="translate(1160.013 715.01)"
          className="st42 st30 st123"
        >
          {"Square"}
        </text>
        <text transform="translate(1194.856 715.01)" className="st25 st26" />
        <text
          transform="translate(931.602 700.453)"
          className="st42 st30 st123"
        >
          {"Edgware Road"}
        </text>
        <text
          transform="translate(838.313 654.695)"
          className="st42 st30 st123"
        >
          {"Edgware Road"}
        </text>
        <text
          transform="translate(1242.197 1002.527)"
          className="st42 st30 st123"
        >
          {"Embankment"}
        </text>
        <text transform="translate(1231.073 775.39)" className="st25 st26" />
        <text
          transform="translate(1231.073 775.39)"
          className="st42 st30 st123"
        >
          {"Tottenham"}
        </text>
        <text transform="translate(1285.73 775.39)" className="st25 st26" />
        <text
          transform="translate(1230.593 786.79)"
          className="st42 st30 st123"
        >
          {"Court Road"}
        </text>
        <text transform="translate(1286.52 786.79)" className="st25 st26" />
        <text
          transform="translate(929.236 654.695)"
          className="st42 st30 st123"
        >
          {"Marylebone"}
        </text>
        <path
          className="st72"
          d="M1003.3 654.6L999 652.7 1005.1 652.7 1005.1 651.4 998.8 651.4 1002 649.8 1005.1 649.8 1005.1 648.6 1002 648.6 998.1 646.8 995.1 646.8 999.2 648.6 992.9 648.6 992.9 649.8 999.2 649.8 995.9 651.4 992.9 651.4 992.9 652.7 996.1 652.7 1000.3 654.6z"
        />
        <path
          className="st72"
          d="M897.5 757.1L893.2 755.2 899.3 755.2 899.3 753.9 893 753.9 896.2 752.3 899.3 752.3 899.3 751.1 896.2 751.1 892.3 749.3 889.3 749.3 893.5 751.1 887.1 751.1 887.1 752.3 893.5 752.3 890.1 753.9 887.1 753.9 887.1 755.2 890.4 755.2 894.6 757.1z"
        />
        <text transform="translate(864.242 744.2)" className="st42 st30 st123">
          {"Paddington"}
        </text>
        <text
          transform="translate(687.005 134.392)"
          className="st42 st30 st124"
        >
          {"Watford High Street"}
        </text>
        <text transform="translate(689.943 78.365)" className="st42 st30 st124">
          {"Watford Junction"}
        </text>
        <text
          transform="translate(691.104 171.449)"
          className="st42 st30 st124"
        >
          {"Bushey"}
        </text>
        <text
          transform="translate(690.622 205.633)"
          className="st42 st30 st124"
        >
          {"Carpenders Park"}
        </text>
        <text
          transform="translate(688.914 238.002)"
          className="st42 st30 st124"
        >
          {"Hatch End"}
        </text>
        <text transform="translate(582.507 452.95)" className="st42 st30 st124">
          {"North Wembley"}
        </text>
        <text
          transform="translate(592.738 429.875)"
          className="st42 st30 st124"
        >
          {"South Kenton"}
        </text>
        <text
          transform="translate(686.706 347.978)"
          className="st42 st30 st124"
        >
          {"Kenton"}
        </text>
        <text
          transform="translate(577.237 476.001)"
          className="st42 st30 st121"
        >
          {"Wembley Central"}
        </text>
        <text transform="translate(686.82 567.38)" className="st42 st30 st124">
          {"Kensal Green"}
        </text>
        <text transform="translate(687.02 589.299)" className="st42 st30 st124">
          {"Queen's Park"}
        </text>
        <text
          transform="translate(574.654 499.074)"
          className="st42 st30 st121"
        >
          {"Stonebridge Park"}
        </text>
        <text
          transform="translate(1730.056 668.063)"
          className="st42 st30 st124"
        >
          {"Bethnal Green"}
        </text>
        <text
          transform="translate(1746.156 648.793)"
          className="st42 st30 st124"
        >
          {"Cambridge Heath"}
        </text>
        <text
          transform="translate(1756.668 623.703)"
          className="st42 st30 st124"
        >
          {"London Fields"}
        </text>
        <text
          transform="translate(611.227 522.129)"
          className="st42 st30 st121"
        >
          {"Harlesden"}
        </text>
        <text transform="translate(570.89 544.144)" className="st42 st30 st121">
          {"Willesden Junction"}
        </text>
        <text
          transform="translate(688.914 270.237)"
          className="st42 st30 st124"
        >
          {"Headstone Lane"}
        </text>
        <path
          className="st72"
          d="M562.4 476L558.1 474 564.2 474 564.2 472.7 557.9 472.7 561.1 471.2 564.2 471.2 564.2 469.9 561.1 469.9 557.2 468.1 554.2 468.1 558.3 469.9 552 469.9 552 471.2 558.3 471.2 555 472.7 552 472.7 552 474 555.2 474 559.5 476z"
        />
        <text transform="translate(616.018 292.162)" className="st25 st26" />
        <text
          transform="translate(616.018 292.162)"
          className="st42 st30 st124"
        >
          {"Harrow &"}
        </text>
        <text transform="translate(663.457 292.162)" className="st25 st26" />
        <text
          transform="translate(604.618 303.562)"
          className="st42 st30 st124"
        >
          {"Wealdstone"}
        </text>
        <text transform="translate(663.51 303.562)" className="st25 st26" />
        <path
          className="st72"
          d="M604.8 292.2L600.4 290.2 606.6 290.2 606.6 288.9 600.2 288.9 603.5 287.4 606.6 287.4 606.6 286.1 603.5 286.1 599.5 284.3 596.6 284.3 600.7 286.1 594.3 286.1 594.3 287.4 600.7 287.4 597.4 288.9 594.3 288.9 594.3 290.2 597.6 290.2 601.8 292.2z"
        />
        <path
          className="st72"
          d="M747.7 171.4L743.3 169.5 749.5 169.5 749.5 168.2 743.2 168.2 746.4 166.6 749.5 166.6 749.5 165.4 746.4 165.4 742.4 163.6 739.5 163.6 743.6 165.4 737.3 165.4 737.3 166.6 743.6 166.6 740.3 168.2 737.3 168.2 737.3 169.5 740.5 169.5 744.7 171.4z"
        />
        <path
          className="st72"
          d="M800.7 78.3L796.3 76.4 802.5 76.4 802.5 75.1 796.1 75.1 799.3 73.6 802.5 73.6 802.5 72.3 799.3 72.3 795.4 70.5 792.5 70.5 796.6 72.3 790.2 72.3 790.2 73.6 796.6 73.6 793.3 75.1 790.2 75.1 790.2 76.4 793.5 76.4 797.7 78.3z"
        />
        <text transform="translate(610.26 650.936)" className="st42 st30 st121">
          {"Kilburn Park"}
        </text>
        <text transform="translate(707.61 681.832)" className="st25 st26" />
        <text transform="translate(707.61 681.832)" className="st42 st30 st122">
          {"Warwick"}
        </text>
        <text transform="translate(750.589 681.832)" className="st25 st26" />
        <text transform="translate(710.35 692.882)" className="st42 st30 st122">
          {"Avenue"}
        </text>
        <text transform="translate(747.315 692.882)" className="st25 st26" />
        <text
          transform="translate(637.326 671.483)"
          className="st42 st30 st123"
        >
          {"Maida Vale"}
        </text>
        <text
          transform="translate(1173.759 657.218)"
          className="st42 st30 st123"
        >
          {"Euston"}
        </text>
        <path
          className="st72"
          d="M1167.2 657.2L1162.9 655.2 1169 655.2 1169 654 1162.7 654 1165.9 652.4 1169 652.4 1169 651.1 1165.9 651.1 1162 649.3 1159 649.3 1163.1 651.1 1156.8 651.1 1156.8 652.4 1163.1 652.4 1159.8 654 1156.8 654 1156.8 655.2 1160.1 655.2 1164.2 657.2z"
        />
        <text transform="translate(1620.565 1256.24)" className="st25 st26" />
        <text
          transform="translate(1620.565 1256.24)"
          className="st42 st30 st125"
        >
          {"New Cross"}
        </text>
        <text transform="translate(1675.248 1256.24)" className="st25 st26" />
        <text
          transform="translate(1649.465 1267.64)"
          className="st42 st30 st125"
        >
          {"Gate"}
        </text>
        <text transform="translate(1673.06 1267.64)" className="st25 st26" />
        <text transform="translate(886.84 1172.354)" className="st25 st26" />
        <text
          transform="translate(886.84 1172.354)"
          className="st42 st30 st124"
        >
          {"Imperial"}
        </text>
        <text transform="translate(930.915 1172.354)" className="st25 st26" />
        <text
          transform="translate(886.84 1183.754)"
          className="st42 st30 st124"
        >
          {"Wharf"}
        </text>
        <text transform="translate(917.732 1183.754)" className="st25 st26" />
        <text transform="translate(910.057 1325.463)" className="st25 st26" />
        <text
          transform="translate(910.057 1325.463)"
          className="st42 st30 st124"
        >
          {"Clapham"}
        </text>
        <text transform="translate(953.897 1325.463)" className="st25 st26" />
        <text
          transform="translate(911.167 1336.863)"
          className="st42 st30 st124"
        >
          {"Junction"}
        </text>
        <text transform="translate(952.725 1336.863)" className="st25 st26" />
        <text
          transform="translate(1553.229 1467.532)"
          className="st42 st30 st124"
        >
          {"Crystal Palace"}
        </text>
        <path
          className="st72"
          d="M970.7 1336.9L966.4 1334.9 972.5 1334.9 972.5 1333.6 966.2 1333.6 969.4 1332.1 972.5 1332.1 972.5 1330.8 969.4 1330.8 965.5 1329 962.5 1329 966.7 1330.8 960.3 1330.8 960.3 1332.1 966.7 1332.1 963.3 1333.6 960.3 1333.6 960.3 1334.9 963.6 1334.9 967.8 1336.9z"
        />
        <text
          transform="translate(1695.394 1483.465)"
          className="st42 st30 st124"
        >
          {"Norwood Junction"}
        </text>
        <path
          className="st72"
          d="M1811.6 1483.5L1807.3 1481.5 1813.4 1481.5 1813.4 1480.2 1807.1 1480.2 1810.3 1478.7 1813.4 1478.7 1813.4 1477.4 1810.3 1477.4 1806.4 1475.6 1803.4 1475.6 1807.6 1477.4 1801.2 1477.4 1801.2 1478.7 1807.6 1478.7 1804.2 1480.2 1801.2 1480.2 1801.2 1481.5 1804.5 1481.5 1808.7 1483.5z"
        />
        <text
          transform="translate(1620.34 1381.57)"
          className="st42 st30 st124"
        >
          {"Sydenham"}
        </text>
        <text
          transform="translate(1622.211 1353.735)"
          className="st42 st30 st124"
        >
          {"Forest Hill"}
        </text>
        <text
          transform="translate(1695.703 1452.337)"
          className="st42 st30 st124"
        >
          {"Anerley"}
        </text>
        <text
          transform="translate(1693.59 1426.264)"
          className="st42 st30 st124"
        >
          {"Penge West"}
        </text>
        <text transform="translate(1641.697 1321.28)" className="st25 st26" />
        <text
          transform="translate(1641.697 1321.28)"
          className="st42 st30 st124"
        >
          {"Honor"}
        </text>
        <text transform="translate(1672.943 1321.28)" className="st25 st26" />
        <text
          transform="translate(1628.317 1332.68)"
          className="st42 st30 st124"
        >
          {"Oak Park"}
        </text>
        <text transform="translate(1672.71 1332.68)" className="st25 st26" />
        <text
          transform="translate(1630.185 1302.211)"
          className="st42 st30 st124"
        >
          {"Brockley"}
        </text>
        <text
          transform="translate(1693.995 952.383)"
          className="st42 st30 st125"
        >
          {"Wapping"}
        </text>
        <path
          className="st72"
          d="M1609.6 1256.2L1605.2 1254.3 1611.4 1254.3 1611.4 1253 1605.1 1253 1608.3 1251.4 1611.4 1251.4 1611.4 1250.2 1608.3 1250.2 1604.4 1248.3 1601.4 1248.3 1605.5 1250.2 1599.2 1250.2 1599.2 1251.4 1605.5 1251.4 1602.2 1253 1599.2 1253 1599.2 1254.3 1602.4 1254.3 1606.6 1256.2z"
        />
        <path
          className="st72"
          d="M1611.6 1381.3L1607.2 1379.4 1613.4 1379.4 1613.4 1378.1 1607.1 1378.1 1610.3 1376.5 1613.4 1376.5 1613.4 1375.3 1610.3 1375.3 1606.4 1373.5 1603.4 1373.5 1607.5 1375.3 1601.2 1375.3 1601.2 1376.5 1607.5 1376.5 1604.2 1378.1 1601.2 1378.1 1601.2 1379.4 1604.4 1379.4 1608.6 1381.3z"
        />
        <text transform="translate(1723.014 1228.648)" className="st25 st26" />
        <text
          transform="translate(1723.014 1228.648)"
          className="st42 st30 st125"
        >
          {"New"}
        </text>
        <text transform="translate(1748.068 1228.648)" className="st25 st26" />
        <text
          transform="translate(1723.014 1240.047)"
          className="st42 st30 st125"
        >
          {"Cross"}
        </text>
        <text transform="translate(1749.985 1240.047)" className="st25 st26" />
        <path
          className="st72"
          d="M1734.4 1251L1730 1249 1736.2 1249 1736.2 1247.7 1729.8 1247.7 1733.1 1246.2 1736.2 1246.2 1736.2 1244.9 1733.1 1244.9 1729.1 1243.1 1726.2 1243.1 1730.3 1244.9 1723.9 1244.9 1723.9 1246.2 1730.3 1246.2 1727 1247.7 1723.9 1247.7 1723.9 1249 1727.2 1249 1731.4 1251z"
        />
        <path
          className="st72"
          d="M1541.4 1467.6L1537 1465.6 1543.2 1465.6 1543.2 1464.3 1536.8 1464.3 1540.1 1462.8 1543.2 1462.8 1543.2 1461.5 1540.1 1461.5 1536.1 1459.7 1533.2 1459.7 1537.3 1461.5 1531 1461.5 1531 1462.8 1537.3 1462.8 1534 1464.3 1531 1464.3 1531 1465.6 1534.2 1465.6 1538.4 1467.6z"
        />
        <text transform="translate(1464.854 1227.11)" className="st25 st26" />
        <text
          transform="translate(1464.854 1227.11)"
          className="st42 st30 st124"
        >
          {"Queens Road"}
        </text>
        <text transform="translate(1530.203 1227.11)" className="st25 st26" />
        <text
          transform="translate(1485.014 1238.51)"
          className="st42 st30 st124"
        >
          {"Peckham"}
        </text>
        <text transform="translate(1530.383 1238.51)" className="st25 st26" />
        <path
          className="st72"
          d="M1453.2 1227.2L1448.9 1225.2 1455.1 1225.2 1455.1 1223.9 1448.7 1223.9 1451.9 1222.4 1455.1 1222.4 1455.1 1221.1 1451.9 1221.1 1448 1219.3 1445 1219.3 1449.2 1221.1 1442.8 1221.1 1442.8 1222.4 1449.2 1222.4 1445.9 1223.9 1442.8 1223.9 1442.8 1225.2 1446.1 1225.2 1450.3 1227.2z"
        />
        <text
          transform="translate(1608.387 1128.12)"
          className="st42 st30 st125"
        >
          {"Surrey Quays"}
        </text>
        <text
          transform="translate(1718.935 786.153)"
          className="st42 st30 st125"
        >
          {"Whitechapel"}
        </text>
        <text transform="translate(999.335 1323.78)" className="st25 st26" />
        <text
          transform="translate(999.335 1323.78)"
          className="st42 st30 st123"
        >
          {"Wandsworth"}
        </text>
        <text transform="translate(1063.317 1323.78)" className="st25 st26" />
        <text
          transform="translate(1018.725 1335.18)"
          className="st42 st30 st123"
        >
          {"Road"}
        </text>
        <text transform="translate(1043.63 1335.18)" className="st25 st26" />
        <text
          transform="translate(1614.509 999.67)"
          className="st42 st30 st126"
        >
          {"Rotherhithe"}
        </text>
        <text transform="translate(1616.832 738.201)" className="st25 st26" />
        <text
          transform="translate(1616.832 738.201)"
          className="st42 st30 st126"
        >
          {"Shoreditch"}
        </text>
        <text transform="translate(1671.478 738.201)" className="st25 st26" />
        <text
          transform="translate(1614.342 749.601)"
          className="st42 st30 st126"
        >
          {"High Street"}
        </text>
        <text transform="translate(1671.364 749.601)" className="st25 st26" />
        <text
          transform="translate(1613.736 632.403)"
          className="st42 st30 st126"
        >
          {"Haggerston"}
        </text>
        <text
          transform="translate(1635.884 658.256)"
          className="st42 st30 st126"
        >
          {"Hoxton"}
        </text>
        <text transform="translate(740.161 838.77)" className="st25 st26" />
        <text transform="translate(740.161 838.77)" className="st42 st30 st127">
          {"Shepherd's"}
        </text>
        <text transform="translate(795.097 838.77)" className="st25 st26" />
        <text transform="translate(755.831 850.17)" className="st42 st30 st127">
          {"Bush"}
        </text>
        <text transform="translate(780.049 850.17)" className="st25 st26" />
        <path
          className="st72"
          d="M793.7 850.2L789.4 848.2 795.5 848.2 795.5 846.9 789.2 846.9 792.4 845.4 795.5 845.4 795.5 844.1 792.4 844.1 788.5 842.3 785.5 842.3 789.7 844.1 783.3 844.1 783.3 845.4 789.7 845.4 786.3 846.9 783.3 846.9 783.3 848.2 786.6 848.2 790.8 850.2z"
        />
        <text
          transform="translate(1698.583 922.796)"
          className="st42 st30 st125"
        >
          {"Shadwell"}
        </text>
        <text transform="translate(1639.712 1030.834)" className="st25 st26" />
        <text
          transform="translate(1639.712 1030.834)"
          className="st42 st30 st125"
        >
          {"Canada"}
        </text>
        <text transform="translate(1676.435 1030.834)" className="st25 st26" />
        <text
          transform="translate(1645.882 1042.235)"
          className="st42 st30 st125"
        >
          {"Water"}
        </text>
        <text transform="translate(1676.546 1042.235)" className="st25 st26" />
        <text transform="translate(714.49 1154.15)" className="st42 st30 st124">
          {"Fulham Broadway"}
        </text>
        <text
          transform="translate(706.32 1092.688)"
          className="st42 st30 st124"
        >
          {"West Brompton"}
        </text>
        <text
          transform="translate(733.976 1174.826)"
          className="st42 st30 st124"
        >
          {"Parsons Green"}
        </text>
        <text
          transform="translate(733.143 1196.15)"
          className="st42 st30 st124"
        >
          {"Putney Bridge"}
        </text>
        <text
          transform="translate(747.136 1249.031)"
          className="st42 st30 st124"
        >
          {"East Putney"}
        </text>
        <text
          transform="translate(747.042 1276.952)"
          className="st42 st30 st124"
        >
          {"Southfields"}
        </text>
        <text
          transform="translate(721.29 1304.846)"
          className="st42 st30 st124"
        >
          {"Wimbledon Park"}
        </text>
        <text
          transform="translate(746.393 1335.078)"
          className="st42 st30 st124"
        >
          {"Wimbledon"}
        </text>
        <path
          className="st72"
          d="M733.9 1335.1L729.5 1333.2 735.7 1333.2 735.7 1331.9 729.4 1331.9 732.6 1330.3 735.7 1330.3 735.7 1329.1 732.6 1329.1 728.7 1327.2 725.7 1327.2 729.8 1329.1 723.5 1329.1 723.5 1330.3 729.8 1330.3 726.5 1331.9 723.5 1331.9 723.5 1333.2 726.7 1333.2 730.9 1335.1z"
        />
        <path
          className="st72"
          d="M691.8 1092.7L687.5 1090.7 693.6 1090.7 693.6 1089.4 687.3 1089.4 690.5 1087.9 693.6 1087.9 693.6 1086.6 690.5 1086.6 686.6 1084.8 683.6 1084.8 687.8 1086.6 681.4 1086.6 681.4 1087.9 687.8 1087.9 684.5 1089.4 681.4 1089.4 681.4 1090.7 684.7 1090.7 688.9 1092.7z"
        />
        <text transform="translate(728.379 939.505)" className="st25 st26" />
        <text
          transform="translate(728.379 939.505)"
          className="st42 st30 st123"
        >
          {"Kensington"}
        </text>
        <text transform="translate(785.658 939.505)" className="st25 st26" />
        <text
          transform="translate(736.859 950.905)"
          className="st42 st30 st123"
        >
          {"(Olympia)"}
        </text>
        <text transform="translate(785.66 950.905)" className="st25 st26" />
        <path
          className="st72"
          d="M783.1 930L778.8 928.1 784.9 928.1 784.9 926.8 778.6 926.8 781.8 925.2 784.9 925.2 784.9 924 781.8 924 777.9 922.2 774.9 922.2 779 924 772.7 924 772.7 925.2 779 925.2 775.7 926.8 772.7 926.8 772.7 928.1 776 928.1 780.1 930z"
        />
        <text transform="translate(1615.265 784.78)" className="st25 st26" />
        <text
          transform="translate(1615.265 784.78)"
          className="st42 st30 st123"
        >
          {"Aldgate"}
        </text>
        <text transform="translate(1654.129 784.78)" className="st25 st26" />
        <text
          transform="translate(1633.175 796.18)"
          className="st42 st30 st123"
        >
          {"East"}
        </text>
        <text transform="translate(1654.306 796.18)" className="st25 st26" />
        <text
          transform="translate(1704.596 698.973)"
          className="st42 st30 st124"
        >
          {"Bethnal Green"}
        </text>
        <text
          transform="translate(1801.724 745.713)"
          className="st42 st30 st124"
        >
          {"Mile End"}
        </text>
        <text transform="translate(1627.328 529.208)" className="st25 st26" />
        <text
          transform="translate(1627.328 529.208)"
          className="st42 st30 st128"
        >
          {"Dalston"}
        </text>
        <text transform="translate(1668.366 529.208)" className="st25 st26" />
        <text
          transform="translate(1623.228 540.258)"
          className="st42 st30 st128"
        >
          {"Kingsland"}
        </text>
        <text transform="translate(1672.34 540.258)" className="st25 st26" />
        <text transform="translate(1882.614 599.168)" className="st25 st26" />
        <text
          transform="translate(1882.614 599.168)"
          className="st42 st30 st124"
        >
          {"Hackney"}
        </text>
        <text transform="translate(1924.938 599.168)" className="st25 st26" />
        <text
          transform="translate(1891.774 610.567)"
          className="st42 st30 st124"
        >
          {"Wick"}
        </text>
        <text transform="translate(1915.894 610.567)" className="st25 st26" />
        <text
          transform="translate(1810.486 598.856)"
          className="st42 st30 st124"
        >
          {"Homerton"}
        </text>
        <text transform="translate(1766.762 556.15)" className="st25 st26" />
        <text
          transform="translate(1766.762 556.15)"
          className="st42 st30 st124"
        >
          {"Hackney"}
        </text>
        <text transform="translate(1809.085 556.15)" className="st25 st26" />
        <text
          transform="translate(1766.762 567.55)"
          className="st42 st30 st124"
        >
          {"Central"}
        </text>
        <text transform="translate(1802.9 567.55)" className="st25 st26" />
        <text transform="translate(1733.345 496.114)" className="st25 st26" />
        <text
          transform="translate(1733.345 496.114)"
          className="st42 st30 st124"
        >
          {"Rectory"}
        </text>
        <text transform="translate(1772.199 496.114)" className="st25 st26" />
        <text
          transform="translate(1733.345 507.514)"
          className="st42 st30 st124"
        >
          {"Road"}
        </text>
        <text transform="translate(1758.252 507.514)" className="st25 st26" />
        <text transform="translate(1693.917 549.73)" className="st25 st26" />
        <text
          transform="translate(1693.917 549.73)"
          className="st42 st30 st124"
        >
          {"Hackney"}
        </text>
        <text transform="translate(1736.24 549.73)" className="st25 st26" />
        <text
          transform="translate(1702.497 561.13)"
          className="st42 st30 st124"
        >
          {"Downs"}
        </text>
        <text transform="translate(1736.295 561.13)" className="st25 st26" />
        <text
          transform="translate(2011.768 105.217)"
          className="st42 st30 st124"
        >
          {"Theydon Bois"}
        </text>
        <text
          transform="translate(2011.768 79.136)"
          className="st42 st30 st124"
        >
          {"Epping"}
        </text>
        <text
          transform="translate(2011.767 131.292)"
          className="st42 st30 st124"
        >
          {"Debden"}
        </text>
        <text
          transform="translate(2011.768 157.374)"
          className="st42 st30 st124"
        >
          {"Loughton"}
        </text>
        <text
          transform="translate(2011.768 183.453)"
          className="st42 st30 st124"
        >
          {"Buckhurst Hill"}
        </text>
        <text
          transform="translate(2009.993 437.675)"
          className="st42 st30 st124"
        >
          {"Leytonstone"}
        </text>
        <text
          transform="translate(1850.893 311.911)"
          className="st42 st30 st124"
        >
          {"Wood Street"}
        </text>
        <text
          transform="translate(1674.287 296.56)"
          className="st42 st30 st124"
        >
          {"Bruce Grove"}
        </text>
        <text
          transform="translate(1674.287 271.209)"
          className="st42 st30 st124"
        >
          {"White Hart Lane"}
        </text>
        <text
          transform="translate(1674.287 242.359)"
          className="st42 st30 st124"
        >
          {"Silver Street"}
        </text>
        <text
          transform="translate(1674.287 213.674)"
          className="st42 st30 st124"
        >
          {"Edmonton Green"}
        </text>
        <text
          transform="translate(1692.808 178.998)"
          className="st42 st30 st124"
        >
          {"Southbury"}
        </text>
        <text
          transform="translate(1725.965 146.323)"
          className="st42 st30 st124"
        >
          {"Turkey Street"}
        </text>
        <text
          transform="translate(1757.645 115.073)"
          className="st42 st30 st124"
        >
          {"Theobalds Grove"}
        </text>
        <text
          transform="translate(1789.243 80.304)"
          className="st42 st30 st124"
        >
          {"Cheshunt"}
        </text>
        <text
          transform="translate(1586.854 104.525)"
          className="st42 st30 st124"
        >
          {"Enfield Town"}
        </text>
        <text transform="translate(1671.695 431.265)" className="st25 st26" />
        <text
          transform="translate(1671.695 431.265)"
          className="st42 st30 st124"
        >
          {"Stamford"}
        </text>
        <text transform="translate(1718.394 431.265)" className="st25 st26" />
        <text
          transform="translate(1671.695 442.665)"
          className="st42 st30 st124"
        >
          {"Hill"}
        </text>
        <text transform="translate(1687.935 442.665)" className="st25 st26" />
        <text transform="translate(1608.17 134.633)" className="st25 st26" />
        <text
          transform="translate(1608.17 134.633)"
          className="st42 st30 st124"
        >
          {"Bush Hill"}
        </text>
        <text transform="translate(1651.293 134.633)" className="st25 st26" />
        <text
          transform="translate(1629.01 146.033)"
          className="st42 st30 st124"
        >
          {"Park"}
        </text>
        <text transform="translate(1651.295 146.033)" className="st25 st26" />
        <text
          transform="translate(1852.281 248.503)"
          className="st42 st30 st124"
        >
          {"Highams Park"}
        </text>
        <text
          transform="translate(1852.479 181.258)"
          className="st42 st30 st124"
        >
          {"Chingford"}
        </text>
        <text
          transform="translate(2010.295 513.457)"
          className="st42 st30 st124"
        >
          {"Leyton"}
        </text>
        <text
          transform="translate(2011.812 288.606)"
          className="st42 st30 st124"
        >
          {"Woodford"}
        </text>
        <text
          transform="translate(2011.812 317.601)"
          className="st42 st30 st124"
        >
          {"South Woodford"}
        </text>
        <text
          transform="translate(2010.128 347.344)"
          className="st42 st30 st124"
        >
          {"Snaresbrook"}
        </text>
        <text
          transform="translate(2131.458 283.693)"
          className="st42 st30 st124"
        >
          {"Hainault"}
        </text>
        <text
          transform="translate(2130.287 311.582)"
          className="st42 st30 st124"
        >
          {"Fairlop"}
        </text>
        <text
          transform="translate(2130.287 339.435)"
          className="st42 st30 st124"
        >
          {"Barkingside"}
        </text>
        <text transform="translate(2130.287 367.288)" className="st25 st26" />
        <text
          transform="translate(2130.287 367.288)"
          className="st42 st30 st124"
        >
          {"Newbury"}
        </text>
        <text transform="translate(2178.55 367.288)" className="st25 st26" />
        <text
          transform="translate(2130.287 378.688)"
          className="st42 st30 st124"
        >
          {"Park"}
        </text>
        <text transform="translate(2152.572 378.688)" className="st25 st26" />
        <text
          transform="translate(2027.15 584.658)"
          className="st42 st30 st124"
        >
          {"Stratford"}
        </text>
        <text transform="translate(2017.565 222.053)" className="st25 st26" />
        <text
          transform="translate(2017.565 222.053)"
          className="st42 st30 st124"
        >
          {"Roding"}
        </text>
        <text transform="translate(2052.468 222.053)" className="st25 st26" />
        <text
          transform="translate(2020.134 233.453)"
          className="st42 st30 st124"
        >
          {"Valley"}
        </text>
        <text transform="translate(2049.663 233.453)" className="st25 st26" />
        <text transform="translate(2086.469 224.29)" className="st25 st26" />
        <text
          transform="translate(2086.469 224.29)"
          className="st42 st30 st124"
        >
          {"Grange"}
        </text>
        <text transform="translate(2122.548 224.29)" className="st25 st26" />
        <text transform="translate(2096.57 235.69)" className="st42 st30 st124">
          {"Hill"}
        </text>
        <text transform="translate(2112.81 235.69)" className="st25 st26" />
        <text
          transform="translate(2053.277 262.93)"
          className="st42 st30 st124"
        >
          {"Chigwell"}
        </text>
        <text
          transform="translate(2044.195 385.069)"
          className="st42 st30 st124"
        >
          {"Redbridge"}
        </text>
        <text transform="translate(2090.296 411.898)" className="st25 st26" />
        <text
          transform="translate(2090.296 411.898)"
          className="st42 st30 st124"
        >
          {"Gants"}
        </text>
        <text transform="translate(2119.013 411.898)" className="st25 st26" />
        <text
          transform="translate(2096.566 423.298)"
          className="st42 st30 st124"
        >
          {"Hill"}
        </text>
        <text transform="translate(2112.806 423.298)" className="st25 st26" />
        <text transform="translate(2010.4 411.898)" className="st42 st30 st124">
          {"Wanstead"}
        </text>
        <path
          className="st72"
          d="M2089.3 584.6L2085 582.7 2091.1 582.7 2091.1 581.4 2084.8 581.4 2088 579.8 2091.1 579.8 2091.1 578.6 2088 578.6 2084.1 576.8 2081.1 576.8 2085.2 578.6 2078.9 578.6 2078.9 579.8 2085.2 579.8 2081.9 581.4 2078.9 581.4 2078.9 582.7 2082.1 582.7 2086.4 584.6z"
        />
        <text
          transform="translate(1580.677 613.44)"
          className="st42 st30 st126"
        >
          {"Dalston Junction"}
        </text>
        <text
          transform="translate(1577.15 586.816)"
          className="st42 st30 st124"
        >
          {"Canonbury"}
        </text>
        <text transform="translate(1738.812 751.405)" className="st25 st26" />
        <text
          transform="translate(1738.812 751.405)"
          className="st42 st30 st124"
        >
          {"Stepney"}
        </text>
        <text transform="translate(1779.43 751.405)" className="st25 st26" />
        <text
          transform="translate(1738.812 762.805)"
          className="st42 st30 st124"
        >
          {"Green"}
        </text>
        <text transform="translate(1768.647 762.805)" className="st25 st26" />
        <text transform="translate(1625.832 363.785)" className="st25 st26" />
        <text
          transform="translate(1625.832 363.785)"
          className="st42 st30 st124"
        >
          {"Seven"}
        </text>
        <text transform="translate(1655.631 363.785)" className="st25 st26" />
        <text
          transform="translate(1622.232 375.185)"
          className="st42 st30 st124"
        >
          {"Sisters"}
        </text>
        <text transform="translate(1655.865 375.185)" className="st25 st26" />
        <text transform="translate(1542.565 524.733)" className="st25 st26" />
        <text
          transform="translate(1542.565 524.733)"
          className="st42 st30 st124"
        >
          {"Highbury &"}
        </text>
        <text transform="translate(1599.834 524.733)" className="st25 st26" />
        <text
          transform="translate(1542.565 536.133)"
          className="st42 st30 st124"
        >
          {"Islington"}
        </text>
        <text transform="translate(1586.416 536.133)" className="st25 st26" />
        <text transform="translate(1680.894 403.06)" className="st25 st26" />
        <text
          transform="translate(1680.894 403.06)"
          className="st42 st30 st124"
        >
          {"Tottenham"}
        </text>
        <text transform="translate(1735.553 403.06)" className="st25 st26" />
        <text
          transform="translate(1697.544 414.46)"
          className="st42 st30 st124"
        >
          {"Hale"}
        </text>
        <text transform="translate(1719.875 414.46)" className="st25 st26" />
        <text
          transform="translate(1791.302 509.28)"
          className="st42 st30 st124"
        >
          {"Clapton"}
        </text>
        <text
          transform="translate(1814.553 486.03)"
          className="st42 st30 st124"
        >
          {"St James Street"}
        </text>
        <text transform="translate(1698.376 460.769)" className="st25 st26" />
        <text
          transform="translate(1698.376 460.769)"
          className="st42 st30 st124"
        >
          {"Stoke"}
        </text>
        <text transform="translate(1726.612 460.769)" className="st25 st26" />
        <text
          transform="translate(1698.376 472.168)"
          className="st42 st30 st124"
        >
          {"Newington"}
        </text>
        <text transform="translate(1753.859 472.168)" className="st25 st26" />
        <path
          className="st72"
          d="M1606.1 536.1L1601.8 534.2 1607.9 534.2 1607.9 532.9 1601.6 532.9 1604.8 531.3 1607.9 531.3 1607.9 530.1 1604.8 530.1 1600.9 528.2 1597.9 528.2 1602 530.1 1595.7 530.1 1595.7 531.3 1602 531.3 1598.7 532.9 1595.7 532.9 1595.7 534.2 1598.9 534.2 1603.2 536.1z"
        />
        <path
          className="st72"
          d="M1734.2 541.2L1729.9 539.2 1736 539.2 1736 538 1729.7 538 1732.9 536.4 1736 536.4 1736 535.2 1732.9 535.2 1729 533.3 1726 533.3 1730.2 535.2 1723.8 535.2 1723.8 536.4 1730.2 536.4 1726.8 538 1723.8 538 1723.8 539.2 1727.1 539.2 1731.3 541.2z"
        />
        <path
          className="st72"
          d="M1734.1 414.5L1729.7 412.5 1735.9 412.5 1735.9 411.2 1729.6 411.2 1732.8 409.7 1735.9 409.7 1735.9 408.4 1732.8 408.4 1728.8 406.6 1725.9 406.6 1730 408.4 1723.7 408.4 1723.7 409.7 1730 409.7 1726.7 411.2 1723.7 411.2 1723.7 412.5 1726.9 412.5 1731.1 414.5z"
        />
        <path
          className="st72"
          d="M1620.1 363.8L1615.7 361.8 1621.8 361.8 1621.8 360.5 1615.5 360.5 1618.7 359 1621.8 359 1621.8 357.7 1618.7 357.7 1614.8 355.9 1611.8 355.9 1616 357.7 1609.6 357.7 1609.6 359 1616 359 1612.7 360.5 1609.6 360.5 1609.6 361.8 1612.9 361.8 1617.1 363.8z"
        />
        <path
          className="st72"
          d="M1781.9 213.6L1777.5 211.6 1783.7 211.6 1783.7 210.3 1777.3 210.3 1780.6 208.8 1783.7 208.8 1783.7 207.5 1780.6 207.5 1776.6 205.7 1773.7 205.7 1777.8 207.5 1771.4 207.5 1771.4 208.8 1777.8 208.8 1774.5 210.3 1771.4 210.3 1771.4 211.6 1774.7 211.6 1778.9 213.6z"
        />
        <path
          className="st72"
          d="M1855.1 80.2L1850.8 78.3 1856.9 78.3 1856.9 77 1850.6 77 1853.8 75.4 1856.9 75.4 1856.9 74.2 1853.8 74.2 1849.9 72.4 1846.9 72.4 1851 74.2 1844.7 74.2 1844.7 75.4 1851 75.4 1847.7 77 1844.7 77 1844.7 78.3 1847.9 78.3 1852.1 80.2z"
        />
        <text transform="translate(2270.96 525.604)" className="st25 st26" />
        <text
          transform="translate(2270.96 525.604)"
          className="st42 st30 st129"
        >
          {"Dagenham"}
        </text>
        <text transform="translate(2327.777 525.604)" className="st25 st26" />
        <text
          transform="translate(2270.96 536.994)"
          className="st42 st30 st129"
        >
          {"East"}
        </text>
        <text transform="translate(2292.072 536.994)" className="st25 st26" />
        <text
          transform="translate(2252.198 556.15)"
          className="st42 st30 st129"
        >
          {"Dagenham Heathway"}
        </text>
        <text
          transform="translate(2224.167 572.681)"
          className="st42 st30 st129"
        >
          {"Becontree"}
        </text>
        <text
          transform="translate(2191.404 610.046)"
          className="st42 st30 st129"
        >
          {"Upney"}
        </text>
        <text
          transform="translate(2379.575 420.653)"
          className="st42 st30 st129"
        >
          {"Upminster"}
        </text>
        <text
          transform="translate(2350.988 447.505)"
          className="st42 st30 st129"
        >
          {"Upminster Bridge"}
        </text>
        <text
          transform="translate(2325.947 472.533)"
          className="st42 st30 st129"
        >
          {"Hornchurch"}
        </text>
        <path
          className="st72"
          d="M2454 420.6L2449.6 418.7 2455.8 418.7 2455.8 417.4 2449.4 417.4 2452.7 415.8 2455.8 415.8 2455.8 414.6 2452.7 414.6 2448.7 412.8 2445.8 412.8 2449.9 414.6 2443.6 414.6 2443.6 415.8 2449.9 415.8 2446.6 417.4 2443.6 417.4 2443.6 418.7 2446.8 418.7 2451 420.6z"
        />
        <path
          className="st72"
          d="M2378.1 130L2373.8 128 2379.9 128 2379.9 126.7 2373.6 126.7 2376.8 125.2 2379.9 125.2 2379.9 123.9 2376.8 123.9 2372.9 122.1 2369.9 122.1 2374.1 123.9 2367.7 123.9 2367.7 125.2 2374.1 125.2 2370.7 126.7 2367.7 126.7 2367.7 128 2371 128 2375.2 130z"
        />
        <path
          className="st72"
          d="M2342.2 308.9L2337.8 307 2344 307 2344 305.7 2337.6 305.7 2340.9 304.1 2344 304.1 2344 302.9 2340.9 302.9 2336.9 301 2334 301 2338.1 302.9 2331.8 302.9 2331.8 304.1 2338.1 304.1 2334.8 305.7 2331.8 305.7 2331.8 307 2335 307 2339.2 308.9z"
        />
        <text
          transform="translate(2305.088 497.57)"
          className="st42 st30 st129"
        >
          {"Elm Park"}
        </text>
        <text
          transform="translate(2146.312 445.615)"
          className="st42 st30 st129"
        >
          {"Ilford"}
        </text>
        <text
          transform="translate(2192.193 400.772)"
          className="st42 st30 st129"
        >
          {"Goodmayes"}
        </text>
        <text transform="translate(2233.698 358.906)" className="st25 st26" />
        <text
          transform="translate(2233.698 358.906)"
          className="st42 st30 st129"
        >
          {"Chadwell"}
        </text>
        <text transform="translate(2281.879 358.906)" className="st25 st26" />
        <text
          transform="translate(2233.698 370.296)"
          className="st42 st30 st129"
        >
          {"Heath"}
        </text>
        <text transform="translate(2263.997 370.296)" className="st25 st26" />
        <text transform="translate(2279.08 308.95)" className="st42 st30 st129">
          {"Romford"}
        </text>
        <text
          transform="translate(2306.069 287.876)"
          className="st42 st30 st129"
        >
          {"Gidea Park"}
        </text>
        <text
          transform="translate(2329.22 266.102)"
          className="st42 st30 st129"
        >
          {"Harold Wood"}
        </text>
        <text
          transform="translate(2389.237 129.942)"
          className="st42 st30 st129"
        >
          {"Shenfield"}
        </text>
        <text
          transform="translate(2392.305 201.64)"
          className="st42 st30 st129"
        >
          {"Brentwood"}
        </text>
        <text
          transform="translate(2171.667 422.626)"
          className="st42 st30 st129"
        >
          {"Seven Kings"}
        </text>
        <text transform="translate(1590.219 306.404)" className="st25 st26" />
        <text
          transform="translate(1590.219 306.404)"
          className="st42 st30 st124"
        >
          {"Harringay"}
        </text>
        <text transform="translate(1639.445 306.404)" className="st25 st26" />
        <text
          transform="translate(1599.979 317.804)"
          className="st42 st30 st124"
        >
          {"Green"}
        </text>
        <text transform="translate(1629.813 317.804)" className="st25 st26" />
        <text
          transform="translate(1600.789 329.204)"
          className="st42 st30 st124"
        >
          {"Lanes"}
        </text>
        <text transform="translate(1629.294 329.204)" className="st25 st26" />
        <text transform="translate(1914.984 482.992)" className="st25 st26" />
        <text
          transform="translate(1914.984 482.992)"
          className="st42 st30 st124"
        >
          {"Leytonstone"}
        </text>
        <text transform="translate(1977.286 482.992)" className="st25 st26" />
        <text
          transform="translate(1920.474 494.392)"
          className="st42 st30 st124"
        >
          {"High Road"}
        </text>
        <text transform="translate(1971.57 494.392)" className="st25 st26" />
        <text transform="translate(1877.362 443.83)" className="st25 st26" />
        <text
          transform="translate(1877.362 443.83)"
          className="st42 st30 st124"
        >
          {"Leyton"}
        </text>
        <text transform="translate(1911.63 443.83)" className="st25 st26" />
        <text
          transform="translate(1860.352 455.23)"
          className="st42 st30 st124"
        >
          {"Midland Road"}
        </text>
        <text transform="translate(1928.406 455.23)" className="st25 st26" />
        <text
          transform="translate(2323.066 347.513)"
          className="st42 st30 st124"
        >
          {"Emerson Park"}
        </text>
        <text transform="translate(1689.876 317.793)" className="st25 st26" />
        <text
          transform="translate(1689.876 317.793)"
          className="st42 st30 st124"
        >
          {"South"}
        </text>
        <text transform="translate(1719.581 317.793)" className="st25 st26" />
        <text
          transform="translate(1676.976 329.193)"
          className="st42 st30 st124"
        >
          {"Tottenham"}
        </text>
        <text transform="translate(1731.636 329.193)" className="st25 st26" />
        <text
          transform="translate(2155.129 640.865)"
          className="st42 st30 st124"
        >
          {"Barking"}
        </text>
        <text
          transform="translate(2131.18 670.071)"
          className="st42 st30 st124"
        >
          {"East Ham"}
        </text>
        <text
          transform="translate(2071.605 726.965)"
          className="st42 st30 st124"
        >
          {"Plaistow"}
        </text>
        <text transform="translate(2104.235 694.573)" className="st25 st26" />
        <text
          transform="translate(2104.235 694.573)"
          className="st42 st30 st124"
        >
          {"Upton"}
        </text>
        <text transform="translate(2138.02 694.573)" className="st25 st26" />
        <text
          transform="translate(2104.235 705.973)"
          className="st42 st30 st124"
        >
          {"Park"}
        </text>
        <text transform="translate(2126.52 705.973)" className="st25 st26" />
        <text
          transform="translate(1369.664 428.399)"
          className="st42 st30 st124"
        >
          {"Upper Holloway"}
        </text>
        <text transform="translate(1428.445 347.684)" className="st25 st26" />
        <text
          transform="translate(1428.445 347.684)"
          className="st42 st30 st124"
        >
          {"Crouch"}
        </text>
        <text transform="translate(1463.783 347.684)" className="st25 st26" />
        <text
          transform="translate(1447.834 359.084)"
          className="st42 st30 st124"
        >
          {"Hill"}
        </text>
        <text transform="translate(1464.074 359.084)" className="st25 st26" />
        <text transform="translate(1219.576 448.637)" className="st25 st26" />
        <text
          transform="translate(1219.576 448.637)"
          className="st42 st30 st124"
        >
          {"Gospel"}
        </text>
        <text transform="translate(1253.361 448.637)" className="st25 st26" />
        <text
          transform="translate(1226.626 460.037)"
          className="st42 st30 st124"
        >
          {"Oak"}
        </text>
        <text transform="translate(1246.076 460.037)" className="st25 st26" />
        <path
          className="st72"
          d="M2179.5 651.8L2175.2 649.8 2181.3 649.8 2181.3 648.5 2175 648.5 2178.2 647 2181.3 647 2181.3 645.7 2178.2 645.7 2174.3 643.9 2171.3 643.9 2175.5 645.7 2169.1 645.7 2169.1 647 2175.5 647 2172.1 648.5 2169.1 648.5 2169.1 649.8 2172.4 649.8 2176.6 651.8z"
        />
        <text transform="translate(1875.823 763.502)" className="st25 st26" />
        <text
          transform="translate(1875.823 763.502)"
          className="st42 st30 st124"
        >
          {"Bow"}
        </text>
        <text transform="translate(1897.18 763.502)" className="st25 st26" />
        <text
          transform="translate(1875.823 774.902)"
          className="st42 st30 st124"
        >
          {"Church"}
        </text>
        <text transform="translate(1911.279 774.902)" className="st25 st26" />
        <text transform="translate(2023.691 746.553)" className="st25 st26" />
        <text
          transform="translate(2023.691 746.553)"
          className="st42 st30 st124"
        >
          {"West"}
        </text>
        <text transform="translate(2048.622 746.553)" className="st25 st26" />
        <text
          transform="translate(2023.691 757.953)"
          className="st42 st30 st124"
        >
          {"Ham"}
        </text>
        <text transform="translate(2046.905 757.953)" className="st25 st26" />
        <text transform="translate(1898.996 706.903)" className="st25 st26" />
        <text
          transform="translate(1898.996 706.903)"
          className="st42 st30 st124"
        >
          {"Bow"}
        </text>
        <text transform="translate(1920.352 706.903)" className="st25 st26" />
        <text
          transform="translate(1898.996 718.303)"
          className="st42 st30 st124"
        >
          {"Road"}
        </text>
        <text transform="translate(1923.903 718.303)" className="st25 st26" />
        <text transform="translate(1938.98 745.075)" className="st25 st26" />
        <text
          transform="translate(1938.98 745.075)"
          className="st42 st30 st124"
        >
          {"Bromley-"}
        </text>
        <text transform="translate(1983.432 745.075)" className="st25 st26" />
        <text transform="translate(1943 756.475)" className="st42 st30 st124">
          {"by-Bow"}
        </text>
        <text transform="translate(1979.703 756.475)" className="st25 st26" />
        <path
          className="st72"
          d="M2062 757.9L2057.6 755.9 2063.8 755.9 2063.8 754.7 2057.4 754.7 2060.7 753.1 2063.8 753.1 2063.8 751.8 2060.7 751.8 2056.7 750 2053.8 750 2057.9 751.8 2051.6 751.8 2051.6 753.1 2057.9 753.1 2054.6 754.7 2051.6 754.7 2051.6 755.9 2054.8 755.9 2059 757.9z"
        />
        <text
          transform="translate(1780.098 1162.19)"
          className="st42 st30 st124"
        >
          {"Island Gardens"}
        </text>
        <text
          transform="translate(1878.635 1283.646)"
          className="st42 st30 st124"
        >
          {"Deptford Bridge"}
        </text>
        <text
          transform="translate(1795.044 1072.93)"
          className="st42 st30 st124"
        >
          {"South Quay"}
        </text>
        <text
          transform="translate(1785.684 1102.683)"
          className="st42 st30 st124"
        >
          {"Crossharbour"}
        </text>
        <text
          transform="translate(1802.464 1132.437)"
          className="st42 st30 st124"
        >
          {"Mudchute"}
        </text>
        <text
          transform="translate(1789.057 1043.178)"
          className="st42 st30 st124"
        >
          {"Heron Quays"}
        </text>
        <text transform="translate(1830.968 929.245)" className="st25 st26" />
        <text
          transform="translate(1830.968 929.245)"
          className="st42 st30 st124"
        >
          {"West"}
        </text>
        <text transform="translate(1855.899 929.245)" className="st25 st26" />
        <text
          transform="translate(1831.628 940.645)"
          className="st42 st30 st124"
        >
          {"India"}
        </text>
        <text transform="translate(1856.37 940.645)" className="st25 st26" />
        <text
          transform="translate(1830.308 952.045)"
          className="st42 st30 st124"
        >
          {"Quay"}
        </text>
        <text transform="translate(1856.18 952.045)" className="st25 st26" />
        <text
          transform="translate(1878.642 1308.24)"
          className="st42 st30 st124"
        >
          {"Elverson Road"}
        </text>
        <text
          transform="translate(1790.902 802.51)"
          className="st42 st30 st124"
        >
          {"Devons Road"}
        </text>
        <text
          transform="translate(1787.281 831.967)"
          className="st42 st30 st124"
        >
          {"Langdon Park"}
        </text>
        <text
          transform="translate(1809.636 861.438)"
          className="st42 st30 st124"
        >
          {"All Saints"}
        </text>
        <text
          transform="translate(1783.939 1000.542)"
          className="st42 st30 st124"
        >
          {"Canary Wharf"}
        </text>
        <text transform="translate(1878.583 1209.633)" className="st25 st26" />
        <text
          transform="translate(1878.583 1209.633)"
          className="st42 st30 st124"
        >
          {"Cutty Sark for"}
        </text>
        <text transform="translate(1950.67 1209.633)" className="st25 st26" />
        <text
          transform="translate(1878.583 1221.033)"
          className="st42 st30 st124"
        >
          {"Maritime Greenwich"}
        </text>
        <text transform="translate(1980.376 1221.033)" className="st25 st26" />
        <text
          transform="translate(1878.635 1332.347)"
          className="st42 st30 st124"
        >
          {"Lewisham"}
        </text>
        <path
          className="st72"
          d="M1946.4 1332.4L1942 1330.4 1948.2 1330.4 1948.2 1329.1 1941.9 1329.1 1945.1 1327.6 1948.2 1327.6 1948.2 1326.3 1945.1 1326.3 1941.2 1324.5 1938.2 1324.5 1942.3 1326.3 1936 1326.3 1936 1327.6 1942.3 1327.6 1939 1329.1 1936 1329.1 1936 1330.4 1939.2 1330.4 1943.4 1332.4z"
        />
        <text transform="translate(2120.95 1019.27)" className="st25 st26" />
        <text
          transform="translate(2120.95 1019.27)"
          className="st42 st30 st128"
        >
          {"West"}
        </text>
        <text transform="translate(2145.9 1019.27)" className="st25 st26" />
        <text
          transform="translate(2092.62 1030.32)"
          className="st42 st30 st128"
        >
          {"Silvertown"}
        </text>
        <text transform="translate(2146.486 1030.32)" className="st25 st26" />
        <text transform="translate(2126.211 1048.864)" className="st25 st26" />
        <text
          transform="translate(2126.211 1048.864)"
          className="st42 st30 st128"
        >
          {"Pontoon"}
        </text>
        <text transform="translate(2168.85 1048.864)" className="st25 st26" />
        <text
          transform="translate(2143.891 1059.914)"
          className="st42 st30 st128"
        >
          {"Dock"}
        </text>
        <text transform="translate(2168.912 1059.914)" className="st25 st26" />
        <text transform="translate(2146.1 1119.486)" className="st25 st26" />
        <text
          transform="translate(2146.1 1119.486)"
          className="st42 st30 st128"
        >
          {"King"}
        </text>
        <text transform="translate(2168.732 1119.486)" className="st25 st26" />
        <text
          transform="translate(2122.72 1130.536)"
          className="st42 st30 st128"
        >
          {"George V"}
        </text>
        <text transform="translate(2168.678 1130.536)" className="st25 st26" />
        <text transform="translate(2217.9 920.501)" className="st25 st26" />
        <text transform="translate(2217.9 920.501)" className="st42 st30 st124">
          {"Custom House"}
        </text>
        <text transform="translate(2290.292 920.501)" className="st25 st26" />
        <text transform="translate(2217.9 931.901)" className="st42 st30 st124">
          {"for ExCeL"}
        </text>
        <text transform="translate(2264.174 931.901)" className="st25 st26" />
        <text
          transform="translate(2249.704 966.802)"
          className="st42 st30 st124"
        >
          {"Prince Regent"}
        </text>
        <text
          transform="translate(2249.704 998.509)"
          className="st42 st30 st124"
        >
          {"Royal Albert"}
        </text>
        <text
          transform="translate(2249.704 1030.215)"
          className="st42 st30 st124"
        >
          {"Beckton Park"}
        </text>
        <text
          transform="translate(2249.704 1061.922)"
          className="st42 st30 st124"
        >
          {"Cyprus"}
        </text>
        <text
          transform="translate(2249.704 1125.335)"
          className="st42 st30 st124"
        >
          {"Beckton"}
        </text>
        <text
          transform="translate(2249.704 1093.628)"
          className="st42 st30 st124"
        >
          {"Gallions Reach"}
        </text>
        <text transform="translate(1756.31 919.8)" className="st42 st30 st124">
          {"Westferry"}
        </text>
        <text
          transform="translate(1880.68 919.987)"
          className="st42 st30 st124"
        >
          {"Blackwall"}
        </text>
        <text transform="translate(2099.627 876.356)" className="st25 st26" />
        <text
          transform="translate(2099.627 876.356)"
          className="st42 st30 st124"
        >
          {"Royal"}
        </text>
        <text transform="translate(2126.486 876.356)" className="st25 st26" />
        <text
          transform="translate(2093.597 887.756)"
          className="st42 st30 st124"
        >
          {"Victoria"}
        </text>
        <text transform="translate(2132.863 887.756)" className="st25 st26" />
        <text transform="translate(2023.443 858.527)" className="st25 st26" />
        <text
          transform="translate(2023.443 858.527)"
          className="st42 st30 st124"
        >
          {"Canning"}
        </text>
        <text transform="translate(2064.378 858.527)" className="st25 st26" />
        <text
          transform="translate(2023.443 869.927)"
          className="st42 st30 st124"
        >
          {"Town"}
        </text>
        <text transform="translate(2049.938 869.927)" className="st25 st26" />
        <text
          transform="translate(1829.242 891.22)"
          className="st42 st30 st124"
        >
          {"Poplar"}
        </text>
        <text transform="translate(1716.568 887.8)" className="st42 st30 st124">
          {"Limehouse"}
        </text>
        <text transform="translate(1943.623 920.022)" className="st25 st26" />
        <text
          transform="translate(1943.623 920.022)"
          className="st42 st30 st124"
        >
          {"East"}
        </text>
        <text transform="translate(1964.755 920.022)" className="st25 st26" />
        <text
          transform="translate(1941.793 931.422)"
          className="st42 st30 st124"
        >
          {"India"}
        </text>
        <text transform="translate(1966.535 931.422)" className="st25 st26" />
        <text transform="translate(2131.45 1082.908)" className="st25 st26" />
        <text
          transform="translate(2131.45 1082.908)"
          className="st42 st30 st128"
        >
          {"London"}
        </text>
        <text transform="translate(2168.91 1082.908)" className="st25 st26" />
        <text
          transform="translate(2110.48 1093.958)"
          className="st42 st30 st128"
        >
          {"City Airport"}
        </text>
        <text transform="translate(2169.382 1093.958)" className="st25 st26" />
        <path
          className="st42"
          d="M2117.7 1071.1c.4 0 .6.7.6 1.2v3l4.1 3.1c.1.1.7.5.8.6.1.2.1.4.1.6v.3l-4.1-1.6c-.2-.1-.4-.1-.6-.1-.5 0-.4.6-.4.9v1.6l1.4 1 .1.8-1.9-.5h-.3l-1.9.5.1-.8 1.3-1v-1.6c0-.3.1-.9-.4-.9-.2 0-.4.1-.6.1l-4.1 1.6v-.3c0-.2 0-.5.1-.6.1-.1.6-.5.7-.6l4.1-3.1.1-3c.3-.5.4-1.2.8-1.2z"
        />
        <path
          className="st72"
          d="M1748.1 875.3L1743.7 873.4 1749.9 873.4 1749.9 872.1 1743.5 872.1 1746.8 870.5 1749.9 870.5 1749.9 869.3 1746.8 869.3 1742.8 867.5 1739.9 867.5 1744 869.3 1737.7 869.3 1737.7 870.5 1744 870.5 1740.7 872.1 1737.7 872.1 1737.7 873.4 1740.9 873.4 1745.1 875.3z"
        />
        <text transform="translate(1901.232 538.138)" className="st25 st26" />
        <text
          transform="translate(1901.232 538.138)"
          className="st42 st30 st124"
        >
          {"Stratford"}
        </text>
        <text transform="translate(1946.86 538.138)" className="st25 st26" />
        <text
          transform="translate(1891.772 549.538)"
          className="st42 st30 st124"
        >
          {"International"}
        </text>
        <text transform="translate(1957.026 549.538)" className="st25 st26" />
        <path
          className="st72"
          d="M1895.8 538.1L1891.5 536.2 1897.6 536.2 1897.6 534.9 1891.3 534.9 1894.5 533.3 1897.6 533.3 1897.6 532.1 1894.5 532.1 1890.6 530.3 1887.6 530.3 1891.8 532.1 1885.4 532.1 1885.4 533.3 1891.8 533.3 1888.4 534.9 1885.4 534.9 1885.4 536.2 1888.7 536.2 1892.9 538.1z"
        />
        <text
          transform="translate(2027.606 809.987)"
          className="st42 st30 st124"
        >
          {"Star Lane"}
        </text>
        <text transform="translate(1946.765 1029.75)" className="st25 st26" />
        <text
          transform="translate(1946.765 1029.75)"
          className="st42 st30 st124"
        >
          {"North"}
        </text>
        <text transform="translate(1976.694 1029.75)" className="st25 st26" />
        <text
          transform="translate(1922.906 1041.15)"
          className="st42 st30 st124"
        >
          {"Greenwich"}
        </text>
        <text transform="translate(1976.048 1041.15)" className="st25 st26" />
        <text
          transform="translate(2045.714 550.106)"
          className="st42 st30 st123"
        >
          {"Maryland"}
        </text>
        <text
          transform="translate(2126.183 468.485)"
          className="st42 st30 st123"
        >
          {"Manor Park"}
        </text>
        <text
          transform="translate(1523.549 171.404)"
          className="st42 st30 st129"
        >
          {"Oakwood"}
        </text>
        <text
          transform="translate(1511.989 140.622)"
          className="st42 st30 st129"
        >
          {"Cockfosters"}
        </text>
        <text
          transform="translate(1521.34 202.196)"
          className="st42 st30 st129"
        >
          {"Southgate"}
        </text>
        <text
          transform="translate(1512.048 233.006)"
          className="st42 st30 st129"
        >
          {"Arnos Grove"}
        </text>
        <text
          transform="translate(1503.93 263.795)"
          className="st42 st30 st129"
        >
          {"Bounds Green"}
        </text>
        <text
          transform="translate(1503.154 325.36)"
          className="st42 st30 st129"
        >
          {"Turnpike Lane"}
        </text>
        <text
          transform="translate(1511.554 294.58)"
          className="st42 st30 st129"
        >
          {"Wood Green"}
        </text>
        <text transform="translate(1539.066 370.09)" className="st25 st26" />
        <text
          transform="translate(1539.066 370.09)"
          className="st42 st30 st124"
        >
          {"Manor"}
        </text>
        <text transform="translate(1574.415 370.09)" className="st25 st26" />
        <text
          transform="translate(1540.466 381.49)"
          className="st42 st30 st124"
        >
          {"House"}
        </text>
        <text transform="translate(1571.7 381.49)" className="st25 st26" />
        <text transform="translate(1470.6 465.913)" className="st42 st30 st124">
          {"Arsenal"}
        </text>
        <text transform="translate(1265.75 477.16)" className="st25 st26" />
        <text transform="translate(1265.75 477.16)" className="st42 st30 st124">
          {"Kentish"}
        </text>
        <text transform="translate(1303.71 477.16)" className="st25 st26" />
        <text transform="translate(1265.75 488.56)" className="st42 st30 st124">
          {"Town"}
        </text>
        <text transform="translate(1292.246 488.56)" className="st25 st26" />
        <text transform="translate(1265.75 499.96)" className="st42 st30 st124">
          {"West"}
        </text>
        <text transform="translate(1290.681 499.96)" className="st25 st26" />
        <text transform="translate(1435.54 481.67)" className="st25 st26" />
        <text transform="translate(1435.54 481.67)" className="st42 st30 st124">
          {"Holloway"}
        </text>
        <text transform="translate(1484.096 481.67)" className="st25 st26" />
        <text transform="translate(1456.54 493.07)" className="st42 st30 st124">
          {"Road"}
        </text>
        <text transform="translate(1481.447 493.07)" className="st25 st26" />
        <text
          transform="matrix(.98 0 0 1 1410.657 504.501)"
          className="st25 st26"
        />
        <text
          transform="matrix(.98 0 0 1 1410.657 504.501)"
          className="st42 st30 st124"
        >
          {"Caledonian"}
        </text>
        <text
          transform="matrix(.98 0 0 1 1465.352 504.501)"
          className="st25 st26"
        />
        <text
          transform="matrix(.98 0 0 1 1440.655 515.9)"
          className="st42 st30 st124"
        >
          {"Road"}
        </text>
        <text
          transform="matrix(.98 0 0 1 1465.064 515.9)"
          className="st25 st26"
        />
        <text
          transform="translate(1242.452 252.84)"
          className="st42 st30 st128"
        >
          {"Mill Hill East"}
        </text>
        <text
          transform="translate(905.936 254.737)"
          className="st42 st30 st128"
        >
          {"Edgware"}
        </text>
        <text transform="translate(949.279 281.875)" className="st25 st26" />
        <text
          transform="translate(949.279 281.875)"
          className="st42 st30 st128"
        >
          {"Burnt"}
        </text>
        <text transform="translate(979.901 281.875)" className="st25 st26" />
        <text
          transform="translate(957.659 292.925)"
          className="st42 st30 st128"
        >
          {"Oak"}
        </text>
        <text transform="translate(977.125 292.925)" className="st25 st26" />
        <text
          transform="translate(957.292 308.151)"
          className="st42 st30 st128"
        >
          {"Colindale"}
        </text>
        <text
          transform="translate(1069.772 327.312)"
          className="st42 st30 st128"
        >
          {"Hendon Central"}
        </text>
        <text
          transform="translate(965.611 353.348)"
          className="st42 st30 st128"
        >
          {"Hendon"}
        </text>
        <text transform="translate(943.11 397.304)" className="st42 st30 st128">
          {"Cricklewood"}
        </text>
        <text
          transform="translate(1082.14 354.303)"
          className="st42 st30 st128"
        >
          {"Brent Cross"}
        </text>
        <text transform="translate(1110.4 379.69)" className="st42 st30 st128">
          {"Golders Green"}
        </text>
        <text
          transform="translate(1148.955 413.24)"
          className="st42 st30 st128"
        >
          {"Hampstead"}
        </text>
        <text
          transform="translate(1157.823 520.058)"
          className="st42 st30 st121"
        >
          {"Belsize Park"}
        </text>
        <text
          transform="translate(1186.672 544.843)"
          className="st42 st30 st128"
        >
          {"Chalk Farm"}
        </text>
        <text
          transform="translate(1176.089 570.368)"
          className="st42 st30 st124"
        >
          {"Camden Town"}
        </text>
        <text
          transform="translate(1265.825 147.051)"
          className="st42 st30 st124"
        >
          {"High Barnet"}
        </text>
        <text
          transform="translate(1205.97 175.432)"
          className="st42 st30 st124"
        >
          {"Totteridge & Whetstone"}
        </text>
        <text
          transform="translate(1250.879 198.36)"
          className="st42 st30 st124"
        >
          {"Woodside Park"}
        </text>
        <text transform="translate(1256.1 218.228)" className="st42 st30 st124">
          {"West Finchley"}
        </text>
        <text transform="translate(1245 289.607)" className="st42 st30 st124">
          {"Finchley Central"}
        </text>
        <text
          transform="translate(1348.025 319.92)"
          className="st42 st30 st124"
        >
          {"East Finchley"}
        </text>
        <text
          transform="translate(1348.025 350.231)"
          className="st42 st30 st124"
        >
          {"Highgate"}
        </text>
        <text
          transform="translate(1348.032 380.544)"
          className="st42 st30 st124"
        >
          {"Archway"}
        </text>
        <text
          transform="translate(1348.025 455.141)"
          className="st42 st30 st124"
        >
          {"Tufnell Park"}
        </text>
        <text transform="translate(1178.475 601.33)" className="st25 st26" />
        <text
          transform="translate(1178.475 601.33)"
          className="st42 st30 st123"
        >
          {"Mornington"}
        </text>
        <text transform="translate(1238.377 601.33)" className="st25 st26" />
        <text
          transform="translate(1194.435 612.73)"
          className="st42 st30 st123"
        >
          {"Crescent"}
        </text>
        <text transform="translate(1237.721 612.73)" className="st25 st26" />
        <text transform="translate(1298.53 516.643)" className="st25 st26" />
        <text
          transform="translate(1298.53 516.643)"
          className="st42 st30 st128"
        >
          {"Camden"}
        </text>
        <text transform="translate(1342.146 516.643)" className="st25 st26" />
        <text
          transform="translate(1298.53 527.693)"
          className="st42 st30 st128"
        >
          {"Road"}
        </text>
        <text transform="translate(1323.457 527.693)" className="st25 st26" />
        <text transform="translate(1456.344 570.231)" className="st25 st26" />
        <text
          transform="translate(1456.344 570.231)"
          className="st42 st30 st124"
        >
          {"Caledonian"}
        </text>
        <text transform="translate(1512.155 570.231)" className="st25 st26" />
        <text
          transform="translate(1466.384 581.631)"
          className="st42 st30 st124"
        >
          {"Road &"}
        </text>
        <text transform="translate(1501.816 581.631)" className="st25 st26" />
        <text
          transform="translate(1458.704 593.031)"
          className="st42 st30 st124"
        >
          {"Barnsbury"}
        </text>
        <text transform="translate(1509.858 593.031)" className="st25 st26" />
        <text transform="translate(87.309 150.988)" className="st42 st30 st128">
          {"Amersham"}
        </text>
        <text transform="translate(238.93 171.894)" className="st42 st30 st128">
          {"Chorleywood"}
        </text>
        <text
          transform="translate(265.978 204.413)"
          className="st42 st30"
          fontSize="11.7676px"
        >
          {"Rickmansworth"}
        </text>
        <text transform="translate(205.525 106.848)" className="st25 st26" />
        <text
          transform="translate(205.525 106.848)"
          className="st42 st30 st128"
        >
          {"Chalfont &"}
        </text>
        <text transform="translate(258.968 106.848)" className="st25 st26" />
        <text
          transform="translate(212.845 117.898)"
          className="st42 st30 st128"
        >
          {"Latimer"}
        </text>
        <text transform="translate(251.824 117.898)" className="st25 st26" />
        <text transform="translate(88.691 92.669)" className="st42 st30 st128">
          {"Chesham"}
        </text>
        <path
          className="st72"
          d="M98.7 161.6L94.3 159.6 100.5 159.6 100.5 158.3 94.2 158.3 97.4 156.8 100.5 156.8 100.5 155.5 97.4 155.5 93.5 153.7 90.5 153.7 94.6 155.5 88.3 155.5 88.3 156.8 94.6 156.8 91.3 158.3 88.3 158.3 88.3 159.6 91.6 159.6 95.7 161.6z"
        />
        <path
          className="st72"
          d="M266 117.9L261.6 116 267.8 116 267.8 114.7 261.5 114.7 264.7 113.1 267.8 113.1 267.8 111.9 264.7 111.9 260.8 110.1 257.8 110.1 261.9 111.9 255.6 111.9 255.6 113.1 261.9 113.1 258.6 114.7 255.6 114.7 255.6 116 258.9 116 263 117.9z"
        />
        <text
          transform="translate(393.976 224.643)"
          className="st42 st30 st124"
        >
          {"Moor Park"}
        </text>
        <text transform="translate(382.57 180.749)" className="st42 st30 st124">
          {"Croxley"}
        </text>
        <text transform="translate(382.57 143.862)" className="st42 st30 st124">
          {"Watford"}
        </text>
        <text transform="translate(422.09 251.589)" className="st42 st30 st124">
          {"Northwood"}
        </text>
        <text
          transform="translate(448.908 278.538)"
          className="st42 st30 st124"
        >
          {"Northwood Hills"}
        </text>
        <text
          transform="translate(478.689 305.485)"
          className="st42 st30 st124"
        >
          {"Pinner"}
        </text>
        <text
          transform="translate(501.252 332.433)"
          className="st42 st30 st124"
        >
          {"North Harrow"}
        </text>
        <text transform="translate(548.64 359.38)" className="st25 st26" />
        <text transform="translate(548.64 359.38)" className="st42 st30 st124">
          {"Harrow-"}
        </text>
        <text transform="translate(588.847 359.38)" className="st25 st26" />
        <text transform="translate(542.7 370.78)" className="st42 st30 st124">
          {"on-the-Hill"}
        </text>
        <text transform="translate(595.136 370.78)" className="st25 st26" />
        <text transform="translate(610.801 401.91)" className="st25 st26" />
        <text transform="translate(610.801 401.91)" className="st42 st30 st124">
          {"Northwick"}
        </text>
        <text transform="translate(663.297 401.91)" className="st25 st26" />
        <text transform="translate(625.731 413.31)" className="st42 st30 st124">
          {"Park"}
        </text>
        <text transform="translate(648.016 413.31)" className="st25 st26" />
        <text
          transform="translate(691.347 372.215)"
          className="st42 st30 st124"
        >
          {"Preston Road"}
        </text>
        <path
          className="st72"
          d="M540.3 359.6L535.9 357.6 542.1 357.6 542.1 356.4 535.8 356.4 539 354.8 542.1 354.8 542.1 353.5 539 353.5 535.1 351.7 532.1 351.7 536.2 353.5 529.9 353.5 529.9 354.8 536.2 354.8 532.9 356.4 529.9 356.4 529.9 357.6 533.1 357.6 537.3 359.6z"
        />
        <text
          transform="translate(710.525 429.248)"
          className="st42 st30 st124"
        >
          {"Wembley Park"}
        </text>
        <text
          transform="translate(337.038 386.676)"
          className="st42 st30 st124"
        >
          {"Rayners Lane"}
        </text>
        <text transform="translate(810.855 266.85)" className="st42 st30 st124">
          {"Stanmore"}
        </text>
        <text
          transform="translate(808.275 295.526)"
          className="st42 st30 st124"
        >
          {"Canons Park"}
        </text>
        <text
          transform="translate(808.275 324.195)"
          className="st42 st30 st124"
        >
          {"Queensbury"}
        </text>
        <text transform="translate(810.247 352.88)" className="st42 st30 st124">
          {"Kingsbury"}
        </text>
        <text
          transform="translate(831.444 396.827)"
          className="st42 st30 st124"
        >
          {"Neasden"}
        </text>
        <text
          transform="translate(853.876 419.038)"
          className="st42 st30 st124"
        >
          {"Dollis Hill"}
        </text>
        <text
          transform="translate(876.879 441.274)"
          className="st42 st30 st124"
        >
          {"Willesden Green"}
        </text>
        <text
          transform="translate(1044.62 634.057)"
          className="st42 st30 st124"
        >
          {"Swiss Cottage"}
        </text>
        <text transform="translate(900.85 463.272)" className="st42 st30 st124">
          {"Kilburn"}
        </text>
        <text
          transform="translate(874.018 592.563)"
          className="st42 st30 st124"
        >
          {"Finchley Road"}
        </text>
        <text transform="translate(487.011 401.16)" className="st25 st26" />
        <text transform="translate(487.011 401.16)" className="st42 st30 st124">
          {"West"}
        </text>
        <text transform="translate(511.942 401.16)" className="st25 st26" />
        <text transform="translate(481.051 412.56)" className="st42 st30 st124">
          {"Harrow"}
        </text>
        <text transform="translate(517.966 412.56)" className="st25 st26" />
        <text
          transform="translate(216.844 325.453)"
          className="st42 st30 st124"
        >
          {"Ickenham"}
        </text>
        <text
          transform="translate(124.924 325.453)"
          className="st42 st30 st124"
        >
          {"Uxbridge"}
        </text>
        <text transform="translate(174.74 294.133)" className="st42 st30 st124">
          {"Hillingdon"}
        </text>
        <text transform="translate(292.069 292.47)" className="st42 st30 st124">
          {"Ruislip"}
        </text>
        <text
          transform="translate(363.665 309.267)"
          className="st42 st30 st124"
        >
          {"Ruislip Manor"}
        </text>
        <text
          transform="translate(393.132 338.672)"
          className="st42 st30 st124"
        >
          {"Eastcote"}
        </text>
        <text
          transform="translate(1043.178 656.137)"
          className="st42 st30 st123"
        >
          {"St John's Wood"}
        </text>
        <text transform="translate(114.203 1303.987)" className="st25 st26" />
        <text
          transform="translate(114.203 1303.987)"
          className="st42 st30 st121"
        >
          {"Heathrow"}
        </text>
        <text transform="translate(163.593 1303.987)" className="st25 st26" />
        <text
          transform="translate(110.843 1315.367)"
          className="st42 st30 st121"
        >
          {"Terminal 5"}
        </text>
        <text transform="translate(163.184 1315.367)" className="st25 st26" />
        <text transform="translate(389.5 1020.81)" className="st42 st30 st121">
          {"Northfields"}
        </text>
        <text
          transform="translate(356.828 1052.873)"
          className="st42 st30 st121"
        >
          {"Boston Manor"}
        </text>
        <text transform="translate(391.181 976.525)" className="st25 st26" />
        <text
          transform="translate(391.181 976.525)"
          className="st42 st30 st121"
        >
          {"South"}
        </text>
        <text transform="translate(420.885 976.525)" className="st25 st26" />
        <text
          transform="translate(390.801 987.905)"
          className="st42 st30 st121"
        >
          {"Ealing"}
        </text>
        <text transform="translate(421.329 987.905)" className="st25 st26" />
        <text
          transform="translate(336.565 1074.448)"
          className="st42 st30 st121"
        >
          {"Osterley"}
        </text>
        <text
          transform="translate(293.246 1116.542)"
          className="st42 st30 st121"
        >
          {"Hounslow Central"}
        </text>
        <text
          transform="translate(318.037 1095.246)"
          className="st42 st30 st121"
        >
          {"Hounslow East"}
        </text>
        <text transform="translate(274.49 1137.531)" className="st25 st26" />
        <text
          transform="translate(274.49 1137.531)"
          className="st42 st30 st121"
        >
          {"Hounslow"}
        </text>
        <text transform="translate(326.583 1137.531)" className="st25 st26" />
        <text
          transform="translate(274.49 1148.911)"
          className="st42 st30 st121"
        >
          {"West"}
        </text>
        <text transform="translate(299.42 1148.911)" className="st25 st26" />
        <text
          transform="translate(239.658 1170.67)"
          className="st42 st30 st121"
        >
          {"Hatton Cross"}
        </text>
        <text
          transform="translate(319.838 691.353)"
          className="st42 st30 st121"
        >
          {"Perivale"}
        </text>
        <text transform="translate(360.445 733.271)" className="st25 st26" />
        <text
          transform="translate(360.445 733.271)"
          className="st42 st30 st121"
        >
          {"Hanger"}
        </text>
        <text transform="translate(399.627 733.271)" className="st25 st26" />
        <text
          transform="translate(373.535 744.322)"
          className="st42 st30 st121"
        >
          {"Lane"}
        </text>
        <text transform="translate(397.148 744.322)" className="st25 st26" />
        <path
          className="st72"
          d="M261.7 485.6L257.4 483.7 263.5 483.7 263.5 482.4 257.2 482.4 260.4 480.8 263.5 480.8 263.5 479.6 260.4 479.6 256.5 477.7 253.5 477.7 257.7 479.6 251.3 479.6 251.3 480.8 257.7 480.8 254.4 482.4 251.3 482.4 251.3 483.7 254.6 483.7 258.8 485.6z"
        />
        <path
          className="st72"
          d="M195.4 267.4L191 265.4 197.2 265.4 197.2 264.1 190.8 264.1 194.1 262.6 197.2 262.6 197.2 261.3 194.1 261.3 190.1 259.5 187.1 259.5 191.3 261.3 184.9 261.3 184.9 262.6 191.3 262.6 188 264.1 184.9 264.1 184.9 265.4 188.2 265.4 192.4 267.4z"
        />
        <text transform="translate(233.892 392.678)" className="st25 st26" />
        <text
          transform="translate(233.892 392.678)"
          className="st42 st30 st124"
        >
          {"Ruislip"}
        </text>
        <text transform="translate(266.678 392.678)" className="st25 st26" />
        <text
          transform="translate(225.592 404.078)"
          className="st42 st30 st124"
        >
          {"Gardens"}
        </text>
        <text transform="translate(266.504 404.078)" className="st25 st26" />
        <text transform="translate(235.168 462.072)" className="st25 st26" />
        <text
          transform="translate(235.168 462.072)"
          className="st42 st30 st121"
        >
          {"South"}
        </text>
        <text transform="translate(264.872 462.072)" className="st25 st26" />
        <text
          transform="translate(231.908 473.472)"
          className="st42 st30 st121"
        >
          {"Ruislip"}
        </text>
        <text transform="translate(264.693 473.472)" className="st25 st26" />
        <path
          className="st72"
          d="M364 620.5L359.7 618.6 365.8 618.6 365.8 617.3 359.5 617.3 362.7 615.7 365.8 615.7 365.8 614.5 362.7 614.5 358.8 612.7 355.8 612.7 360 614.5 353.6 614.5 353.6 615.7 360 615.7 356.6 617.3 353.6 617.3 353.6 618.6 356.9 618.6 361.1 620.5z"
        />
        <text transform="translate(87.835 699.428)" className="st42 st30 st123">
          {"Slough"}
        </text>
        <path
          className="st72"
          d="M123.2 711.7L118.9 709.8 125.1 709.8 125.1 708.5 118.7 708.5 121.9 706.9 125.1 706.9 125.1 705.7 121.9 705.7 118 703.8 115 703.8 119.2 705.7 112.8 705.7 112.8 706.9 119.2 706.9 115.9 708.5 112.8 708.5 112.8 709.8 116.1 709.8 120.3 711.7z"
        />
        <text transform="translate(58.131 611.926)" className="st42 st30 st123">
          {"Maidenhead"}
        </text>
        <text transform="translate(78.804 582.758)" className="st42 st30 st123">
          {"Twyford"}
        </text>
        <text transform="translate(82.073 553.59)" className="st42 st30 st123">
          {"Reading"}
        </text>
        <path
          className="st72"
          d="M123.2 622.9L118.9 621 125.1 621 125.1 619.7 118.7 619.7 121.9 618.1 125.1 618.1 125.1 616.9 121.9 616.9 118 615 115 615 119.2 616.9 112.8 616.9 112.8 618.1 119.2 618.1 115.9 619.7 112.8 619.7 112.8 621 116.1 621 120.3 622.9z"
        />
        <path
          className="st72"
          d="M123.2 594.2L118.9 592.3 125.1 592.3 125.1 591 118.7 591 121.9 589.4 125.1 589.4 125.1 588.2 121.9 588.2 118 586.3 115 586.3 119.2 588.2 112.8 588.2 112.8 589.4 119.2 589.4 115.9 591 112.8 591 112.8 592.3 116.1 592.3 120.3 594.2z"
        />
        <path
          className="st72"
          d="M123.2 564.6L118.9 562.6 125.1 562.6 125.1 561.3 118.7 561.3 121.9 559.8 125.1 559.8 125.1 558.5 121.9 558.5 118 556.7 115 556.7 119.2 558.5 112.8 558.5 112.8 559.8 119.2 559.8 115.9 561.3 112.8 561.3 112.8 562.6 116.1 562.6 120.3 564.6z"
        />
        <text transform="translate(315.4 609.937)" className="st42 st30 st121">
          {"Greenford"}
        </text>
        <text
          transform="translate(223.663 525.054)"
          className="st42 st30 st121"
        >
          {"Northolt"}
        </text>
        <text
          transform="translate(369.866 441.485)"
          className="st42 st30 st124"
        >
          {"South Harrow"}
        </text>
        <text
          transform="translate(376.037 495.444)"
          className="st42 st30 st121"
        >
          {"Sudbury Hill"}
        </text>
        <text
          transform="translate(365.042 549.402)"
          className="st42 st30 st121"
        >
          {"Sudbury Town"}
        </text>
        <text
          transform="translate(393.006 603.362)"
          className="st42 st30 st121"
        >
          {"Alperton"}
        </text>
        <text
          transform="translate(466.919 721.829)"
          className="st42 st30 st121"
        >
          {"Park Royal"}
        </text>
        <text transform="translate(376.806 818.83)" className="st42 st30 st121">
          {"North Ealing"}
        </text>
        <text transform="translate(203.82 267.187)" className="st42 st30 st124">
          {"West Ruislip"}
        </text>
        <text
          transform="translate(355.171 940.979)"
          className="st42 st30 st121"
        >
          {"Ealing Common"}
        </text>
        <text
          transform="translate(521.455 1092.57)"
          className="st42 st30 st121"
        >
          {"Gunnersbury"}
        </text>
        <text
          transform="translate(521.357 1151.563)"
          className="st42 st30 st121"
        >
          {"Kew Gardens"}
        </text>
        <text
          transform="translate(520.986 1195.018)"
          className="st42 st30 st121"
        >
          {"Richmond"}
        </text>
        <text transform="translate(465.096 989.31)" className="st42 st30 st121">
          {"Acton Town"}
        </text>
        <text transform="translate(439.078 1032.771)" className="st25 st26" />
        <text
          transform="translate(439.078 1032.771)"
          className="st42 st30 st121"
        >
          {"Chiswick"}
        </text>
        <text transform="translate(482.752 1032.771)" className="st25 st26" />
        <text
          transform="translate(460.348 1044.171)"
          className="st42 st30 st121"
        >
          {"Park"}
        </text>
        <text transform="translate(482.632 1044.171)" className="st25 st26" />
        <text transform="translate(522.717 1032.92)" className="st25 st26" />
        <text
          transform="translate(522.717 1032.92)"
          className="st42 st30 st121"
        >
          {"Turnham"}
        </text>
        <text transform="translate(567.755 1032.92)" className="st25 st26" />
        <text
          transform="translate(530.287 1044.32)"
          className="st42 st30 st121"
        >
          {"Green"}
        </text>
        <text transform="translate(560.12 1044.32)" className="st25 st26" />
        <path
          className="st72"
          d="M589.5 1195L585.1 1193.1 591.3 1193.1 591.3 1191.8 585 1191.8 588.2 1190.2 591.3 1190.2 591.3 1189 588.2 1189 584.2 1187.2 581.3 1187.2 585.4 1189 579.1 1189 579.1 1190.2 585.4 1190.2 582.1 1191.8 579.1 1191.8 579.1 1193.1 582.3 1193.1 586.5 1195z"
        />
        <text transform="translate(581.936 1032.778)" className="st25 st26" />
        <text
          transform="translate(581.936 1032.778)"
          className="st42 st30 st121"
        >
          {"Stamford"}
        </text>
        <text transform="translate(628.633 1032.778)" className="st25 st26" />
        <text
          transform="translate(590.896 1044.178)"
          className="st42 st30 st121"
        >
          {"Brook"}
        </text>
        <text transform="translate(620.035 1044.178)" className="st25 st26" />
        <text transform="translate(638.252 1032.773)" className="st25 st26" />
        <text
          transform="translate(638.252 1032.773)"
          className="st42 st30 st123"
        >
          {"Ravenscourt"}
        </text>
        <text transform="translate(700.117 1032.773)" className="st25 st26" />
        <text
          transform="translate(658.132 1044.173)"
          className="st42 st30 st123"
        >
          {"Park"}
        </text>
        <text transform="translate(680.416 1044.173)" className="st25 st26" />
        <text transform="translate(761.045 1032.772)" className="st25 st26" />
        <text
          transform="translate(761.045 1032.772)"
          className="st42 st30 st123"
        >
          {"West"}
        </text>
        <text transform="translate(785.975 1032.772)" className="st25 st26" />
        <text
          transform="translate(729.165 1044.172)"
          className="st42 st30 st123"
        >
          {"Kensington"}
        </text>
        <text transform="translate(786.444 1044.172)" className="st25 st26" />
        <text transform="translate(734.686 976.557)" className="st25 st26" />
        <text
          transform="translate(734.686 976.557)"
          className="st42 st30 st123"
        >
          {"Barons"}
        </text>
        <text transform="translate(768.8 976.557)" className="st25 st26" />
        <text
          transform="translate(737.766 987.957)"
          className="st42 st30 st123"
        >
          {"Court"}
        </text>
        <text transform="translate(766.13 987.957)" className="st25 st26" />
        <text transform="translate(824.605 1035.329)" className="st25 st26" />
        <text
          transform="translate(824.605 1035.329)"
          className="st42 st30 st123"
        >
          {"Earl's"}
        </text>
        <text transform="translate(850.769 1035.329)" className="st25 st26" />
        <text
          transform="translate(823.695 1046.729)"
          className="st42 st30 st123"
        >
          {"Court"}
        </text>
        <text transform="translate(852.058 1046.729)" className="st25 st26" />
        <text transform="translate(637.808 916.714)" className="st25 st26" />
        <text
          transform="translate(637.808 916.714)"
          className="st42 st30 st123"
        >
          {"Shepherd's"}
        </text>
        <text transform="translate(692.758 916.714)" className="st25 st26" />
        <text
          transform="translate(630.538 928.114)"
          className="st42 st30 st123"
        >
          {"Bush Market"}
        </text>
        <text transform="translate(693.132 928.114)" className="st25 st26" />
        <text transform="translate(617.07 949.593)" className="st42 st30 st121">
          {"Goldhawk Road"}
        </text>
        <text
          transform="translate(628.555 984.093)"
          className="st42 st30 st123"
        >
          {"Hammersmith"}
        </text>
        <text
          transform="translate(640.546 895.158)"
          className="st42 st30 st127"
        >
          {"Wood Lane"}
        </text>
        <g>
          <text transform="translate(665.665 837.908)" className="st25 st26" />
          <text
            transform="translate(665.665 837.908)"
            className="st42 st30 st127"
          >
            {"White"}
          </text>
          <text transform="translate(695.585 837.908)" className="st25 st26" />
          <text
            transform="translate(670.805 849.308)"
            className="st42 st30 st127"
          >
            {"City"}
          </text>
          <text transform="translate(690.555 849.308)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(1026.482 519.5)" className="st25 st26" />
          <text
            transform="translate(1026.482 519.5)"
            className="st42 st30 st124"
          >
            {"Finchley Road"}
          </text>
          <text transform="translate(1097.77 519.5)" className="st25 st26" />
          <text
            transform="translate(1026.482 530.9)"
            className="st42 st30 st124"
          >
            {"& Frognal"}
          </text>
          <text transform="translate(1074.533 530.9)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(730.859 506.11)" className="st25 st26" />
          <text
            transform="translate(730.859 506.11)"
            className="st42 st30 st124"
          >
            {"Kensal"}
          </text>
          <text transform="translate(763.81 506.11)" className="st25 st26" />
          <text
            transform="translate(737.109 517.51)"
            className="st42 st30 st124"
          >
            {"Rise"}
          </text>
          <text transform="translate(757.383 517.51)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(783.005 507.293)" className="st25 st26" />
          <text
            transform="translate(783.005 507.293)"
            className="st42 st30 st124"
          >
            {"Brondesbury"}
          </text>
          <text transform="translate(846.907 507.293)" className="st25 st26" />
          <text
            transform="translate(803.845 518.693)"
            className="st42 st30 st124"
          >
            {"Park"}
          </text>
          <text transform="translate(826.13 518.693)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(832.943 545.849)"
            className="st42 st30 st124"
          >
            {"Brondesbury"}
          </text>
        </g>
        <g>
          <text transform="translate(794.302 584.446)" className="st25 st26" />
          <text
            transform="translate(794.302 584.446)"
            className="st42 st30 st123"
          >
            {"Kilburn"}
          </text>
          <text transform="translate(830.591 584.446)" className="st25 st26" />
          <text
            transform="translate(786.902 595.846)"
            className="st42 st30 st123"
          >
            {"High Road"}
          </text>
          <text transform="translate(837.996 595.846)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(1063.78 596.027)"
            className="st42 st30 st123"
          >
            {"South Hampstead"}
          </text>
        </g>
        <g>
          <text transform="translate(481.39 879.324)" className="st25 st26" />
          <text
            transform="translate(481.39 879.324)"
            className="st42 st30 st121"
          >
            {"West"}
          </text>
          <text transform="translate(506.32 879.324)" className="st25 st26" />
          <text
            transform="translate(479.31 890.724)"
            className="st42 st30 st121"
          >
            {"Acton"}
          </text>
          <text transform="translate(508.861 890.724)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(571.217 878.607)" className="st25 st26" />
          <text
            transform="translate(571.217 878.607)"
            className="st42 st30 st121"
          >
            {"North"}
          </text>
          <text transform="translate(601.144 878.607)" className="st25 st26" />
          <text
            transform="translate(571.257 890.007)"
            className="st42 st30 st121"
          >
            {"Acton"}
          </text>
          <text transform="translate(600.808 890.007)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(617.244 839.693)" className="st25 st26" />
          <text
            transform="translate(617.244 839.693)"
            className="st42 st30 st121"
          >
            {"East"}
          </text>
          <text transform="translate(638.375 839.693)" className="st25 st26" />
          <text
            transform="translate(613.004 851.093)"
            className="st42 st30 st121"
          >
            {"Acton"}
          </text>
          <text transform="translate(642.555 851.093)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(1262.765 1144.68)"
            className="st42 st30 st124"
          >
            {"Southwark"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1016.097 1268.916)"
            className="st42 st30 st124"
          >
            {"Nine Elms"}
          </text>
        </g>
        <g>
          <text transform="translate(951.798 1268.551)" className="st25 st26" />
          <text
            transform="translate(951.798 1268.551)"
            className="st42 st30 st124"
          >
            {"Battersea"}
          </text>
          <text
            transform="translate(1002.494 1268.551)"
            className="st25 st26"
          />
          <text
            transform="translate(959.998 1279.951)"
            className="st42 st30 st124"
          >
            {"Power"}
          </text>
          <text transform="translate(991.573 1279.951)" className="st25 st26" />
          <text
            transform="translate(957.648 1291.351)"
            className="st42 st30 st124"
          >
            {"Station"}
          </text>
          <text transform="translate(994.104 1291.351)" className="st25 st26" />
        </g>
        <g>
          <path
            className="st72"
            d="M1184.2 1097.8L1179.8 1095.8 1186 1095.8 1186 1094.5 1179.7 1094.5 1182.9 1093 1186 1093 1186 1091.7 1182.9 1091.7 1179 1089.9 1176 1089.9 1180.1 1091.7 1173.8 1091.7 1173.8 1093 1180.1 1093 1176.8 1094.5 1173.8 1094.5 1173.8 1095.8 1177 1095.8 1181.2 1097.8z"
          />
          <text
            transform="translate(1140.79 1086.862)"
            className="st42 st30 st124"
          >
            {"Waterloo"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1491.605 1032.774)"
            className="st25 st26"
          />
          <text
            transform="translate(1491.605 1032.774)"
            className="st42 st30 st123"
          >
            {"London"}
          </text>
          <text
            transform="translate(1531.693 1032.774)"
            className="st25 st26"
          />
          <text
            transform="translate(1491.605 1044.174)"
            className="st42 st30 st123"
          >
            {"Bridge"}
          </text>
          <text transform="translate(1524.19 1044.174)" className="st25 st26" />
        </g>
        <path
          className="st72"
          d="M1502.7 1057L1498.4 1055.1 1504.6 1055.1 1504.6 1053.8 1498.2 1053.8 1501.4 1052.2 1504.6 1052.2 1504.6 1050.9 1501.4 1050.9 1497.5 1049.1 1494.5 1049.1 1498.7 1050.9 1492.3 1050.9 1492.3 1052.2 1498.7 1052.2 1495.4 1053.8 1492.3 1053.8 1492.3 1055.1 1495.6 1055.1 1499.8 1057z"
        />
        <g>
          <text
            transform="translate(1548.691 1036.202)"
            className="st42 st30 st126"
          >
            {"Bermondsey"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1043.118 1295.532)"
            className="st42 st30 st128"
          >
            {"Vauxhall"}
          </text>
        </g>
        <text transform="translate(1244.04 1165.252)" className="st25 st26" />
        <text
          transform="translate(1244.04 1165.252)"
          className="st42 st30 st124"
        >
          {"Lambeth"}
        </text>
        <text transform="translate(1290.997 1165.252)" className="st25 st26" />
        <text
          transform="translate(1244.04 1176.652)"
          className="st42 st30 st124"
        >
          {"North"}
        </text>
        <text transform="translate(1273.97 1176.652)" className="st25 st26" />
        <text
          transform="translate(1018.32 1121.05)"
          className="st42 st30 st124"
        >
          {"Pimlico"}
        </text>
        <text
          transform="translate(1173.289 1349.259)"
          className="st42 st30 st124"
        >
          {"Stockwell"}
        </text>
        <text
          transform="translate(1180.044 1422.305)"
          className="st42 st30 st124"
        >
          {"Brixton"}
        </text>
        <g>
          <text
            transform="translate(1160.843 1310.328)"
            className="st42 st30 st124"
          >
            {"Oval"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1142.258 1259.177)"
            className="st42 st30 st124"
          >
            {"Kennington"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1401.269 1148.077)"
            className="st42 st30 st124"
          >
            {"Borough"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1034.718 1385.688)"
            className="st42 st30 st124"
          >
            {"Clapham North"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1006.447 1355.895)"
            className="st42 st30 st124"
          >
            {"Clapham High Street"}
          </text>
        </g>
        <path
          className="st72"
          d="M1171.1 1422.2L1166.7 1420.2 1172.9 1420.2 1172.9 1418.9 1166.6 1418.9 1169.8 1417.4 1172.9 1417.4 1172.9 1416.1 1169.8 1416.1 1165.8 1414.3 1162.9 1414.3 1167 1416.1 1160.7 1416.1 1160.7 1417.4 1167 1417.4 1163.7 1418.9 1160.7 1418.9 1160.7 1420.2 1163.9 1420.2 1168.1 1422.2z"
        />
        <path
          className="st72"
          d="M1038.2 1295.5L1033.9 1293.6 1040 1293.6 1040 1292.3 1033.7 1292.3 1036.9 1290.7 1040 1290.7 1040 1289.5 1036.9 1289.5 1033 1287.7 1030 1287.7 1034.1 1289.5 1027.8 1289.5 1027.8 1290.7 1034.1 1290.7 1030.8 1292.3 1027.8 1292.3 1027.8 1293.6 1031.1 1293.6 1035.2 1295.5z"
        />
        <g>
          <text
            transform="translate(998.073 1406.034)"
            className="st42 st30 st129"
          >
            {"Clapham Common"}
          </text>
        </g>
        <g>
          <text
            transform="translate(993.21 1426.636)"
            className="st42 st30 st129"
          >
            {"Clapham South"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1005.98 1449.31)"
            className="st42 st30 st129"
          >
            {"Balham"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1041.175 1486.558)"
            className="st42 st30 st129"
          >
            {"Tooting Bec"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1025.092 1502.728)"
            className="st42 st30 st129"
          >
            {"Tooting Broadway"}
          </text>
        </g>
        <g>
          <text
            transform="translate(991.378 1534.545)"
            className="st42 st30 st129"
          >
            {"Colliers Wood"}
          </text>
        </g>
        <g>
          <text
            transform="translate(972.358 1552.077)"
            className="st42 st30 st129"
          >
            {"South Wimbledon"}
          </text>
        </g>
        <path
          className="st72"
          d="M997.4 1449.3L993.1 1447.3 999.2 1447.3 999.2 1446 992.9 1446 996.1 1444.5 999.2 1444.5 999.2 1443.2 996.1 1443.2 992.2 1441.4 989.2 1441.4 993.3 1443.2 987 1443.2 987 1444.5 993.3 1444.5 990 1446 987 1446 987 1447.3 990.2 1447.3 994.5 1449.3z"
        />
        <g>
          <text
            transform="translate(890.932 1639.536)"
            className="st42 st30 st129"
          >
            {"Morden"}
          </text>
        </g>
        <text transform="translate(718.977 821.62)" className="st42 st30 st121">
          {"Latimer Road"}
        </text>
        <text
          transform="translate(718.977 798.967)"
          className="st42 st30 st121"
        >
          {"Ladbroke Grove"}
        </text>
        <text transform="translate(718.977 777.24)" className="st42 st30 st121">
          {"Westbourne Park"}
        </text>
        <g>
          <text
            transform="translate(726.631 756.488)"
            className="st42 st30 st121"
          >
            {"Royal Oak"}
          </text>
        </g>
        <g>
          <text transform="translate(1935.566 671.277)" className="st25 st26" />
          <text
            transform="translate(1935.566 671.277)"
            className="st42 st30 st124"
          >
            {"Pudding"}
          </text>
          <text transform="translate(1976.914 671.277)" className="st25 st26" />
          <text
            transform="translate(1935.566 682.677)"
            className="st42 st30 st124"
          >
            {"Mill Lane"}
          </text>
          <text transform="translate(1980.112 682.677)" className="st25 st26" />
        </g>
        <text
          transform="translate(470.201 923.613)"
          className="st42 st30 st121"
        >
          {"Acton Central"}
        </text>
        <text transform="translate(476.94 956.635)" className="st42 st30 st121">
          {"South Acton"}
        </text>
        <g>
          <text transform="translate(1088.882 475.204)" className="st25 st26" />
          <text
            transform="translate(1088.882 475.204)"
            className="st42 st30 st121"
          >
            {"Hampstead"}
          </text>
          <text transform="translate(1145.915 475.204)" className="st25 st26" />
          <text
            transform="translate(1102.292 486.604)"
            className="st42 st30 st121"
          >
            {"Heath"}
          </text>
          <text transform="translate(1132.62 486.604)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(2026.986 627.77)" className="st25 st26" />
          <text
            transform="translate(2026.986 627.77)"
            className="st42 st30 st124"
          >
            {"Stratford"}
          </text>
          <text transform="translate(2075.272 627.77)" className="st25 st26" />
          <text
            transform="translate(2026.986 639.17)"
            className="st42 st30 st124"
          >
            {"High Street"}
          </text>
          <text transform="translate(2083.998 639.17)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(2026.986 674.682)" className="st25 st26" />
          <text
            transform="translate(2026.986 674.682)"
            className="st42 st30 st124"
          >
            {"Abbey"}
          </text>
          <text transform="translate(2061.149 674.682)" className="st25 st26" />
          <text
            transform="translate(2026.986 686.082)"
            className="st42 st30 st124"
          >
            {"Road"}
          </text>
          <text transform="translate(2051.894 686.082)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(2132.597 493.973)" className="st25 st26" />
          <text
            transform="translate(2132.597 493.973)"
            className="st42 st30 st124"
          >
            {"Woodgrange"}
          </text>
          <text transform="translate(2196.993 493.973)" className="st25 st26" />
          <text
            transform="translate(2132.597 505.373)"
            className="st42 st30 st124"
          >
            {"Park"}
          </text>
          <text transform="translate(2154.882 505.373)" className="st25 st26" />
        </g>
        <text transform="translate(1741.35 436.506)" className="st25 st26" />
        <text
          transform="translate(1741.35 436.506)"
          className="st42 st30 st124"
        >
          {"Walthamstow"}
        </text>
        <text transform="translate(1810.65 436.506)" className="st25 st26" />
        <text
          transform="translate(1742.75 447.906)"
          className="st42 st30 st124"
        >
          {"Queen's Road"}
        </text>
        <text transform="translate(1810.333 447.906)" className="st25 st26" />
        <g>
          <text
            transform="translate(1695.486 1524.894)"
            className="st42 st30 st131"
          >
            {"West Croydon"}
          </text>
        </g>
        <g>
          <text transform="translate(2254.59 1529)" className="st25 st26" />
          <text transform="translate(2254.59 1529)" className="st42 st30 st131">
            {"Beckenham"}
          </text>
          <text transform="translate(2312.299 1529)" className="st25 st26" />
          <text
            transform="translate(2271.01 1540.41)"
            className="st42 st30 st131"
          >
            {"Junction"}
          </text>
          <text transform="translate(2312.597 1540.41)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(2123.526 1477.34)"
            className="st42 st30 st131"
          >
            {"Elmers End"}
          </text>
        </g>
        <g>
          <text
            transform="translate(2101.104 1440.655)"
            className="st25 st26"
          />
          <text
            transform="translate(2101.104 1440.655)"
            className="st42 st30 st131"
          >
            {"Harrington"}
          </text>
          <text transform="translate(2159.13 1440.655)" className="st25 st26" />
          <text
            transform="translate(2116.234 1452.065)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text
            transform="translate(2141.158 1452.065)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(2038.541 1498.233)"
            className="st42 st30 st131"
          >
            {"Arena"}
          </text>
        </g>
        <g>
          <text transform="translate(856.175 1435.145)" className="st25 st26" />
          <text
            transform="translate(856.175 1435.145)"
            className="st42 st30 st131"
          >
            {"Dundonald"}
          </text>
          <text transform="translate(910.954 1435.145)" className="st25 st26" />
          <text
            transform="translate(856.175 1446.555)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text transform="translate(881.099 1446.555)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(873.517 1510.988)" className="st25 st26" />
          <text
            transform="translate(873.517 1510.988)"
            className="st42 st30 st131"
          >
            {"Merton"}
          </text>
          <text transform="translate(911.103 1510.988)" className="st25 st26" />
          <text
            transform="translate(873.517 1522.398)"
            className="st42 st30 st131"
          >
            {"Park"}
          </text>
          <text transform="translate(895.817 1522.398)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(2011.713 1524.963)"
            className="st42 st30 st131"
          >
            {"Woodside"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1985.303 1551.396)"
            className="st42 st30 st131"
          >
            {"Blackhorse Lane"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1958.895 1577.825)"
            className="st42 st30 st131"
          >
            {"Addiscombe"}
          </text>
        </g>
        <g>
          <text transform="translate(2209.824 1462.04)" className="st25 st26" />
          <text
            transform="translate(2209.824 1462.04)"
            className="st42 st30 st131"
          >
            {"Avenue"}
          </text>
          <text transform="translate(2246.786 1462.04)" className="st25 st26" />
          <text
            transform="translate(2222.214 1473.45)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text transform="translate(2247.138 1473.45)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(1728.035 1563.75)" className="st25 st26" />
          <text
            transform="translate(1728.035 1563.75)"
            className="st42 st30 st131"
          >
            {"Wellesley"}
          </text>
          <text transform="translate(1774.623 1563.75)" className="st25 st26" />
          <text
            transform="translate(1739.045 1575.16)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text transform="translate(1763.97 1575.16)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(1516.798 1565.706)"
            className="st42 st30 st131"
          >
            {"Reeves Corner"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1118.456 1615.538)"
            className="st42 st30 st131"
          >
            {"Mitcham"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1259.906 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1259.906 1615.538)"
            className="st42 st30 st131"
          >
            {"Beddington"}
          </text>
          <text
            transform="translate(1318.344 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1277.256 1626.948)"
            className="st42 st30 st131"
          >
            {"Lane"}
          </text>
          <text
            transform="translate(1300.885 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(1399.857 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1399.857 1615.538)"
            className="st42 st30 st131"
          >
            {"Ampere"}
          </text>
          <text
            transform="translate(1439.243 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1408.897 1626.948)"
            className="st42 st30 st131"
          >
            {"Way"}
          </text>
          <text
            transform="translate(1430.196 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(1522.714 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1522.714 1615.538)"
            className="st42 st30 st131"
          >
            {"Wandle"}
          </text>
          <text
            transform="translate(1560.111 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1530.354 1626.948)"
            className="st42 st30 st131"
          >
            {"Park"}
          </text>
          <text
            transform="translate(1552.654 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(1623.319 1563.751)"
            className="st42 st30 st131"
          >
            {"Centrale"}
          </text>
        </g>
        <g>
          <text transform="translate(1644.515 1615.54)" className="st25 st26" />
          <text
            transform="translate(1644.515 1615.54)"
            className="st42 st30 st131"
          >
            {"Church"}
          </text>
          <text transform="translate(1679.994 1615.54)" className="st25 st26" />
          <text
            transform="translate(1646.775 1626.949)"
            className="st42 st30 st131"
          >
            {"Street"}
          </text>
          <text
            transform="translate(1677.618 1626.949)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(1053.132 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1053.132 1615.538)"
            className="st42 st30 st131"
          >
            {"Belgrave"}
          </text>
          <text transform="translate(1096.39 1615.538)" className="st25 st26" />
          <text
            transform="translate(1062.693 1626.948)"
            className="st42 st30 st131"
          >
            {"Walk"}
          </text>
          <text
            transform="translate(1087.134 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text transform="translate(998.374 1615.538)" className="st25 st26" />
          <text
            transform="translate(998.374 1615.538)"
            className="st42 st30 st131"
          >
            {"Phipps"}
          </text>
          <text
            transform="translate(1031.782 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(998.684 1626.948)"
            className="st42 st30 st131"
          >
            {"Bridge"}
          </text>
          <text
            transform="translate(1031.292 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text transform="translate(939.734 1615.538)" className="st25 st26" />
          <text
            transform="translate(939.734 1615.538)"
            className="st42 st30 st131"
          >
            {"Morden"}
          </text>
          <text transform="translate(978.673 1615.538)" className="st25 st26" />
          <text
            transform="translate(946.833 1626.948)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text transform="translate(971.758 1626.948)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(1336.918 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1336.918 1615.538)"
            className="st42 st30 st131"
          >
            {"Therapia"}
          </text>
          <text
            transform="translate(1380.658 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1347.028 1626.948)"
            className="st42 st30 st131"
          >
            {"Lane"}
          </text>
          <text
            transform="translate(1370.657 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(1460.121 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1460.121 1615.538)"
            className="st42 st30 st131"
          >
            {"Waddon"}
          </text>
          <text
            transform="translate(1501.532 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1465.281 1626.948)"
            className="st42 st30 st131"
          >
            {"Marsh"}
          </text>
          <text
            transform="translate(1496.548 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text transform="translate(1722.668 1615.54)" className="st25 st26" />
          <text
            transform="translate(1722.668 1615.54)"
            className="st42 st30 st131"
          >
            {"George"}
          </text>
          <text transform="translate(1759.065 1615.54)" className="st25 st26" />
          <text
            transform="translate(1725.388 1626.949)"
            className="st42 st30 st131"
          >
            {"Street"}
          </text>
          <text
            transform="translate(1756.231 1626.949)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(2221.003 1495.414)"
            className="st25 st26"
          />
          <text
            transform="translate(2221.003 1495.414)"
            className="st42 st30 st131"
          >
            {"Beckenham"}
          </text>
          <text
            transform="translate(2278.712 1495.414)"
            className="st25 st26"
          />
          <text
            transform="translate(2253.843 1506.824)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text
            transform="translate(2278.767 1506.824)"
            className="st25 st26"
          />
        </g>
        <g>
          <text transform="translate(1184.76 1615.538)" className="st25 st26" />
          <text
            transform="translate(1184.76 1615.538)"
            className="st42 st30 st131"
          >
            {"Mitcham"}
          </text>
          <text
            transform="translate(1229.135 1615.538)"
            className="st25 st26"
          />
          <text
            transform="translate(1186.18 1626.948)"
            className="st42 st30 st131"
          >
            {"Junction"}
          </text>
          <text
            transform="translate(1227.766 1626.948)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(2168.076 1440.378)"
            className="st42 st30 st131"
          >
            {"Birkbeck"}
          </text>
        </g>
        <path
          className="st42"
          d="M307.7 1152.8v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7.1-1.6.4-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.4-1 .9-1 .4 0 .6.1 1.3.4.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.6-.2-.8 0-.7.5-1.1 1.1-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.4.7-.5 1-.5 1.7.6 0 .6-.1 1.8-.6.3-.2.5-.2.8-.2.6 0 .9.4.9 1.1 0 .6-.4 1.1-1 1.1-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1h-.6zM993.5 844.7v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7 0-1.6.5-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.3-1 .9-1 .4 0 .6.1 1.3.5.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.5-.2-.8 0-.7.5-1.1 1.2-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.3.7-.5 1-.5 1.7.6 0 .6 0 1.8-.6.3-.2.5-.2.8-.2.6 0 .9.4.9 1s-.4 1-1 1c-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1l-.7-.1zM877.3 762.3v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7 0-1.7.5-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.3-1 .9-1 .4 0 .6.1 1.3.5.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.5-.2-.8 0-.7.5-1.1 1.2-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.3.7-.5 1-.5 1.7.6 0 .6 0 1.8-.6.3-.2.5-.2.8-.2.6 0 .9.4.9 1s-.4 1-1 1c-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1l-.6-.1zM648.5 855.1v-2.6c0-1.3-.2-2.6-.4-3.8-.1-.8-.2-1.1-.5-1.8.6-.5.8-.8 1-1.5-.5 0-.7 0-1.6.5-.4.2-.7.2-.9.2-.6 0-1-.4-1-1.1 0-.6.3-1 .9-1 .4 0 .6.1 1.3.5.5.2.8.3 1.3.4-.1-.7-.1-.9-.7-1.9-.2-.4-.2-.5-.2-.8 0-.7.5-1.1 1.2-1.1s1.1.4 1.1 1.1c0 .3-.1.6-.3 1.1-.3.7-.5 1-.5 1.7.6 0 .6 0 1.8-.6.3-.2.5-.2.8-.2.6 0 .9.4.9 1s-.4 1-1 1c-.2 0-.5-.1-1-.3-.8-.3-1.1-.4-1.6-.4.2.7.3.9 1 1.5-.5 1.5-.7 2.3-.8 3.9-.1 1-.1 2-.1 3.2v1.1l-.7-.1z"
        />
        <g>
          <text transform="translate(1867.516 382.036)" className="st25 st26" />
          <text
            transform="translate(1867.516 382.036)"
            className="st42 st30 st121"
          >
            {"Walthamstow"}
          </text>
          <text transform="translate(1936.814 382.036)" className="st25 st26" />
          <text
            transform="translate(1867.516 393.436)"
            className="st42 st30 st121"
          >
            {"Central"}
          </text>
          <text transform="translate(1903.652 393.436)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(2009.258 484.965)" className="st25 st26" />
          <text
            transform="translate(2009.258 484.965)"
            className="st42 st30 st121"
          >
            {"Wanstead"}
          </text>
          <text transform="translate(2058.87 484.965)" className="st25 st26" />
          <text
            transform="translate(2036.758 496.025)"
            className="st42 st30 st121"
          >
            {"Park"}
          </text>
          <text transform="translate(2059.042 496.025)" className="st25 st26" />
        </g>
        <text transform="translate(1774.642 351.161)" className="st25 st26" />
        <text
          transform="translate(1774.642 351.161)"
          className="st42 st30 st121"
        >
          {"Blackhorse"}
        </text>
        <text transform="translate(1831.522 351.161)" className="st25 st26" />
        <text
          transform="translate(1774.642 362.561)"
          className="st42 st30 st121"
        >
          {"Road"}
        </text>
        <text transform="translate(1799.548 362.561)" className="st25 st26" />
        <g>
          <text transform="translate(2078.872 510.147)" className="st25 st26" />
          <text
            transform="translate(2078.872 510.147)"
            className="st42 st30 st121"
          >
            {"Forest"}
          </text>
          <text transform="translate(2115.173 510.147)" className="st25 st26" />
          <text
            transform="translate(2078.872 521.547)"
            className="st42 st30 st121"
          >
            {"Gate"}
          </text>
          <text transform="translate(2102.461 521.547)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(1011.108 998.789)"
            className="st42 st30 st123"
          >
            {"Victoria"}
          </text>
        </g>
        <path
          className="st72"
          d="M1047.8 989.3L1043.4 987.4 1049.6 987.4 1049.6 986.1 1043.3 986.1 1046.5 984.5 1049.6 984.5 1049.6 983.3 1046.5 983.3 1042.6 981.5 1039.6 981.5 1043.7 983.3 1037.4 983.3 1037.4 984.5 1043.7 984.5 1040.4 986.1 1037.4 986.1 1037.4 987.4 1040.6 987.4 1044.8 989.3z"
        />
        <g>
          <path
            className="st42"
            d="M1014.1 988.1c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2-.5-1.2-1.2-1.2c-.6 0-1.2.6-1.2 1.2zm.7 0c0-.3.3-.6.6-.6s.6.3.6.6-.3.6-.6.6-.6-.2-.6-.6zM1026 988.1c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2-.5-1.2-1.2-1.2-1.2.6-1.2 1.2zm.6 0c0-.3.3-.6.6-.6s.6.3.6.6-.3.6-.6.6-.6-.2-.6-.6zM1028.8 988.1c0 .7.5 1.2 1.2 1.2s1.2-.5 1.2-1.2-.5-1.2-1.2-1.2-1.2.6-1.2 1.2zm.6 0c0-.3.3-.6.6-.6s.6.3.6.6-.3.6-.6.6-.6-.3-.6-.6z"
          />
          <path
            className="st42"
            d="M1009.7 983.5c0 .2.2.3.3.3s.3-.2.3-.3c0-.4.1-.7.2-.8h.9c-.7.7-1.3 1.7-1.3 3.1-.1 1.8 0 2.7 0 2.7h3.8v-.3c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v.3h8.8v-.3c0-.8.7-1.5 1.5-1.5.7 0 1.2.4 1.4 1 .2-.6.8-1 1.4-1 .8 0 1.5.7 1.5 1.5v.3h.1s2.2-1 2.2-1.1v-4.5s0-.3-.4-.8c-.4-.6-.9-.6-.9-.6h-19.4s-.4.2-1 .6h-1.7c-.1 0-.2 0-.2.1-.1 0-.5.4-.5 1.3zm18-1.4h4.1s.4 0 .6.4c.2.3.2.6.2.6v1.7h-5v-2.7zm-5.3 0h4.7v2.7h-4.7v-2.7zm-5.6 0h5v2.7h-5v-2.7zm-3.6 0h2.9v2.7h-1.4s-2.4 1.1-2.9 1.1c-.7.1-1.2 0-1.2 0s.1-2.5 2.6-3.8z"
          />
        </g>
        <g>
          <text transform="translate(218.519 1309.218)" className="st25 st26" />
          <text
            transform="translate(218.519 1309.218)"
            className="st42 st30 st121"
          >
            {"Heathrow"}
          </text>
          <text transform="translate(267.908 1309.218)" className="st25 st26" />
          <text
            transform="translate(218.519 1320.598)"
            className="st42 st30 st121"
          >
            {"Terminal 4"}
          </text>
          <text transform="translate(271.118 1320.598)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(133.685 1161.321)" className="st25 st26" />
          <text
            transform="translate(133.685 1161.321)"
            className="st42 st30 st121"
          >
            {"Heathrow"}
          </text>
          <text transform="translate(183.074 1161.321)" className="st25 st26" />
          <text
            transform="translate(108.755 1172.701)"
            className="st42 st30 st121"
          >
            {"Terminals"}
          </text>
          <text transform="translate(157.203 1172.701)" className="st25 st26" />
          <text
            transform="translate(160.865 1172.701)"
            className="st42 st30 st121"
          >
            {"2"}
          </text>
          <text transform="translate(166.568 1172.701)" className="st25 st26" />
          <text transform="translate(166.385 1172.701)" className="st25 st26" />
          <text
            transform="translate(168.225 1172.701)"
            className="st42 st30 st121"
          >
            {"&"}
          </text>
          <text transform="translate(176.092 1172.701)" className="st25 st26" />
          <text transform="translate(175.385 1172.701)" className="st25 st26" />
          <text
            transform="translate(177.515 1172.701)"
            className="st42 st30 st121"
          >
            {"3"}
          </text>
          <text transform="translate(183.312 1172.701)" className="st25 st26" />
        </g>
        <path
          className="st42"
          d="M94.2 1185.7c.7 0 .9 1.1.9 1.8l.1 4.5 6.2 4.7c.2.1 1 .7 1.1.9.2.2.2.7.2.9v.5l-6.1-2.4c-.3-.1-.6-.2-.9-.2-.7 0-.6.9-.7 1.4v2.4l2.1 1.5.2 1.2-2.8-.8H94l-2.8.8.2-1.2 2-1.5v-2.4c0-.5.1-1.4-.6-1.4-.3 0-.6.1-.9.2l-6.1 2.4v-.5c0-.3-.1-.7.2-.9.1-.2.9-.8 1.1-.9l6.2-4.7.1-4.5c-.1-.7.2-1.8.8-1.8z"
        />
        <text transform="translate(489.425 760.113)" className="st25 st26" />
        <text
          transform="translate(489.425 760.113)"
          className="st42 st30 st121"
        >
          {"Acton"}
        </text>
        <text transform="translate(518.976 760.113)" className="st25 st26" />
        <text
          transform="translate(470.615 771.503)"
          className="st42 st30 st121"
        >
          {"Main Line"}
        </text>
        <text transform="translate(518.922 771.503)" className="st25 st26" />
        <path
          className="st72"
          d="M412.3 921.7L407.9 919.8 414.1 919.8 414.1 918.5 407.8 918.5 411 917 414.1 917 414.1 915.7 411 915.7 407 913.9 404.1 913.9 408.2 915.7 401.9 915.7 401.9 917 408.2 917 404.9 918.5 401.9 918.5 401.9 919.8 405.1 919.8 409.3 921.7z"
        />
        <text transform="translate(392.808 899.273)" className="st25 st26" />
        <text
          transform="translate(392.808 899.273)"
          className="st42 st30 st121"
        >
          {"Ealing"}
        </text>
        <text transform="translate(423.335 899.273)" className="st25 st26" />
        <text
          transform="translate(383.258 910.663)"
          className="st42 st30 st121"
        >
          {"Broadway"}
        </text>
        <text transform="translate(432.4 910.663)" className="st25 st26" />
        <g>
          <text transform="translate(1000.59 843.495)" className="st25 st26" />
          <text
            transform="translate(1000.59 843.495)"
            className="st42 st30 st123"
          >
            {"Bond"}
          </text>
          <text transform="translate(1026.248 843.495)" className="st25 st26" />
          <text
            transform="translate(995.08 854.895)"
            className="st42 st30 st123"
          >
            {"Street"}
          </text>
          <text transform="translate(1025.9 854.895)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(269.566 862.694)"
            className="st42 st30 st121"
          >
            {"Southall"}
          </text>
        </g>
        <g>
          <text
            transform="translate(295.64 832.535)"
            className="st42 st30 st121"
          >
            {"Hanwell"}
          </text>
        </g>
        <g>
          <text transform="translate(210.367 821.636)" className="st25 st26" />
          <text
            transform="translate(210.367 821.636)"
            className="st42 st30 st121"
          >
            {"Hayes &"}
          </text>
          <text transform="translate(250.584 821.636)" className="st25 st26" />
          <text
            transform="translate(203.747 833.036)"
            className="st42 st30 st121"
          >
            {"Harlington"}
          </text>
          <text transform="translate(257.51 833.036)" className="st25 st26" />
        </g>
        <path
          className="st72"
          d="M234.8 812.6L230.7 810.8 236.5 810.8 236.5 809.5 230.6 809.5 233.6 808.1 236.5 808.1 236.5 806.9 233.6 806.9 229.9 805.2 227.1 805.2 231 806.9 225.1 806.9 225.1 808.1 231 808.1 227.9 809.5 225.1 809.5 225.1 810.8 228.1 810.8 232 812.6z"
        />
        <g>
          <text
            transform="translate(1954.74 1619.798)"
            className="st42 st30 st131"
          >
            {"Lloyd Park"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1876.488 1640.538)"
            className="st42 st30 st131"
          >
            {"Coombe Lane"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1996.474 1661.832)"
            className="st42 st30 st131"
          >
            {"Gravel Hill"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1903.766 1683.403)"
            className="st42 st30 st131"
          >
            {"Addington Village"}
          </text>
        </g>
        <g>
          <text
            transform="translate(2042.396 1703.023)"
            className="st42 st30 st131"
          >
            {"Fieldway"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1938.537 1723.914)"
            className="st42 st30 st131"
          >
            {"King Henry's Drive"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1843.953 1573.295)"
            className="st25 st26"
          />
          <text
            transform="translate(1843.953 1573.295)"
            className="st42 st30 st131"
          >
            {"Lebanon"}
          </text>
          <text
            transform="translate(1886.858 1573.295)"
            className="st25 st26"
          />
          <text
            transform="translate(1852.853 1584.705)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text
            transform="translate(1877.777 1584.705)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(1973.275 1744.81)"
            className="st42 st30 st131"
          >
            {"New Addington"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1870.95 1615.54)"
            className="st42 st30 st131"
          >
            {"Sandilands"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1843.953 1573.295)"
            className="st25 st26"
          />
          <text
            transform="translate(1843.953 1573.295)"
            className="st42 st30 st131"
          >
            {"Lebanon"}
          </text>
          <text
            transform="translate(1886.858 1573.295)"
            className="st25 st26"
          />
          <text
            transform="translate(1852.853 1584.705)"
            className="st42 st30 st131"
          >
            {"Road"}
          </text>
          <text
            transform="translate(1877.777 1584.705)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(1300.696 983.35)"
            className="st42 st30 st132"
          >
            {"Blackfriars"}
          </text>
          <path
            className="st72"
            d="M1291.7 983.3L1287.4 981.4 1293.5 981.4 1293.5 980.1 1287.2 980.1 1290.4 978.5 1293.5 978.5 1293.5 977.3 1290.4 977.3 1286.5 975.5 1283.5 975.5 1287.7 977.3 1281.3 977.3 1281.3 978.5 1287.7 978.5 1284.3 980.1 1281.3 980.1 1281.3 981.4 1284.6 981.4 1288.8 983.3z"
          />
        </g>
        <text
          transform="matrix(.98 0 0 1 1287.436 587.102)"
          className="st25 st26"
        />
        <text
          transform="matrix(.98 0 0 1 1287.436 587.102)"
          className="st42 st30 st132"
        >
          {"King's Cross"}
        </text>
        <text
          transform="matrix(.98 0 0 1 1345.595 587.102)"
          className="st25 st26"
        />
        <text
          transform="matrix(.98 0 0 1 1285.055 598.502)"
          className="st42 st30 st132"
        >
          {"St Pancras"}
        </text>
        <text
          transform="matrix(.98 0 0 1 1335.887 598.502)"
          className="st25 st26"
        />
        <path
          className="st72"
          d="M1359.5 600L1355.2 598 1361.3 598 1361.3 596.7 1355 596.7 1358.2 595.2 1361.3 595.2 1361.3 593.9 1358.2 593.9 1354.3 592.1 1351.3 592.1 1355.5 593.9 1349.1 593.9 1349.1 595.2 1355.5 595.2 1352.2 596.7 1349.1 596.7 1349.1 598 1352.4 598 1356.6 600z"
        />
        <path
          className="st72"
          d="M1446.1 709.2L1441.7 707.2 1447.9 707.2 1447.9 705.9 1441.5 705.9 1444.8 704.4 1447.9 704.4 1447.9 703.1 1444.8 703.1 1440.8 701.3 1437.8 701.3 1442 703.1 1435.7 703.1 1435.7 704.4 1442 704.4 1438.7 705.9 1435.7 705.9 1435.7 707.2 1438.9 707.2 1443.1 709.2z"
        />
        <path
          className="st72"
          d="M1386.3 485.6L1382 483.7 1388.2 483.7 1388.2 482.4 1381.8 482.4 1385 480.8 1388.2 480.8 1388.2 479.6 1385 479.6 1381.1 477.7 1378.1 477.7 1382.3 479.6 1375.9 479.6 1375.9 480.8 1382.3 480.8 1379 482.4 1375.9 482.4 1375.9 483.7 1379.2 483.7 1383.4 485.6z"
        />
        <text
          transform="translate(1026.668 137.152)"
          className="st42 st30 st133"
        >
          {"Elstree & Borehamwood"}
        </text>
        <text
          transform="translate(1024.586 251.289)"
          className="st42 st30 st133"
        >
          {"Mill Hill Broadway"}
        </text>
        <g>
          <text
            transform="translate(1358.543 1334.067)"
            className="st42 st30 st133"
          >
            {"Denmark Hill"}
          </text>
        </g>
        <path
          className="st72"
          d="M1444 1333.6L1439.6 1331.6 1445.8 1331.6 1445.8 1330.3 1439.4 1330.3 1442.7 1328.8 1445.8 1328.8 1445.8 1327.5 1442.7 1327.5 1438.7 1325.7 1435.8 1325.7 1439.9 1327.5 1433.6 1327.5 1433.6 1328.8 1439.9 1328.8 1436.6 1330.3 1433.6 1330.3 1433.6 1331.6 1436.8 1331.6 1441 1333.6z"
        />
        <g>
          <path className="st28" d="M1281.3 1251.6H1407.5V1274.5H1281.3z" />
          <text
            transform="translate(1285.765 1266.639)"
            className="st42 st30 st124"
          >
            {"Elephant & Castle"}
          </text>
          <path
            className="st72"
            d="M1397.9 1267.3L1393.6 1265.4 1399.7 1265.4 1399.7 1264.1 1393.4 1264.1 1396.6 1262.6 1399.7 1262.6 1399.7 1261.3 1396.6 1261.3 1392.7 1259.5 1389.7 1259.5 1393.8 1261.3 1387.5 1261.3 1387.5 1262.6 1393.8 1262.6 1390.5 1264.1 1387.5 1264.1 1387.5 1265.4 1390.8 1265.4 1394.9 1267.3z"
          />
        </g>
        <path
          className="st72"
          d="M1327.6 1434.3L1323.2 1432.4 1329.4 1432.4 1329.4 1431.1 1323.1 1431.1 1326.3 1429.5 1329.4 1429.5 1329.4 1428.3 1326.3 1428.3 1322.3 1426.5 1319.4 1426.5 1323.5 1428.3 1317.2 1428.3 1317.2 1429.5 1323.5 1429.5 1320.2 1431.1 1317.2 1431.1 1317.2 1432.4 1320.4 1432.4 1324.6 1434.3z"
        />
        <path
          className="st72"
          d="M1324.6 1458L1320.3 1456 1326.4 1456 1326.4 1454.7 1320.1 1454.7 1323.3 1453.2 1326.4 1453.2 1326.4 1451.9 1323.3 1451.9 1319.4 1450.1 1316.4 1450.1 1320.6 1451.9 1314.2 1451.9 1314.2 1453.2 1320.6 1453.2 1317.2 1454.7 1314.2 1454.7 1314.2 1456 1317.5 1456 1321.7 1458z"
        />
        <path
          className="st72"
          d="M1327.7 1479.1L1323.3 1477.2 1329.5 1477.2 1329.5 1475.9 1323.2 1475.9 1326.4 1474.3 1329.5 1474.3 1329.5 1473.1 1326.4 1473.1 1322.5 1471.3 1319.5 1471.3 1323.6 1473.1 1317.3 1473.1 1317.3 1474.3 1323.6 1474.3 1320.3 1475.9 1317.3 1475.9 1317.3 1477.2 1320.6 1477.2 1324.7 1479.1z"
        />
        <path
          className="st72"
          d="M1374.7 1530.3L1370.4 1528.3 1376.5 1528.3 1376.5 1527 1370.2 1527 1373.4 1525.5 1376.5 1525.5 1376.5 1524.2 1373.4 1524.2 1369.5 1522.4 1366.5 1522.4 1370.7 1524.2 1364.3 1524.2 1364.3 1525.5 1370.7 1525.5 1367.3 1527 1364.3 1527 1364.3 1528.3 1367.6 1528.3 1371.8 1530.3z"
        />
        <path
          className="st72"
          d="M1098.8 1680.4L1094.5 1678.5 1100.7 1678.5 1100.7 1677.2 1094.3 1677.2 1097.5 1675.6 1100.7 1675.6 1100.7 1674.4 1097.5 1674.4 1093.6 1672.6 1090.6 1672.6 1094.8 1674.4 1088.4 1674.4 1088.4 1675.6 1094.8 1675.6 1091.5 1677.2 1088.4 1677.2 1088.4 1678.5 1091.7 1678.5 1095.9 1680.4z"
        />
        <text transform="translate(796.297 1547.036)" className="st25 st26" />
        <text
          transform="translate(796.297 1547.036)"
          className="st42 st30 st133"
        >
          {"Wimbledon"}
        </text>
        <text transform="translate(856.41 1547.036)" className="st25 st26" />
        <text
          transform="translate(796.297 1558.056)"
          className="st42 st30 st133"
        >
          {"Chase"}
        </text>
        <text transform="translate(826.253 1558.056)" className="st25 st26" />
        <path
          className="st72"
          d="M1383.7 150.4L1379.3 148.4 1385.4 148.4 1385.4 147.1 1379.1 147.1 1382.3 145.6 1385.4 145.6 1385.4 144.3 1382.3 144.3 1378.4 142.5 1375.4 142.5 1379.6 144.3 1373.2 144.3 1373.2 145.6 1379.6 145.6 1376.3 147.1 1373.2 147.1 1373.2 148.4 1376.5 148.4 1380.7 150.4z"
        />
        <path
          className="st72"
          d="M1365.4 242.7L1361 240.7 1367.2 240.7 1367.2 239.4 1360.9 239.4 1364.1 237.9 1367.2 237.9 1367.2 236.6 1364.1 236.6 1360.2 234.8 1357.2 234.8 1361.3 236.6 1355 236.6 1355 237.9 1361.3 237.9 1358 239.4 1355 239.4 1355 240.7 1358.2 240.7 1362.4 242.7z"
        />
        <g>
          <text
            transform="translate(2106.834 1202.768)"
            className="st25 st26"
          />
          <text
            transform="translate(2106.834 1202.768)"
            className="st42 st30 st134"
          >
            {"Woolwich"}
          </text>
          <text
            transform="translate(2158.404 1202.768)"
            className="st25 st26"
          />
          <text
            transform="translate(2112.654 1213.818)"
            className="st42 st30 st134"
          >
            {"Arsenal"}
          </text>
          <text
            transform="translate(2150.105 1213.818)"
            className="st25 st26"
          />
        </g>
        <g>
          <text
            transform="translate(2225.823 1187.748)"
            className="st42 st30 st134"
          >
            {"Woolwich"}
          </text>
        </g>
        <g>
          <text
            transform="translate(2221.911 1219.532)"
            className="st25 st26"
          />
          <text
            transform="translate(2221.911 1219.532)"
            className="st42 st30 st134"
          >
            {"Abbey"}
          </text>
          <text
            transform="translate(2253.432 1219.532)"
            className="st25 st26"
          />
          <text
            transform="translate(2223.311 1230.552)"
            className="st42 st30 st134"
          >
            {"Wood"}
          </text>
          <text
            transform="translate(2252.491 1230.552)"
            className="st25 st26"
          />
        </g>
        <g>
          <text transform="translate(1552.69 462.452)" className="st25 st26" />
          <text
            transform="translate(1552.69 462.452)"
            className="st42 st30 st133"
          >
            {"Finsbury"}
          </text>
          <text transform="translate(1595.768 462.452)" className="st25 st26" />
          <text
            transform="translate(1552.69 473.853)"
            className="st42 st30 st133"
          >
            {"Park"}
          </text>
          <text transform="translate(1574.97 473.853)" className="st25 st26" />
        </g>
        <path
          className="st72"
          d="M1588.5 473.8L1584.2 471.9 1590.3 471.9 1590.3 470.6 1584 470.6 1587.2 469 1590.3 469 1590.3 467.8 1587.2 467.8 1583.3 466 1580.3 466 1584.5 467.8 1578.1 467.8 1578.1 469 1584.5 469 1581.2 470.6 1578.1 470.6 1578.1 471.9 1581.4 471.9 1585.6 473.8z"
        />
        <text transform="translate(1341.638 473.173)" className="st25 st26" />
        <text
          transform="translate(1341.638 473.173)"
          className="st42 st30 st133"
        >
          {"Kentish"}
        </text>
        <text transform="translate(1382.246 473.173)" className="st25 st26" />
        <text
          transform="translate(1341.638 484.573)"
          className="st42 st30 st133"
        >
          {"Town"}
        </text>
        <text transform="translate(1368.126 484.573)" className="st25 st26" />
        <text transform="translate(944.766 478.388)" className="st25 st26" />
        <text
          transform="translate(944.766 478.388)"
          className="st42 st30 st133"
        >
          {"West"}
        </text>
        <text transform="translate(969.69 478.388)" className="st25 st26" />
        <text
          transform="translate(928.926 489.788)"
          className="st42 st30 st133"
        >
          {"Hampstead"}
        </text>
        <text transform="translate(985.947 489.788)" className="st25 st26" />
        <g>
          <text
            transform="translate(1259.45 1434.331)"
            className="st42 st30 st133"
          >
            {"Herne Hill"}
          </text>
        </g>
        <g>
          <text
            transform="translate(1260.222 1457.975)"
            className="st42 st30 st133"
          >
            {"Tulse Hill"}
          </text>
        </g>
        <g id="XMLID_22_">
          <text transform="translate(1782.978 1689.13)" className="st25 st26" />
          <text
            transform="translate(1782.978 1689.13)"
            className="st42 st30 st135"
          >
            {"South"}
          </text>
          <text transform="translate(1815.355 1689.13)" className="st25 st26" />
          <text
            transform="translate(1782.978 1700.54)"
            className="st42 st30 st135"
          >
            {"Croydon"}
          </text>
          <text transform="translate(1824.873 1700.54)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(2362.155 1443.024)"
            className="st42 st30 st135"
          >
            {"Orpington"}
          </text>
        </g>
        <g>
          <text
            transform="translate(2430.633 1225.415)"
            className="st42 st30 st135"
          >
            {"Dartford"}
          </text>
        </g>
        <text transform="translate(1039.925 435.198)" className="st25 st26" />
        <text
          transform="translate(1039.925 435.198)"
          className="st42 st30 st136"
        >
          {"West Hampstead"}
        </text>
        <text transform="translate(1124.529 435.198)" className="st25 st26" />
        <text
          transform="translate(1039.925 446.598)"
          className="st42 st30 st136"
        >
          {"Thameslink"}
        </text>
        <text transform="translate(1106.259 446.598)" className="st25 st26" />
        <text transform="translate(1374.069 708.215)" className="st25 st26" />
        <text
          transform="translate(1374.069 708.215)"
          className="st42 st30 st132"
        >
          {"Farringdon"}
        </text>
        <text transform="translate(1429.018 708.215)" className="st25 st26" />
        <text transform="translate(1369.664 815.866)" className="st25 st26" />
        <text
          transform="translate(1369.664 815.866)"
          className="st42 st30 st132"
        >
          {"City"}
        </text>
        <text transform="translate(1389.414 815.866)" className="st25 st26" />
        <text
          transform="translate(1369.664 827.266)"
          className="st42 st30 st132"
        >
          {"Thameslink"}
        </text>
        <text transform="translate(1426.494 827.266)" className="st25 st26" />
        <text transform="translate(1381.574 880.2)" className="st25 st26" />
        <text transform="translate(1381.574 880.2)" className="st42 st30 st132">
          {"St Paul's"}
        </text>
        <text transform="translate(1423.05 880.2)" className="st25 st26" />
        <text transform="translate(1448.332 1263.668)" className="st25 st26" />
        <text
          transform="translate(1448.332 1263.668)"
          className="st42 st30 st136"
        >
          {"Peckham"}
        </text>
        <text transform="translate(1493.69 1263.668)" className="st25 st26" />
        <text
          transform="translate(1475.962 1275.059)"
          className="st42 st30 st136"
        >
          {"Rye"}
        </text>
        <text transform="translate(1493.926 1275.059)" className="st25 st26" />
        <path
          className="st72"
          d="M1469.8 1274.9L1465.4 1272.9 1471.6 1272.9 1471.6 1271.6 1465.3 1271.6 1468.5 1270.1 1471.6 1270.1 1471.6 1268.8 1468.5 1268.8 1464.6 1267 1461.6 1267 1465.7 1268.8 1459.4 1268.8 1459.4 1270.1 1465.7 1270.1 1462.4 1271.6 1459.4 1271.6 1459.4 1272.9 1462.6 1272.9 1466.8 1274.9z"
        />
        <text transform="translate(1777.804 1257.66)" className="st25 st26" />
        <text
          transform="translate(1777.804 1257.66)"
          className="st42 st30 st134"
        >
          {"Deptford"}
        </text>
        <text transform="translate(1822.845 1257.66)" className="st25 st26" />
        <text transform="translate(1878.606 1259.281)" className="st25 st26" />
        <text
          transform="translate(1878.606 1259.281)"
          className="st42 st30 st136"
        >
          {"Greenwich"}
        </text>
        <text transform="translate(1931.736 1259.281)" className="st25 st26" />
        <path
          className="st72"
          d="M1950.4 1259.3L1946.1 1257.3 1952.2 1257.3 1952.2 1256.1 1945.9 1256.1 1949.1 1254.5 1952.2 1254.5 1952.2 1253.2 1949.1 1253.2 1945.2 1251.4 1942.2 1251.4 1946.4 1253.2 1940 1253.2 1940 1254.5 1946.4 1254.5 1943.1 1256.1 1940 1256.1 1940 1257.3 1943.3 1257.3 1947.5 1259.3z"
        />
        <g>
          <path
            className="st42"
            d="M2001.1 1229.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
          />
          <path
            className="st4"
            d="M2001.1 1245.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
          />
          <path
            className="st42"
            d="M1998.2 1240.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2001.2 1232.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
          />
          <path
            className="st42"
            d="M2001.9 1234.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
          />
          <text
            transform="translate(1976.342 1258.516)"
            className="st42 st30 st134"
          >
            {"Maze Hill"}
          </text>
        </g>
        <g>
          <path
            className="st42"
            d="M2037.6 1229.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6"
          />
          <path
            className="st4"
            d="M2037.6 1245.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
          />
          <path
            className="st42"
            d="M2034.7 1240.2c.4 1.3 1.7 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2037.7 1232.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
          />
          <path
            className="st42"
            d="M2038.4 1234.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
          />
          <text
            transform="translate(2008.326 1213.424)"
            className="st25 st26"
          />
          <text
            transform="translate(2008.326 1213.424)"
            className="st42 st30 st134"
          >
            {"Westcombe"}
          </text>
          <text
            transform="translate(2066.863 1213.424)"
            className="st25 st26"
          />
          <text
            transform="translate(2026.716 1224.445)"
            className="st42 st30 st134"
          >
            {"Park"}
          </text>
          <text
            transform="translate(2049.013 1224.445)"
            className="st25 st26"
          />
        </g>
        <g>
          <path
            className="st42"
            d="M2071.9 1229.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6s3.9-8.6 8.6-8.6"
          />
          <path
            className="st4"
            d="M2071.9 1245.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.5 7.7-7.7 7.7"
          />
          <path
            className="st42"
            d="M2069 1240.2c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2072 1232.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
          />
          <path
            className="st42"
            d="M2072.7 1234.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
          />
          <text
            transform="translate(2049.107 1258.516)"
            className="st25 st26"
          />
          <text
            transform="translate(2049.107 1258.516)"
            className="st42 st30 st134"
          >
            {"Charlton"}
          </text>
          <text
            transform="translate(2092.582 1258.516)"
            className="st25 st26"
          />
          <path
            className="st72"
            d="M2076.8 1269.3L2072.4 1267.3 2078.6 1267.3 2078.6 1266 2072.2 1266 2075.5 1264.5 2078.6 1264.5 2078.6 1263.2 2075.5 1263.2 2071.5 1261.4 2068.6 1261.4 2072.7 1263.2 2066.4 1263.2 2066.4 1264.5 2072.7 1264.5 2069.4 1266 2066.4 1266 2066.4 1267.3 2069.6 1267.3 2073.8 1269.3z"
          />
        </g>
        <text transform="translate(2382.314 1256.72)" className="st25 st26" />
        <text
          transform="translate(2382.314 1256.72)"
          className="st42 st30 st134"
        >
          {"Slade Green"}
        </text>
        <text transform="translate(2441.932 1256.72)" className="st25 st26" />
        <path
          className="st72"
          d="M2456.7 1215.8L2452.4 1213.9 2458.5 1213.9 2458.5 1212.6 2452.2 1212.6 2455.4 1211 2458.5 1211 2458.5 1209.8 2455.4 1209.8 2451.5 1207.9 2448.5 1207.9 2452.6 1209.8 2446.3 1209.8 2446.3 1211 2452.6 1211 2449.3 1212.6 2446.3 1212.6 2446.3 1213.9 2449.6 1213.9 2453.8 1215.8z"
        />
        <path
          className="st72"
          d="M2400.6 1278.8L2396.3 1276.9 2402.4 1276.9 2402.4 1275.6 2396.1 1275.6 2399.3 1274.1 2402.4 1274.1 2402.4 1272.8 2399.3 1272.8 2395.4 1271 2392.4 1271 2396.5 1272.8 2390.2 1272.8 2390.2 1274.1 2396.5 1274.1 2393.2 1275.6 2390.2 1275.6 2390.2 1276.9 2393.5 1276.9 2397.6 1278.8z"
        />
        <g>
          <path
            className="st42"
            d="M2212.1 1229.2c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6-4.7 0-8.6-3.8-8.6-8.6.1-4.8 3.9-8.6 8.6-8.6"
          />
          <path
            className="st4"
            d="M2212.1 1245.4c-4.2 0-7.7-3.4-7.7-7.7 0-4.2 3.4-7.7 7.7-7.7 4.2 0 7.7 3.4 7.7 7.7 0 4.3-3.4 7.7-7.7 7.7"
          />
          <path
            className="st42"
            d="M2209.2 1240.2c.4 1.3 1.6 2.3 3.1 2.3 1.8 0 3.3-1.5 3.3-3.3 0-.9-.4-1.8-1.1-2.4l.2-1.4c1.3.8 2.1 2.2 2.1 3.8 0 2.5-2 4.5-4.5 4.5-1.6 0-3-.8-3.8-2.1l.7-1.4zM2212.2 1232.1c0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
          />
          <path
            className="st42"
            d="M2212.9 1234.3l-.1.9h-2.7s-.6.1-.6.6c0 .6.6.6.6.6h2.6l-.1.8h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 3.9s-.2.5.3.8c.6.3.9-.3.9-.3l1.5-3.1s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.4s0-.7-.8-.8c-.6.1-.8.7-.8.7"
          />
        </g>
        <path
          className="st72"
          d="M2269.1 1225.5L2264.7 1223.6 2270.9 1223.6 2270.9 1222.3 2264.5 1222.3 2267.8 1220.7 2270.9 1220.7 2270.9 1219.5 2267.8 1219.5 2263.8 1217.7 2260.9 1217.7 2265 1219.5 2258.6 1219.5 2258.6 1220.7 2265 1220.7 2261.7 1222.3 2258.6 1222.3 2258.6 1223.6 2261.9 1223.6 2266.1 1225.5z"
        />
        <path
          className="st72"
          d="M2135.7 1224.9L2131.3 1223 2137.5 1223 2137.5 1221.7 2131.2 1221.7 2134.4 1220.1 2137.5 1220.1 2137.5 1218.9 2134.4 1218.9 2130.4 1217.1 2127.5 1217.1 2131.6 1218.9 2125.3 1218.9 2125.3 1220.1 2131.6 1220.1 2128.3 1221.7 2125.3 1221.7 2125.3 1223 2128.5 1223 2132.7 1224.9z"
        />
        <text
          transform="translate(1774.85 1314.315)"
          className="st42 st30 st124"
        >
          {"Nunhead"}
        </text>
        <path
          className="st72"
          d="M1930.7 1402.3L1926.4 1400.4 1932.5 1400.4 1932.5 1399.1 1926.2 1399.1 1929.4 1397.6 1932.5 1397.6 1932.5 1396.3 1929.4 1396.3 1925.5 1394.5 1922.5 1394.5 1926.7 1396.3 1920.3 1396.3 1920.3 1397.6 1926.7 1397.6 1923.3 1399.1 1920.3 1399.1 1920.3 1400.4 1923.6 1400.4 1927.8 1402.3z"
        />
        <text transform="translate(1905.54 1390.672)" className="st25 st26" />
        <text
          transform="translate(1905.54 1390.672)"
          className="st42 st30 st134"
        >
          {"Catford"}
        </text>
        <text transform="translate(1943.073 1390.672)" className="st25 st26" />
        <text transform="translate(1834.195 1391.505)" className="st25 st26" />
        <text
          transform="translate(1834.195 1391.505)"
          className="st42 st30 st134"
        >
          {"Crofton"}
        </text>
        <text transform="translate(1872.482 1391.505)" className="st25 st26" />
        <text
          transform="translate(1834.195 1402.905)"
          className="st42 st30 st134"
        >
          {"Park"}
        </text>
        <text transform="translate(1856.492 1402.905)" className="st25 st26" />
        <path
          className="st72"
          d="M1838.8 1314.6L1834.5 1312.7 1840.7 1312.7 1840.7 1311.4 1834.3 1311.4 1837.5 1309.8 1840.7 1309.8 1840.7 1308.6 1837.5 1308.6 1833.6 1306.8 1830.6 1306.8 1834.8 1308.6 1828.4 1308.6 1828.4 1309.8 1834.8 1309.8 1831.5 1311.4 1828.4 1311.4 1828.4 1312.7 1831.7 1312.7 1835.9 1314.6z"
        />
        <text transform="translate(2132.313 1388.597)" className="st25 st26" />
        <text
          transform="translate(2132.313 1388.597)"
          className="st42 st30 st134"
        >
          {"Ravensbourne"}
        </text>
        <text transform="translate(2203.38 1388.597)" className="st25 st26" />
        <text transform="translate(2089.94 1347.755)" className="st25 st26" />
        <text
          transform="translate(2089.94 1347.755)"
          className="st42 st30 st134"
        >
          {"Beckenham"}
        </text>
        <text transform="translate(2147.642 1347.755)" className="st25 st26" />
        <text
          transform="translate(2110.7 1359.515)"
          className="st42 st30 st134"
        >
          {"Hill"}
        </text>
        <text transform="translate(2126.95 1359.515)" className="st25 st26" />
        <text
          transform="translate(1965.131 1388.46)"
          className="st42 st30 st134"
        >
          {"Bellingham"}
        </text>
        <text transform="translate(2367.746 1347.698)" className="st25 st26" />
        <text
          transform="translate(2367.746 1347.698)"
          className="st42 st30 st134"
        >
          {"St Mary"}
        </text>
        <text transform="translate(2406.55 1347.698)" className="st25 st26" />
        <text
          transform="translate(2375.816 1359.458)"
          className="st42 st30 st134"
        >
          {"Cray"}
        </text>
        <text transform="translate(2398.065 1359.458)" className="st25 st26" />
        <path
          className="st72"
          d="M2335.6 1348.2L2331.3 1346.2 2337.4 1346.2 2337.4 1344.9 2331.1 1344.9 2334.3 1343.4 2337.4 1343.4 2337.4 1342.2 2334.3 1342.2 2330.4 1340.3 2327.4 1340.3 2331.6 1342.2 2325.2 1342.2 2325.2 1343.4 2331.6 1343.4 2328.2 1344.9 2325.2 1344.9 2325.2 1346.2 2328.5 1346.2 2332.7 1348.2z"
        />
        <text
          transform="translate(2312.59 1359.268)"
          className="st42 st30 st134"
        >
          {"Bickley"}
        </text>
        <text
          transform="translate(2425.097 1360.069)"
          className="st42 st30 st134"
        >
          {"Swanley"}
        </text>
        <g>
          <path
            id="XMLID_139_"
            className="st44"
            d="M2178.1 1239.2H2181.9V1244.8H2178.1z"
          />
          <text
            transform="translate(2153.548 1258.516)"
            className="st42 st30 st134"
          >
            {"Plumstead"}
          </text>
        </g>
        <path
          className="st72"
          d="M2222.9 1348.2L2218.5 1346.2 2224.7 1346.2 2224.7 1344.9 2218.4 1344.9 2221.6 1343.4 2224.7 1343.4 2224.7 1342.2 2221.6 1342.2 2217.6 1340.3 2214.7 1340.3 2218.8 1342.2 2212.5 1342.2 2212.5 1343.4 2218.8 1343.4 2215.5 1344.9 2212.5 1344.9 2212.5 1346.2 2215.7 1346.2 2219.9 1348.2z"
        />
        <text
          transform="translate(2188.632 1359.072)"
          className="st42 st30 st134"
        >
          {"Shortlands"}
        </text>
        <text transform="translate(2273.468 1390.902)" className="st25 st26" />
        <text
          transform="translate(2273.468 1390.902)"
          className="st42 st30 st134"
        >
          {"Bromley"}
        </text>
        <text transform="translate(2314.65 1390.902)" className="st25 st26" />
        <text
          transform="translate(2279.348 1401.922)"
          className="st42 st30 st134"
        >
          {"South"}
        </text>
        <text transform="translate(2309.07 1401.922)" className="st25 st26" />
        <text transform="translate(1388.147 150.362)" className="st25 st26" />
        <text
          transform="translate(1388.147 150.362)"
          className="st42 st30 st136"
        >
          {"New Barnet"}
        </text>
        <text transform="translate(1446.568 150.362)" className="st25 st26" />
        <text transform="translate(1379.148 197.54)" className="st25 st26" />
        <text
          transform="translate(1379.148 197.54)"
          className="st42 st30 st136"
        >
          {"Oakleigh Park"}
        </text>
        <text transform="translate(1448.28 197.54)" className="st25 st26" />
        <text transform="translate(1370.083 242.67)" className="st25 st26" />
        <text
          transform="translate(1370.083 242.67)"
          className="st42 st30 st136"
        >
          {"New Southgate"}
        </text>
        <text transform="translate(1447.386 242.67)" className="st25 st26" />
        <text
          id="XMLID_16_"
          transform="translate(1532.155 1705.56)"
          className="st42 st30 st136"
        >
          {"Coulsdon South"}
        </text>
        <text transform="translate(1257.493 1319.561)" className="st25 st26" />
        <text
          transform="translate(1257.493 1319.561)"
          className="st42 st30 st136"
        >
          {"Loughborough"}
        </text>
        <text transform="translate(1334.09 1319.561)" className="st25 st26" />
        <text
          transform="translate(1257.493 1330.581)"
          className="st42 st30 st136"
        >
          {"Junction"}
        </text>
        <text transform="translate(1299.042 1330.581)" className="st25 st26" />
        <text
          id="XMLID_8_"
          transform="translate(1259.744 1530.277)"
          className="st42 st30 st136"
        >
          {"Mitcham Eastfields"}
        </text>
        <text
          id="XMLID_13_"
          transform="translate(1257.913 1479.144)"
          className="st42 st30 st136"
        >
          {"Streatham"}
        </text>
        <text
          id="XMLID_12_"
          transform="translate(1153.416 1507.436)"
          className="st42 st30 st136"
        >
          {"Tooting"}
        </text>
        <text transform="translate(1024.671 1681.227)" className="st25 st26" />
        <text
          transform="translate(1024.671 1681.227)"
          className="st42 st30 st136"
        >
          {"West"}
        </text>
        <text transform="translate(1052.253 1681.227)" className="st25 st26" />
        <text
          transform="translate(1020.351 1692.247)"
          className="st42 st30 st136"
        >
          {"Sutton"}
        </text>
        <text transform="translate(1054.211 1692.247)" className="st25 st26" />
        <text transform="translate(1158.994 1678.936)" className="st25 st26" />
        <text transform="translate(1158.994 1678.936)" className="st25 st26" />
        <text
          transform="translate(1131.974 1689.956)"
          className="st42 st30 st136"
        >
          {"Carshalton"}
        </text>
        <text transform="translate(1186.01 1689.956)" className="st25 st26" />
        <text
          id="XMLID_9_"
          transform="translate(1232.186 1710.887)"
          className="st42 st30 st136"
        >
          {"Hackbridge"}
        </text>
        <text
          id="XMLID_15_"
          transform="translate(1078.342 1689.836)"
          className="st42 st30 st136"
        >
          {"Sutton"}
        </text>
        <text transform="translate(939.32 1491.228)" className="st25 st26" />
        <text
          transform="translate(939.32 1491.228)"
          className="st42 st30 st136"
        >
          {"Haydons"}
        </text>
        <text transform="translate(984.95 1491.228)" className="st25 st26" />
        <text transform="translate(957.4 1502.248)" className="st42 st30 st136">
          {"Road"}
        </text>
        <text transform="translate(982.302 1502.248)" className="st25 st26" />
        <text transform="translate(814.172 1575.58)" className="st25 st26" />
        <text
          transform="translate(814.172 1575.58)"
          className="st42 st30 st136"
        >
          {"South"}
        </text>
        <text transform="translate(846.527 1575.58)" className="st25 st26" />
        <text transform="translate(814.172 1586.6)" className="st42 st30 st136">
          {"Merton"}
        </text>
        <text transform="translate(851.724 1586.6)" className="st25 st26" />
        <text transform="translate(841.138 1602.747)" className="st25 st26" />
        <text
          transform="translate(841.138 1602.747)"
          className="st42 st30 st136"
        >
          {"Morden"}
        </text>
        <text transform="translate(882.699 1602.747)" className="st25 st26" />
        <text
          transform="translate(841.138 1613.767)"
          className="st42 st30 st136"
        >
          {"South"}
        </text>
        <text transform="translate(870.836 1613.767)" className="st25 st26" />
        <text
          id="XMLID_4_"
          transform="translate(884.41 1657.327)"
          className="st42 st30 st136"
        >
          {"St Helier (London)"}
        </text>
        <text transform="translate(909.71 1673.072)" className="st25 st26" />
        <text
          transform="translate(909.71 1673.072)"
          className="st42 st30 st136"
        >
          {"Sutton"}
        </text>
        <text transform="translate(946.227 1673.072)" className="st25 st26" />
        <text
          transform="translate(909.71 1684.092)"
          className="st42 st30 st136"
        >
          {"Common"}
        </text>
        <text transform="translate(954.916 1684.092)" className="st25 st26" />
        <text
          id="XMLID_2_"
          transform="translate(1681.702 1705.356)"
          className="st42 st30 st136"
        >
          {"Purley"}
        </text>
        <text transform="translate(2346.696 1399.84)" className="st25 st26" />
        <text
          transform="translate(2346.696 1399.84)"
          className="st42 st30 st136"
        >
          {"Petts"}
        </text>
        <text transform="translate(2375.1 1399.84)" className="st25 st26" />
        <text
          transform="translate(2343.226 1411.84)"
          className="st42 st30 st136"
        >
          {"Wood"}
        </text>
        <text transform="translate(2372.384 1411.84)" className="st25 st26" />
        <path
          className="st72"
          d="M1859.1 1618.9L1854.7 1617 1860.9 1617 1860.9 1615.7 1854.5 1615.7 1857.8 1614.1 1860.9 1614.1 1860.9 1612.9 1857.8 1612.9 1853.8 1611.1 1850.8 1611.1 1855 1612.9 1848.7 1612.9 1848.7 1614.1 1855 1614.1 1851.7 1615.7 1848.7 1615.7 1848.7 1617 1851.9 1617 1856.1 1618.9z"
        />
        <path
          className="st72"
          d="M1843.6 1700.5L1839.2 1698.5 1845.3 1698.5 1845.3 1697.2 1839 1697.2 1842.2 1695.7 1845.3 1695.7 1845.3 1694.4 1842.2 1694.4 1838.3 1692.6 1835.3 1692.6 1839.5 1694.4 1833.1 1694.4 1833.1 1695.7 1839.5 1695.7 1836.2 1697.2 1833.1 1697.2 1833.1 1698.5 1836.4 1698.5 1840.6 1700.5z"
        />
        <path
          className="st72"
          d="M1701.8 1717L1697.5 1715.1 1703.6 1715.1 1703.6 1713.8 1697.3 1713.8 1700.5 1712.2 1703.6 1712.2 1703.6 1710.9 1700.5 1710.9 1696.6 1709.1 1693.6 1709.1 1697.8 1710.9 1691.4 1710.9 1691.4 1712.2 1697.8 1712.2 1694.4 1713.8 1691.4 1713.8 1691.4 1715.1 1694.7 1715.1 1698.9 1717z"
        />
        <text transform="translate(1824.102 1618.61)" className="st25 st26" />
        <text
          transform="translate(1824.102 1618.61)"
          className="st42 st30 st135"
        >
          {"East"}
        </text>
        <text transform="translate(1845.244 1618.61)" className="st25 st26" />
        <text
          transform="translate(1824.102 1630.01)"
          className="st42 st30 st135"
        >
          {"Croydon"}
        </text>
        <text transform="translate(1865.997 1630.01)" className="st25 st26" />
        <g>
          <path
            className="st42"
            d="M2342.1 749.9c5.2 0 9.4 4.2 9.4 9.4s-4.2 9.4-9.4 9.4-9.4-4.2-9.4-9.4c.1-5.2 4.3-9.4 9.4-9.4"
          />
          <path
            className="st4"
            d="M2342.1 767.6c-4.6 0-8.4-3.8-8.4-8.4 0-4.6 3.8-8.4 8.4-8.4s8.4 3.8 8.4 8.4c.1 4.7-3.7 8.4-8.4 8.4"
          />
          <path
            className="st42"
            d="M2336.6 761.2l-1.9-2.6h1.9l1.2-1.5s.1 0 .2-.1.3-.1.3-.1h1.5v-.5h.7l.4-.9h.5l-.2.5.3.4h1.8v.5h3s.3 0 .4.2l.3.3.5 1.3h1.1l1 2.6s-1.2-.7-3.1-.6c-1.5.1-2.1.6-3.9.6-.9 0-2.4-.5-3.5-.5-.7-.2-2 .2-2.5.4m.9 1.2c.6-.2 1.5-.4 3.1-.1.8.2 1.5.3 2.2.3.9 0 1.4-.2 2.1-.3.6-.2 1.4-.3 1.9-.3 1 0 1.7.2 2.1.4l-.3-.8c-.8-.3-2.2-.4-3.8 0-.7.2-1.4.3-2.1.3-.6 0-1.3-.1-1.9-.2-2-.5-2.8-.1-3.8.1l.5.6zm0-3.9h1.9v-1.2h-.7s-.1 0-.3.1l-.3.3-.6.8zm4.8 0h1.9v-1.2h-1.9v1.2zm4.1-.9s-.1-.1-.1-.2c-.1-.1-.2-.1-.2-.1h-1.4v1.2h2l-.3-.9zm-6.5.9h2v-1.2h-2v1.2z"
          />
          <path
            transform="rotate(-45.001 2329.705 746.285)"
            d="M2327.8 744.4H2331.5V748.1H2327.8z"
          />
          <path
            transform="rotate(-45.001 2333.649 750.229)"
            d="M2331.8 748.3H2335.5V752H2331.8z"
          />
          <path
            className="st42"
            d="M2321.4 729.4c4.8 0 8.7 3.9 8.7 8.7 0 4.8-3.9 8.7-8.7 8.7-4.8 0-8.7-3.9-8.7-8.7-.1-4.8 3.8-8.7 8.7-8.7"
          />
          <path
            className="st4"
            d="M2318.4 740.6c.4 1.4 1.7 2.4 3.2 2.4 1.8 0 3.3-1.5 3.3-3.3 0-1-.4-1.8-1.1-2.4l.2-1.5c1.3.8 2.1 2.3 2.1 3.9 0 2.5-2.1 4.6-4.6 4.6-1.6 0-3.1-.9-3.9-2.2l.8-1.5zM2321.5 732.3c0 .7.6 1.3 1.3 1.3s1.3-.6 1.3-1.3c0-.7-.6-1.3-1.3-1.3-.7 0-1.3.6-1.3 1.3"
          />
          <path
            className="st4"
            d="M2322.2 734.6l-.1.9h-2.8s-.6.1-.6.6.6.6.6.6h2.6l-.1.9h-3.5s-.2 0-.4.1c-.1.1-.2.4-.2.4l-1.9 4s-.2.5.3.8c.6.3.9-.3.9-.3l1.6-3.2s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.2s.3 0 .6-.3.3-.5.3-.5l.5-3.5s0-.7-.8-.8c-.6.1-.8.7-.8.7"
          />
        </g>
        <text transform="translate(2266.832 747.828)" className="st25 st26" />
        <text
          transform="translate(2266.832 747.828)"
          className="st42 st30 st137"
        >
          {"Barking"}
        </text>
        <text transform="translate(2309.353 747.828)" className="st25 st26" />
        <text
          transform="translate(2262.942 758.728)"
          className="st42 st30 st137"
        >
          {"Riverside"}
        </text>
        <text transform="translate(2310.413 758.728)" className="st25 st26" />
      </g>
      <g id="Not_Stations">
        <text
          transform="translate(1520.827 940.276)"
          className="st42 st30"
          fontSize="6.9638px"
        >
          {"Fenchurch Street"}
        </text>
        <text transform="translate(2124.32 937.874)" className="st25 st26" />
        <text
          transform="translate(2124.32 937.874)"
          className="st42 st30 st128"
        >
          {"Royal"}
        </text>
        <text transform="translate(2153.86 937.874)" className="st25 st26" />
        <text
          transform="translate(2124.32 948.923)"
          className="st42 st30 st128"
        >
          {"Docks"}
        </text>
        <text transform="translate(2154.236 948.923)" className="st25 st26" />
        <text transform="translate(1994.327 1026.236)" className="st25 st26" />
        <text
          transform="translate(1994.327 1026.236)"
          className="st42 st30 st128"
        >
          {"Greenwich"}
        </text>
        <text transform="translate(2047.51 1026.236)" className="st25 st26" />
        <text
          transform="translate(1994.327 1037.286)"
          className="st42 st30 st128"
        >
          {"Peninsula"}
        </text>
        <text transform="translate(2042.403 1037.286)" className="st25 st26" />
        <g>
          <text transform="translate(2229.528 1607.37)" className="st25 st26" />
          <text
            transform="translate(2229.528 1607.37)"
            className="st33 st30 st35"
          >
            {"London Trams"}
          </text>
          <text transform="translate(2344.182 1607.37)" className="st25 st26" />
          <text
            transform="translate(2249.028 1625.52)"
            className="st33 st30 st35"
          >
            {"fare zone"}
          </text>
          <text transform="translate(2323.725 1625.52)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(1028.213 76.527)" className="st25 st26" />
          <text
            transform="translate(1028.213 76.527)"
            className="st42 st30 st134"
          >
            {"T"}
          </text>
          <text transform="translate(1034.13 76.527)" className="st25 st26" />
          <text
            transform="translate(1033.383 76.527)"
            className="st42 st30 st134"
          >
            {"ow"}
          </text>
          <text transform="translate(1048.302 76.527)" className="st25 st26" />
          <text
            transform="translate(1048.123 76.527)"
            className="st42 st30 st134"
          >
            {"a"}
          </text>
          <text transform="translate(1053.947 76.527)" className="st25 st26" />
          <text
            transform="translate(1053.943 76.527)"
            className="st42 st30 st134"
          >
            {"r"}
          </text>
          <text transform="translate(1058.39 76.527)" className="st25 st26" />
          <text
            transform="translate(1058.273 76.527)"
            className="st42 st30 st134"
          >
            {"ds"}
          </text>
          <text transform="translate(1069.58 76.527)" className="st25 st26" />
          <text transform="translate(1028.213 87.575)" className="st25 st26" />
          <text
            transform="translate(1028.213 87.575)"
            className="st42 st30 st134"
          >
            {"St Albans City and"}
          </text>
          <text transform="translate(1121.082 87.575)" className="st25 st26" />
          <text
            transform="translate(1028.213 98.575)"
            className="st42 st30 st134"
          >
            {"Luton Airport Parkway"}
          </text>
          <text transform="translate(1141.331 98.575)" className="st25 st26" />
        </g>
        <g>
          <text
            transform="translate(2442.965 1260.128)"
            className="st25 st26"
          />
          <text
            transform="translate(2442.965 1260.128)"
            className="st42 st30 st134"
          >
            {"T"}
          </text>
          <text
            transform="translate(2448.883 1260.128)"
            className="st25 st26"
          />
          <text
            transform="translate(2448.135 1260.128)"
            className="st42 st30 st134"
          >
            {"ow"}
          </text>
          <text
            transform="translate(2463.054 1260.128)"
            className="st25 st26"
          />
          <text
            transform="translate(2462.874 1260.128)"
            className="st42 st30 st134"
          >
            {"a"}
          </text>
          <text
            transform="translate(2468.699 1260.128)"
            className="st25 st26"
          />
          <text
            transform="translate(2468.695 1260.128)"
            className="st42 st30 st134"
          >
            {"r"}
          </text>
          <text
            transform="translate(2473.142 1260.128)"
            className="st25 st26"
          />
          <text
            transform="translate(2473.035 1260.128)"
            className="st42 st30 st134"
          >
            {"ds"}
          </text>
          <text
            transform="translate(2484.342 1260.128)"
            className="st25 st26"
          />
          <text
            transform="translate(2431.246 1271.175)"
            className="st25 st26"
          />
          <text
            transform="translate(2431.246 1271.175)"
            className="st42 st30 st134"
          >
            {"Gra"}
          </text>
          <text transform="translate(2448.66 1271.175)" className="st25 st26" />
          <text
            transform="translate(2448.836 1271.175)"
            className="st42 st30 st134"
          >
            {"v"}
          </text>
          <text
            transform="translate(2454.448 1271.175)"
            className="st25 st26"
          />
          <text
            transform="translate(2454.346 1271.175)"
            className="st42 st30 st134"
          >
            {"esend"}
          </text>
          <text
            transform="translate(2483.973 1271.175)"
            className="st25 st26"
          />
        </g>
        <g>
          <text transform="translate(2442.963 1393.92)" className="st25 st26" />
          <text
            transform="translate(2442.963 1393.92)"
            className="st42 st30 st134"
          >
            {"T"}
          </text>
          <text transform="translate(2448.88 1393.92)" className="st25 st26" />
          <text
            transform="translate(2448.133 1393.92)"
            className="st42 st30 st134"
          >
            {"ow"}
          </text>
          <text transform="translate(2463.052 1393.92)" className="st25 st26" />
          <text
            transform="translate(2462.873 1393.92)"
            className="st42 st30 st134"
          >
            {"a"}
          </text>
          <text transform="translate(2468.697 1393.92)" className="st25 st26" />
          <text
            transform="translate(2468.693 1393.92)"
            className="st42 st30 st134"
          >
            {"r"}
          </text>
          <text transform="translate(2473.14 1393.92)" className="st25 st26" />
          <text
            transform="translate(2473.033 1393.92)"
            className="st42 st30 st134"
          >
            {"ds"}
          </text>
          <text transform="translate(2484.34 1393.92)" className="st25 st26" />
          <text
            transform="translate(2431.574 1404.968)"
            className="st25 st26"
          />
          <text
            transform="translate(2431.574 1404.968)"
            className="st42 st30 st134"
          >
            {"Se"}
          </text>
          <text
            transform="translate(2443.622 1404.968)"
            className="st25 st26"
          />
          <text
            transform="translate(2443.624 1404.968)"
            className="st42 st30 st134"
          >
            {"v"}
          </text>
          <text
            transform="translate(2449.236 1404.968)"
            className="st25 st26"
          />
          <text
            transform="translate(2449.134 1404.968)"
            className="st42 st30 st134"
          >
            {"enoaks"}
          </text>
          <text
            transform="translate(2484.385 1404.968)"
            className="st25 st26"
          />
        </g>
        <g>
          <text transform="translate(1480.533 76.677)" className="st25 st26" />
          <text
            transform="translate(1480.533 76.677)"
            className="st42 st30 st134"
          >
            {"T"}
          </text>
          <text transform="translate(1486.451 76.677)" className="st25 st26" />
          <text
            transform="translate(1485.703 76.677)"
            className="st42 st30 st134"
          >
            {"ow"}
          </text>
          <text transform="translate(1500.622 76.677)" className="st25 st26" />
          <text
            transform="translate(1500.443 76.677)"
            className="st42 st30 st134"
          >
            {"a"}
          </text>
          <text transform="translate(1506.267 76.677)" className="st25 st26" />
          <text
            transform="translate(1506.263 76.677)"
            className="st42 st30 st134"
          >
            {"r"}
          </text>
          <text transform="translate(1510.71 76.677)" className="st25 st26" />
          <text
            transform="translate(1510.603 76.677)"
            className="st42 st30 st134"
          >
            {"ds"}
          </text>
          <text transform="translate(1524.57 76.677)" className="st25 st26" />
          <text
            transform="translate(1480.533 87.697)"
            className="st42 st30 st134"
          >
            {"Welwyn"}
          </text>
          <text transform="translate(1522.573 87.697)" className="st25 st26" />
          <text
            transform="translate(1480.533 98.717)"
            className="st42 st30 st134"
          >
            {"Garden"}
          </text>
          <text transform="translate(1519.231 98.717)" className="st25 st26" />
          <text
            transform="translate(1480.533 109.747)"
            className="st42 st30 st134"
          >
            {"City"}
          </text>
          <text transform="translate(1500.3 109.747)" className="st25 st26" />
        </g>
        <g>
          <text transform="translate(1438.68 1743.228)" className="st25 st26" />
          <text
            transform="translate(1438.68 1743.228)"
            className="st42 st30 st134"
          >
            {"T"}
          </text>
          <text
            transform="translate(1444.598 1743.228)"
            className="st25 st26"
          />
          <text
            transform="translate(1443.83 1743.228)"
            className="st42 st30 st134"
          >
            {"ow"}
          </text>
          <text
            transform="translate(1458.749 1743.228)"
            className="st25 st26"
          />
          <text
            transform="translate(1458.58 1743.228)"
            className="st42 st30 st134"
          >
            {"a"}
          </text>
          <text
            transform="translate(1464.404 1743.228)"
            className="st25 st26"
          />
          <text
            transform="translate(1464.4 1743.228)"
            className="st42 st30 st134"
          >
            {"r"}
          </text>
          <text
            transform="translate(1468.847 1743.228)"
            className="st25 st26"
          />
          <text
            transform="translate(1468.73 1743.228)"
            className="st42 st30 st134"
          >
            {"ds"}
          </text>
          <text
            transform="translate(1480.036 1743.228)"
            className="st25 st26"
          />
          <text
            transform="translate(1437.727 1754.277)"
            className="st42 st30 st134"
          >
            {"Gatwick Airport"}
          </text>
        </g>
      </g>
      <path
        className="st36"
        id="Keys"
        d="M2025.7 1538.9H2183.1V1696.2H2025.7z"
      />
      <g id="Layer_61">
        <path className="st4" d="M2495.6 0H2584.7999999999997V1794.3H2495.6z" />
        <path className="st4" d="M0 0H2495.4V37.9H0z" />
        <path className="st4" d="M0 1761.3H2499.6V1861H0z" />
        <path className="st4" d="M0 0H35.2V1794.3H0z" />
        <path className="st4" d="M31.2 1414H768.5V1767.7H31.2z" />
        <path className="st4" d="M970 1767L707.7 1734.8 767.3 1561.7z" />
      </g>
      <g id="Key_information_Existing">
        <path
          className="st42"
          d="M54.3 1726.9c0-2.9 2.3-5.3 5.3-5.3 2.9 0 5.3 2.4 5.3 5.3s-2.3 5.3-5.2 5.3c-3 0-5.4-2.4-5.4-5.3zm9.6 0c0-2.4-1.9-4.3-4.3-4.3s-4.4 1.9-4.4 4.3 2 4.4 4.4 4.4c2.4 0 4.3-2 4.3-4.4zm-2.9-1.1c0-.8-.4-1.3-1.3-1.3-1.2 0-1.7 1-1.7 2.5s.5 2.5 1.7 2.5c.8 0 1.3-.5 1.3-1.4h1.2c0 1.4-1.1 2.3-2.5 2.3-2 0-2.9-1.4-2.9-3.3s.9-3.4 3-3.4c1.3 0 2.3.8 2.4 2.2l-1.2-.1z"
        />
        <text
          transform="translate(65.208 1731.977)"
          className="st42 st30"
          fontSize="14.0253px"
        >
          {"Transport for London August 2022 338785-A01"}
        </text>
        <path className="st4" d="M52.2 1413.4H606.4000000000001V1707.9H52.2z" />
        <path className="st140" d="M56.5 1413.4L641.8 1413.4" />
        <path className="st140" d="M56.5 1707.8L641.8 1707.8" />
        <text
          transform="translate(92.635 1440.977)"
          className="st42 st30 st141"
        >
          {"Key to symbols"}
        </text>
        <text transform="translate(424.206 1441)" className="st42 st30 st141">
          {"Explanation of zones"}
        </text>
        <path className="st116" d="M425 1629.3H630.4V1657.7H425z" />
        <path className="st116" d="M425 1469.9H630.4V1493.5H425z" />
        <path className="st116" d="M425 1519.4H630.4V1550.3000000000002H425z" />
        <path className="st142" d="M472 1677.7L467.4 1677.7" />
        <path className="st116" d="M425 1571.7H630.4V1598.4H425z" />
        <path className="st143" d="M470.5 1593.8H590.8V1606.6H470.5z" />
        <path className="st36" d="M440 1668.7H447.6V1685.4H440z" />
        <text transform="translate(442.5 1681.176)" className="st42 st30 st144">
          {"1"}
        </text>
        <path className="st36" d="M440 1605.1H447.6V1621.8H440z" />
        <text
          transform="translate(440.974 1617.58)"
          className="st42 st30 st144"
        >
          {"3"}
        </text>
        <path className="st36" d="M440 1576.6H448.2V1593.3H440z" />
        <text
          transform="translate(440.872 1589.067)"
          className="st42 st30 st144"
        >
          {"4"}
        </text>
        <path className="st36" d="M440 1552.9H447.6V1569.6000000000001H440z" />
        <text transform="translate(440.6 1565.404)" className="st42 st30 st144">
          {"5"}
        </text>
        <path className="st36" d="M440 1526.7H447.6V1543.4H440z" />
        <text
          transform="translate(440.466 1539.253)"
          className="st42 st30 st144"
        >
          {"6"}
        </text>
        <path className="st36" d="M440 1635.3H447.6V1652H440z" />
        <text
          transform="translate(441.081 1647.82)"
          className="st42 st30 st144"
        >
          {"2"}
        </text>
        <path className="st142" d="M472 1638.2L467.4 1638.2" />
        <path className="st142" d="M472 1618.5L467.4 1618.5" />
        <path className="st142" d="M472 1578.9L467.4 1578.9" />
        <path className="st142" d="M472 1559.2L467.4 1559.2" />
        <path className="st142" d="M472 1539.4L467.4 1539.4" />
        <path className="st36" d="M434 1498.2H453.4V1514.9H434z" />
        <text
          transform="translate(440.392 1510.764)"
          className="st42 st30 st144"
        >
          {"7"}
        </text>
        <path className="st142" d="M472 1499.9L467.4 1499.9" />
        <path className="st36" d="M434.8 1473.6H452.6V1490.3H434.8z" />
        <text transform="translate(440.283 1486.1)" className="st42 st30 st144">
          {"8"}
        </text>
        <path className="st142" d="M472 1480.2L467.4 1480.2" />
        <path className="st36" d="M434 1452.2H453.4V1468.9H434z" />
        <text
          transform="translate(440.197 1464.682)"
          className="st42 st30 st144"
        >
          {"9"}
        </text>
        <path className="st142" d="M472 1598.7L467.4 1598.7" />
        <path className="st142" d="M472 1460.4L467.4 1460.4" />
        <path className="st142" d="M467.4 1460.4L462.8 1460.4" />
        <text
          transform="translate(477.934 1602.983)"
          className="st42 st30 st145"
        >
          {"Station in both zones"}
        </text>
        <path
          className="st143"
          d="M470.5 1514.1H590.8V1526.8999999999999H470.5z"
        />
        <text
          transform="translate(477.934 1524.154)"
          className="st42 st30 st145"
        >
          {"Station in both zones"}
        </text>
        <path className="st143" d="M470.5 1652.9H593.6V1665.7H470.5z" />
        <text
          transform="translate(477.934 1662.104)"
          className="st42 st30 st145"
        >
          {"Station in both zones"}
        </text>
        <path
          fill="none"
          stroke="#79004c"
          strokeWidth={3.7863}
          strokeLinejoin="round"
          strokeMiterlimit={3.8636}
          d="M467.4 1461.2L467.4 1688.7"
        />
        <path className="st142" d="M472 1658L467.4 1658" />
        <text transform="translate(478.2 1465.033)" className="st25 st26" />
        <text transform="translate(478.2 1465.033)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1465.033)" className="st25 st26" />
        <text
          transform="translate(551.52 1465.033)"
          className="st42 st30 st145"
        >
          {"9"}
        </text>
        <text transform="translate(557.263 1465.033)" className="st25 st26" />
        <text transform="translate(478.2 1543.862)" className="st25 st26" />
        <text transform="translate(478.2 1543.862)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1543.862)" className="st25 st26" />
        <text
          transform="translate(551.52 1543.862)"
          className="st42 st30 st145"
        >
          {"6"}
        </text>
        <text transform="translate(557.34 1543.862)" className="st25 st26" />
        <text transform="translate(478.2 1563.568)" className="st25 st26" />
        <text transform="translate(478.2 1563.568)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1563.568)" className="st25 st26" />
        <text
          transform="translate(551.52 1563.568)"
          className="st42 st30 st145"
        >
          {"5"}
        </text>
        <text transform="translate(557.23 1563.568)" className="st25 st26" />
        <text transform="translate(478.2 1622.69)" className="st25 st26" />
        <text transform="translate(478.2 1622.69)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1622.69)" className="st25 st26" />
        <text transform="translate(551.52 1622.69)" className="st42 st30 st145">
          {"3"}
        </text>
        <text transform="translate(556.923 1622.69)" className="st25 st26" />
        <text transform="translate(478.2 1642.397)" className="st25 st26" />
        <text transform="translate(478.2 1642.397)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1642.397)" className="st25 st26" />
        <text
          transform="translate(551.52 1642.397)"
          className="st42 st30 st145"
        >
          {"2"}
        </text>
        <text transform="translate(556.836 1642.397)" className="st25 st26" />
        <text transform="translate(478.2 1681.812)" className="st25 st26" />
        <text transform="translate(478.2 1681.812)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1681.812)" className="st25 st26" />
        <text
          transform="translate(551.52 1681.812)"
          className="st42 st30 st145"
        >
          {"1"}
        </text>
        <text transform="translate(555.674 1681.812)" className="st25 st26" />
        <text transform="translate(478.2 1583.276)" className="st25 st26" />
        <text transform="translate(478.2 1583.276)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1583.276)" className="st25 st26" />
        <text
          transform="translate(551.52 1583.276)"
          className="st42 st30 st145"
        >
          {"4"}
        </text>
        <text transform="translate(557.472 1583.276)" className="st25 st26" />
        <text transform="translate(478.2 1484.74)" className="st25 st26" />
        <text transform="translate(478.2 1484.74)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1484.74)" className="st25 st26" />
        <text transform="translate(551.52 1484.74)" className="st42 st30 st145">
          {"8"}
        </text>
        <text transform="translate(557.11 1484.74)" className="st25 st26" />
        <text transform="translate(478.2 1504.448)" className="st25 st26" />
        <text transform="translate(478.2 1504.448)" className="st42 st30 st145">
          {"Station in Zone"}
        </text>
        <text transform="translate(551.577 1504.448)" className="st25 st26" />
        <text
          transform="translate(551.52 1504.448)"
          className="st42 st30 st145"
        >
          {"7"}
        </text>
        <text transform="translate(556.945 1504.448)" className="st25 st26" />
        <path className="st142" d="M472 1519.7L467.4 1519.7" />
        <text
          transform="translate(120.698 1588.119)"
          className="st42 st30 st147"
        >
          {"National Rail interchange"}
        </text>
        <path
          className="st72"
          d="M105.6 1588.3L100.2 1585.9 107.9 1585.9 107.9 1584.3 100 1584.3 104 1582.3 107.9 1582.3 107.9 1580.8 104 1580.8 99.1 1578.5 95.4 1578.5 100.6 1580.8 92.6 1580.8 92.6 1582.3 100.6 1582.3 96.4 1584.3 92.6 1584.3 92.6 1585.9 96.7 1585.9 101.9 1588.3z"
        />
        <text
          transform="translate(120.698 1612.547)"
          className="st42 st30 st147"
        >
          {"River services interchange"}
        </text>
        <text
          transform="translate(328.984 1588.24)"
          className="st42 st30 st147"
        >
          {"Airport"}
        </text>
        <path
          className="st42"
          d="M309.2 1576.3c.6 0 .8.9.8 1.5v3.8l5.2 3.9c.2.1.8.6.9.7.2.2.1.6.1.8v.4l-5.1-2c-.2-.1-.5-.1-.7-.1-.6 0-.5.7-.5 1.1v2l1.7 1.2.1 1-2.3-.6h-.4l-2.3.6.2-1 1.7-1.2v-2c0-.4.1-1.1-.5-1.1-.2 0-.5.1-.7.1l-5 2v-.4c0-.2 0-.6.1-.8.1-.1.8-.6.9-.7l5.2-3.9.1-3.8c-.1-.6.1-1.5.5-1.5z"
        />
        <text transform="translate(120.698 1563.927)" className="st25 st26" />
        <text
          transform="translate(120.698 1563.927)"
          className="st42 st30 st148"
        >
          {"Step-free"}
        </text>
        <text transform="translate(175.202 1563.927)" className="st25 st26" />
        <text transform="translate(175.827 1563.927)" className="st25 st26" />
        <text
          transform="translate(178.007 1563.927)"
          className="st42 st30 st148"
        >
          {"access"}
        </text>
        <text transform="translate(215.31 1563.927)" className="st25 st26" />
        <text transform="translate(216.088 1563.927)" className="st25 st26" />
        <text
          transform="translate(218.257 1563.927)"
          className="st42 st30 st148"
        >
          {"from"}
        </text>
        <text transform="translate(246.988 1563.927)" className="st25 st26" />
        <text transform="translate(247.548 1563.927)" className="st25 st26" />
        <text
          transform="translate(249.727 1563.927)"
          className="st42 st30 st148"
        >
          {"street"}
        </text>
        <text transform="translate(284.953 1563.927)" className="st25 st26" />
        <text transform="translate(285.298 1563.927)" className="st25 st26" />
        <text
          transform="translate(287.467 1563.927)"
          className="st42 st30 st148"
        >
          {"to"}
        </text>
        <text transform="translate(300.222 1563.927)" className="st25 st26" />
        <text transform="translate(300.228 1563.927)" className="st25 st26" />
        <text
          transform="translate(302.397 1563.927)"
          className="st42 st30 st148"
        >
          {"platform"}
        </text>
        <text transform="translate(354.49 1563.927)" className="st25 st26" />
        <g>
          <path
            className="st42"
            d="M101.1 1549.7c5.1 0 9.2 4.1 9.2 9.1 0 5.1-4.1 9.1-9.2 9.1s-9.1-4.1-9.1-9.1 4.1-9.1 9.1-9.1z"
          />
          <path
            className="st4"
            d="M101.1 1567.1c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2z"
          />
          <g>
            <path
              className="st42"
              d="M98 1561.6c.4 1.4 1.8 2.5 3.3 2.5 1.9 0 3.5-1.6 3.5-3.5 0-1-.4-1.9-1.1-2.6l.2-1.5c1.3.8 2.2 2.4 2.2 4.1 0 2.7-2.2 4.8-4.8 4.8-1.7 0-3.2-.9-4.1-2.3l.8-1.5zM101.3 1552.8c0 .8.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
            />
            <path
              className="st42"
              d="M102 1555.2l-.1.9H99s-.6.1-.6.7.6.7.6.7h2.7l-.1.9h-3.7s-.2 0-.4.2c-.1.1-.2.4-.2.4l-2.1 4.2s-.2.6.4.9c.6.3 1-.3 1-.3l1.6-3.3s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.4s.3 0 .6-.3.3-.6.3-.6l.5-3.7s0-.8-.8-.8c-.6-.1-.8.5-.8.5z"
            />
          </g>
        </g>
        <g>
          <path
            className="st42"
            d="M101.1 1598.2c5.1 0 9.2 4.1 9.2 9.1 0 5.1-4.1 9.1-9.2 9.1s-9.1-4.1-9.1-9.1 4.1-9.1 9.1-9.1z"
          />
          <path
            className="st4"
            d="M101.1 1615.6c-4.5 0-8.2-3.7-8.2-8.2 0-4.5 3.7-8.2 8.2-8.2 4.5 0 8.2 3.7 8.2 8.2 0 4.5-3.7 8.2-8.2 8.2z"
          />
          <path
            className="st42"
            d="M95.8 1609.2l-1.9-2.6h1.9l1.2-1.5s.1-.1.2-.1c.1-.1.3-.1.3-.1H99v-.5h.7l.4-.9h.5l-.2.5.3.4h1.8v.5h2.9s.3 0 .4.1c.2.2.2.3.2.3l.5 1.2h1.1l1 2.6s-1.1-.7-3-.6c-1.5.1-2.1.6-3.8.6-.9 0-2.3-.4-3.4-.5-1 .1-2.2.5-2.6.6zm.8 1.2c.6-.2 1.5-.4 3-.1.7.2 1.4.3 2.1.3.9 0 1.4-.2 2.1-.3.6-.2 1.3-.3 1.9-.3 1 0 1.7.2 2.1.3l-.3-.8c-.8-.3-2.2-.4-3.7 0-.7.2-1.3.3-2 .3-.6 0-1.2-.1-1.8-.2-2-.5-2.7-.1-3.7.1l.3.7zm0-3.7h1.8v-1.1h-.7s-.1 0-.3.1l-.3.3-.5.7zm4.6 0h1.9v-1.1h-1.9v1.1zm4.1-.9s-.1-.1-.1-.2c-.1-.1-.2-.1-.2-.1h-1.3v1.1h2l-.4-.8zm-6.4.9h1.9v-1.1h-1.9v1.1zM73.6 1609.2l-1.9-2.6h1.9l1.2-1.5s.1-.1.2-.1c.1-.1.3-.1.3-.1h1.5v-.5h.7l.4-.9h.5l-.2.5.3.4h1.8v.5h2.9s.3 0 .4.1c.2.2.2.3.2.3l.5 1.2h1.1l1 2.6s-1.1-.7-3-.6c-1.5.1-2.1.6-3.8.6-.9 0-2.3-.4-3.4-.5-.9.1-2.1.5-2.6.6zm.9 1.2c.6-.2 1.5-.4 3-.1.7.2 1.4.3 2.1.3.9 0 1.4-.2 2.1-.3.6-.2 1.3-.3 1.9-.3 1 0 1.7.2 2.1.3l-.3-.8c-.8-.3-2.2-.4-3.7 0-.7.2-1.3.3-2 .3-.6 0-1.2-.1-1.8-.2-2-.5-2.7-.1-3.7.1l.3.7zm-.1-3.7h1.8v-1.1h-.7s-.1 0-.3.1l-.3.3-.5.7zm4.8 0h1.9v-1.1h-1.9v1.1zm4-.9s-.1-.1-.1-.2c-.1-.1-.2-.1-.2-.1h-1.3v1.1h2l-.4-.8zm-6.4.9h1.9v-1.1h-1.9v1.1z"
          />
        </g>
        <g>
          <text
            transform="translate(120.698 1491.54)"
            className="st42 st30 st148"
          >
            {"Internal interchange"}
          </text>
        </g>
        <g>
          <path
            className="st42"
            d="M101.1 1525.9c5.1 0 9.2 4.1 9.2 9.2 0 5-4.1 9.1-9.2 9.1s-9.1-4.1-9.1-9.1c0-5.2 4.1-9.2 9.1-9.2z"
          />
          <path
            className="st4"
            d="M98 1537.7c.4 1.4 1.8 2.5 3.3 2.5 1.9 0 3.5-1.6 3.5-3.5 0-1-.4-1.9-1.1-2.6l.2-1.5c1.3.8 2.2 2.4 2.2 4.1 0 2.7-2.2 4.8-4.8 4.8-1.7 0-3.2-.9-4.1-2.3l.8-1.5zM101.3 1528.9c0 .8.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3s-.6-1.3-1.3-1.3c-.7 0-1.3.6-1.3 1.3z"
          />
          <path
            className="st4"
            d="M102 1531.3l-.1 1H99s-.6.1-.6.7.6.6.6.6h2.7l-.1.9h-3.7s-.2 0-.4.1c-.1.1-.2.4-.2.4l-2.1 4.2s-.2.5.4.8c.6.3 1-.3 1-.3l1.6-3.3s.1-.2.3-.3c.2-.1.3-.1.3-.1h3.4s.3 0 .6-.3.3-.6.3-.6l.5-3.7s0-.8-.8-.8c-.6.1-.8.7-.8.7z"
          />
          <g>
            <text
              transform="translate(120.698 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(120.698 1539.735)"
              className="st42 st30 st148"
            >
              {"Step-free"}
            </text>
            <text
              transform="translate(175.202 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(175.827 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(178.007 1539.735)"
              className="st42 st30 st148"
            >
              {"access"}
            </text>
            <text
              transform="translate(215.31 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(216.088 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(218.257 1539.735)"
              className="st42 st30 st148"
            >
              {"from"}
            </text>
            <text
              transform="translate(246.988 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(247.548 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(249.727 1539.735)"
              className="st42 st30 st148"
            >
              {"street"}
            </text>
            <text
              transform="translate(284.953 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(285.298 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(287.467 1539.735)"
              className="st42 st30 st148"
            >
              {"to"}
            </text>
            <text
              transform="translate(300.222 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(300.228 1539.735)"
              className="st25 st26"
            />
            <text
              transform="translate(302.397 1539.735)"
              className="st42 st30 st148"
            >
              {"train"}
            </text>
            <text
              transform="translate(330.667 1539.735)"
              className="st25 st26"
            />
          </g>
        </g>
        <g>
          <text
            transform="translate(120.698 1660.927)"
            className="st42 st30 st147"
          >
            {"London Cable Car"}
          </text>
        </g>
        <g>
          <text
            transform="translate(120.698 1636.736)"
            className="st42 st30"
            fontSize="13.9386px"
          >
            {"Victoria Coach Station"}
          </text>
          <text transform="translate(120.698 1685.12)" className="st25 st26" />
          <text
            transform="translate(120.698 1685.12)"
            className="st42 st30 st147"
          >
            {"Outside fare zones,"}
          </text>
          <text transform="translate(236.132 1685.12)" className="st25 st26" />
          <text
            transform="translate(120.698 1698.94)"
            className="st42 st30 st147"
          >
            {"Oyster not valid"}
          </text>
          <text transform="translate(215.08 1698.94)" className="st25 st26" />
          <g>
            <path
              className="st42"
              d="M91.4 1635.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5zm.8 0c0-.4.3-.7.7-.7s.7.3.7.7-.3.7-.7.7c-.4 0-.7-.3-.7-.7zM106.1 1635.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5zm.8 0c0-.4.3-.7.7-.7s.7.3.7.7-.3.7-.7.7c-.4 0-.7-.3-.7-.7zM109.7 1635.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5-.7-1.5-1.5-1.5-1.5.7-1.5 1.5zm.8 0c0-.4.3-.7.7-.7s.7.3.7.7-.3.7-.7.7c-.4 0-.7-.3-.7-.7z"
            />
            <path
              className="st42"
              d="M85.9 1630c0 .2.2.4.4.4s.4-.2.4-.4c0-.5.2-.9.3-1h1c-.8.9-1.6 2.1-1.7 3.8-.1 2.3 0 3.3 0 3.3H91c0-.1-.1-.3-.1-.4 0-1.1.8-1.9 1.9-1.9s1.9.8 1.9 1.9c0 .1 0 .3-.1.4h11c0-.1-.1-.3-.1-.4 0-1.1.8-1.9 1.9-1.9.8 0 1.5.5 1.8 1.2.3-.7 1-1.2 1.8-1.2 1 0 1.9.8 1.9 1.9 0 .1 0 .3-.1.4h.2s2.7-1.2 2.7-1.4v-5.6s-.1-.4-.5-1c-.6-.7-1.1-.7-1.1-.7H90s-.6.2-1.2.8h-2.2c-.1 0-.2 0-.3.1.1 0-.4.5-.4 1.7zm22.4-1.8h5.1s.5 0 .8.4c.3.4.2.8.2.8v2.2h-6.2v-3.4zm-6.6 0h5.8v3.4h-5.8v-3.4zm-7 0h6.2v3.4h-6.2v-3.4zm-4.4 0h3.6v3.4h-1.8s-3 1.3-3.6 1.4c-.8.1-1.5 0-1.5 0s.2-3.2 3.3-4.8z"
            />
          </g>
        </g>
        <g>
          <text
            transform="translate(120.698 1467.349)"
            className="st42 st30 st148"
          >
            {"Interchange stations"}
          </text>
        </g>
        <g>
          <path
            className="st4"
            d="M108.8 1462.8c0 4.2-3.4 7.6-7.6 7.6s-7.6-3.4-7.6-7.6 3.4-7.6 7.6-7.6c4.1-.1 7.6 3.4 7.6 7.6z"
          />
          <path d="M110.3 1462.8c0 5.1-4.1 9.2-9.2 9.2s-9.2-4.1-9.2-9.2 4.1-9.2 9.2-9.2 9.2 4.1 9.2 9.2zm-9.2 6.1c3.4 0 6.1-2.7 6.1-6.1s-2.7-6.1-6.1-6.1c-3.4 0-6.1 2.7-6.1 6.1 0 3.3 2.8 6.1 6.1 6.1z" />
        </g>
        <g>
          <text transform="translate(120.698 1515.544)" className="st25 st26" />
          <text
            transform="translate(120.698 1515.544)"
            className="st42 st30 st148"
          >
            {"Under"}
          </text>
          <text transform="translate(157.261 1515.544)" className="st25 st26" />
          <text
            transform="translate(157.257 1515.544)"
            className="st42 st30 st148"
          >
            {"a 1"}
          </text>
          <text transform="translate(175.742 1515.544)" className="st25 st26" />
          <text
            transform="translate(171.847 1515.544)"
            className="st42 st30 st148"
          >
            {"0"}
          </text>
          <text transform="translate(179.933 1515.544)" className="st25 st26" />
          <text transform="translate(179.928 1515.544)" className="st25 st26" />
          <text
            transform="translate(182.097 1515.544)"
            className="st42 st30 st148"
          >
            {"minute walk between stations"}
          </text>
          <text transform="translate(361.111 1515.544)" className="st25 st26" />
        </g>
        <g>
          <path
            className="st4"
            d="M108.8 1511.1c0 4.2-3.4 7.6-7.6 7.6s-7.6-3.4-7.6-7.6 3.4-7.6 7.6-7.6c4.1 0 7.6 3.4 7.6 7.6z"
          />
          <path d="M110.3 1511.1c0 5.1-4.1 9.2-9.2 9.2s-9.2-4.1-9.2-9.2 4.1-9.2 9.2-9.2c5.1.1 9.2 4.2 9.2 9.2zm-9.2 6.1c3.4 0 6.1-2.7 6.1-6.1s-2.7-6.1-6.1-6.1c-3.4 0-6.1 2.7-6.1 6.1 0 3.4 2.8 6.1 6.1 6.1z" />
        </g>
        <g>
          <path
            className="st4"
            d="M72.5 1511.1c0 4.2-3.4 7.6-7.6 7.6s-7.6-3.4-7.6-7.6 3.4-7.6 7.6-7.6c4.2 0 7.6 3.4 7.6 7.6z"
          />
          <path d="M74.1 1511.1c0 5.1-4.1 9.2-9.2 9.2s-9.2-4.1-9.2-9.2 4.1-9.2 9.2-9.2 9.2 4.2 9.2 9.2zm-9.2 6.1c3.4 0 6.1-2.7 6.1-6.1s-2.7-6.1-6.1-6.1c-3.4 0-6.1 2.7-6.1 6.1 0 3.4 2.7 6.1 6.1 6.1z" />
        </g>
        <g>
          <path d="M86.7 1509.3H90.4V1513H86.7z" />
          <path d="M81.2 1509.3H84.9V1513H81.2z" />
          <g>
            <path d="M75.6 1509.3H79.3V1513H75.6z" />
          </g>
        </g>
        <g>
          <path
            className="st4"
            d="M71.9 1490.2h22.2c1.2 2.7 3.9 4.6 7 4.6 4.2 0 7.7-3.4 7.7-7.6 0-4.2-3.4-7.7-7.7-7.7-3.1 0-5.8 1.9-7 4.6H71.9c-1.2-2.7-3.9-4.6-7-4.6-4.2 0-7.6 3.4-7.6 7.7 0 4.2 3.4 7.6 7.6 7.6 3.1 0 5.8-1.9 7-4.6z"
          />
          <path d="M64.9 1493.2c-3.4 0-6.1-2.7-6.1-6.1s2.7-6.1 6.1-6.1c2.8 0 5.2 1.9 5.9 4.6h24.4c.7-2.6 3.1-4.6 5.9-4.6 3.4 0 6.1 2.7 6.1 6.1s-2.7 6.1-6.1 6.1c-2.8 0-5.2-1.9-5.9-4.6H70.8c-.6 2.7-3 4.6-5.9 4.6zm7.9-1.5h20.3c1.6 2.7 4.5 4.6 7.9 4.6 5.1 0 9.2-4.1 9.2-9.2s-4.1-9.2-9.2-9.2c-3.4 0-6.3 1.8-7.9 4.6H72.8c-1.6-2.7-4.5-4.6-7.9-4.6-5.1 0-9.2 4.1-9.2 9.2s4.1 9.2 9.2 9.2c3.4 0 6.4-1.9 7.9-4.6z" />
        </g>
        <path fill="#e1e8f6" d="M86.3 1673.7H115.9V1686.9H86.3z" />
        <g>
          <path className="st4" d="M92.9 1648.6H109.4V1665.1H92.9z" />
          <path
            className="st72"
            d="M106 1656.7c-.2-.5-.4-.9-.7-1.2l-.2-.2c-.1-.1-.2-.1-.3-.1-.4-.1-.8-.2-1.3-.2h-.1c-.1 0-.2-.1-.2-.2v-.2c.7-1.4-.1-4-.1-4-.1-.2 0-.4.4-.6l3.4-1.2H103l-10.1 4.2v.7l7.9-2.7s1.2-.4 1.5-.1c.3.4.5.9.5 1.9 0 .8-.3 1.4-.9 1.8-.2.1-.3.1-.5.1-.3-.1-.6-.1-.8-.1-.2 0-.5 0-.7.1h-.2l-1.8.3h-.1s-.1 0-.1.1c-.2.2-.3.4-.4.6-.3.5-.6 1-.7 1.5-.3.7-.4 1.4-.4 2.2 0 .9.2 1.8.6 2.6.2.5.5.9.9 1.4v.1l.3.3h.1l1.5.3h.2c.3.1.6.1.9.1h.2c.2 0 .3 0 .5-.1.2 0 .4-.1.6-.1.6-.1 1.1-.3 1.7-.4.5-.1.9-.2 1.4-.3H105.4c.1 0 .1-.1.2-.1.1-.1.1-.2.2-.3.1-.2.3-.5.4-.7.4-.8.5-1.8.5-2.7-.3-1.4-.4-2.1-.7-2.8"
          />
          <path
            className="st4"
            d="M100.1 1655.2c0 .3-.1.6-.1 1-.1.6-.1 1.1-.1 1.7v1.8l-1-.1c-.6 0-1.2-.1-1.8-.1h-.3c0-.4 0-.9.1-1.3.2-.9.5-1.7.9-2.4 0 0 0-.1.1-.1.1-.1.3-.2.4-.2l1.7-.2c0-.2.1-.2.1-.1"
          />
          <path
            className="st115"
            d="M105 1648.7L103.1 1648.7 93 1652.8 93 1653.2z"
          />
          <path
            className="st72"
            d="M108.9 1664.7H93.2V1649h15.7v15.7zm.4-16.1H92.9v16.5h16.5v-16.5z"
          />
          <path
            className="st115"
            d="M101.9 1663.4c.6-.1 1.1-.2 1.7-.4.5-.1.9-.2 1.4-.3H105.3c.1 0 .1-.1.2-.1.1-.1.1-.2.2-.3.1-.2.3-.5.4-.7.4-.8.5-1.8.5-2.7 0-.7-.2-1.4-.5-2.1-.2-.5-.4-.9-.7-1.2l-.2-.2-.1-.1c-.3-.1-2.6-.6-3.8-.8-.1 0-.3 0-.4-.1-.2 1.2-.5 5 .1 9.4.1 0 .3 0 .4-.1.1-.2.3-.2.5-.3"
          />
          <path
            className="st116"
            d="M105.9 1659.3h-.5c-.4 0-.8.1-1.2.1-.5 0-.9.1-1.4.1l-1.2.1h-.4-.1c-.1-.8-.1-1.6 0-4.5l3.4.5h.1c.1 0 .3 0 .5.3.1.1.1.2.2.3 0 .1.1.1.1.2s.1.2.1.3c.2.8.4 1.7.4 2.6"
          />
        </g>
      </g>
      <g id="Grid">
        <path className="st151" d="M1402.1 37.9L1402.1 1761.3" />
        <path className="st151" d="M2495 1404.1L35.8 1404.1" />
        <path className="st151" d="M2495.1 1130.9L35.3 1130.9" />
        <path className="st151" d="M2495 857.6L35.2 857.6" />
        <path className="st151" d="M2495.1 584.4L35.2 584.4" />
        <path className="st151" d="M2495.1 311.1L35.3 311.1" />
        <path className="st151" d="M309.1 37.9L309.1 1761.1" />
        <path className="st151" d="M582.3 37.9L582.3 1761.1" />
        <path className="st151" d="M855.5 37.9L855.5 1761.3" />
        <path className="st151" d="M1128.8 38L1128.8 1761.3" />
        <path className="st151" d="M1675.3 37.9L1675.3 1761.3" />
        <path className="st151" d="M1948.5 37.9L1948.5 1761.3" />
        <path className="st151" d="M2221.8 37.9L2221.8 1761.3" />
        <path className="st152" d="M166.6 37.9L35.8 37.9 35.8 166.4" />
        <path className="st152" d="M35.8 182.6L35.8 439.7" />
        <path className="st152" d="M35.8 455.9L35.8 712.9" />
        <path className="st152" d="M35.8 729.1L35.8 986.2" />
        <path className="st152" d="M35.8 1002.3L35.8 1259.3" />
        <path className="st152" d="M35.8 1275.5L35.8 1579.2" />
        <path className="st152" d="M178.3 1761.3L439.9 1761.3" />
        <path className="st152" d="M451.5 1761.3L713.1 1761.3" />
        <path className="st152" d="M724.8 1761.3L986.4 1761.3" />
        <path className="st152" d="M998.1 1761.3L1259.7 1761.3" />
        <path className="st152" d="M1271.4 1761.3L1532.8 1761.3" />
        <path className="st152" d="M1544.5 1761.3L1806.1 1761.3" />
        <path className="st152" d="M1817.7 1761.3L2079.3 1761.3" />
        <path className="st152" d="M2091.1 1761.3L2352.5 1761.3" />
        <path
          className="st152"
          d="M2364.2 1761.3L2495.1 1761.3 2495.4 1595.3"
        />
        <path className="st152" d="M2495.4 1579.2L2495.4 1275.5" />
        <path className="st152" d="M2495.4 1259.3L2495.4 1002.3" />
        <path className="st152" d="M2495.4 986.2L2495.4 729.1" />
        <path className="st152" d="M2495.4 712.9L2495.4 455.9" />
        <path className="st152" d="M2495.4 439.7L2495.4 182.6" />
        <path className="st152" d="M2495.4 166.4L2495.4 37.9 2364.2 37.9" />
        <path className="st152" d="M2352.5 37.9L2091 37.9" />
        <path className="st152" d="M2079.3 37.9L1817.7 37.9" />
        <path className="st152" d="M1806.1 37.9L1544.5 37.9" />
        <path className="st152" d="M1532.8 37.9L1271.4 37.9" />
        <path className="st152" d="M1259.7 37.9L998.1 37.9" />
        <path className="st152" d="M986.4 37.9L724.8 37.9" />
        <path className="st152" d="M713.1 37.9L451.5 37.9" />
        <path className="st152" d="M439.9 37.9L178.3 37.9" />
        <text
          transform="translate(28.865 182.358)"
          className="st40 st30"
          fontSize="19.8079px"
        >
          {"A"}
        </text>
        <text transform="translate(30.67 454.2)" className="st40 st30 st154">
          {"B"}
        </text>
        <text transform="translate(30.526 727.44)" className="st40 st30 st154">
          {"C"}
        </text>
        <text transform="translate(29.782 1000.68)" className="st40 st30 st154">
          {"D"}
        </text>
        <text
          transform="translate(31.124 1273.886)"
          className="st40 st30 st154"
        >
          {"E"}
        </text>
        <text
          transform="translate(31.287 1593.758)"
          className="st40 st30 st154"
        >
          {"F"}
        </text>
        <text transform="translate(168.918 44.335)" className="st40 st30 st154">
          {"1"}
        </text>
        <text transform="translate(441.144 44.335)" className="st40 st30 st154">
          {"2"}
        </text>
        <text transform="translate(714.308 44.335)" className="st40 st30 st154">
          {"3"}
        </text>
        <text transform="translate(987.068 44.335)" className="st40 st30 st154">
          {"4"}
        </text>
        <text transform="translate(1260.62 44.335)" className="st40 st30 st154">
          {"5"}
        </text>
        <text
          transform="translate(1533.671 44.335)"
          className="st40 st30 st154"
        >
          {"6"}
        </text>
        <text
          transform="translate(1807.257 44.335)"
          className="st40 st30 st154"
        >
          {"7"}
        </text>
        <text
          transform="translate(2080.352 44.335)"
          className="st40 st30 st154"
        >
          {"8"}
        </text>
        <text
          transform="translate(2353.462 44.335)"
          className="st40 st30 st154"
        >
          {"9"}
        </text>
        <text
          transform="matrix(1.0019 0 0 1 168.885 1767.725)"
          className="st40 st30 st154"
        >
          {"1"}
        </text>
        <text
          transform="translate(441.38 1767.725)"
          className="st40 st30 st154"
        >
          {"2"}
        </text>
        <text
          transform="translate(713.93 1767.725)"
          className="st40 st30 st154"
        >
          {"3"}
        </text>
        <text
          transform="translate(987.616 1767.725)"
          className="st40 st30 st154"
        >
          {"4"}
        </text>
        <text
          transform="translate(1260.859 1767.725)"
          className="st40 st30 st154"
        >
          {"5"}
        </text>
        <text
          transform="translate(1807.29 1767.725)"
          className="st40 st30 st154"
        >
          {"7"}
        </text>
        <text
          transform="translate(1533.707 1767.725)"
          className="st40 st30 st154"
        >
          {"6"}
        </text>
        <text
          transform="translate(2079.775 1767.725)"
          className="st40 st30 st154"
        >
          {"8"}
        </text>
        <text
          transform="translate(2353.95 1767.725)"
          className="st40 st30 st154"
        >
          {"9"}
        </text>
        <text
          transform="translate(2489.785 180.907)"
          className="st40 st30 st154"
        >
          {"A"}
        </text>
        <text transform="translate(2490.24 454.2)" className="st40 st30 st154">
          {"B"}
        </text>
        <text
          transform="translate(2490.097 727.44)"
          className="st40 st30 st154"
        >
          {"C"}
        </text>
        <text
          transform="translate(2489.354 1000.68)"
          className="st40 st30 st154"
        >
          {"D"}
        </text>
        <text
          transform="translate(2490.695 1273.886)"
          className="st40 st30 st154"
        >
          {"E"}
        </text>
        <text
          transform="translate(2490.858 1593.758)"
          className="st40 st30 st154"
        >
          {"F"}
        </text>
        <path className="st152" d="M35.8 1595.3L35.8 1761.3 166.6 1761.3" />
      </g>
      <g id="nvre_added">
        <g id="park">
          <g id="on_map_00000139983311385359899310000010211466328828629667_">
            <g id="nvre_added_00000181083491604892829150000002111905864770671034_">
              <g id="park_00000024686530981890139360000008319468738519215019_">
                <g id="nvre_added-2_00000134958096907974515120000018196177542060286902_">
                  <g id="park-2_00000138546189694443980380000000404292515803970747_">
                    <path
                      id="park_icon_00000150103439453199573810000002974854433311674005_"
                      className="st155"
                      d="M975 786.7c.9 5.9-.5 10.7-4 15.7-.8 1.1-1.6 2-2.6 2.9 0-1.3-.8-1.9-2.1-2.2 5.2-5.1 7.3-10.8 8-16.4H973c-3.9-.4-8.2 6.2-13.2 8 2.4-4.6-.3-5.2-6.3-3.2 4.5-5.4 5-7.4 0-6.7 2.6-1.9 4.9-3 7.2-3.5-4.7-1.5-8.8-4-12.3-7.8 6.6-.2 5-4.7-1-11.4 8 4 12.1 4.5 10.8-.1 2.3 1.6 5.4 4.6 8.5 8-1.2-6.2-2.1-12.2-1.7-16.6 3.1 4.7 6.4 0 9.7-9.6 2.8 8.7 5.7 13.5 9.4 10 .5 3.9 0 8-1.4 12.4l-.1 3.3c3.1-3.3 6.1-6.5 8.6-7.7-1.5 5 3.8 3.3 10.6.2-6.5 7.2-7 11-1.3 11.3-2.4 3.7-6.5 5.9-11.4 7.6 2.1.6 4.2 1.7 6.3 3.5-4.4-.4-3.4 2.5.1 7.1-5.5-1.6-8.2-1.2-6.5 3-6.4-5.4-11-8-13.9-8l-.1.2z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <text
              transform="translate(958.359 778.24)"
              className="st4 st25 st156"
            >
              {"\u6444\u653F\u516C\u56ED"}
            </text>
            <g id="nvre_added_00000094587352065836723210000011521648105037025966_">
              <g id="park_00000097478007992500274000000016250098985578243495_">
                <path
                  id="park_icon_00000092452361783256895370000015665589028861286324_"
                  d="M539.3 1257.1c1 6.6-.5 11.9-4.4 17.3-.9 1.2-1.8 2.2-2.9 3.2 0-1.4-.9-2.1-2.3-2.4 5.8-5.7 8.1-11.9 8.9-18.2h-1.3c-4.3-.4-9 6.8-14.5 8.8 2.6-5.1-.3-5.7-7-3.5 5-6 5.5-8.2 0-7.4 2.8-2.1 5.5-3.4 7.9-3.9-5.2-1.6-9.7-4.4-13.6-8.6 7.3-.3 5.5-5.2-1.1-12.6 8.8 4.4 13.4 5 12-.1 2.6 1.8 5.9 5.1 9.4 8.9-1.3-6.9-2.4-13.4-1.9-18.3 3.4 5.2 7.1-.1 10.7-10.6 3 9.6 6.3 15 10.4 11.1.5 4.3 0 8.9-1.5 13.7l-.1 3.7c3.4-3.7 6.8-7.2 9.5-8.5-1.7 5.6 4.2 3.6 11.7.2-7.1 8-7.7 12.2-1.4 12.5-2.6 4.1-7.2 6.5-12.6 8.4 2.3.7 4.7 1.9 7 3.9-4.8-.4-3.8 2.8.1 7.8-6-1.8-9.1-1.3-7.2 3.3-7.1-6-12.2-8.8-15.3-8.8l-.5.1z"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#557096"
                />
              </g>
            </g>
            <text
              transform="translate(525.807 1244.595)"
              className="st25 st26"
            />
            <text
              transform="translate(525.807 1245.031)"
              className="st4 st25 st156"
            >
              {"\u91CC\u58EB\u6EE1"}
            </text>
            <text
              transform="translate(552.807 1244.595)"
              className="st25 st26"
            />
            <text
              transform="translate(530.307 1255.831)"
              className="st4 st25 st156"
            >
              {"\u516C\u56ED"}
            </text>
            <text
              transform="translate(548.307 1255.395)"
              className="st25 st26"
            />
            <g>
              <g id="nvre_added_00000067934332511373480590000006048902311217191836_">
                <g id="park_00000057146909802307596420000005787036857147418254_">
                  <g id="nvre_added-2">
                    <g id="park-2">
                      <path
                        id="park_icon_00000097485140007464367950000017020618427341166264_"
                        className="st155"
                        d="M622.3 605c.9 5.9-.5 10.7-4 15.7-.8 1.1-1.6 2-2.6 2.9 0-1.3-.8-1.9-2.1-2.2 5.2-5.1 7.3-10.8 8-16.4h-1.2c-3.9-.4-8.2 6.2-13.2 8 2.4-4.6-.3-5.2-6.3-3.2 4.5-5.4 5-7.4 0-6.7 2.6-1.9 4.9-3 7.2-3.5-4.7-1.5-8.8-4-12.3-7.8 6.6-.2 5-4.7-1-11.4 8 4 12.1 4.5 10.8-.1 2.3 1.6 5.4 4.6 8.5 8-1.2-6.2-2.1-12.2-1.7-16.6 3.1 4.7 6.4 0 9.7-9.6 2.8 8.7 5.7 13.5 9.4 10 .5 3.9 0 8-1.4 12.4l-.1 3.3c3.1-3.3 6.1-6.5 8.6-7.7-1.5 5 3.8 3.3 10.6.2-6.5 7.2-7 11-1.3 11.3-2.4 3.7-6.5 5.9-11.4 7.6 2.1.6 4.2 1.7 6.3 3.5-4.4-.4-3.4 2.5.1 7.1-5.5-1.6-8.2-1.2-6.5 3-6.4-5.4-11-8-13.9-8l-.2.2z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <text
                transform="translate(604.097 596.027)"
                className="st4 st25 st156"
              >
                {"\u5973\u738B\u516C\u56ED"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000109030897420203716470000008562776661031923645_">
                <g id="park_00000121958702898404599990000002485226572738361760_">
                  <g id="nvre_added-2_00000112597781290526931890000005161390358818827964_">
                    <g id="park-2_00000070823145124184132060000000050660955985718403_">
                      <path
                        id="park_icon_00000163047118209516286390000010664045799709319103_"
                        className="st155"
                        d="M888.7 914.7c.9 5.6-.5 10.1-4 14.8-.8 1-1.6 1.9-2.6 2.8 0-1.2-.8-1.8-2.1-2 5.2-4.8 7.3-10.2 8-15.5h-1.2c-3.9-.4-8.2 5.8-13.2 7.5 2.4-4.3-.3-4.9-6.3-3 4.5-5.1 5-7 0-6.3 2.6-1.8 4.9-2.9 7.2-3.3-4.7-1.4-8.8-3.8-12.3-7.3 6.6-.2 5-4.4-1-10.7 8 3.8 12.1 4.2 10.8-.1 2.3 1.5 5.4 4.4 8.5 7.6-1.2-5.9-2.1-11.5-1.7-15.6 3.1 4.4 6.4 0 9.7-9 2.8 8.2 5.7 12.8 9.4 9.5.5 3.7 0 7.6-1.4 11.7l-.1 3.1c3.1-3.2 6.1-6.1 8.6-7.3-1.5 4.8 3.8 3.1 10.6.2-6.5 6.8-7 10.4-1.3 10.6-2.4 3.5-6.5 5.6-11.4 7.2 2.1.6 4.2 1.6 6.3 3.3-4.4-.3-3.4 2.4.1 6.7-5.5-1.5-8.2-1.1-6.5 2.8-6.4-5.1-11-7.5-13.9-7.5l-.2-.2z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <text
                transform="translate(870.447 905.773)"
                className="st4 st25 st156"
              >
                {"\u6D77\u5FB7\u516C\u56ED"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000020362893786767852960000015938837355611555737_">
                <g id="park_00000058573360103430231100000012237144905698272411_">
                  <g id="nvre_added-2_00000084510078960032566780000006237562746915704230_">
                    <g id="park-2_00000132808056891015084650000010811291541361581992_">
                      <path
                        id="park_icon_00000141445893928962280660000009837002056655913108_"
                        className="st155"
                        d="M1256.5 406.8c.9 6.5-.5 11.7-4.4 17-.9 1.2-1.8 2.2-2.8 3.2 0-1.4-.9-2-2.3-2.4 5.7-5.6 8-11.7 8.7-17.8h-1.3c-4.2-.4-8.8 6.7-14.3 8.6 2.6-5-.3-5.6-6.9-3.4 4.9-5.9 5.4-8 0-7.2 2.8-2.1 5.4-3.3 7.8-3.8-5.1-1.6-9.6-4.3-13.4-8.4 7.1-.3 5.4-5.1-1.1-12.3 8.6 4.3 13.2 4.9 11.8-.1 2.6 1.7 5.8 5 9.3 8.7-1.3-6.8-2.3-13.2-1.9-18 3.4 5.1 7 0 10.5-10.4 3 9.5 6.2 14.7 10.2 10.9.5 4.2 0 8.7-1.5 13.4l-.1 3.6c3.4-3.6 6.7-7.1 9.3-8.4-1.7 5.5 4.1 3.6 11.5.2-7 7.8-7.6 12-1.4 12.2-2.6 4-7.1 6.4-12.3 8.2 2.3.6 4.6 1.9 6.9 3.8-4.7-.4-3.7 2.7.1 7.7-5.9-1.7-8.9-1.3-7.1 3.2-7-5.9-12-8.7-15.1-8.6l-.2.1z"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <text
                transform="translate(1238.248 394.214)"
                className="st25 st26"
              />
              <text
                transform="translate(1238.248 394.65)"
                className="st4 st25 st156"
              >
                {"\u6C49\u666E\u65AF\u7279"}
              </text>
              <text
                transform="translate(1274.248 394.214)"
                className="st25 st26"
              />
              <text
                transform="translate(1247.248 405.45)"
                className="st4 st25 st156"
              >
                {"\u516C\u56ED"}
              </text>
              <text
                transform="translate(1265.248 405.014)"
                className="st25 st26"
              />
            </g>
          </g>
        </g>
        <g id="school">
          <g id="on_map">
            <g id="nvre_added_00000183237558018085692540000012434084581373576843_">
              <g id="university_00000176019132915143286970000011182600044017222844_">
                <path
                  id="uni_icon_00000062179493227727879510000012434804936274268322_"
                  className="st158"
                  d="M1735.1 1275c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-3.9 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.4 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9c-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-.9-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.6-2.8 1z"
                />
              </g>
            </g>
            <text
              transform="translate(1720.812 1287.077)"
              className="st25 st26"
            />
            <text
              transform="translate(1720.812 1287.513)"
              className="st4 st25 st156"
            >
              {"\u91D1\u53F2\u5BC6\u65AF"}
            </text>
            <text
              transform="translate(1756.812 1287.077)"
              className="st25 st26"
            />
            <text
              transform="translate(1729.812 1298.313)"
              className="st4 st25 st156"
            >
              {"\u5927\u5B66"}
            </text>
            <text
              transform="translate(1747.812 1297.877)"
              className="st25 st26"
            />
            <g id="nvre_added_00000038373973226795664470000017772944682481007267_">
              <g id="university_00000115479216895847901440000003281808706492888202_">
                <path
                  id="uni_icon_00000000930321273836179480000013769230378911723966_"
                  className="st158"
                  d="M496.2 426.1c-2.6.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8s0 .1.2.1c8.5 3.7 11.3 4.9 11.3 4.9s0 .2-.1.4c-.1.4-.1 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1v1.5c0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.5.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.9-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.1-.2-.3v-2.5c-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.4 0 .1-.1 1.7-.1 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.9 2.7 4.6.5.3 3.1 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.1 2.6-.7 4.6-1.6 5.7-2.6.9-.8 1.1-1.3 1.3-2.9 0-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.9-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.5.3-3 .7z"
                />
              </g>
            </g>
            <text
              transform="translate(481.753 438.299)"
              className="st4 st25 st156"
            >
              {"\u54C8\u7F57\u516C\u5B66"}
            </text>
            <g id="nvre_added_00000029004087602316552780000010359266956901166511_">
              <g id="university_00000101815556812573689140000009876623723581125791_">
                <path
                  id="uni_icon_00000011030489705091930650000011615726882273016985_"
                  className="st158"
                  d="M330.4 948.6c-2.6.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8s0 .1.2.1c8.5 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.1 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1v1.5c0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.5.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.9-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3v-2.5c-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.1 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.1 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.5-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9 0-.4.1-.9.1-1.1s-.2-2.4-.4-4.9c-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1-12.2-2.8-16.3-3.8c-4.1-1-7.5-1.8-7.5-1.8s-1.4.7-3 1.1z"
                />
              </g>
            </g>
            <text
              transform="translate(320.951 961.208)"
              className="st25 st26"
            />
            <text
              transform="translate(320.951 961.644)"
              className="st4 st25 st156"
            >
              {"\u897F\u4F26\u6566"}
            </text>
            <text
              transform="translate(347.951 961.208)"
              className="st25 st26"
            />
            <text
              transform="translate(325.451 972.444)"
              className="st4 st25 st156"
            >
              {"\u5927\u5B66"}
            </text>
            <text
              transform="translate(343.451 972.008)"
              className="st25 st26"
            />
            <g id="nvre_added_00000054259238945452061610000014333846647860841353_">
              <g id="university_00000070120695827876350300000014967959332919441294_">
                <path
                  id="uni_icon_00000127024764472738212270000007041618747144199856_"
                  className="st158"
                  d="M434.1 1345.6c-2.6.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8s0 .1.2.1c8.5 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.1 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1v1.5c0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.5.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.9-3.8-.8-3.9 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3v-2.5c-.1-1.8-.1-2.4 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.1 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.1 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.5-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9 0-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-.9-8.9-2.1c-4.9-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.5.6-3 1z"
                />
              </g>
            </g>
            <text
              transform="translate(424.073 1357.072)"
              className="st25 st26"
            />
            <text
              transform="translate(424.073 1357.508)"
              className="st4 st25 st156"
            >
              {"\u91D1\u58EB\u987F"}
            </text>
            <text
              transform="translate(451.073 1357.072)"
              className="st25 st26"
            />
            <text
              transform="translate(428.573 1368.308)"
              className="st4 st25 st156"
            >
              {"\u5927\u5B66"}
            </text>
            <text
              transform="translate(446.573 1367.872)"
              className="st25 st26"
            />
            <g id="nvre_added_00000145037483859138635100000008144659549397280653_">
              <g id="university_00000150076454020734825600000010396530216310818223_">
                <path
                  id="uni_icon_00000021838190670218394750000015680240048386298510_"
                  className="st158"
                  d="M905.7 266.1c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8s0 .1.2.1c8.5 3.7 11.3 4.9 11.3 4.9s0 .2-.1.4c-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1v1.5c0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.5.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.1-.2-.3v-2.5c-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.4 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.9 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.1 2.6-.7 4.5-1.6 5.7-2.6.9-.8 1.1-1.3 1.3-2.9 0-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.9-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8-.1 0-1.4.3-2.9.7z"
                />
              </g>
            </g>
            <text
              transform="translate(892.609 278.721)"
              className="st25 st26"
            />
            <text
              transform="translate(892.609 279.158)"
              className="st4 st25 st156"
            >
              {"\u5BC6\u5FB7\u8428\u65AF"}
            </text>
            <text
              transform="translate(928.609 278.721)"
              className="st25 st26"
            />
            <text
              transform="translate(901.609 289.958)"
              className="st4 st25 st156"
            >
              {"\u5927\u5B66"}
            </text>
            <text
              transform="translate(919.609 289.521)"
              className="st25 st26"
            />
            <g>
              <g id="nvre_added_00000075132220119202877520000010401596056806627469_">
                <g id="university_00000095323365579128092360000000161578313088254092_">
                  <path
                    id="uni_icon_00000057130079577550398860000008027641642915075004_"
                    className="st158"
                    d="M987.1 597.4c-3.1.8-5.1 1.3-14.3 3.7-2.3.6-6 1.5-8.2 2.1-2.2.6-5.4 1.4-7.1 1.8-1.8.5-3.2.8-3.3.9-.1 0 0 .1.2.2 9.9 4.1 13.1 5.4 13.1 5.4s0 .2-.1.4c-.1.5-.2 2.3-.1 4.8v2.2c0 .2-.1.3-.3.5-.7.6-.9 1.6-.6 2.5.1.2.3.5.4.7l.2.2.2 1.8c.2 1 .3 1.8.3 1.8h.1c.1 0 .1.4 0 1.7 0 2.1-.1 3.2-.6 7.8-.1 1.3-.2 2.4-.3 3.8 0 .6 0 .7.2 1 .2.4.5.7 1 .9.5.2 1.5.2 2.2 0 .9-.3 1.7-.9 2.1-1.6.2-.3.2-.4.2-1 0-1.3-.4-3.2-1.6-8.5-.8-3.6-1-4.3-1-4.4 0-.1-.1-.9-.2-1.8l-.2-1.7.2-.4c.3-.7.4-1.3.1-2-.2-.3-.5-.8-.8-1-.2-.1-.2-.2-.2-.3 0-.1 0-1.3-.1-2.8-.1-2-.1-2.7 0-3.2 0-.3.1-.7.1-.7s1.2.4 2.7 1c1.5.6 2.9 1.2 3.2 1.3.5.2.6.3.6.4 0 .1-.1 1.9-.2 4-.3 6-.3 5.8-.2 6.5.4 2.2 1.6 4.3 3.1 5.2.5.3 3.7 1.3 5.5 1.8 6.2 1.5 12 1.4 18.2-.2 3-.8 5.3-1.8 6.6-3 1.1-.9 1.3-1.4 1.5-3.2.1-.4.1-1 .1-1.2 0-.2-.2-2.7-.5-5.5s-.5-5.1-.5-5.2c0-.2 0-.2.9-.6.5-.2 4.8-2.1 9.5-4.3 4.8-2.1 8.7-3.9 8.8-4 .1 0 .2-.1.1-.1 0 0-4.7-1.1-10.3-2.3-5.6-1.3-14.1-3.2-18.9-4.3-4.8-1.1-8.7-2-8.7-2 .1 0-1.3.4-3.1.9z"
                  />
                </g>
              </g>
              <text
                transform="matrix(.9986 0 0 1 966.536 610.46)"
                className="st4 st25 st156"
                fontSize="9.5898px"
              >
                {"\u4F26\u6566\u5546\u5B66\u9662"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000093869430539739396390000016806833909021319559_">
                <g id="university_00000142144147724919081440000012689712966716365471_">
                  <path
                    id="uni_icon_00000039093571555010771120000014673315633756072077_"
                    className="st158"
                    d="M1038.5 751.8c-2.9.8-4.8 1.3-13.4 3.6-2.2.6-5.6 1.5-7.7 2s-5 1.3-6.7 1.8c-1.6.4-3 .8-3.1.8s0 .1.2.2c9.3 4 12.3 5.2 12.3 5.3 0 0 0 .2-.1.4-.1.5-.2 2.2-.1 4.6v2.1c0 .2-.1.3-.3.5-.7.6-.9 1.6-.5 2.5.1.2.3.5.4.6l.2.2.2 1.7c.1 1 .2 1.7.2 1.8s0 0 .1 0v1.6c0 2-.1 3-.5 7.5-.1 1.3-.2 2.3-.3 3.7 0 .6 0 .6.1.9.2.4.5.6 1 .8.5.2 1.5.2 2 0 .9-.3 1.6-.9 1.9-1.6.1-.3.2-.4.1-1 0-1.2-.4-3.1-1.5-8.2-.8-3.5-.9-4.2-.9-4.3 0-.1-.1-.9-.2-1.8l-.2-1.6.2-.4c.3-.6.3-1.3.1-1.9-.1-.3-.5-.8-.8-.9-.2-.1-.2-.2-.2-.3v-2.7c-.1-1.9-.1-2.7 0-3.1 0-.3.1-.6.1-.7 0 0 1.2.4 2.5 1 1.4.6 2.7 1.2 3 1.3.5.2.6.3.6.4 0 .1-.1 1.8-.2 3.9-.2 5.8-.2 5.7-.1 6.3.3 2.1 1.5 4.2 2.9 5 .5.3 3.4 1.3 5.1 1.7 5.8 1.5 11.2 1.4 17.1-.2 2.8-.8 4.9-1.7 6.2-2.9 1-.9 1.2-1.4 1.4-3.1.1-.4.1-1 .1-1.2s-.2-2.6-.5-5.3-.5-5-.5-5.1c0-.2 0-.2.8-.6.5-.2 4.5-2.1 8.9-4.1 4.5-2.1 8.2-3.8 8.3-3.8.1 0 .1-.1.1-.1s-4.4-1-9.6-2.2c-5.3-1.2-13.2-3.1-17.7-4.1-4.5-1.1-8.2-1.9-8.2-1.9s-1.1.4-2.8.9z"
                  />
                </g>
              </g>
              <text
                transform="translate(1020.09 764.083)"
                className="st25 st26"
              />
              <text
                transform="translate(1020.09 764.52)"
                className="st4 st25 st156"
              >
                {"\u5A01\u65AF\u654F\u65AF\u7279"}
              </text>
              <text
                transform="translate(1065.09 764.083)"
                className="st25 st26"
              />
              <text
                transform="translate(1033.59 775.32)"
                className="st4 st25 st156"
              >
                {"\u5927\u5B66"}
              </text>
              <text
                transform="translate(1051.59 774.884)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000013907814702342654090000014982094483990795423_">
                <g id="university_00000029731427717533501390000016886253098394061224_">
                  <path
                    id="uni_icon_00000144335928819789130080000009449020649620351930_"
                    className="st158"
                    d="M1119.9 766.2c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1105.476 778.217)"
                className="st25 st26"
              />
              <text
                transform="translate(1105.476 778.654)"
                className="st4 st25 st156"
              >
                {"\u4F26\u6566\u65F6\u88C5"}
              </text>
              <text
                transform="translate(1141.476 778.217)"
                className="st25 st26"
              />
              <text
                transform="translate(1114.476 789.453)"
                className="st4 st25 st156"
              >
                {"\u5B66\u9662"}
              </text>
              <text
                transform="translate(1132.476 789.017)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000182523897059351192700000008359908244065504154_">
                <g id="university_00000166664251034631868890000015687079669908628667_">
                  <path
                    id="uni_icon_00000145743092337761609460000016870667726934838958_"
                    className="st158"
                    d="M948.2 956.3c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8s0 .1.2.1c8.5 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1v1.5c0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.5.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3v-2.5c-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.5-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9 0-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8-.1.4-1.4.7-2.9 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(935.102 967.804)"
                className="st4 st25 st156"
              >
                {"\u5E1D\u56FD\u7406\u5DE5"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000133505292908559535890000005033454393642486714_">
                <g id="university_00000057844104589491000090000002468386668158912162_">
                  <path
                    id="uni_icon_00000138534545052059817510000001210176325951570330_"
                    className="st158"
                    d="M1114.8 1071.5c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-3.9 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.4 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-.9-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.6-2.8 1z"
                    // d="M1114.8 1051.5c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-3.9 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.4 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-.9-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.6-2.8 1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1101.345 1083.149)"
                className="st25 st26"
              />
              <text
                transform="translate(1101.345 1083.585)"
                className="st4 st25 st156"
              >
                {"\u56FD\u738B\u5927\u5B66"}
              </text>
              <text
                transform="translate(1137.345 1083.149)"
                className="st25 st26"
              />
              <text
                transform="translate(1110.345 1094.386)"
                className="st4 st25 st156"
              >
                {"\u5B66\u9662"}
              </text>
              <text
                transform="translate(1128.345 1093.949)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000011028004111395204980000010725301325281741727_">
                <g id="university_00000070107082045114218310000006359037430956539544_">
                  <path
                    id="uni_icon_00000116928716337103539490000001422476733114869381_"
                    className="st158"
                    d="M1355.9 1206c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-3.9 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.4 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9c-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-.9-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.6-2.8 1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1342.118 1218.198)"
                className="st25 st26"
              />
              <text
                transform="translate(1342.118 1218.634)"
                className="st4 st25 st156"
              >
                {"\u4F26\u6566\u5357\u5CB8"}
              </text>
              <text
                transform="translate(1378.118 1218.198)"
                className="st25 st26"
              />
              <text
                transform="translate(1351.118 1229.434)"
                className="st4 st25 st156"
              >
                {"\u5927\u5B66"}
              </text>
              <text
                transform="translate(1369.118 1228.998)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000132769665678037498750000011733354317668230541_">
                <g id="university_00000032637926830514323660000010976556393019277977_">
                  <path
                    id="uni_icon_00000049933800926640711490000008368885155928353670_"
                    className="st158"
                    d="M1343 858.8c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1 0-.2-.2-2.4-.4-4.9-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.2.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1328.33 870.545)"
                className="st4 st25 st156"
              >
                {"\u4F26\u6566\u653F\u7ECF"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000103250021970676818470000001101556234850935690_">
                <g id="university_00000106860888783868560630000011340646771912591544_">
                  <path
                    id="uni_icon_00000073702671550468380860000007551121685659797429_"
                    className="st158"
                    d="M1192.2 717.8c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1 0-.2-.2-2.4-.4-4.9-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1185.192 731.261)"
                className="st4 st25 st156"
              >
                {"UCL"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000124877349010586497010000008204340920792731265_">
                <g id="university_00000131330815069070496380000001644573665531467957_">
                  <path
                    id="uni_icon_00000085941087903939777620000016495968823841960882_"
                    className="st158"
                    d="M1302.9 616.1c-2.8.8-4.8 1.3-13.3 3.5-2.2.6-5.6 1.5-7.6 2s-5 1.3-6.6 1.8-3 .8-3.1.8c-.1 0 0 .1.2.2 9.2 4 12.2 5.2 12.2 5.2s0 .2-.1.4c-.1.5-.2 2.2-.1 4.6v2.1c0 .2-.1.3-.3.5-.7.6-.9 1.6-.5 2.4.1.2.3.5.4.6l.2.2.2 1.7c.1 1 .2 1.7.2 1.7h.1c.1 0 .1.4 0 1.6 0 2-.1 3-.6 7.5-.1 1.3-.2 2.3-.3 3.7 0 .6 0 .6.1.9.2.4.5.6.9.8.5.2 1.4.2 2 0 .9-.3 1.6-.9 1.9-1.6.1-.3.2-.4.1-1 0-1.2-.4-3.1-1.5-8.2-.8-3.4-.9-4.1-.9-4.2 0-.1-.1-.8-.2-1.7l-.2-1.6.2-.4c.3-.6.3-1.3.1-1.9-.1-.3-.5-.8-.8-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.3-.1-2.7-.1-1.9-.1-2.6 0-3.1 0-.3.1-.6.1-.7 0 0 1.1.4 2.5 1 1.3.6 2.7 1.2 3 1.3.5.2.6.3.6.4 0 .1-.1 1.8-.2 3.9-.2 5.8-.2 5.6-.1 6.3.3 2.1 1.5 4.2 2.9 5 .5.3 3.4 1.3 5.1 1.7 5.8 1.4 11.1 1.4 17-.2 2.8-.7 4.9-1.7 6.2-2.8 1-.9 1.2-1.4 1.4-3.1.1-.4.1-1 .1-1.2s-.2-2.6-.5-5.3c-.3-2.7-.5-4.9-.5-5 0-.2 0-.2.8-.6.4-.2 4.4-2 8.8-4.1 4.4-2 8.1-3.8 8.2-3.8.1 0 .1-.1.1-.1s-4.3-1-9.5-2.2c-5.2-1.2-13.1-3.1-17.6-4.1-4.4-1.1-8.1-1.9-8.1-1.9s-1 .5-2.7.9z"
                  />
                </g>
              </g>
              <text
                transform="translate(1285.587 628.295)"
                className="st4 st25 st156"
              >
                {"\u4E2D\u592E\u5723\u9A6C\u4E01"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000013873983964177409680000011640539365105444492_">
                <g id="university_00000008146552397932887700000007306537583415445149_">
                  <path
                    id="uni_icon_00000087395582715818480460000006068980837263881391_"
                    className="st158"
                    d="M1458.9 709.2c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9c-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1444.403 721.606)"
                className="st25 st26"
              />
              <text
                transform="translate(1444.403 722.042)"
                className="st4 st25 st156"
              >
                {"\u4F26\u6566\u57CE\u5E02"}
              </text>
              <text
                transform="translate(1480.403 721.606)"
                className="st25 st26"
              />
              <text
                transform="translate(1453.403 732.842)"
                className="st4 st25 st156"
              >
                {"\u5927\u5B66"}
              </text>
              <text
                transform="translate(1471.403 732.406)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000121980047463507179840000010703341615468997299_">
                <g id="university_00000143591354283552711800000006975327043106479766_">
                  <path
                    id="uni_icon_00000093176293686971600470000009050337200161132451_"
                    className="st158"
                    d="M1584.9 712.3c-2.9.8-4.8 1.3-13.3 3.6-2.2.6-5.6 1.5-7.6 2.1s-5 1.4-6.6 1.8-3 .8-3.1.8c-.1 0 0 .1.2.2 9.2 4 12.2 5.3 12.2 5.4 0 0 0 .2-.1.4-.1.5-.2 2.3-.1 4.7v2.1c0 .2-.1.3-.3.5-.7.6-.9 1.6-.5 2.5.1.2.3.5.4.7l.2.2.2 1.8c.1 1 .2 1.8.2 1.8h.1c.1 0 .1.4 0 1.7 0 2.1-.1 3.1-.6 7.7-.1 1.3-.2 2.4-.3 3.7 0 .6 0 .6.1 1 .2.4.5.6.9.8.5.2 1.4.2 2 0 .9-.3 1.6-.9 1.9-1.6.1-.3.2-.4.1-1 0-1.2-.4-3.2-1.5-8.3-.8-3.5-.9-4.2-.9-4.3 0-.1-.1-.9-.2-1.8l-.2-1.7.2-.4c.3-.6.3-1.3.1-1.9-.1-.3-.5-.8-.8-1-.2-.1-.2-.2-.2-.3 0-.1 0-1.3-.1-2.7-.1-2-.1-2.7 0-3.2 0-.3.1-.6.1-.7 0 0 1.1.4 2.5 1 1.3.6 2.7 1.2 3 1.3.5.2.6.3.6.4 0 .1-.1 1.9-.2 4-.2 5.9-.2 5.8-.1 6.4.3 2.2 1.5 4.2 2.9 5.1.5.3 3.4 1.3 5.1 1.7 5.8 1.5 11.2 1.4 17-.2 2.8-.8 4.9-1.8 6.2-2.9 1-.9 1.2-1.4 1.4-3.2.1-.4.1-1 .1-1.2s-.2-2.7-.5-5.4-.5-5.1-.5-5.2c0-.2 0-.2.8-.6.4-.2 4.4-2.1 8.9-4.2 4.4-2.1 8.1-3.8 8.2-3.9.1 0 .1-.1.1-.1s-4.3-1-9.6-2.3c-5.2-1.3-13.1-3.1-17.6-4.2-4.4-1.1-8.1-1.9-8.1-1.9s-1 .3-2.7.8z"
                  />
                </g>
              </g>
              <text
                transform="translate(1567.27 724.987)"
                className="st4 st25 st156"
              >
                {"\u5361\u65AF\u5546\u5B66\u9662"}
              </text>
            </g>
            <g>
              <g id="nvre_added_00000049186456902185056450000011971173970782110596_">
                <g id="university_00000104692389702967419300000009712575338199905154_">
                  <path
                    id="uni_icon_00000058558345698658901680000008031090380418468793_"
                    className="st158"
                    d="M2067.9 1302c-2.6.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9-1.9.5-4.6 1.2-6.2 1.6-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.5 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.1 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.9-3.8-.8-3.9 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.4 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.1 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.1 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-.9-8.9-2.1c-4.9-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.6-2.9 1z"
                  />
                </g>
              </g>
              <text
                transform="translate(2054.294 1313.315)"
                className="st25 st26"
              />
              <text
                transform="translate(2054.294 1313.752)"
                className="st4 st25 st156"
              >
                {"\u683C\u6797\u5A01\u6CBB"}
              </text>
              <text
                transform="translate(2090.294 1313.315)"
                className="st25 st26"
              />
              <text
                transform="translate(2063.294 1324.552)"
                className="st4 st25 st156"
              >
                {"\u5927\u5B66"}
              </text>
              <text
                transform="translate(2081.294 1324.116)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000039100917101485483550000001443234857411162007_">
                <g id="university_00000119104895584758332060000005729128432980671664_">
                  <path
                    id="uni_icon_00000003812919102282045260000004323454509627772603_"
                    className="st158"
                    d="M1966.8 943.9c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9c-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1956.912 956.635)"
                className="st25 st26"
              />
              <text
                transform="translate(1956.912 957.072)"
                className="st4 st25 st156"
              >
                {"\u6851\u5FB7\u5170"}
              </text>
              <text
                transform="translate(1983.912 956.635)"
                className="st25 st26"
              />
              <text
                transform="translate(1961.412 967.872)"
                className="st4 st25 st156"
              >
                {"\u5927\u5B66"}
              </text>
              <text
                transform="translate(1979.412 967.435)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000166668764146653609330000003358492287131016612_">
                <g id="university_00000015350315191766488150000016717487515416597937_">
                  <path
                    id="uni_icon_00000038372429586471807270000015634881229130423957_"
                    className="st158"
                    d="M1949.9 561.1c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1 0-.2-.2-2.4-.4-4.9s-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1934.924 573.012)"
                className="st25 st26"
              />
              <text
                transform="translate(1934.924 573.448)"
                className="st4 st25 st156"
              >
                {"\u4F26\u6566\u827A\u672F"}
              </text>
              <text
                transform="translate(1970.924 573.012)"
                className="st25 st26"
              />
              <text
                transform="translate(1943.924 584.248)"
                className="st4 st25 st156"
              >
                {"\u5927\u5B66"}
              </text>
              <text
                transform="translate(1961.924 583.812)"
                className="st25 st26"
              />
            </g>
            <g id="_x3C_Group_x3E_">
              <path
                id="uni_icon_00000106838076327698989150000012992134716351549868_"
                d="M149.6 422.3c-2.6.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.5 3.7 11.3 4.9 11.3 4.9s0 .2-.1.4c-.1.4-.1 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.4 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.9-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.1-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.4 0 .1-.1 1.7-.1 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.9 2.7 4.6.5.3 3.1 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.1 2.6-.7 4.6-1.6 5.7-2.6.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9c-.2-2.5-.4-4.6-.4-4.7 0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1-12.2-2.9-16.3-3.8c-4.1-1-7.5-1.8-7.5-1.8s-1.4.3-2.9.7z"
                fill="#557096"
              />
              <text
                transform="translate(136.078 434.912)"
                className="st25 st26"
              />
              <text
                transform="translate(136.078 435.348)"
                className="st4 st25 st156"
              >
                {"\u5E03\u9C81\u5948\u5C14"}
              </text>
              <text
                transform="translate(172.078 434.912)"
                className="st25 st26"
              />
              <text
                transform="translate(145.078 446.148)"
                className="st4 st25 st156"
              >
                {"\u5927\u5B66"}
              </text>
              <text
                transform="translate(163.078 445.712)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000108275896589928368930000015090594397621913021_">
                <g id="university_00000148639766769674429930000014127604114033596056_">
                  <path
                    id="uni_icon_00000117650317340528912590000006044923999907647910_"
                    className="st158"
                    d="M1861.9 650.7c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1s-.2-2.4-.4-4.9-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1847.624 662.651)"
                className="st25 st26"
              />
              <text
                transform="translate(1847.624 663.088)"
                className="st4 st25 st156"
              >
                {"\u739B\u4E3D\u738B\u540E"}
              </text>
              <text
                transform="translate(1883.624 662.651)"
                className="st25 st26"
              />
              <text
                transform="translate(1856.624 673.888)"
                className="st4 st25 st156"
              >
                {"\u5B66\u9662"}
              </text>
              <text
                transform="translate(1874.624 673.451)"
                className="st25 st26"
              />
            </g>
            <g>
              <g id="nvre_added_00000123420325157265717740000014090700830659098527_">
                <g id="university_00000108995171645640919280000003149439445988475575_">
                  <path
                    id="uni_icon_00000013894516698819334530000009650302135952222111_"
                    className="st158"
                    d="M1908.8 970.8c-2.7.7-4.4 1.2-12.4 3.3-2 .5-5.2 1.4-7.1 1.9s-4.6 1.2-6.2 1.6c-1.5.4-2.8.8-2.8.8-.1 0 0 .1.2.1 8.6 3.7 11.3 4.8 11.3 4.9 0 0 0 .2-.1.3-.1.4-.2 2.1-.1 4.3v1.9c0 .2-.1.3-.2.4-.6.6-.8 1.5-.5 2.3.1.2.2.5.4.6l.2.2.2 1.6c.1.9.2 1.6.2 1.6h.1c.1 0 .1.3 0 1.5 0 1.9-.1 2.8-.5 7-.1 1.2-.2 2.2-.2 3.4 0 .6 0 .6.1.9.2.3.4.6.9.8.4.2 1.3.2 1.9 0 .8-.3 1.5-.8 1.8-1.5.1-.2.1-.3.1-.9 0-1.1-.3-2.9-1.4-7.6-.7-3.2-.8-3.8-.8-4 0-.1-.1-.8-.2-1.6l-.2-1.5.2-.3c.3-.6.3-1.2.1-1.8-.1-.3-.5-.7-.7-.9-.2-.1-.2-.2-.2-.3 0-.1 0-1.2-.1-2.5-.1-1.8-.1-2.5 0-2.9 0-.3.1-.6.1-.6s1.1.4 2.3.9c1.2.5 2.5 1.1 2.8 1.2.4.2.5.2.5.3 0 .1-.1 1.7-.2 3.6-.2 5.4-.2 5.2-.1 5.8.3 2 1.4 3.8 2.7 4.6.5.3 3.2 1.2 4.7 1.6 5.3 1.3 10.3 1.3 15.8-.2 2.6-.7 4.6-1.6 5.7-2.7.9-.8 1.1-1.3 1.3-2.9.1-.4.1-.9.1-1.1 0-.2-.2-2.4-.4-4.9s-.4-4.6-.4-4.7c0-.2 0-.2.7-.5.4-.2 4.1-1.9 8.2-3.8s7.5-3.5 7.6-3.5c.1 0 .1-.1.1-.1s-4-1-8.9-2.1c-4.8-1.1-12.2-2.8-16.3-3.8-4.1-1-7.5-1.8-7.5-1.8s-1.3.7-2.8 1.1z"
                  />
                </g>
              </g>
              <text
                transform="translate(1902.579 983.602)"
                className="st25 st26"
              />
              <text
                transform="translate(1902.579 983.602)"
                className="st4 st25 st156"
              >
                {"UCL"}
              </text>
              <text
                transform="translate(1923.673 983.602)"
                className="st25 st26"
              />
              <text
                transform="translate(1899.629 994.839)"
                className="st4 st25 st156"
              >
                {"\u5546\u5B66\u9662"}
              </text>
              <text
                transform="translate(1926.629 994.402)"
                className="st25 st26"
              />
            </g>
          </g>
        </g>
        <g id="sites">
          <g id="_x3C_Group_x3E__00000142158812829125555460000002398200877491346867_">
            <path
              className="st155"
              d="M291.4 1290.4h-42.5c-4.4 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h42.5c4.4 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(247.528 1284.284)"
              className="st4 st25 st156"
            >
              {"\u5E0C\u601D\u7F57\u673A\u573A"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000085209394726224067320000000365000211632842175_">
            <path
              className="st155"
              d="M749.4 880.3h-32c-4.3 0-7.9-3.5-7.9-7.9V858c0-4.3 3.5-7.9 7.9-7.9h32c4.3 0 7.9 3.5 7.9 7.9v14.4c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(715.419 862.869)"
              className="st25 st26"
            />
            <text
              transform="translate(715.419 863.305)"
              className="st4 st25 st156"
            >
              {"\u897F\u7530\u8D2D\u7269"}
            </text>
            <text
              transform="translate(751.419 862.869)"
              className="st25 st26"
            />
            <text
              transform="translate(724.419 874.105)"
              className="st4 st25 st156"
            >
              {"\u5E7F\u573A"}
            </text>
            <text
              transform="translate(742.419 873.668)"
              className="st25 st26"
            />
          </g>
          <g id="_x3C_Group_x3E__00000148631248477393920640000009209150891104054959_">
            <path
              className="st155"
              d="M785 467h-51.5c-4.3 0-7.9-3.5-7.9-7.9V456c0-4.4 3.5-7.9 7.9-7.9H785c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(731.63 460.713)"
              className="st4 st25 st156"
            >
              {"\u6E29\u5E03\u5229\u4F53\u80B2\u9986"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000092419331970431905530000014273268485571487917_">
            <path
              className="st155"
              d="M1027.6 826.8h-24.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h24.9c4.3 0 7.9 3.5 7.9 7.9v3.1c-.1 4.4-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1000.681 820.528)"
              className="st4 st25 st156"
            >
              {"\u725B\u6D25\u8857"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000163063869571474411350000001973509972096043944_">
            <path
              className="st155"
              d="M1092.8 944.6h-31.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h31.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1058.312 938.494)"
              className="st4 st25 st156"
            >
              {"\u767D\u91D1\u6C49\u5BAB"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000093879035605890122700000018278950772782880696_">
            <path
              className="st155"
              d="M988.8 1014.7h-42.5c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h42.5c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(944.885 1008.559)"
              className="st4 st25 st156"
            >
              {"\u54C8\u7F57\u5FB7\u767E\u8D27"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000170242194981899318810000009418920312406916260_">
            <path
              className="st155"
              d="M1195.7 881.1h-24.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h24.9c4.3 0 7.9 3.5 7.9 7.9v3.1c-.1 4.3-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1168.778 874.74)"
              className="st4 st25 st156"
            >
              {"\u4E2D\u56FD\u57CE"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000085933825168632345610000003050478579863889575_">
            <path
              className="st155"
              d="M1218.8 1047.8H1193.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h24.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1191.917 1041.483)"
              className="st4 st25 st156"
            >
              {"\u5927\u672C\u949F"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000183952076143182536750000012288216622158684086_">
            <path
              className="st155"
              d="M1077.9 1083.6H1028c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h49.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
              // d="M1077.9 1063.6H1028c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h49.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1025.593 1077.483)"
              // transform="translate(1025.593 1057.483)"
              className="st4 st25 st156"
            >
              {"\u5A01\u65AF\u654F\u65AF\u7279\u5BAB"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000029006661940539103690000005829781560982010762_">
            <path
              className="st155"
              d="M1280.3 1076h-24.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h24.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.3-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1253.468 1069.642)"
              className="st4 st25 st156"
            >
              {"\u4F26\u6566\u773C"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000147916950008881293930000012315881516234744212_">
            <path
              className="st155"
              d="M1473.1 835.5h-24.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h24.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1446.236 829.175)"
              className="st4 st25 st156"
            >
              {"\u91D1\u878D\u57CE"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000071546632237554025520000015005573305638222505_">
            <path
              className="st155"
              d="M2131 589.9h-24.9c-4.4 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h24.9c4.4 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(2104.173 583.58)"
              className="st4 st25 st156"
            >
              {"\u5965\u8FD0\u6751"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000127014107905602176850000001393683710680764058_">
            <path
              className="st155"
              d="M2138.3 613.4h-49.9c-4.4 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h49.9c4.4 0 7.9 3.5 7.9 7.9v3.1c-.1 4.3-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(2085.922 607.264)"
              className="st4 st25 st156"
            >
              {"\u897F\u7530\u8D2D\u7269\u5E7F\u573A"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000075860135969422944880000016998352822177476242_">
            <path
              className="st155"
              d="M2286.3 889.1h-59.1c-4.4 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h59.1c4.4 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(2224.823 882.986)"
              className="st4 st25 st156"
            >
              {"ExCel\u5C55\u89C8\u4E2D\u5FC3"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000152960507137104631030000008213533811998088863_">
            <path
              className="st155"
              d="M2272.2 1052.3h-49.9c-4.4 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h49.9c4.4 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(2219.897 1046.183)"
              className="st4 st25 st156"
            >
              {"\u4F26\u6566\u57CE\u5E02\u673A\u573A"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000173131782516457143210000004185464025333835945_">
            <path
              className="st155"
              d="M2057.4 1188.1h-59.1c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h59.1c4.4 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1996.482 1181.964)"
              className="st4 st25 st156"
            >
              {"\u683C\u6797\u5A01\u6CBB\u5929\u6587\u53F0"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000173875333623208865420000018261043008584207790_">
            <path
              className="st155"
              d="M1295.2 701.8h-42.5c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h42.5c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1251.323 695.69)"
              className="st4 st25 st156"
            >
              {"\u5927\u82F1\u535A\u7269\u9986"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000121965098382096287890000016856898732453221023_">
            <path
              className="st155"
              d="M1484.8 885.8h-49.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h49.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1432.417 879.671)"
              className="st4 st161 st156"
            >
              {"\u5723\u4FDD\u7F57\u5927\u6559\u5802"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000165919399557481389350000009611050388877601679_">
            <path
              className="st155"
              d="M1542.4 1010.9h-31.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h31.9c4.3 0 7.9 3.5 7.9 7.9v3.1c-.1 4.3-3.6 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1507.866 1004.755)"
              className="st4 st161 st156"
            >
              {"\u4F26\u6566\u5854\u6865"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000054228813276227712190000012690244291268783266_">
            <path
              className="st155"
              d="M1461.8 1076.3h-31.9c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h31.9c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1427.31 1070.227)"
              className="st4 st25 st156"
            >
              {"\u788E\u7247\u5927\u53A6"}
            </text>
          </g>
          <g id="_x3C_Group_x3E__00000152249216442521763110000006764321856355178150_">
            <path
              className="st155"
              d="M1838.2 987.7h-42.5c-4.3 0-7.9-3.5-7.9-7.9v-3.1c0-4.3 3.5-7.9 7.9-7.9h42.5c4.3 0 7.9 3.5 7.9 7.9v3.1c0 4.4-3.5 7.9-7.9 7.9z"
            />
            <text
              transform="translate(1794.314 981.565)"
              className="st4 st25 st156"
            >
              {"\u91D1\u4E1D\u96C0\u7801\u5934"}
            </text>
          </g>
        </g>
      </g>
    </svg>
  );
}
